'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter$1(thisArg, _arguments, P, generator) {
  function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
  return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
      function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
      function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
  function verb(n) { return function (v) { return step([n, v]); }; }
  function step(op) {
      if (f) throw new TypeError("Generator is already executing.");
      while (g && (g = 0, op[0] && (_ = 0)), _) try {
          if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
          if (y = 0, t) op = [op[0] & 2, t.value];
          switch (op[0]) {
              case 0: case 1: t = op; break;
              case 4: _.label++; return { value: op[1], done: false };
              case 5: _.label++; y = op[1]; op = [0]; continue;
              case 7: op = _.ops.pop(); _.trys.pop(); continue;
              default:
                  if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                  if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                  if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                  if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                  if (t[2]) _.ops.pop();
                  _.trys.pop(); continue;
          }
          op = body.call(thisArg, _);
      } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
      if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
  }
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

exports.Environment = void 0;
(function (Environment) {
    Environment["LOCAL"] = "local";
    Environment["DEVELOPMENT"] = "development";
    Environment["UAT"] = "uat";
    Environment["STAGING"] = "staging";
    Environment["PRODUCTION"] = "production";
})(exports.Environment || (exports.Environment = {}));
exports.MarketLocale = void 0;
(function (MarketLocale) {
    MarketLocale["EN_US"] = "en-US";
    MarketLocale["EN_CA"] = "en-CA";
    MarketLocale["FR_CA"] = "fr-CA";
    MarketLocale["ES_US"] = "es-US";
})(exports.MarketLocale || (exports.MarketLocale = {}));
var LocaleConstants = {
    EN_CA: 'en-CA',
    EN_US: 'en-US',
    ES_US: 'es-US',
    FR_CA: 'fr-CA',
};

var env = process.env.LS_ENV || process.env.NODE_ENV || 'development';
var appDomain = process.env.DOMAIN || 'dev-legalshield.com:' + (process.env.PORT || 3006);
var subDomain = process.env.APP_SUBDOMAIN || 'hello';
var identitiesServiceBaseUrl = process.env.IDENTITIES_DOMAIN || 'https://identities.api.dev-legalshield.com';
var appTitle = process.env.APP_TITLE || 'Example Node Legalshield';
var port = process.env.PORT ? parseInt(process.env.PORT, 10) : 3011;
var getLsComDomainPrefix = function () {
    switch (env) {
        case exports.Environment.LOCAL:
        case exports.Environment.DEVELOPMENT:
            return 'dev-';
        case exports.Environment.STAGING:
        case exports.Environment.UAT:
            return 'uat-';
        case exports.Environment.PRODUCTION:
            return '';
        default:
            return 'dev-';
    }
};
var selectEvironment = function () {
    switch (env) {
        case exports.Environment.LOCAL:
            return exports.Environment.LOCAL;
        case exports.Environment.STAGING:
            return exports.Environment.STAGING;
        case exports.Environment.UAT:
            return exports.Environment.UAT;
        case exports.Environment.PRODUCTION:
            return exports.Environment.PRODUCTION;
        default:
            return exports.Environment.DEVELOPMENT;
    }
};
var CV3_URL_LOCAL = 'https://checkoutv3.dev-legalshield.com:3011';
var CV3_URL_DEVELOPMENT = 'https://checkoutv3.dev-legalshield.com';
var CV3_URL_PRODUCTION = 'https://checkoutv3.legalshield.com';
var CV3_URL_STAGING = 'https://checkoutv3.uat-legalshield.com';
var CV3_URL_UAT = 'https://checkoutv3.uat-legalshield.com';
var EX_A_LBLS_URL = 'https://lisamelville.wearelegalshield.com';
var EX_A_LBLS_STRIPPED_URL = 'lisamelville.wearelegalshield.com';
var EX_A_LBLS_SPONSOR_ID = '128001682';
var GROUP_URL_DEV = 'https://tempbenefits.dev-legalshield.com';
var GROUP_URL_UAT = 'https://tempbenefits.uat-legalshield.com';
var GROUP_URL_PROD = 'https://tempbenefits.legalshield.com';
var IDS_CA_WP_STG_URL = 'https://uat-idshield.ca';
var IDS_CA_WP_STG_URL_STRIP = 'uat-idshield.ca';
var IDS_CA_WP_URL = 'https://www1.idshield.ca';
var IDS_CA_WP_URL_STRIP = 'www1.idshield.ca';
var IDS_CA_URL = 'https://www.idshield.ca';
var IDS_CA_URL_STRIP = 'www.idshield.ca';
var LS_CA_WP_STG_URL = 'https://uat-legalshield.ca';
var LS_CA_WP_STG_URL_STRIP = 'uat-legalshield.ca';
var LS_CA_WP_URL = 'https://ww1.legalshield.ca';
var LS_CA_WP_URL_STRIP = 'ww1.legalshield.ca';
var LS_CA_URL = 'https://www.legalshield.ca';
var LS_CA_URL_STRIP = 'www.legalshield.ca';
var LS_US_WP_STG_URL = 'https://uat-legalshield.com';
var LS_US_WP_STG_URL_STRIP = 'uat-legalshield.com';
var LS_US_WP_URL = 'https://www1.legalshield.com'; //Uncertain of the ww* subdomain
var LS_US_WP_URL_STRIP = 'www1.legalshield.com'; //Uncertain of the ww* subdomain
var LS_US_URL = 'https://www.legalshield.com';
var LS_US_URL_STRIP = 'www.legalshield.com';
var PSX_URL_DEVELOPMENT = 'https://orders.api.dev-legalshield.com';
var PSX_URL_PRODUCTION = 'https://orders.api.legalshield.com';
var PSX_URL_STAGING = 'https://orders.api.uat-legalshield.com';
var PSX_URL_UAT = 'https://orders.api.uat-legalshield.com';
var WALS_SPONSOR_ID = '127525095';
var WALS_URL = 'https://lspro.networkus.dev.dd';
var WALS_STRIPPED_URL = 'lspro.networkus.dev.dd';
var atlasAuthParams = { app: subDomain, port: port };
if (env !== 'development') {
    delete atlasAuthParams.port;
}
var environment$1 = {
    app: {
        certLocation: process.env.SSL_CERT_LOCATION || './dist/ssl/localhost.crt',
        commit: process.env.COMMIT_SHA,
        domain: appDomain,
        https: process.env.HTTPS || false,
        keyLocation: process.env.SSL_KEY_LOCATION || './dist/ssl/localhost.key',
        port: port,
        subdomain: subDomain,
        title: appTitle,
    },
    atlasAuth: {
        identitiesService: { url: identitiesServiceBaseUrl },
        loginService: {
            params: atlasAuthParams,
            url: process.env.LOGIN_URL || 'https://login.dev-legalshield.com',
        },
    },
    checkout: {
        development: CV3_URL_DEVELOPMENT,
        local: CV3_URL_LOCAL,
        production: CV3_URL_PRODUCTION,
        staging: CV3_URL_STAGING,
        uat: CV3_URL_UAT,
    },
    design: {
        config: { designServiceBaseUrl: process.env.DESIGN_URL || 'https://design.api.dev-legalshield.com' },
        headerType: process.env.DESIGN_HEADER_TYPE || 'member',
        pathToIndexHtml: process.env.DESIGN_PATH_TO_INDEX || './dist/client/index_template.html',
        templateMap: {
            loginapp: subDomain,
            logoutapp: subDomain,
            title: appTitle,
        },
    },
    environment: env,
    ga: {
        'dev-shieldbenefits.com': 'UA-7450226-31',
        'idshield.ca': 'UA-7450226-59',
        'idshield.com': 'UA-7450226-16',
        'legalshield.ca': 'UA-7450226-58',
        'legalshield.com': 'UA-7450226-17',
        'shieldbenefits.com': 'UA-7450226-48',
        'uat-idshield.ca': 'UA-7450226-59',
        'uat-legalshield.ca': 'UA-7450226-58',
        'uat-legalshield.com': 'UA-7450226-61',
        'uat-shieldbenefits.com': 'UA-7450226-31',
    },
    group: {
        development: GROUP_URL_DEV,
        local: GROUP_URL_DEV,
        production: GROUP_URL_PROD,
        staging: GROUP_URL_UAT,
        uat: GROUP_URL_UAT,
    },
    identities: {
        host: identitiesServiceBaseUrl,
        secret: process.env.IDENTITIES_SECRET || '4a47c6de-e7cc-11ea-adc1-0242ac120002',
        uuid: process.env.IDENTITIES_UUID || '3a3d22ac-e7cc-11ea-adc1-0242ac120002',
    },
    idshieldCAURL: {
        prd: IDS_CA_URL,
        prdaStrip: IDS_CA_URL_STRIP,
        wpPrd: IDS_CA_WP_URL,
        wpPrdStrip: IDS_CA_WP_URL_STRIP,
        wpStg: IDS_CA_WP_STG_URL,
        wpStgStrip: IDS_CA_WP_STG_URL_STRIP,
    },
    launchByLS: {
        exAFullURL: EX_A_LBLS_URL,
        exASponsorId: EX_A_LBLS_SPONSOR_ID,
        exAStripURL: EX_A_LBLS_STRIPPED_URL,
    },
    lglShieldCAURL: {
        prd: LS_CA_URL,
        prdStrip: LS_CA_URL_STRIP,
        wpPrd: LS_CA_WP_URL,
        wpPrdStrip: LS_CA_WP_URL_STRIP,
        wpStg: LS_CA_WP_STG_URL,
        wpStgStrip: LS_CA_WP_STG_URL_STRIP,
    },
    lglShieldUSURL: {
        prd: LS_US_URL,
        prdStrip: LS_US_URL_STRIP,
        wpPrd: LS_US_WP_URL,
        wpPrdStrip: LS_US_WP_URL_STRIP,
        wpStg: LS_US_WP_STG_URL,
        wpStgStrip: LS_US_WP_STG_URL_STRIP,
    },
    login: {
        host: process.env.LOGIN_URL || 'https://login.dev-legalshield.com',
    },
    menuItems: {},
    profiles: {
        host: process.env.PROFILE_URL || 'https://profiles.api.dev-legalshield.com',
    },
    psx: {
        development: PSX_URL_DEVELOPMENT,
        local: PSX_URL_DEVELOPMENT,
        production: PSX_URL_PRODUCTION,
        staging: PSX_URL_STAGING,
        uat: PSX_URL_UAT,
    },
    test: {
        domainPrefix: getLsComDomainPrefix(),
        printLogs: true,
        testEnv: selectEvironment(),
    },
    wals: {
        exASponsorId: WALS_SPONSOR_ID,
        fullURL: WALS_URL,
        stripURL: WALS_STRIPPED_URL,
    },
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var axios$2 = {exports: {}};

var bind$2 = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};

var bind$1 = bind$2;

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (toString.call(val) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind$1(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

var utils$e = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM
};

var utils$d = utils$e;

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
var buildURL$2 = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils$d.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils$d.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils$d.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils$d.forEach(val, function parseValue(v) {
        if (utils$d.isDate(v)) {
          v = v.toISOString();
        } else if (utils$d.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};

var utils$c = utils$e;

function InterceptorManager$1() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager$1.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager$1.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager$1.prototype.forEach = function forEach(fn) {
  utils$c.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

var InterceptorManager_1 = InterceptorManager$1;

var utils$b = utils$e;

var normalizeHeaderName$1 = function normalizeHeaderName(headers, normalizedName) {
  utils$b.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};

/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
var enhanceError$2 = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};

var enhanceError$1 = enhanceError$2;

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
var createError$2 = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError$1(error, config, code, request, response);
};

var createError$1 = createError$2;

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
var settle$1 = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError$1(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};

var utils$a = utils$e;

var cookies$1 = (
  utils$a.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils$a.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils$a.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils$a.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);

/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
var isAbsoluteURL$1 = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
var combineURLs$1 = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};

var isAbsoluteURL = isAbsoluteURL$1;
var combineURLs = combineURLs$1;

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
var buildFullPath$1 = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};

var utils$9 = utils$e;

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
var parseHeaders$1 = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils$9.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils$9.trim(line.substr(0, i)).toLowerCase();
    val = utils$9.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};

var utils$8 = utils$e;

var isURLSameOrigin$1 = (
  utils$8.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils$8.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);

var utils$7 = utils$e;
var settle = settle$1;
var cookies = cookies$1;
var buildURL$1 = buildURL$2;
var buildFullPath = buildFullPath$1;
var parseHeaders = parseHeaders$1;
var isURLSameOrigin = isURLSameOrigin$1;
var createError = createError$2;

var xhr = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;

    if (utils$7.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL$1(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(
        timeoutErrorMessage,
        config,
        config.transitional && config.transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils$7.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils$7.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils$7.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (!requestData) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};

var utils$6 = utils$e;
var normalizeHeaderName = normalizeHeaderName$1;
var enhanceError = enhanceError$2;

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils$6.isUndefined(headers) && utils$6.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = xhr;
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = xhr;
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils$6.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils$6.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults$3 = {

  transitional: {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
  },

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils$6.isFormData(data) ||
      utils$6.isArrayBuffer(data) ||
      utils$6.isBuffer(data) ||
      utils$6.isStream(data) ||
      utils$6.isFile(data) ||
      utils$6.isBlob(data)
    ) {
      return data;
    }
    if (utils$6.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils$6.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils$6.isObject(data) || (headers && headers['Content-Type'] === 'application/json')) {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || (forcedJSONParsing && utils$6.isString(data) && data.length)) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw enhanceError(e, this, 'E_JSON_PARSE');
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults$3.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils$6.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults$3.headers[method] = {};
});

utils$6.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults$3.headers[method] = utils$6.merge(DEFAULT_CONTENT_TYPE);
});

var defaults_1 = defaults$3;

var utils$5 = utils$e;
var defaults$2 = defaults_1;

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
var transformData$1 = function transformData(data, headers, fns) {
  var context = this || defaults$2;
  /*eslint no-param-reassign:0*/
  utils$5.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};

var isCancel$1 = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};

var utils$4 = utils$e;
var transformData = transformData$1;
var isCancel = isCancel$1;
var defaults$1 = defaults_1;

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
var dispatchRequest$1 = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils$4.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils$4.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults$1.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};

var utils$3 = utils$e;

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
var mergeConfig$2 = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy', 'params'];
  var defaultToConfig2Keys = [
    'baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'timeoutMessage', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'decompress',
    'maxContentLength', 'maxBodyLength', 'maxRedirects', 'transport', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath', 'responseEncoding'
  ];
  var directMergeKeys = ['validateStatus'];

  function getMergedValue(target, source) {
    if (utils$3.isPlainObject(target) && utils$3.isPlainObject(source)) {
      return utils$3.merge(target, source);
    } else if (utils$3.isPlainObject(source)) {
      return utils$3.merge({}, source);
    } else if (utils$3.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  function mergeDeepProperties(prop) {
    if (!utils$3.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (!utils$3.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  }

  utils$3.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (!utils$3.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    }
  });

  utils$3.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);

  utils$3.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (!utils$3.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    } else if (!utils$3.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  utils$3.forEach(directMergeKeys, function merge(prop) {
    if (prop in config2) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys)
    .concat(directMergeKeys);

  var otherKeys = Object
    .keys(config1)
    .concat(Object.keys(config2))
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils$3.forEach(otherKeys, mergeDeepProperties);

  return config;
};

var name = "axios";
var version = "0.21.4";
var description = "Promise based HTTP client for the browser and node.js";
var main = "index.js";
var scripts = {
	test: "grunt test",
	start: "node ./sandbox/server.js",
	build: "NODE_ENV=production grunt build",
	preversion: "npm test",
	version: "npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json",
	postversion: "git push && git push --tags",
	examples: "node ./examples/server.js",
	coveralls: "cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js",
	fix: "eslint --fix lib/**/*.js"
};
var repository = {
	type: "git",
	url: "https://github.com/axios/axios.git"
};
var keywords = [
	"xhr",
	"http",
	"ajax",
	"promise",
	"node"
];
var author = "Matt Zabriskie";
var license = "MIT";
var bugs = {
	url: "https://github.com/axios/axios/issues"
};
var homepage = "https://axios-http.com";
var devDependencies = {
	coveralls: "^3.0.0",
	"es6-promise": "^4.2.4",
	grunt: "^1.3.0",
	"grunt-banner": "^0.6.0",
	"grunt-cli": "^1.2.0",
	"grunt-contrib-clean": "^1.1.0",
	"grunt-contrib-watch": "^1.0.0",
	"grunt-eslint": "^23.0.0",
	"grunt-karma": "^4.0.0",
	"grunt-mocha-test": "^0.13.3",
	"grunt-ts": "^6.0.0-beta.19",
	"grunt-webpack": "^4.0.2",
	"istanbul-instrumenter-loader": "^1.0.0",
	"jasmine-core": "^2.4.1",
	karma: "^6.3.2",
	"karma-chrome-launcher": "^3.1.0",
	"karma-firefox-launcher": "^2.1.0",
	"karma-jasmine": "^1.1.1",
	"karma-jasmine-ajax": "^0.1.13",
	"karma-safari-launcher": "^1.0.0",
	"karma-sauce-launcher": "^4.3.6",
	"karma-sinon": "^1.0.5",
	"karma-sourcemap-loader": "^0.3.8",
	"karma-webpack": "^4.0.2",
	"load-grunt-tasks": "^3.5.2",
	minimist: "^1.2.0",
	mocha: "^8.2.1",
	sinon: "^4.5.0",
	"terser-webpack-plugin": "^4.2.3",
	typescript: "^4.0.5",
	"url-search-params": "^0.10.0",
	webpack: "^4.44.2",
	"webpack-dev-server": "^3.11.0"
};
var browser = {
	"./lib/adapters/http.js": "./lib/adapters/xhr.js"
};
var jsdelivr = "dist/axios.min.js";
var unpkg = "dist/axios.min.js";
var typings = "./index.d.ts";
var dependencies = {
	"follow-redirects": "^1.14.0"
};
var bundlesize = [
	{
		path: "./dist/axios.min.js",
		threshold: "5kB"
	}
];
var _resolved = "https://registry.npmjs.org/axios/-/axios-0.21.4.tgz";
var _integrity = "sha512-ut5vewkiu8jjGBdqpM44XxjuCjq9LAKeHVmoVfHVzy8eHgxxq8SbAVQNovDA8mVi05kP0Ea/n/UzcSHcTJQfNg==";
var _from = "axios@0.21.4";
var require$$0 = {
	name: name,
	version: version,
	description: description,
	main: main,
	scripts: scripts,
	repository: repository,
	keywords: keywords,
	author: author,
	license: license,
	bugs: bugs,
	homepage: homepage,
	devDependencies: devDependencies,
	browser: browser,
	jsdelivr: jsdelivr,
	unpkg: unpkg,
	typings: typings,
	dependencies: dependencies,
	bundlesize: bundlesize,
	_resolved: _resolved,
	_integrity: _integrity,
	_from: _from
};

var pkg = require$$0;

var validators$1 = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators$1[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};
var currentVerArr = pkg.version.split('.');

/**
 * Compare package versions
 * @param {string} version
 * @param {string?} thanVersion
 * @returns {boolean}
 */
function isOlderVersion(version, thanVersion) {
  var pkgVersionArr = thanVersion ? thanVersion.split('.') : currentVerArr;
  var destVer = version.split('.');
  for (var i = 0; i < 3; i++) {
    if (pkgVersionArr[i] > destVer[i]) {
      return true;
    } else if (pkgVersionArr[i] < destVer[i]) {
      return false;
    }
  }
  return false;
}

/**
 * Transitional option validator
 * @param {function|boolean?} validator
 * @param {string?} version
 * @param {string} message
 * @returns {function}
 */
validators$1.transitional = function transitional(validator, version, message) {
  var isDeprecated = version && isOlderVersion(version);

  function formatMessage(opt, desc) {
    return '[Axios v' + pkg.version + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new Error(formatMessage(opt, ' has been removed in ' + version));
    }

    if (isDeprecated && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new TypeError('options must be an object');
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new TypeError('option ' + opt + ' must be ' + result);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw Error('Unknown option ' + opt);
    }
  }
}

var validator$1 = {
  isOlderVersion: isOlderVersion,
  assertOptions: assertOptions,
  validators: validators$1
};

var utils$2 = utils$e;
var buildURL = buildURL$2;
var InterceptorManager = InterceptorManager_1;
var dispatchRequest = dispatchRequest$1;
var mergeConfig$1 = mergeConfig$2;
var validator = validator$1;

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios$1(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios$1.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig$1(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
      forcedJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
      clarifyTimeoutError: validators.transitional(validators.boolean, '1.0.0')
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios$1.prototype.getUri = function getUri(config) {
  config = mergeConfig$1(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils$2.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios$1.prototype[method] = function(url, config) {
    return this.request(mergeConfig$1(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils$2.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios$1.prototype[method] = function(url, data, config) {
    return this.request(mergeConfig$1(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

var Axios_1 = Axios$1;

/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel$1(message) {
  this.message = message;
}

Cancel$1.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel$1.prototype.__CANCEL__ = true;

var Cancel_1 = Cancel$1;

var Cancel = Cancel_1;

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

var CancelToken_1 = CancelToken;

/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
var spread = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};

/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
var isAxiosError = function isAxiosError(payload) {
  return (typeof payload === 'object') && (payload.isAxiosError === true);
};

var utils$1 = utils$e;
var bind = bind$2;
var Axios = Axios_1;
var mergeConfig = mergeConfig$2;
var defaults = defaults_1;

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils$1.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils$1.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios$1 = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios$1.Axios = Axios;

// Factory for creating new instances
axios$1.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios$1.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios$1.Cancel = Cancel_1;
axios$1.CancelToken = CancelToken_1;
axios$1.isCancel = isCancel$1;

// Expose all/spread
axios$1.all = function all(promises) {
  return Promise.all(promises);
};
axios$1.spread = spread;

// Expose isAxiosError
axios$1.isAxiosError = isAxiosError;

axios$2.exports = axios$1;

// Allow use of default import syntax in TypeScript
axios$2.exports.default = axios$1;

var axios = axios$2.exports;

var js_cookie = {exports: {}};

/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */

(function (module, exports) {
(function (factory) {
	var registeredInModuleLoader;
	{
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function decode (s) {
		return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
	}

	function init (converter) {
		function api() {}

		function set (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			attributes = extend({
				path: '/'
			}, api.defaults, attributes);

			if (typeof attributes.expires === 'number') {
				attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
			}

			// We're using "expires" because "max-age" is not supported by IE
			attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

			try {
				var result = JSON.stringify(value);
				if (/^[\{\[]/.test(result)) {
					value = result;
				}
			} catch (e) {}

			value = converter.write ?
				converter.write(value, key) :
				encodeURIComponent(String(value))
					.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

			key = encodeURIComponent(String(key))
				.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
				.replace(/[\(\)]/g, escape);

			var stringifiedAttributes = '';
			for (var attributeName in attributes) {
				if (!attributes[attributeName]) {
					continue;
				}
				stringifiedAttributes += '; ' + attributeName;
				if (attributes[attributeName] === true) {
					continue;
				}

				// Considers RFC 6265 section 5.2:
				// ...
				// 3.  If the remaining unparsed-attributes contains a %x3B (";")
				//     character:
				// Consume the characters of the unparsed-attributes up to,
				// not including, the first %x3B (";") character.
				// ...
				stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
			}

			return (document.cookie = key + '=' + value + stringifiedAttributes);
		}

		function get (key, json) {
			if (typeof document === 'undefined') {
				return;
			}

			var jar = {};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = set;
		api.get = function (key) {
			return get(key, false /* read as raw */);
		};
		api.getJSON = function (key) {
			return get(key, true /* read as json */);
		};
		api.remove = function (key, attributes) {
			set(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));
}(js_cookie));

var Cookies = js_cookie.exports;

exports.BillingPeriod = void 0;
(function (BillingPeriod) {
    BillingPeriod["DAY"] = "DAY";
    BillingPeriod["WEEK"] = "WEEK";
    BillingPeriod["MONTH"] = "MONTH";
    BillingPeriod["QUARTER"] = "QUARTER";
    BillingPeriod["BIANNUAL"] = "BIANNUAL";
    BillingPeriod["ANNUAL"] = "ANNUAL";
    BillingPeriod["PAY_PERIOD"] = "PAY_PERIOD";
})(exports.BillingPeriod || (exports.BillingPeriod = {}));
exports.BillingProvider = void 0;
(function (BillingProvider) {
    BillingProvider["PSX"] = "PSX";
    BillingProvider["SYSTEMI"] = "SYSTEM I";
    BillingProvider["VINDICIA"] = "VINDICIA";
})(exports.BillingProvider || (exports.BillingProvider = {}));
exports.BillingStatus = void 0;
(function (BillingStatus) {
    BillingStatus["OPEN"] = "OPEN";
    BillingStatus["FUNDED"] = "FUNDED";
    BillingStatus["FULLY_FUNDED"] = "FULLY_FUNDED";
})(exports.BillingStatus || (exports.BillingStatus = {}));
exports.Channel = void 0;
(function (Channel) {
    Channel["GROUP_SITES"] = "GroupSites";
    Channel["D_TO_C"] = "Corp";
    Channel["NETWORK"] = "Hubsites";
    Channel["LAUNCH"] = "LaunchByLS";
    Channel["BUYNOW"] = "BUYNOW";
})(exports.Channel || (exports.Channel = {}));
exports.Currency = void 0;
(function (Currency) {
    Currency["USD"] = "USD";
    Currency["CAD"] = "CAD";
})(exports.Currency || (exports.Currency = {}));
exports.PaymentType = void 0;
(function (PaymentType) {
    PaymentType["CREDIT_CARD"] = "CREDIT_CARD";
    PaymentType["BANK_DRAFT"] = "BANK_DRAFT";
    PaymentType["PREMIUM_GROUP"] = "PREMIUM_GROUP";
    PaymentType["CHECK"] = "CHECK";
})(exports.PaymentType || (exports.PaymentType = {}));
exports.SubscriptionActions = void 0;
(function (SubscriptionActions) {
    SubscriptionActions["CREATE"] = "CREATE";
    SubscriptionActions["UPDATE"] = "UPDATE";
})(exports.SubscriptionActions || (exports.SubscriptionActions = {}));

var getPSXURLV2 = function (environmentArg) {
    if (environmentArg === void 0) { environmentArg = exports.Environment.PRODUCTION; }
    var baseURL = environment$1.psx[environmentArg];
    return baseURL;
};
var createSupplementV1 = function (id, name) {
    return {
        id: id,
        name: name,
    };
};
var createOfferV1 = function (productId, billingFrequency, couponCode, friendlyId, prepaidMonths, productSupplements) {
    if (billingFrequency === void 0) { billingFrequency = {
        period: exports.BillingPeriod.MONTH,
        term: 1,
    }; }
    if (prepaidMonths === void 0) { prepaidMonths = 0; }
    return {
        billingFrequency: billingFrequency,
        couponCode: couponCode,
        friendlyId: friendlyId,
        id: productId,
        prepaidMonths: prepaidMonths,
        products: [
            {
                productId: productId,
                supplements: productSupplements,
            },
        ],
    };
};
var createMinD2CInfo = function (productId, marketLocale, marketingSite) {
    if (marketLocale === void 0) { marketLocale = exports.MarketLocale.ES_US; }
    return {
        offers: [
            {
                billingFrequency: {
                    period: exports.BillingPeriod.MONTH,
                    term: 1,
                },
                id: productId,
                products: [
                    {
                        productId: productId,
                    },
                ],
            },
        ],
        source: {
            channel: exports.Channel.D_TO_C,
            marketLocale: marketLocale,
            marketingSite: marketingSite,
        },
        subscriptionAction: exports.SubscriptionActions.CREATE,
    };
};
var createWALSOrderV1 = function (marketLocale, marketingSite, offers, sponsorId) {
    if (marketLocale === void 0) { marketLocale = exports.MarketLocale.ES_US; }
    return {
        offers: offers,
        source: {
            channel: exports.Channel.NETWORK,
            marketLocale: marketLocale,
            marketingSite: marketingSite,
            sponsorId: sponsorId,
        },
        subscriptionAction: exports.SubscriptionActions.CREATE,
    };
};
var createLaunchInfo = function (launchPlanId, homeBizSupId, marketLocale, marketingSite, sponsorId) {
    if (marketLocale === void 0) { marketLocale = exports.MarketLocale.ES_US; }
    return {
        offers: [
            {
                billingFrequency: {
                    period: exports.BillingPeriod.MONTH,
                    term: 1,
                },
                id: launchPlanId,
                prepaidMonths: 3,
                products: [
                    {
                        productId: launchPlanId,
                        supplements: [
                            {
                                id: homeBizSupId,
                            },
                        ],
                    },
                ],
            },
        ],
        source: {
            channel: exports.Channel.LAUNCH,
            marketLocale: marketLocale,
            marketingSite: marketingSite,
            sponsorId: sponsorId,
        },
        subscriptionAction: exports.SubscriptionActions.CREATE,
    };
};
var createMinGroupsInfo = function (groupId, groupOfferToken, marketLocale, marketingSite, productIds) {
    if (marketLocale === void 0) { marketLocale = exports.MarketLocale.ES_US; }
    return {
        group: {
            id: groupId,
            token: groupOfferToken,
        },
        offers: productIds.map(function (pId) {
            return {
                billingFrequency: {
                    period: exports.BillingPeriod.MONTH,
                    term: 1,
                },
                id: pId,
                products: [
                    {
                        productId: pId,
                    },
                ],
            };
        }),
        source: {
            channel: exports.Channel.GROUP_SITES,
            marketLocale: marketLocale,
            marketingSite: marketingSite,
        },
        subscriptionAction: exports.SubscriptionActions.CREATE,
    };
};
var createMinPrimericaInfo = function (groupId, groupOfferToken, marketLocale, marketingSite, productIds, sponsorId, subAgentId) {
    if (marketLocale === void 0) { marketLocale = exports.MarketLocale.EN_US; }
    return {
        group: {
            id: groupId,
            token: groupOfferToken,
        },
        offers: productIds.map(function (pId) {
            return {
                billingFrequency: {
                    period: exports.BillingPeriod.MONTH,
                    term: 1,
                },
                id: pId,
                products: [
                    {
                        productId: pId,
                    },
                ],
            };
        }),
        source: {
            channel: exports.Channel.GROUP_SITES,
            marketLocale: marketLocale,
            marketingSite: marketingSite,
            sponsorId: sponsorId,
            subAgentId: subAgentId,
        },
        subscriptionAction: exports.SubscriptionActions.CREATE,
    };
};
//FIXME: Catch exceptions
var OrderService = /** @class */ (function () {
    function OrderService() {
    }
    OrderService.prototype.anonymousCreateOrder = function (orderInfo, environmentArg, httpAdapter) {
        if (environmentArg === void 0) { environmentArg = exports.Environment.PRODUCTION; }
        if (httpAdapter === void 0) { httpAdapter = true; }
        return __awaiter$1(this, void 0, void 0, function () {
            var fullURL, PurchasesClient, response, info, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        fullURL = "".concat(getPSXURLV2(environmentArg)) + '/v1/orders';
                        PurchasesClient = axios.create({
                            baseURL: fullURL,
                            timeout: 5000,
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, PurchasesClient.post('', orderInfo, {
                                adapter: httpAdapter ? require('axios/lib/adapters/http') : null,
                                headers: {
                                    'Content-Type': httpAdapter ? 'application/json' : null,
                                },
                            }).catch(function (err) {
                                console.log('err.response');
                                console.log(err.response);
                                console.log('err.response.data');
                                console.log(err.response.data);
                                console.log('err.response.data.errors');
                                console.log(err.response.data.errors);
                            })];
                    case 2:
                        response = _a.sent();
                        info = response.data;
                        Cookies.set('Order', info, { expires: 2 });
                        return [2 /*return*/, info];
                    case 3:
                        err_1 = _a.sent();
                        console.log('anonymousCreateOrder (v1) fails and Err is');
                        console.log(err_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    OrderService.prototype.readOrder = function (orderId, environmentArg) {
        if (environmentArg === void 0) { environmentArg = exports.Environment.PRODUCTION; }
        return __awaiter$1(this, void 0, void 0, function () {
            var fullUrl, response, info;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        fullUrl = "".concat(getPSXURLV2(environmentArg)) + '/v1/orders' + '/' + orderId;
                        return [4 /*yield*/, axios.get(fullUrl)];
                    case 1:
                        response = _a.sent();
                        info = response.data;
                        return [2 /*return*/, info];
                }
            });
        });
    };
    OrderService.prototype.updateOrder = function (orderId, updateOrderInfo, environmentArg) {
        if (environmentArg === void 0) { environmentArg = exports.Environment.PRODUCTION; }
        return __awaiter$1(this, void 0, void 0, function () {
            var fullUrl, response, info;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        fullUrl = "".concat(getPSXURLV2(environmentArg)) + '/v1/orders' + '/' + orderId + '/offers';
                        return [4 /*yield*/, axios.put(fullUrl, updateOrderInfo)];
                    case 1:
                        response = _a.sent();
                        info = response.data;
                        return [2 /*return*/, info];
                }
            });
        });
    };
    return OrderService;
}());

var dist = {};

var interfaces = {};

var actor_interface = {};

Object.defineProperty(actor_interface, "__esModule", { value: true });

var authNPayload_interface = {};

Object.defineProperty(authNPayload_interface, "__esModule", { value: true });

var authZPayload_interface = {};

Object.defineProperty(authZPayload_interface, "__esModule", { value: true });

var pplsiPayload_interface = {};

Object.defineProperty(pplsiPayload_interface, "__esModule", { value: true });

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(actor_interface, exports);
__exportStar(authNPayload_interface, exports);
__exportStar(authZPayload_interface, exports);
__exportStar(pplsiPayload_interface, exports);

}(interfaces));

var sdk = {};

var alerts$1 = {};

var alerts = {};

var utils = {};

var design = {};

Object.defineProperty(design, "__esModule", { value: true });
design.Design = void 0;
const breakpoint = 1023;
const getResponsiveNavigationType = (width) => {
    return width > breakpoint ? 'pane' : 'slideout';
};
design.Design = {
    breakpoint,
    getResponsiveNavigationType,
};

var environment = {};

Object.defineProperty(environment, "__esModule", { value: true });
environment.Environment = void 0;
const getDomainEnvironmentPrefix = () => {
    return pplsi.envPrefix;
};
const getDomainEnvironment = () => {
    return pplsi.env;
};
const getRealmDomainEnvironment = () => {
    return pplsi.realmDomain;
};
const getEnvironmentUrl = (url) => {
    var _a;
    const isNode = new Function('try {return this===global;}catch(e){return false;}');
    // check if running in browser context
    if (isNode()) {
        const LS_ENV = process.env.LS_ENV || 'prod';
        if (url.includes(`.dev-`) || url.includes(`.uat-`)) {
            return url;
        }
        // Check if LS_ENV is "dev" or "uat"
        if (LS_ENV === 'dev') {
            return url.replace(/\.api\./, '.api.dev-');
        }
        else if (LS_ENV === 'uat') {
            return url.replace(/\.api\./, '.api.uat-');
        }
        else {
            return url;
        }
    }
    else {
        // Get the realm domain E.g. dev-legalshieldproviders.com
        const realmDomain = (_a = getRealmDomainEnvironment()) !== null && _a !== void 0 ? _a : '';
        // Check if the url already includes “.dev-” or “.uat-”
        if (url.includes(`.dev-`) || url.includes(`.uat-`) || realmDomain === '') {
            return url;
        }
        const regexForEnvsToReplace = /\blegalshield.com|legalshieldinternal.com|legalshieldproviders.com|legalshieldatwork.com\b/;
        // Injects env if needed, also ensures that we're using the correct realm
        return url.replace(regexForEnvsToReplace, realmDomain);
    }
};
const getAppName = (hostName) => {
    if (hostName === pplsi.realmDomain)
        return '';
    return hostName.replace('.' + pplsi.realmDomain, '');
};
environment.Environment = {
    getAppName,
    getDomainEnvironment,
    getDomainEnvironmentPrefix,
    getEnvironmentUrl,
    getRealmDomainEnvironment,
};

var login = {};

var identities$1 = {};

var identities = {};

(function (exports) {
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.ProofType = exports.FactorType = exports.FederatedAuthType = exports.ClassicIdType = exports.Realm = exports.Action = void 0;
(function (Action) {
    Action["LOGGED_IN"] = "LOGGED_IN";
    Action["PASSWORD_RESET_REQUESTED"] = "PASSWORD_RESET_REQUESTED";
    Action["IDENTITY_CREATED"] = "IDENTITY_CREATED";
    Action["IDENTITY_DELETED"] = "IDENTITY_DELETED";
    Action["IMPERSONATED"] = "IMPERSONATED";
    Action["MULTIFACTOR_ADDED"] = "MULTIFACTOR_ADDED";
    Action["MULTIFACTOR_DELETED"] = "MULTIFACTOR_DELETED";
    Action["MULTIFACTOR_MADE_PRIMARY"] = "MULTIFACTOR_MADE_PRIMARY";
    Action["PASSWORD_UPDATED"] = "PASSWORD_UPDATED";
    Action["PASSWORDS_INVALIDATED"] = "PASSWORDS_INVALIDATED";
    Action["EMAIL_ADDED"] = "EMAIL_ADDED";
    Action["EMAIL_REMOVED"] = "EMAIL_REMOVED";
    Action["EMAIL_UPDATED"] = "EMAIL_UPDATED";
    Action["EMAILS_REPLACED"] = "EMAILS_REPLACED";
    Action["USERNAME_ADDED"] = "USERNAME_ADDED";
    Action["USERNAME_REMOVED"] = "USERNAME_REMOVED";
    Action["USERNAME_UPDATED"] = "USERNAME_UPDATED";
    Action["REFERRER_UPDATED"] = "REFERRER_UPDATED";
    Action["FEDERATED_ID_UPDATED"] = "FEDERATED_ID_UPDATED";
    Action["FEDERATED_ID_REMOVED"] = "FEDERATED_ID_REMOVED";
    Action["PASSWORD_RESET_SUCCESSFUL"] = "PASSWORD_RESET_SUCCESSFUL";
    Action["CLASSIC_ID_ADDED"] = "CLASSIC_ID_ADDED";
    Action["CLASSIC_ID_REMOVED"] = "CLASSIC_ID_REMOVED";
    Action["DELETED"] = "DELETED";
})(exports.Action || (exports.Action = {}));
(function (Realm) {
    Realm["User"] = "User";
    Realm["Machine"] = "Machine";
    Realm["Internal"] = "Internal";
    Realm["Partner"] = "Partner";
    Realm["GroupAdmin"] = "GroupAdmin";
})(exports.Realm || (exports.Realm = {}));
(function (ClassicIdType) {
    ClassicIdType["Member"] = "Member";
    ClassicIdType["Associate"] = "Associate";
    ClassicIdType["Dependent"] = "Dependent";
})(exports.ClassicIdType || (exports.ClassicIdType = {}));
(function (FederatedAuthType) {
    FederatedAuthType[FederatedAuthType["Okta"] = 0] = "Okta";
})(exports.FederatedAuthType || (exports.FederatedAuthType = {}));
(function (FactorType) {
    FactorType["GOOGLE"] = "GOOGLE";
    FactorType["SMS"] = "SMS";
    FactorType["EMAIL"] = "EMAIL";
    FactorType["ACCOUNT"] = "ACCOUNT";
    FactorType["QUESTION"] = "QUESTION";
})(exports.FactorType || (exports.FactorType = {}));
(function (ProofType) {
    ProofType["KNOWLEDGE"] = "KNOWLEDGE";
    ProofType["POSSESSION"] = "POSSESSION";
    ProofType["BIOMETRIC"] = "BIOMETRIC";
    ProofType["ACCOUNT"] = "ACCOUNT";
})(exports.ProofType || (exports.ProofType = {}));
const axios_1 = __importDefault(axios);
const utils_1 = utils;
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://identities.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title Identities API
 * @version v1
 * @baseUrl https://identities.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * @description The journal is for internal use only
             *
             * @tags IdentityJournal
             * @name IdentitiesJournalAll
             * @summary Machine JWT Only
             * @request GET:/v1/identities/journal
             * @secure
             */
            identitiesJournalAll: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/journal`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * @description The journal is for internal use only
             *
             * @tags IdentityJournal
             * @name IdentitiesJournal
             * @summary Machine JWT Only
             * @request GET:/v1/identities/journal/maxClock
             * @secure
             */
            identitiesJournal: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/journal/maxClock`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Identities
             * @name IdentitiesFindByIdentityId
             * @request GET:/v1/identities/{identityId}
             * @secure
             */
            identitiesFindByIdentityId: (identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Identities
             * @name IdentitiesRemoveIdentity
             * @request DELETE:/v1/identities/{identityId}
             * @secure
             */
            identitiesRemoveIdentity: (identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}`, method: 'DELETE', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Identities
             * @name IdentitiesIndex
             * @request GET:/v1/identities
             * @secure
             */
            identitiesIndex: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Identities
             * @name IdentitiesCreateIdentity
             * @request POST:/v1/identities
             * @secure
             */
            identitiesCreateIdentity: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Identities
             * @name IdentitiesImpersonate
             * @request POST:/v1/identities/{identityId}/impersonate
             * @secure
             */
            identitiesImpersonate: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/impersonate`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Identities
             * @name IdentitiesMigrateIdentity
             * @request POST:/v1/identities/migrate
             * @secure
             */
            identitiesMigrateIdentity: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/migrate`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Identity
             * @name ExternalBasicAuthorization
             * @request GET:/v1/identityExists
             * @secure
             */
            externalBasicAuthorization: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identityExists`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Keys
             * @name KeysFetchKey
             * @request GET:/v1/keys/{keyId}
             * @secure
             */
            keysFetchKey: (keyId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/keys/${keyId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Multifactor
             * @name MultifactorGetMultifactorType
             * @request GET:/v1/identities/{identityId}/settings
             * @secure
             */
            multifactorGetMultifactorType: (identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/settings`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Multifactor
             * @name MultifactorUpdateMultifactorType
             * @request POST:/v1/identities/{identityId}/settings
             * @secure
             */
            multifactorUpdateMultifactorType: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/settings`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Passwords
             * @name PasswordsUpdateCredential
             * @request POST:/v1/users/{identityId}/passwords
             * @deprecated
             * @secure
             */
            passwordsUpdateCredential: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/passwords`, method: 'POST', body: data, secure: true, type: FecContentType.Json }, params)),
            /**
             * No description
             *
             * @tags Passwords
             * @name PasswordsResetPassword
             * @request POST:/v1/identities/{identityId}/resetPassword
             * @secure
             */
            passwordsResetPassword: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/resetPassword`, method: 'POST', body: data, secure: true, type: FecContentType.Json }, params)),
            /**
             * No description
             *
             * @tags Passwords
             * @name PasswordsUpdatePassword2
             * @request POST:/v1/identities/{identityId}/updatePassword
             * @deprecated
             * @secure
             */
            passwordsUpdatePassword2: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/updatePassword`, method: 'POST', body: data, secure: true, type: FecContentType.Json }, params)),
            /**
             * No description
             *
             * @tags Passwords
             * @name PasswordsBulkAddPasswords
             * @request POST:/v1/identities/{identityId}/bulkAddPasswords
             * @secure
             */
            passwordsBulkAddPasswords: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/bulkAddPasswords`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Passwords
             * @name PasswordsInvalidatePasswords
             * @request POST:/v1/identities/{identityId}/invalidatePasswords
             * @secure
             */
            passwordsInvalidatePasswords: (identityId, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/invalidatePasswords`, method: 'POST', query: query, secure: true }, params)),
            /**
             * No description
             *
             * @tags Passwords
             * @name PasswordsSetPassword
             * @request POST:/v1/setPassword
             * @secure
             */
            passwordsSetPassword: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/setPassword`, method: 'POST', body: data, secure: true, type: FecContentType.Json }, params)),
            /**
             * No description
             *
             * @tags SendPasswordResetEmail
             * @name SendPasswordResetEmailPostPasswordResetToken
             * @request POST:/v1/sendPasswordResetEmail
             * @secure
             */
            sendPasswordResetEmailPostPasswordResetToken: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/sendPasswordResetEmail`, method: 'POST', body: data, secure: true, type: FecContentType.Json }, params)),
            /**
             * No description
             *
             * @tags Tokens
             * @name TokensPostJwtToken
             * @request POST:/v1/tokens
             * @secure
             */
            tokensPostJwtToken: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/tokens`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ClassicId
             * @name ClassicIdAddClassicId
             * @request POST:/v1/identities/{identityId}/addClassicId
             * @secure
             */
            classicIdAddClassicId: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/addClassicId`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ClassicId
             * @name ClassicIdRemoveClassicId
             * @request POST:/v1/identities/{identityId}/removeClassicId
             * @secure
             */
            classicIdRemoveClassicId: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/removeClassicId`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Email
             * @name EmailAddEmail
             * @request POST:/v1/identities/{identityId}/addEmail
             * @secure
             */
            emailAddEmail: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/addEmail`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Email
             * @name EmailRemoveEmail
             * @request POST:/v1/identities/{identityId}/removeEmail
             * @secure
             */
            emailRemoveEmail: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/removeEmail`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Email
             * @name EmailUpdateEmail
             * @request POST:/v1/identities/{identityId}/updateEmail
             * @secure
             */
            emailUpdateEmail: (identityId, query, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/updateEmail`, method: 'POST', query: query, body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Email
             * @name EmailReplaceAllEmails
             * @request POST:/v1/identities/{identityId}/replaceAllEmails
             * @secure
             */
            emailReplaceAllEmails: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/replaceAllEmails`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Referrer
             * @name ReferrerUpdateReferrer
             * @request POST:/v1/identities/{identityId}/updateReferrer
             * @secure
             */
            referrerUpdateReferrer: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/updateReferrer`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags SocialProvider
             * @name SocialProviderUpdateOktaId
             * @request POST:/v1/identities/{identityId}/updateOktaId
             * @secure
             */
            socialProviderUpdateOktaId: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/updateOktaId`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags SocialProvider
             * @name SocialProviderRemoveOktaId
             * @request DELETE:/v1/identities/{identityId}/okta
             * @secure
             */
            socialProviderRemoveOktaId: (identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/okta`, method: 'DELETE', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Username
             * @name UsernameAddUsername
             * @request POST:/v1/identities/{identityId}/addUsername
             * @secure
             */
            usernameAddUsername: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/addUsername`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Username
             * @name UsernameRemoveUsername
             * @request POST:/v1/identities/{identityId}/removeUsername
             * @secure
             */
            usernameRemoveUsername: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/removeUsername`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Username
             * @name UsernameUpdateUsername
             * @request POST:/v1/identities/{identityId}/updateUsername
             * @secure
             */
            usernameUpdateUsername: (identityId, query, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/updateUsername`, method: 'POST', query: query, body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
        };
        this.v2 = {
            /**
             * No description
             *
             * @tags Passwords
             * @name PasswordsUpdatePassword
             * @request POST:/v2/identities/{identityId}/updatePassword
             * @secure
             */
            passwordsUpdatePassword: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/updatePassword`, method: 'POST', body: data, secure: true, type: FecContentType.Json }, params)),
        };
    }
}
exports.Api = Api;

}(identities));

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(identities, exports);

}(identities$1));

Object.defineProperty(login, "__esModule", { value: true });
login.Login = void 0;
const identities_1 = identities$1;
const environment_1 = environment;
const getLoginUrl = (inputPath, inputApp, inputPort) => {
    const path = inputPath
        ? encodeURIComponent(inputPath)
        : encodeURIComponent(window.location.pathname + window.location.search);
    const port = inputPort ? inputPort : window.location.port;
    const portString = port != '' && port != '443' ? '&port=' + port : '';
    const app = inputApp ? inputApp : environment_1.Environment.getAppName(window.location.hostname);
    return 'https://login.' + pplsi.realmDomain + '/login?app=' + app + portString + '&path=' + path;
};
const getAccountCreateUrl = (inputPath, inputApp, inputPort) => {
    const path = inputPath
        ? encodeURIComponent(inputPath)
        : encodeURIComponent(window.location.pathname + window.location.search);
    const port = inputPort ? inputPort : window.location.port;
    const portString = port != '' && port != '443' ? '&port=' + port : '';
    const app = inputApp ? inputApp : environment_1.Environment.getAppName(window.location.hostname);
    return 'https://login.' + pplsi.realmDomain + '/sign-up?app=' + app + portString + '&path=' + path;
};
const getReLoginUrl = (inputPath, inputApp, inputPort) => {
    // sub_type: User, Internal, Partner, Group
    // pplsi.realmdomain: e.g., dev-legalshield.com
    // pplsi.realm: member, internal, partner, group
    var _a, _b, _c, _d, _e, _f, _g;
    // Defaults: shield-service.com, pplsipeople.com, shieldproviders.com, shieldatwork.com
    const path = inputPath
        ? encodeURIComponent(inputPath)
        : encodeURIComponent(window.location.pathname + window.location.search);
    const port = inputPort ? inputPort : window.location.port;
    const portString = port != '' && port != '443' ? '&port=' + port : '';
    const app = inputApp ? inputApp : environment_1.Environment.getAppName(window.location.hostname);
    if ((((_a = pplsi.authNPayload) === null || _a === void 0 ? void 0 : _a.sub_type) === identities_1.Realm.User && pplsi.realm === 'member') ||
        (((_b = pplsi.authNPayload) === null || _b === void 0 ? void 0 : _b.sub_type) === identities_1.Realm.Internal && pplsi.realm === 'internal') ||
        (((_c = pplsi.authNPayload) === null || _c === void 0 ? void 0 : _c.sub_type) === identities_1.Realm.Partner && pplsi.realm === 'partner') ||
        (((_d = pplsi.authNPayload) === null || _d === void 0 ? void 0 : _d.sub_type) === identities_1.Realm.GroupAdmin && pplsi.realm === 'group')) {
        return 'https://login.' + pplsi.realmDomain + '/login?app=' + app + portString + '&path=' + path;
    }
    if (((_e = pplsi.authNPayload) === null || _e === void 0 ? void 0 : _e.sub_type) === identities_1.Realm.User) {
        return ('https://login.shield-service.com/crosslogin?app=' +
            app +
            portString +
            '&path=' +
            path +
            '&loginrealm=' +
            pplsi.realmDomain);
    }
    else if (((_f = pplsi.authNPayload) === null || _f === void 0 ? void 0 : _f.sub_type) === identities_1.Realm.Internal) {
        return ('https://login.pplsipeople.com/crosslogin?app=' +
            app +
            portString +
            '&path=' +
            path +
            '&loginrealm=' +
            pplsi.realmDomain);
    }
    else if (((_g = pplsi.authNPayload) === null || _g === void 0 ? void 0 : _g.sub_type) === identities_1.Realm.Partner) {
        return ('https://login.shieldproviders.com/crosslogin?app=' +
            app +
            portString +
            '&path=' +
            path +
            '&loginrealm=' +
            pplsi.realmDomain);
    }
    else {
        return ('https://login.shieldatwork.com.com/crosslogin?app=' +
            app +
            portString +
            '&path=' +
            path +
            '&loginrealm=' +
            pplsi.realmDomain);
    }
};
const redirectToLogin = () => {
    window.location.href = getLoginUrl();
};
const redirectToSignUp = () => {
    window.location.href = getAccountCreateUrl();
};
const redirectToReLogin = () => {
    window.location.href = getReLoginUrl();
};
const getLogoutUrl = () => {
    return 'https://login.' + realmDomain + '/logout';
};
login.Login = {
    getAccountCreateUrl,
    getLoginUrl,
    getLogoutUrl,
    getReLoginUrl,
    redirectToLogin,
    redirectToReLogin,
    redirectToSignUp,
};

var permissionsUtil = {};

Object.defineProperty(permissionsUtil, "__esModule", { value: true });
permissionsUtil.PermissionsUtil = void 0;
/**
 * Determines if the logged in person has a permission for an application. This is
 * not a security guarantee. It's only a convenience.
 * @example
 * PermissionsUtil.hasPermission('merge', { application: 'member-search' });
 */
const hasPermission = ({ applicationName, permission, }) => {
    var _a, _b, _c;
    const currentApplication = getApplicationName(applicationName);
    if ((_b = (_a = pplsi.authZPayload) === null || _a === void 0 ? void 0 : _a.permissions) === null || _b === void 0 ? void 0 : _b.hasOwnProperty(currentApplication)) {
        return (_c = pplsi.authZPayload) === null || _c === void 0 ? void 0 : _c.permissions[currentApplication].includes(permission);
    }
    return false;
};
function getApplicationName(applicationName) {
    return applicationName ? applicationName : window.location.hostname.split('.').slice(0, -2).join('.');
}
permissionsUtil.PermissionsUtil = {
    hasPermission,
};

var regex = {};

(function (exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegEx = exports.domainRegex = exports.subDomainRegex = exports.emailRegex = void 0;
exports.emailRegex = /^[a-zA-Z0-9!#$%&'*+-/=?^_`{|]{1,64}[@]((([a-zA-Z0-9][a-zA-Z0-9-_]*[a-zA-Z0-9])|[a-zA-Z0-9])\.){1,}[a-zA-Z0-9]{2,}$/;
exports.subDomainRegex = /^(([a-zA-Z0-9][a-zA-Z0-9-_]*[a-zA-Z0-9])|[a-zA-Z0-9])$/;
exports.domainRegex = /^((([a-zA-Z0-9][a-zA-Z0-9-_]*[a-zA-Z0-9])|[a-zA-Z0-9])\.){1,}[a-zA-Z0-9]{2,}$/;
exports.RegEx = {
    domainRegex: exports.domainRegex,
    emailRegex: exports.emailRegex,
    subDomainRegex: exports.subDomainRegex,
};

}(regex));

var sdkDirect = {};

var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(sdkDirect, "__esModule", { value: true });
sdkDirect.SDKDirect = void 0;
const getJson = (url) => __awaiter(void 0, void 0, void 0, function* () {
    const headers = { 'Content-Type': 'application/json' };
    const response = yield fetch(url, { credentials: 'include', headers: headers, method: 'GET' });
    if (response.ok && response.status >= 200 && response.status < 300) {
        if (response.status === 204) {
            return { data: null, status: response.status };
        }
        else {
            const responseData = yield response.json();
            return { data: responseData, status: response.status };
        }
    }
    else {
        const responseText = yield response.text();
        return { data: responseText, status: response.status };
    }
});
const postJson = (url, body = {}, method = 'POST', extraHeaders) => __awaiter(void 0, void 0, void 0, function* () {
    const headers = Object.assign({ 'Content-Type': 'application/json' }, extraHeaders);
    const response = yield fetch(url, {
        body: JSON.stringify(body),
        credentials: 'include',
        headers: headers,
        method: method,
    });
    if (response.ok && response.status >= 200 && response.status < 300) {
        if (response.status === 204) {
            return { data: null, status: response.status };
        }
        else {
            const responseData = yield response.json();
            return { data: responseData, status: response.status };
        }
    }
    else {
        const responseText = yield response.text();
        return { data: responseText, status: response.status };
    }
});
sdkDirect.SDKDirect = {
    getJson,
    postJson,
};

var sdkHeaders = {};

Object.defineProperty(sdkHeaders, "__esModule", { value: true });
sdkHeaders.SDKHeaders = void 0;
// eslint-disable-next-line @typescript-eslint/ban-types
const getVersionConfig = (version, withCredentials = true, params = {}) => {
    return Object.assign(Object.assign({}, params), { headers: { 'If-Match': version }, withCredentials: withCredentials === null || withCredentials ? true : false });
};
sdkHeaders.SDKHeaders = {
    getVersionConfig,
};

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(design, exports);
__exportStar(environment, exports);
__exportStar(login, exports);
__exportStar(permissionsUtil, exports);
__exportStar(regex, exports);
__exportStar(sdkDirect, exports);
__exportStar(sdkHeaders, exports);

}(utils));

(function (exports) {
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.NotificationStatus = exports.Status = exports.Priority = exports.Application = exports.AlertAction = void 0;
(function (AlertAction) {
    AlertAction["CREATED"] = "CREATED";
    AlertAction["DELETED"] = "DELETED";
    AlertAction["ESCALATED"] = "ESCALATED";
    AlertAction["STATUS_UPDATED"] = "STATUS_UPDATED";
    AlertAction["OWNER_CHANGED"] = "OWNER_CHANGED";
    AlertAction["NOTIFICATION_STATUS_UPDATED"] = "NOTIFICATION_STATUS_UPDATED";
})(exports.AlertAction || (exports.AlertAction = {}));
(function (Application) {
    Application["All"] = "all";
    Application["People"] = "people";
    Application["Partner"] = "partner";
    Application["Legalshield"] = "legalshield";
    Application["LegalshieldV2"] = "legalshieldv2";
    Application["Status"] = "status";
    Application["Idshield"] = "idshield";
})(exports.Application || (exports.Application = {}));
(function (Priority) {
    Priority["Low"] = "Low";
    Priority["Medium"] = "Medium";
    Priority["High"] = "High";
    Priority["Critical"] = "Critical";
})(exports.Priority || (exports.Priority = {}));
(function (Status) {
    Status["Unread"] = "Unread";
    Status["Acknowledged"] = "Acknowledged";
    Status["Resolved"] = "Resolved";
    Status["Deleted"] = "Deleted";
    Status["Dismissed"] = "Dismissed";
})(exports.Status || (exports.Status = {}));
(function (NotificationStatus) {
    NotificationStatus["FAILED"] = "FAILED";
    NotificationStatus["SUCCESS"] = "SUCCESS";
    NotificationStatus["MIXED"] = "MIXED";
})(exports.NotificationStatus || (exports.NotificationStatus = {}));
const axios_1 = __importDefault(axios);
const utils_1 = utils;
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://alerts.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title Alerts API
 * @version v1
 * @baseUrl https://alerts.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * No description
             *
             * @tags Alerts
             * @name AlertsFetchAlertsForApplication
             * @request GET:/v1/alerts
             * @secure
             */
            alertsFetchAlertsForApplication: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/alerts`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Alerts
             * @name AlertsCreateAlertForApplication
             * @request POST:/v1/alerts
             * @secure
             */
            alertsCreateAlertForApplication: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/alerts`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Alerts
             * @name AlertsEscalateAlertPriority
             * @request POST:/v1/alerts/{alertId}/escalate
             * @secure
             */
            alertsEscalateAlertPriority: (alertId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/alerts/${alertId}/escalate`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Alerts
             * @name AlertsResolveAlert
             * @request POST:/v1/alerts/{alertId}/resolve
             * @secure
             */
            alertsResolveAlert: (alertId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/alerts/${alertId}/resolve`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Alerts
             * @name AlertsUpdateNotificationStatus
             * @request POST:/v1/alerts/{alertId}/updateNotificationStatus
             * @secure
             */
            alertsUpdateNotificationStatus: (alertId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/alerts/${alertId}/updateNotificationStatus`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Alerts
             * @name AlertsRemoveAlert
             * @request DELETE:/v1/alerts/{alertId}
             * @secure
             */
            alertsRemoveAlert: (alertId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/alerts/${alertId}`, method: 'DELETE', secure: true }, params)),
            /**
             * No description
             *
             * @tags AlertTemplate
             * @name AlertTemplateGetAlertTemplates
             * @request GET:/v1/alerts/templates
             * @secure
             */
            alertTemplateGetAlertTemplates: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/alerts/templates`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags AlertTemplate
             * @name AlertTemplateCreateAlertTemplateResource
             * @request POST:/v1/alerts/templates
             * @secure
             */
            alertTemplateCreateAlertTemplateResource: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/alerts/templates`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags AlertTemplate
             * @name AlertTemplateUpdateAlertTemplateResource
             * @request PUT:/v1/alerts/templates
             * @secure
             */
            alertTemplateUpdateAlertTemplateResource: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/alerts/templates`, method: 'PUT', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags AlertTemplate
             * @name AlertTemplateGetAlertTemplateForKey
             * @request GET:/v1/alerts/templates/{templateKey}
             * @secure
             */
            alertTemplateGetAlertTemplateForKey: (templateKey, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/alerts/templates/${templateKey}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags AlertTemplate
             * @name AlertTemplateRemoveAlertTemplateResource
             * @request DELETE:/v1/alerts/templates/{templateKey}
             * @secure
             */
            alertTemplateRemoveAlertTemplateResource: (templateKey, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/alerts/templates/${templateKey}`, method: 'DELETE', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags IdentityAlerts
             * @name IdentityAlertsFetchAlertsForIdentity
             * @request GET:/v1/identities/{identityId}/alerts
             * @secure
             */
            identityAlertsFetchAlertsForIdentity: (identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/alerts`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags IdentityAlerts
             * @name IdentityAlertsCreateAlertForIdentity
             * @request POST:/v1/identities/{identityId}/alerts
             * @secure
             */
            identityAlertsCreateAlertForIdentity: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/alerts`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags IdentityAlerts
             * @name IdentityAlertsAcknowledgeAlert
             * @request POST:/v1/identities/{identityId}/alerts/{alertId}/acknowledge
             * @secure
             */
            identityAlertsAcknowledgeAlert: (alertId, identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/alerts/${alertId}/acknowledge`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags IdentityAlerts
             * @name IdentityAlertsDismissAlert
             * @request POST:/v1/identities/{identityId}/alerts/{alertId}/dismiss
             * @secure
             */
            identityAlertsDismissAlert: (alertId, identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/alerts/${alertId}/dismiss`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags IdentityAlerts
             * @name IdentityAlertsChangeOwner
             * @request POST:/v1/identities/{identityId}/alerts/{alertId}/changeOwner
             * @secure
             */
            identityAlertsChangeOwner: (identityId, alertId, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/alerts/${alertId}/changeOwner`, method: 'POST', query: query, secure: true, format: 'json' }, params)),
            /**
             * @description The journal is for internal use only
             *
             * @tags Journal
             * @name AlertsJournal
             * @summary Machine JWT Only
             * @request GET:/v1/alerts/journal
             * @secure
             */
            alertsJournal: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/alerts/journal`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Journal
             * @name JournalGetJournalMaxClock
             * @request GET:/v1/alerts/journal/maxClock
             * @secure
             */
            journalGetJournalMaxClock: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/alerts/journal/maxClock`, method: 'GET', secure: true, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;

}(alerts));

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(alerts, exports);

}(alerts$1));

var answers$1 = {};

var answers = {};

(function (exports) {
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.StatusEnum = exports.ActionEnum = void 0;
(function (ActionEnum) {
    ActionEnum["CREATE"] = "CREATE";
    ActionEnum["CHANGE"] = "CHANGE";
    ActionEnum["DELETE"] = "DELETE";
    ActionEnum["SUBMIT"] = "SUBMIT";
    ActionEnum["CHANGE_OWNER"] = "CHANGE_OWNER";
})(exports.ActionEnum || (exports.ActionEnum = {}));
(function (StatusEnum) {
    StatusEnum["CREATED"] = "CREATED";
    StatusEnum["SUBMITTED"] = "SUBMITTED";
    StatusEnum["DELETED"] = "DELETED";
})(exports.StatusEnum || (exports.StatusEnum = {}));
const axios_1 = __importDefault(axios);
const utils_1 = utils;
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://answers.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title Products Answers Service
 * @version v1
 * @baseUrl https://answers.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v2 = {
            /**
             * No description
             *
             * @tags V2Answers
             * @name V2AnswersGetAnswerCollection
             * @request GET:/v2/users/{userId}/answers
             * @secure
             */
            v2AnswersGetAnswerCollection: (userId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/users/${userId}/answers`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags V2Answers
             * @name V2AnswersCreateAnswer
             * @request POST:/v2/users/{userId}/answers
             * @secure
             */
            v2AnswersCreateAnswer: (userId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/users/${userId}/answers`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags V2Answers
             * @name V2AnswersGetSingleAnswer
             * @request GET:/v2/users/{userId}/answers/{answerId}
             * @secure
             */
            v2AnswersGetSingleAnswer: (userId, answerId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/users/${userId}/answers/${answerId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags V2Answers
             * @name V2AnswersReplaceAnswer
             * @request PUT:/v2/users/{userId}/answers/{answerId}
             * @secure
             */
            v2AnswersReplaceAnswer: (userId, answerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/users/${userId}/answers/${answerId}`, method: 'PUT', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags V2Answers
             * @name V2AnswersDeleteAnswer
             * @request DELETE:/v2/users/{userId}/answers/{answerId}
             * @secure
             */
            v2AnswersDeleteAnswer: (userId, answerId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/users/${userId}/answers/${answerId}`, method: 'DELETE', secure: true }, params)),
            /**
             * No description
             *
             * @tags V2Answers
             * @name V2AnswersSubmitAnswer
             * @request POST:/v2/users/{userId}/answers/{answerId}/submitAnswer
             * @secure
             */
            v2AnswersSubmitAnswer: (userId, answerId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/users/${userId}/answers/${answerId}/submitAnswer`, method: 'POST', secure: true, format: 'json' }, params)),
        };
        this.v1 = {
            /**
             * No description
             *
             * @tags Answers
             * @name AnswersGetAnswersByOwner
             * @request GET:/v1/users/{userId}/answers
             * @secure
             */
            answersGetAnswersByOwner: (userId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${userId}/answers`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Answers
             * @name AnswersCreateAnswer
             * @request POST:/v1/users/{userId}/answers
             * @secure
             */
            answersCreateAnswer: (userId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${userId}/answers`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Answers
             * @name AnswersGetSpecificAnswer
             * @request GET:/v1/users/{userId}/answers/{answerId}
             * @secure
             */
            answersGetSpecificAnswer: (userId, answerId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${userId}/answers/${answerId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Answers
             * @name AnswersReplaceAnswer
             * @request PUT:/v1/users/{userId}/answers/{answerId}
             * @secure
             */
            answersReplaceAnswer: (userId, answerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${userId}/answers/${answerId}`, method: 'PUT', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Answers
             * @name AnswersDeleteResource
             * @request DELETE:/v1/users/{userId}/answers/{answerId}
             * @secure
             */
            answersDeleteResource: (userId, answerId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${userId}/answers/${answerId}`, method: 'DELETE', secure: true }, params)),
            /**
             * No description
             *
             * @tags Answers
             * @name AnswersGetS3UploadLinks
             * @request GET:/v1/users/{userId}/answers/{answerId}/getS3UploadLinks
             * @secure
             */
            answersGetS3UploadLinks: (userId, answerId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${userId}/answers/${answerId}/getS3UploadLinks`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Answers
             * @name AnswersGetS3AttachmentDownloadLinks
             * @request GET:/v1/users/{userId}/answers/{answerId}/getS3AttachmentDownloadLinks
             * @secure
             */
            answersGetS3AttachmentDownloadLinks: (userId, answerId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${userId}/answers/${answerId}/getS3AttachmentDownloadLinks`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Answers
             * @name AnswersSubmitAnswer
             * @request POST:/v1/users/{userId}/answers/{answerId}/submitAnswer
             * @secure
             */
            answersSubmitAnswer: (userId, answerId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${userId}/answers/${answerId}/submitAnswer`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Answers
             * @name AnswersChangeOwner
             * @request POST:/v1/users/{userId}/answers/{answerId}/changeOwner
             * @secure
             */
            answersChangeOwner: (userId, answerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${userId}/answers/${answerId}/changeOwner`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags AnswersJournal
             * @name AnswersJournalGetJournalChanges
             * @request GET:/v1/answers/journal
             * @secure
             */
            answersJournalGetJournalChanges: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/answers/journal`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags AnswersJournal
             * @name AnswersJournalGetJournalMaxClock
             * @request GET:/v1/answers/journal/maxClock
             * @secure
             */
            answersJournalGetJournalMaxClock: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/answers/journal/maxClock`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags PublicAnswers
             * @name PublicAnswersCreateAnswer
             * @request POST:/v1/public/users/{userId}/answers
             * @secure
             */
            publicAnswersCreateAnswer: (userId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/public/users/${userId}/answers`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags PublicAnswers
             * @name PublicAnswersReplaceAnswer
             * @request PUT:/v1/public/users/{userId}/answers/{answerId}
             * @secure
             */
            publicAnswersReplaceAnswer: (userId, answerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/public/users/${userId}/answers/${answerId}`, method: 'PUT', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags PublicAnswers
             * @name PublicAnswersSubmitAnswer
             * @request POST:/v1/public/users/{userId}/answers/{answerId}/submitAnswer
             * @secure
             */
            publicAnswersSubmitAnswer: (userId, answerId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/public/users/${userId}/answers/${answerId}/submitAnswer`, method: 'POST', secure: true, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;

}(answers));

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(answers, exports);

}(answers$1));

var applications$1 = {};

var applications = {};

(function (exports) {
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.Action = void 0;
(function (Action) {
    Action["CREATED"] = "CREATED";
    Action["MIGRATED"] = "MIGRATED";
    Action["REMOVED"] = "REMOVED";
    Action["UPDATED_NAME"] = "UPDATED_NAME";
    Action["OWNER_CHANGED"] = "OWNER_CHANGED";
    Action["KEY_UPDATED"] = "KEY_UPDATED";
    Action["EXTERNAL_UPDATED"] = "EXTERNAL_UPDATED";
})(exports.Action || (exports.Action = {}));
const axios_1 = __importDefault(axios);
const utils_1 = utils;
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://applications.api.legalshieldinternal.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title Applications Service
 * @version v1
 * @baseUrl https://applications.api.legalshieldinternal.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * No description
             *
             * @tags Applications
             * @name ApplicationsCreate
             * @request POST:/v1/identities/{identityId}/applications
             * @secure
             */
            applicationsCreate: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/applications`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Applications
             * @name ApplicationsGetByOwner
             * @request GET:/v1/identities/{identityId}/applications
             * @secure
             */
            applicationsGetByOwner: (identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/applications`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Applications
             * @name ApplicationsGetById
             * @request GET:/v1/identities/{identityId}/applications/{applicationId}
             * @secure
             */
            applicationsGetById: (identityId, applicationId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/applications/${applicationId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Applications
             * @name ApplicationsRemove
             * @request DELETE:/v1/identities/{identityId}/applications/{applicationId}
             * @secure
             */
            applicationsRemove: (identityId, applicationId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/applications/${applicationId}`, method: 'DELETE', secure: true }, params)),
            /**
             * No description
             *
             * @tags Applications
             * @name ApplicationsGetById2
             * @request GET:/v1/applications/{applicationId}
             * @secure
             */
            applicationsGetById2: (applicationId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/applications/${applicationId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Applications
             * @name ApplicationsUpdateName
             * @request POST:/v1/identities/{identityId}/applications/{applicationId}/updateName
             * @secure
             */
            applicationsUpdateName: (identityId, applicationId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/applications/${applicationId}/updateName`, method: 'POST', body: data, secure: true, type: FecContentType.Json }, params)),
            /**
             * No description
             *
             * @tags Applications
             * @name ApplicationsUpdateExternal
             * @request POST:/v1/identities/{identityId}/applications/{applicationId}/updateExternal
             * @secure
             */
            applicationsUpdateExternal: (identityId, applicationId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/applications/${applicationId}/updateExternal`, method: 'POST', body: data, secure: true, type: FecContentType.Json }, params)),
            /**
             * No description
             *
             * @tags Applications
             * @name ApplicationsVerify
             * @request POST:/v1/verify
             * @secure
             */
            applicationsVerify: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/verify`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Applications
             * @name ApplicationsGetAllApplications
             * @request GET:/v1/applications
             * @secure
             */
            applicationsGetAllApplications: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/applications`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Applications
             * @name ApplicationsChangeOwner
             * @request POST:/v1/identities/{identityId}/applications/{applicationId}/changeOwner
             * @secure
             */
            applicationsChangeOwner: (identityId, applicationId, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/applications/${applicationId}/changeOwner`, method: 'POST', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Applications
             * @name ApplicationsUpdateKey
             * @request POST:/v1/identities/{identityId}/applications/{applicationId}/updateKey
             * @secure
             */
            applicationsUpdateKey: (identityId, applicationId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/applications/${applicationId}/updateKey`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Applications
             * @name ApplicationsGetJournalChanges
             * @request GET:/v1/applications/journal
             * @secure
             */
            applicationsGetJournalChanges: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/applications/journal`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;

}(applications));

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(applications, exports);

}(applications$1));

var associateMarketing$1 = {};

var associateMarketing = {};

(function (exports) {
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.PhotoApproval = exports.NameApproval = exports.StatusEnum = exports.ActionEnum = exports.ApprovalStatus = void 0;
(function (ApprovalStatus) {
    ApprovalStatus["NO_PENDING"] = "NO_PENDING";
    ApprovalStatus["PENDING"] = "PENDING";
    ApprovalStatus["APPROVED"] = "APPROVED";
    ApprovalStatus["DECLINED"] = "DECLINED";
})(exports.ApprovalStatus || (exports.ApprovalStatus = {}));
(function (ActionEnum) {
    ActionEnum["CREATED"] = "CREATED";
    ActionEnum["CHANGED"] = "CHANGED";
    ActionEnum["CANCELED"] = "CANCELED";
    ActionEnum["CHANGE_OWNER"] = "CHANGE_OWNER";
    ActionEnum["DELETED"] = "DELETED";
    ActionEnum["UPDATE_STATUS"] = "UPDATE_STATUS";
    ActionEnum["PENDING_APPROVAL"] = "PENDING_APPROVAL";
    ActionEnum["APPROVED_PHOTO"] = "APPROVED_PHOTO";
    ActionEnum["APPROVED_NAMES"] = "APPROVED_NAMES";
    ActionEnum["REJECTED_PHOTO"] = "REJECTED_PHOTO";
    ActionEnum["REJECTED_NAMES"] = "REJECTED_NAMES";
    ActionEnum["DELETED_PHOTO"] = "DELETED_PHOTO";
    ActionEnum["UPDATED"] = "UPDATED";
    ActionEnum["CARD_UPDATED"] = "CARD_UPDATED";
    ActionEnum["PRODUCT_MARKETING_UPDATED"] = "PRODUCT_MARKETING_UPDATED";
    ActionEnum["SITENAME_UPDATED"] = "SITENAME_UPDATED";
    ActionEnum["MARKETING_PAGES_UPDATED"] = "MARKETING_PAGES_UPDATED";
    ActionEnum["CHANGE_IDENTITYID"] = "CHANGE_IDENTITYID";
})(exports.ActionEnum || (exports.ActionEnum = {}));
(function (StatusEnum) {
    StatusEnum["ACTIVE"] = "ACTIVE";
    StatusEnum["CANCELED"] = "CANCELED";
    StatusEnum["DELETED"] = "DELETED";
})(exports.StatusEnum || (exports.StatusEnum = {}));
(function (NameApproval) {
    NameApproval["APPROVED"] = "APPROVED";
    NameApproval["REJECTED"] = "REJECTED";
})(exports.NameApproval || (exports.NameApproval = {}));
(function (PhotoApproval) {
    PhotoApproval["APPROVED"] = "APPROVED";
    PhotoApproval["REJECTED"] = "REJECTED";
})(exports.PhotoApproval || (exports.PhotoApproval = {}));
const axios_1 = __importDefault(axios);
const utils_1 = utils;
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://associate-marketing.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title Channels Associates Service Api
 * @version v1
 * @baseUrl https://associate-marketing.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v2 = {
            /**
             * @description No JWTs required
             *
             * @tags AssociateMarketing
             * @name AssociateMarketingGetById
             * @summary No auth required
             * @request GET:/v2/associateMarketing/{id}
             * @secure
             */
            associateMarketingGetById: (id, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/associateMarketing/${id}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * @description No JWTs required
             *
             * @tags AssociateMarketing
             * @name AssociateMarketingGetByOwnerId
             * @summary No auth required
             * @request GET:/v2/associateAgreements/{associateAgreementId}/associateMarketing
             * @secure
             */
            associateMarketingGetByOwnerId: (associateAgreementId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/associateAgreements/${associateAgreementId}/associateMarketing`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * @description Requires user or machine JWTs
             *
             * @tags AssociateMarketing
             * @name AssociateMarketingUpdateCard
             * @summary User or Machine JWT Only
             * @request PUT:/v2/associateMarketing/{id}/updateCard
             * @secure
             */
            associateMarketingUpdateCard: (id, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/associateMarketing/${id}/updateCard`, method: 'PUT', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description Requires internal or machine JWTs
             *
             * @tags AssociateMarketing
             * @name AssociateMarketingUpdatePendingCard
             * @summary Internal or Machine JWT Only
             * @request PUT:/v2/associateMarketing/{id}/updatePendingCard
             * @secure
             */
            associateMarketingUpdatePendingCard: (id, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/associateMarketing/${id}/updatePendingCard`, method: 'PUT', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description Requires user or machine JWTs
             *
             * @tags AssociateMarketing
             * @name AssociateMarketingDeleteAvatarUrl
             * @summary User or Machine JWT Only
             * @request PUT:/v2/associateMarketing/{id}/deleteAvatarUrl
             * @secure
             */
            associateMarketingDeleteAvatarUrl: (id, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/associateMarketing/${id}/deleteAvatarUrl`, method: 'PUT', secure: true, format: 'json' }, params)),
            /**
             * @description Requires internal or machine JWTs
             *
             * @tags AssociateMarketing
             * @name AssociateMarketingCancel
             * @summary Internal or Machine JWT Only
             * @request POST:/v2/associateMarketing/{id}/cancel
             * @secure
             */
            associateMarketingCancel: (id, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/associateMarketing/${id}/cancel`, method: 'POST', secure: true }, params)),
            /**
             * @description Requires user, internal, or machine JWTs
             *
             * @tags AssociateMarketing
             * @name AssociateMarketingUpdateProductMarketing
             * @summary User, Internal, or Machine JWT Only
             * @request POST:/v2/associateMarketing/{id}/updateProductMarketing
             * @secure
             */
            associateMarketingUpdateProductMarketing: (id, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/associateMarketing/${id}/updateProductMarketing`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description Requires user, internal, or machine JWTs
             *
             * @tags AssociateMarketing
             * @name AssociateMarketingUpdateMarketingPages
             * @summary User, Internal, or Machine JWT Only
             * @request POST:/v2/associateMarketing/{id}/updateMarketingPages
             * @secure
             */
            associateMarketingUpdateMarketingPages: (id, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/associateMarketing/${id}/updateMarketingPages`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description Requires user or machine JWTs
             *
             * @tags AssociateMarketing
             * @name AssociateMarketingUpdateSitename
             * @summary User or Machine JWT Only
             * @request POST:/v2/associateMarketing/{id}/updateSitename
             * @secure
             */
            associateMarketingUpdateSitename: (id, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/associateMarketing/${id}/updateSitename`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description Requires user or machine JWTs
             *
             * @tags AssociateMarketing
             * @name AssociateMarketingChangeIdentityId
             * @summary User or Machine JWT Only
             * @request POST:/v2/associateMarketing/{id}/changeIdentityId
             * @secure
             */
            associateMarketingChangeIdentityId: (id, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/associateMarketing/${id}/changeIdentityId`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
        };
        this.v1 = {
            /**
             * No description
             *
             * @tags ChannelsAssociates
             * @name ChannelsAssociatesGetResourcesByOwnerAll
             * @request GET:/v1/channelsAssociates/owner/{channelsAssociateOwnerId}
             * @secure
             */
            channelsAssociatesGetResourcesByOwnerAll: (channelsAssociateOwnerId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/channelsAssociates/owner/${channelsAssociateOwnerId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ChannelsAssociates
             * @name ChannelsAssociatesGetResourcesByOwner
             * @request GET:/v1/identities/{identityId}/channelsAssociates/owner/{channelsAssociateOwnerId}
             * @secure
             */
            channelsAssociatesGetResourcesByOwner: (channelsAssociateOwnerId, identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/channelsAssociates/owner/${channelsAssociateOwnerId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * @description Requires user match or machine JWTs
             *
             * @tags ChannelsAssociates
             * @name ChannelsAssociatesGetByAssociateNumberAll
             * @summary User Match or Machine JWT Only
             * @request GET:/v1/channelsAssociates/getByAssociateNumber/{associateNumber}
             * @secure
             */
            channelsAssociatesGetByAssociateNumberAll: (associateNumber, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/channelsAssociates/getByAssociateNumber/${associateNumber}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * @description Requires user match or machine JWTs
             *
             * @tags ChannelsAssociates
             * @name ChannelsAssociatesGetByAssociateNumber
             * @summary User Match or Machine JWT Only
             * @request GET:/v1/identities/{identityId}/channelsAssociates/getByAssociateNumber/{associateNumber}
             * @secure
             */
            channelsAssociatesGetByAssociateNumber: (associateNumber, identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/channelsAssociates/getByAssociateNumber/${associateNumber}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * @description No JWTs required
             *
             * @tags ChannelsAssociates
             * @name ChannelsAssociatesGetBySitename
             * @summary No auth required
             * @request GET:/v1/channelsAssociates/getBySitename
             * @secure
             */
            channelsAssociatesGetBySitename: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/channelsAssociates/getBySitename`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * @description Requires user match or machine JWTs
             *
             * @tags ChannelsAssociates
             * @name ChannelsAssociatesGetResourceById
             * @summary User Match or Machine JWT Only
             * @request GET:/v1/channelsAssociates/{associateId}
             * @secure
             */
            channelsAssociatesGetResourceById: (associateId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/channelsAssociates/${associateId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * @description Requires user match or machine JWTs
             *
             * @tags ChannelsAssociates
             * @name ChannelsAssociatesGetResourceById2
             * @summary User Match or Machine JWT Only
             * @request GET:/v1/identities/{identityId}/channelsAssociates/{associateId}
             * @secure
             */
            channelsAssociatesGetResourceById2: (associateId, identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/channelsAssociates/${associateId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * @description Requires user match or machine JWTs
             *
             * @tags ChannelsAssociates
             * @name ChannelsAssociatesCreateResource
             * @summary User Match or Machine JWT Only
             * @request POST:/v1/identities/{identityId}/channelsAssociates
             * @secure
             */
            channelsAssociatesCreateResource: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/channelsAssociates`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description Requires user match or machine JWTs
             *
             * @tags ChannelsAssociates
             * @name ChannelsAssociatesUpdateStatus
             * @summary User Match or Machine JWT Only
             * @request POST:/v1/identities/{identityId}/channelsAssociates/{channelsAssociateId}/updateStatus/{newStatus}
             * @secure
             */
            channelsAssociatesUpdateStatus: (identityId, channelsAssociateId, newStatus, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/channelsAssociates/${channelsAssociateId}/updateStatus/${newStatus}`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * @description Requires user match or machine JWTs
             *
             * @tags ChannelsAssociates
             * @name ChannelsAssociatesUpdateResource
             * @summary User Match or Machine JWT Only
             * @request PUT:/v1/identities/{identityId}/channelsAssociates/{channelsAssociateId}
             * @secure
             */
            channelsAssociatesUpdateResource: (channelsAssociateId, identityId, data, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/channelsAssociates/${channelsAssociateId}`, method: 'PUT', query: query, body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description Requires user match or machine JWTs
             *
             * @tags ChannelsAssociates
             * @name ChannelsAssociatesDeleteResource
             * @summary User Match or Machine JWT Only
             * @request DELETE:/v1/identities/{identityId}/channelsAssociates/{channelsAssociateId}
             * @secure
             */
            channelsAssociatesDeleteResource: (identityId, channelsAssociateId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/channelsAssociates/${channelsAssociateId}`, method: 'DELETE', secure: true }, params)),
            /**
             * @description Requires user match, internal match, or machine JWTs
             *
             * @tags ChannelsAssociates
             * @name ChannelsAssociatesUpdateNamesApproval
             * @summary User Match, Internal Match or Machine JWT Only
             * @request PUT:/v1/identities/{identityId}/channelsAssociates/{channelsAssociateId}/approvals/names/updateStatus/{newStatus}
             * @secure
             */
            channelsAssociatesUpdateNamesApproval: (channelsAssociateId, newStatus, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/channelsAssociates/${channelsAssociateId}/approvals/names/updateStatus/${newStatus}`, method: 'PUT', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description Requires user match, internal match, or machine JWTs
             *
             * @tags ChannelsAssociates
             * @name ChannelsAssociatesUpdatePhotoApproval
             * @summary User Match, Internal Match or Machine JWT Only
             * @request PUT:/v1/identities/{identityId}/channelsAssociates/{channelsAssociateId}/approvals/photo/updateStatus/{newStatus}
             * @secure
             */
            channelsAssociatesUpdatePhotoApproval: (channelsAssociateId, newStatus, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/channelsAssociates/${channelsAssociateId}/approvals/photo/updateStatus/${newStatus}`, method: 'PUT', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description Requires user match or machine JWTs
             *
             * @tags ChannelsAssociates
             * @name ChannelsAssociatesUpdateDisplayPhoto
             * @summary User Match or Machine JWT Only
             * @request PUT:/v1/identities/{identityId}/channelsAssociates/{channelsAssociateId}/updateDisplayPhoto
             * @secure
             */
            channelsAssociatesUpdateDisplayPhoto: (channelsAssociateId, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/channelsAssociates/${channelsAssociateId}/updateDisplayPhoto`, method: 'PUT', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description Requires user match or machine JWTs
             *
             * @tags ChannelsAssociates
             * @name ChannelsAssociatesDeleteDisplayPhoto
             * @summary User Match or Machine JWT Only
             * @request PUT:/v1/identities/{identityId}/channelsAssociates/{channelsAssociateId}/deleteDisplayPhoto
             * @secure
             */
            channelsAssociatesDeleteDisplayPhoto: (channelsAssociateId, identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/channelsAssociates/${channelsAssociateId}/deleteDisplayPhoto`, method: 'PUT', secure: true, format: 'json' }, params)),
            /**
             * @description Requires user match or machine JWTs
             *
             * @tags ChannelsAssociates
             * @name ChannelsAssociatesChangeOwner
             * @summary User Match or Machine JWT Only
             * @request POST:/v1/identities/{identityId}/channelsAssociates/{channelsAssociateId}/changeOwner
             * @secure
             */
            channelsAssociatesChangeOwner: (identityId, channelsAssociateId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/channelsAssociates/${channelsAssociateId}/changeOwner`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description Requires user match or machine JWTs
             *
             * @tags ChannelsAssociates
             * @name ChannelsAssociatesUploadPhoto
             * @summary User Match or Machine JWT Only
             * @request PUT:/v1/identities/{identityId}/channelsAssociates/{channelsAssociateId}/uploadPhoto
             * @secure
             */
            channelsAssociatesUploadPhoto: (identityId, channelsAssociateId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/channelsAssociates/${channelsAssociateId}/uploadPhoto`, method: 'PUT', body: data, secure: true, type: FecContentType.FormData }, params)),
            /**
             * @description Requires user match JWT
             *
             * @tags ChannelsAssociates
             * @name ChannelsAssociatesUpdateDisplayMarketingInformation
             * @summary User Match Only
             * @request PUT:/v1/identities/{identityId}/associateMarketing/{associateMarketingId}/updateDisplayMarketingInformation
             * @secure
             */
            channelsAssociatesUpdateDisplayMarketingInformation: (associateMarketingId, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/associateMarketing/${associateMarketingId}/updateDisplayMarketingInformation`, method: 'PUT', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ChannelsAssociatesJournal
             * @name ChannelsAssociatesJournalGetJournalChanges
             * @request GET:/v1/channelsAssociates/journal
             * @secure
             */
            channelsAssociatesJournalGetJournalChanges: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/channelsAssociates/journal`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ChannelsAssociatesJournal
             * @name ChannelsAssociatesJournalGetJournalMaxClock
             * @request GET:/v1/channelsAssociates/maxClock
             * @secure
             */
            channelsAssociatesJournalGetJournalMaxClock: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/channelsAssociates/maxClock`, method: 'GET', secure: true, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;

}(associateMarketing));

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(associateMarketing, exports);

}(associateMarketing$1));

var associates$1 = {};

var associates = {};

(function (exports) {
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.AddressTypeEnum = exports.PlacementStatus = exports.CommissionPaymentStatus = exports.BalanceType = exports.CurrencyCodeEnum = exports.PaymentMethodType = exports.CountryEnum = exports.CommissionPaymentFrequency = exports.AssociateStatus = exports.AssociateAction = void 0;
(function (AssociateAction) {
    AssociateAction["CREATED"] = "CREATED";
    AssociateAction["COMPENSATION_PLAN_CHANGE"] = "COMPENSATION_PLAN_CHANGE";
    AssociateAction["EFFECTIVE_DATE_CHANGE"] = "EFFECTIVE_DATE_CHANGE";
    AssociateAction["STATUS_CHANGE"] = "STATUS_CHANGE";
    AssociateAction["LEVEL_CHANGE"] = "LEVEL_CHANGE";
    AssociateAction["UPLINE_CHANGE"] = "UPLINE_CHANGE";
    AssociateAction["SPONSOR_CHANGE"] = "SPONSOR_CHANGE";
    AssociateAction["B2BGEMCHANGE"] = "B2B_GEM_CHANGE";
    AssociateAction["LEDGER_CHANGE"] = "LEDGER_CHANGE";
    AssociateAction["COMMISSION_PAYMENT_STATUS_CHANGE"] = "COMMISSION_PAYMENT_STATUS_CHANGE";
    AssociateAction["SUBAGENT_ADDED"] = "SUBAGENT_ADDED";
    AssociateAction["SUBAGENT_REMOVED"] = "SUBAGENT_REMOVED";
    AssociateAction["TAX_ID_ADDED"] = "TAX_ID_ADDED";
    AssociateAction["TAX_ID_REMOVED"] = "TAX_ID_REMOVED";
    AssociateAction["COMMISSION_PREFERENCES_CHANGES"] = "COMMISSION_PREFERENCES_CHANGES";
    AssociateAction["ADDRESS_ADDED"] = "ADDRESS_ADDED";
    AssociateAction["ADDRESS_UPDATED"] = "ADDRESS_UPDATED";
    AssociateAction["OWNER_CHANGED"] = "OWNER_CHANGED";
    AssociateAction["DELETED"] = "DELETED";
    AssociateAction["EXECUTIVE_DIRECTOR_CHANGED"] = "EXECUTIVE_DIRECTOR_CHANGED";
    AssociateAction["SENIOR_DIRECTOR_CHANGED"] = "SENIOR_DIRECTOR_CHANGED";
    AssociateAction["ENTITLEMENT_CHANGED"] = "ENTITLEMENT_CHANGED";
    AssociateAction["PLACEMENT_STATUS_CHANGED"] = "PLACEMENT_STATUS_CHANGED";
    AssociateAction["BROKER_QUALIFIED_CHANGED"] = "BROKER_QUALIFIED_CHANGED";
})(exports.AssociateAction || (exports.AssociateAction = {}));
(function (AssociateStatus) {
    AssociateStatus["ACTIVE"] = "ACTIVE";
    AssociateStatus["NEEDS_REVIEW"] = "NEEDS_REVIEW";
    AssociateStatus["SUSPENDED"] = "SUSPENDED";
    AssociateStatus["CANCELLED"] = "CANCELLED";
})(exports.AssociateStatus || (exports.AssociateStatus = {}));
(function (CommissionPaymentFrequency) {
    CommissionPaymentFrequency["DAILY"] = "DAILY";
    CommissionPaymentFrequency["WEEKLY"] = "WEEKLY";
    CommissionPaymentFrequency["MONTHLY"] = "MONTHLY";
})(exports.CommissionPaymentFrequency || (exports.CommissionPaymentFrequency = {}));
(function (CountryEnum) {
    CountryEnum["CAN"] = "CAN";
    CountryEnum["USA"] = "USA";
})(exports.CountryEnum || (exports.CountryEnum = {}));
(function (PaymentMethodType) {
    PaymentMethodType["CHECK"] = "CHECK";
    PaymentMethodType["DIRECT_DEPOSIT"] = "DIRECT_DEPOSIT";
})(exports.PaymentMethodType || (exports.PaymentMethodType = {}));
(function (CurrencyCodeEnum) {
    CurrencyCodeEnum["USD"] = "USD";
    CurrencyCodeEnum["CAD"] = "CAD";
    CurrencyCodeEnum["MXN"] = "MXN";
    CurrencyCodeEnum["GBP"] = "GBP";
})(exports.CurrencyCodeEnum || (exports.CurrencyCodeEnum = {}));
(function (BalanceType) {
    BalanceType["CREDIT"] = "CREDIT";
    BalanceType["DEBIT"] = "DEBIT";
    BalanceType["RESERVE"] = "RESERVE";
})(exports.BalanceType || (exports.BalanceType = {}));
(function (CommissionPaymentStatus) {
    CommissionPaymentStatus["NORMAL"] = "NORMAL";
    CommissionPaymentStatus["HELD_FOR_IRS"] = "HELD_FOR_IRS";
    CommissionPaymentStatus["HELD_BY_ASSOCIATE"] = "HELD_BY_ASSOCIATE";
    CommissionPaymentStatus["HELD_FOR_COMPLAINT"] = "HELD_FOR_COMPLAINT";
    CommissionPaymentStatus["HELD_FOR_DECEASED"] = "HELD_FOR_DECEASED";
    CommissionPaymentStatus["HELD"] = "HELD";
})(exports.CommissionPaymentStatus || (exports.CommissionPaymentStatus = {}));
(function (PlacementStatus) {
    PlacementStatus["AUTOMATIC"] = "AUTOMATIC";
    PlacementStatus["MANUAL"] = "MANUAL";
})(exports.PlacementStatus || (exports.PlacementStatus = {}));
(function (AddressTypeEnum) {
    AddressTypeEnum["MAILING"] = "MAILING";
})(exports.AddressTypeEnum || (exports.AddressTypeEnum = {}));
const axios_1 = __importDefault(axios);
const utils_1 = utils;
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://associates.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title Associates API
 * @version v1
 * @baseUrl https://associates.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * No description
             *
             * @tags AssociateAgreements
             * @name AssociateAgreementsAddAddress
             * @request POST:/v1/identities/{identityId}/associateAgreements/{associateId}/addAddress
             * @secure
             */
            associateAgreementsAddAddress: (identityId, associateId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/associateAgreements/${associateId}/addAddress`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags AssociateAgreements
             * @name AssociateAgreementsUpdateAddress
             * @request POST:/v1/identities/{identityId}/associateAgreements/{associateId}/updateAddress
             * @secure
             */
            associateAgreementsUpdateAddress: (identityId, associateId, data, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/associateAgreements/${associateId}/updateAddress`, method: 'POST', query: query, body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags AssociateAgreements
             * @name AssociateAgreementsChangeOwner
             * @request POST:/v1/associateAgreements/{associateAgreementId}/changeOwner
             * @secure
             */
            associateAgreementsChangeOwner: (associateAgreementId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/associateAgreements/${associateAgreementId}/changeOwner`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags AssociateAgreements
             * @name AssociateAgreementsChangeExecutiveDirector
             * @request POST:/v1/identities/{identityId}/associateAgreements/{associateAgreementId}/changeExecutiveDirector
             * @secure
             */
            associateAgreementsChangeExecutiveDirector: (identityId, associateAgreementId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/associateAgreements/${associateAgreementId}/changeExecutiveDirector`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags AssociateAgreements
             * @name AssociateAgreementsChangeSeniorDirector
             * @request POST:/v1/identities/{identityId}/associateAgreements/{associateAgreementId}/changeSeniorDirector
             * @secure
             */
            associateAgreementsChangeSeniorDirector: (identityId, associateAgreementId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/associateAgreements/${associateAgreementId}/changeSeniorDirector`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags AssociateAgreements
             * @name AssociateAgreementsChangeEntitlement
             * @request POST:/v1/identities/{identityId}/associateAgreements/{associateAgreementId}/changeEntitlement
             * @secure
             */
            associateAgreementsChangeEntitlement: (identityId, associateAgreementId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/associateAgreements/${associateAgreementId}/changeEntitlement`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags AssociateAgreements
             * @name AssociateAgreementsChangePlacementStatus
             * @request POST:/v1/identities/{identityId}/associateAgreements/{associateAgreementId}/changePlacementStatus
             * @secure
             */
            associateAgreementsChangePlacementStatus: (identityId, associateAgreementId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/associateAgreements/${associateAgreementId}/changePlacementStatus`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags AssociateAgreements
             * @name AssociateAgreementsChangeBrokerQualified
             * @request POST:/v1/identities/{identityId}/associateAgreements/{associateId}/changeBrokerQualified
             * @secure
             */
            associateAgreementsChangeBrokerQualified: (identityId, associateId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/associateAgreements/${associateId}/changeBrokerQualified`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Associates
             * @name AssociatesGetAssociate
             * @request GET:/v1/identities/{identityId}/associates/{associateId}
             * @secure
             */
            associatesGetAssociate: (identityId, associateId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/associates/${associateId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Associates
             * @name AssociatesGetAssociate2
             * @request GET:/v1/associates/{associateId}
             * @secure
             */
            associatesGetAssociate2: (associateId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/associates/${associateId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Associates
             * @name AssociatesDeleteAssociate
             * @request DELETE:/v1/associates/{associateId}
             * @secure
             */
            associatesDeleteAssociate: (associateId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/associates/${associateId}`, method: 'DELETE', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Associates
             * @name AssociatesGetAssociates
             * @request GET:/v1/identities/{identityId}/associates
             * @secure
             */
            associatesGetAssociates: (identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/associates`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Associates
             * @name AssociatesCreateAssociate
             * @request POST:/v1/identities/{identityId}/associates
             * @secure
             */
            associatesCreateAssociate: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/associates`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Associates
             * @name AssociatesChangeCompensationPlan
             * @request POST:/v1/identities/{identityId}/associates/{associateId}/changeCompensationPlan
             * @secure
             */
            associatesChangeCompensationPlan: (identityId, associateId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/associates/${associateId}/changeCompensationPlan`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Associates
             * @name AssociatesChangeEffectiveDate
             * @request POST:/v1/identities/{identityId}/associates/{associateId}/changeEffectiveDate
             * @secure
             */
            associatesChangeEffectiveDate: (identityId, associateId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/associates/${associateId}/changeEffectiveDate`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Associates
             * @name AssociatesChangeStatus
             * @request POST:/v1/identities/{identityId}/associates/{associateId}/changeStatus
             * @secure
             */
            associatesChangeStatus: (identityId, associateId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/associates/${associateId}/changeStatus`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Associates
             * @name AssociatesChangeLevel
             * @request POST:/v1/identities/{identityId}/associates/{associateId}/changeLevel
             * @secure
             */
            associatesChangeLevel: (identityId, associateId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/associates/${associateId}/changeLevel`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Associates
             * @name AssociatesChangeUpline
             * @request POST:/v1/identities/{identityId}/associates/{associateId}/changeUpline
             * @secure
             */
            associatesChangeUpline: (identityId, associateId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/associates/${associateId}/changeUpline`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Associates
             * @name AssociatesChangeSponsor
             * @request POST:/v1/identities/{identityId}/associates/{associateId}/changeSponsor
             * @secure
             */
            associatesChangeSponsor: (identityId, associateId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/associates/${associateId}/changeSponsor`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Associates
             * @name AssociatesChangeLedger
             * @request POST:/v1/identities/{identityId}/associates/{associateId}/changeLedger
             * @secure
             */
            associatesChangeLedger: (identityId, associateId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/associates/${associateId}/changeLedger`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Associates
             * @name AssociatesChangeCommissionPaymentStatus
             * @request POST:/v1/identities/{identityId}/associates/{associateId}/changeCommissionPaymentStatus
             * @secure
             */
            associatesChangeCommissionPaymentStatus: (identityId, associateId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/associates/${associateId}/changeCommissionPaymentStatus`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Associates
             * @name AssociatesChangeCommissionPreferences
             * @request POST:/v1/identities/{identityId}/associates/{associateId}/changeCommissionPreferences
             * @secure
             */
            associatesChangeCommissionPreferences: (identityId, associateId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/associates/${associateId}/changeCommissionPreferences`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Associates
             * @name AssociatesAddSubAgent
             * @request POST:/v1/identities/{identityId}/associates/{associateId}/subAgents
             * @secure
             */
            associatesAddSubAgent: (identityId, associateId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/associates/${associateId}/subAgents`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Associates
             * @name AssociatesRemoveSubAgent
             * @request DELETE:/v1/identities/{identityId}/associates/{associateId}/subAgents
             * @secure
             */
            associatesRemoveSubAgent: (identityId, associateId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/associates/${associateId}/subAgents`, method: 'DELETE', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Associates
             * @name AssociatesAddTaxId
             * @request POST:/v1/identities/{identityId}/associates/{associateId}/taxIds
             * @secure
             */
            associatesAddTaxId: (identityId, associateId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/associates/${associateId}/taxIds`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Associates
             * @name AssociatesRemoveTaxId
             * @request DELETE:/v1/identities/{identityId}/associates/{associateId}/taxIds
             * @secure
             */
            associatesRemoveTaxId: (identityId, associateId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/associates/${associateId}/taxIds`, method: 'DELETE', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags AssociatesJournal
             * @name AssociatesJournalGetJournalChanges
             * @request GET:/v1/associates/journal
             * @secure
             */
            associatesJournalGetJournalChanges: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/associates/journal`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags AssociatesJournal
             * @name AssociatesJournalGetJournalMaxClock
             * @request GET:/v1/associates/journal/maxClock
             * @secure
             */
            associatesJournalGetJournalMaxClock: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/associates/journal/maxClock`, method: 'GET', secure: true, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;

}(associates));

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(associates, exports);

}(associates$1));

var atlasQueries$1 = {};

var atlasQueries = {};

(function (exports) {
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = void 0;
const axios_1 = __importDefault(axios);
const utils_1 = utils;
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://atlas-queries.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title Queries Service
 * @version v1
 * @baseUrl https://atlas-queries.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * No description
             *
             * @tags Group
             * @name GroupGroupServiceQueries
             * @request GET:/v1/groups/{groupId}/{serviceName}/{methodName}
             * @secure
             */
            groupGroupServiceQueries: (groupId, serviceName, methodName, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/${serviceName}/${methodName}`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags PublicQueries
             * @name PublicQueriesServiceOriginatedQueries
             * @request GET:/v1/public/queries/{serviceName}/{methodName}
             * @secure
             */
            publicQueriesServiceOriginatedQueries: (serviceName, methodName, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/public/queries/${serviceName}/${methodName}`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Queries
             * @name QueriesInternalServiceQueries
             * @request GET:/v1/queries/{serviceName}/{methodName}
             * @secure
             */
            queriesInternalServiceQueries: (serviceName, methodName, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/queries/${serviceName}/${methodName}`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Queries
             * @name QueriesAuthMatchServiceQueries
             * @request GET:/v1/identities/{identityId}/queries/{serviceName}/{methodName}
             * @secure
             */
            queriesAuthMatchServiceQueries: (identityId, serviceName, methodName, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/queries/${serviceName}/${methodName}`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;

}(atlasQueries));

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(atlasQueries, exports);

}(atlasQueries$1));

var atlasReports$1 = {};

var atlasReports = {};

(function (exports) {
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.WorkerStatus = exports.DataFormat = void 0;
(function (DataFormat) {
    DataFormat["JSON"] = "JSON";
    DataFormat["CSV"] = "CSV";
})(exports.DataFormat || (exports.DataFormat = {}));
(function (WorkerStatus) {
    WorkerStatus["ACTIVE"] = "ACTIVE";
    WorkerStatus["PAUSED"] = "PAUSED";
})(exports.WorkerStatus || (exports.WorkerStatus = {}));
const axios_1 = __importDefault(axios);
const utils_1 = utils;
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://atlas-reports.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title Queries Service
 * @version v1
 * @baseUrl https://atlas-reports.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * No description
             *
             * @tags Reporting
             * @name ReportingCreateReport
             * @request POST:/v1/reporting
             * @secure
             */
            reportingCreateReport: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/reporting`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Reporting
             * @name ReportingGetKeys
             * @request GET:/v1/reporting/keys
             * @secure
             */
            reportingGetKeys: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/reporting/keys`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Reporting
             * @name ReportingGetReport
             * @request GET:/v1/reporting/{reportId}
             * @secure
             */
            reportingGetReport: (reportId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/reporting/${reportId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Reporting
             * @name ReportingDeleteReport
             * @request DELETE:/v1/reporting/{reportId}
             * @secure
             */
            reportingDeleteReport: (reportId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/reporting/${reportId}`, method: 'DELETE', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Reporting
             * @name ReportingGetOrCreateReport
             * @request GET:/v1/reporting/{serviceName}/{methodName}
             * @secure
             */
            reportingGetOrCreateReport: (serviceName, methodName, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/reporting/${serviceName}/${methodName}`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ReportingWorker
             * @name ReportingWorkerGetWorker
             * @request GET:/v1/worker
             * @secure
             */
            reportingWorkerGetWorker: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/worker`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ReportingWorker
             * @name ReportingWorkerPause
             * @request POST:/v1/worker/pause
             * @secure
             */
            reportingWorkerPause: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/worker/pause`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ReportingWorker
             * @name ReportingWorkerActivate
             * @request POST:/v1/worker/activate
             * @secure
             */
            reportingWorkerActivate: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/worker/activate`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ReportingWorker
             * @name ReportingWorkerUpdateTimer
             * @request POST:/v1/worker/timer/{loopTimer}
             * @secure
             */
            reportingWorkerUpdateTimer: (loopTimer, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/worker/timer/${loopTimer}`, method: 'POST', secure: true, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;

}(atlasReports));

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(atlasReports, exports);

}(atlasReports$1));

var autoComments$1 = {};

var autoComments = {};

(function (exports) {
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.CommentAction = exports.SubjectType = exports.CommentPriority = void 0;
(function (CommentPriority) {
    CommentPriority["LOW"] = "LOW";
    CommentPriority["MEDIUM"] = "MEDIUM";
    CommentPriority["HIGH"] = "HIGH";
})(exports.CommentPriority || (exports.CommentPriority = {}));
(function (SubjectType) {
    SubjectType["ENTITLEMENT"] = "ENTITLEMENT";
    SubjectType["BRANCH"] = "BRANCH";
})(exports.SubjectType || (exports.SubjectType = {}));
(function (CommentAction) {
    CommentAction["CREATED"] = "CREATED";
    CommentAction["OWNER_CHANGED"] = "OWNER_CHANGED";
})(exports.CommentAction || (exports.CommentAction = {}));
const axios_1 = __importDefault(axios);
const utils_1 = utils;
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://auto-comments.api.legalshieldinternal.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title Atlas ClassicAutoComment Service API
 * @version v1
 * @baseUrl https://auto-comments.api.legalshieldinternal.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * No description
             *
             * @tags ClassicAutoComments
             * @name ClassicAutoCommentsCreateClassicAutoComment
             * @request POST:/v1/identities/{identityId}/autoComments
             * @secure
             */
            classicAutoCommentsCreateClassicAutoComment: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/autoComments`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ClassicAutoComments
             * @name ClassicAutoCommentsFetchAutoCommentsWithIdentityId
             * @request GET:/v1/identities/{identityId}/autoComments
             * @secure
             */
            classicAutoCommentsFetchAutoCommentsWithIdentityId: (identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/autoComments`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ClassicAutoComments
             * @name ClassicAutoCommentsFetchAutoCommentsWithCommentId
             * @request GET:/v1/identities/{identityId}/autoComments/{commentId}
             * @secure
             */
            classicAutoCommentsFetchAutoCommentsWithCommentId: (identityId, commentId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/autoComments/${commentId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ClassicAutoComments
             * @name ClassicAutoCommentsChangeOwner
             * @request POST:/v1/identities/{identityId}/autoComments/{commentId}/changeOwner
             * @secure
             */
            classicAutoCommentsChangeOwner: (identityId, commentId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/autoComments/${commentId}/changeOwner`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;

}(autoComments));

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(autoComments, exports);

}(autoComments$1));

var benefitcohorts$1 = {};

var benefitcohorts = {};

(function (exports) {
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = void 0;
const axios_1 = __importDefault(axios);
const utils_1 = utils;
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://benefitcohorts.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title BenefitCohorts Service Api
 * @version v1
 * @baseUrl https://benefitcohorts.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * No description
             *
             * @tags BenefitCohorts
             * @name BenefitCohortsGetBenefitCohortsByOwner
             * @request GET:/v1/identities/{identityId}/benefitCohorts
             * @secure
             */
            benefitCohortsGetBenefitCohortsByOwner: (identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/benefitCohorts`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags BenefitCohorts
             * @name BenefitCohortsCreateBenefitCohort
             * @request POST:/v1/identities/{identityId}/benefitCohorts
             * @secure
             */
            benefitCohortsCreateBenefitCohort: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/benefitCohorts`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags BenefitCohorts
             * @name BenefitCohortsGetBenefitCohortById
             * @request GET:/v1/identities/{identityId}/benefitCohorts/{benefitCohortId}
             * @secure
             */
            benefitCohortsGetBenefitCohortById: (identityId, benefitCohortId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/benefitCohorts/${benefitCohortId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags BenefitCohorts
             * @name BenefitCohortsAddBenefits
             * @request POST:/v1/identities/{identityId}/benefitCohorts/{benefitCohortId}/addBenefits
             * @secure
             */
            benefitCohortsAddBenefits: (identityId, benefitCohortId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/benefitCohorts/${benefitCohortId}/addBenefits`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags BenefitCohorts
             * @name BenefitCohortsRemoveBenefits
             * @request POST:/v1/identities/{identityId}/benefitCohorts/{benefitCohortId}/removeBenefits
             * @secure
             */
            benefitCohortsRemoveBenefits: (identityId, benefitCohortId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/benefitCohorts/${benefitCohortId}/removeBenefits`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Health
             * @name HealthGet
             * @request GET:/v1/health
             * @secure
             */
            healthGet: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/health`, method: 'GET', secure: true }, params)),
            /**
             * No description
             *
             * @tags BenefitCohortsJournal
             * @name BenefitCohortsJournalGetJournalChanges
             * @request GET:/v1/benefitcohorts/journal
             * @secure
             */
            benefitCohortsJournalGetJournalChanges: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/benefitcohorts/journal`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;

}(benefitcohorts));

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(benefitcohorts, exports);

}(benefitcohorts$1));

var benefits$1 = {};

var benefits = {};

(function (exports) {
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.AuthorizedUserTypeEnum = exports.TrendProductType = exports.StatusEnum = exports.ActionEnum = void 0;
(function (ActionEnum) {
    ActionEnum["CREATE"] = "CREATE";
    ActionEnum["ACTIVATE"] = "ACTIVATE";
    ActionEnum["DEACTIVATE"] = "DEACTIVATE";
    ActionEnum["DELETE"] = "DELETE";
    ActionEnum["CHANGE"] = "CHANGE";
    ActionEnum["UPDATE_DESCRIPTIONS"] = "UPDATE_DESCRIPTIONS";
    ActionEnum["UPDATE_FRIENDLY_TRANSLATIONS"] = "UPDATE_FRIENDLY_TRANSLATIONS";
    ActionEnum["UPDATE_NAME"] = "UPDATE_NAME";
    ActionEnum["UPDATE_INTERNAL_NAME"] = "UPDATE_INTERNAL_NAME";
    ActionEnum["UPDATE_PROVISIONING_METADATA"] = "UPDATE_PROVISIONING_METADATA";
    ActionEnum["UPDATE_MARKETING_DATA"] = "UPDATE_MARKETING_DATA";
    ActionEnum["UPDATE_CATEGORIES"] = "UPDATE_CATEGORIES";
    ActionEnum["UPDATE_PROVISIONING"] = "UPDATE_PROVISIONING";
})(exports.ActionEnum || (exports.ActionEnum = {}));
(function (StatusEnum) {
    StatusEnum["CREATED"] = "CREATED";
    StatusEnum["ACTIVE"] = "ACTIVE";
    StatusEnum["INACTIVE"] = "INACTIVE";
    StatusEnum["DELETE"] = "DELETE";
})(exports.StatusEnum || (exports.StatusEnum = {}));
(function (TrendProductType) {
    TrendProductType["INDIVIDUAL"] = "INDIVIDUAL";
    TrendProductType["FAMILY"] = "FAMILY";
})(exports.TrendProductType || (exports.TrendProductType = {}));
(function (AuthorizedUserTypeEnum) {
    AuthorizedUserTypeEnum["PRIMARY"] = "PRIMARY";
    AuthorizedUserTypeEnum["SPOUSE"] = "SPOUSE";
    AuthorizedUserTypeEnum["DEPENDENT"] = "DEPENDENT";
    AuthorizedUserTypeEnum["NORMAL_USER"] = "NORMAL_USER";
    AuthorizedUserTypeEnum["OWNER"] = "OWNER";
    AuthorizedUserTypeEnum["CO_OWNER"] = "CO_OWNER";
    AuthorizedUserTypeEnum["SECONDARY"] = "SECONDARY";
    AuthorizedUserTypeEnum["TERTIARY"] = "TERTIARY";
    AuthorizedUserTypeEnum["ELDER"] = "ELDER";
    AuthorizedUserTypeEnum["ANY"] = "ANY";
    AuthorizedUserTypeEnum["ALL"] = "ALL";
})(exports.AuthorizedUserTypeEnum || (exports.AuthorizedUserTypeEnum = {}));
const axios_1 = __importDefault(axios);
const utils_1 = utils;
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://benefits.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title Benefits Service API
 * @version v1
 * @baseUrl https://benefits.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * No description
             *
             * @tags Benefits
             * @name BenefitsGetBenefits
             * @request GET:/v1/benefits
             * @secure
             */
            benefitsGetBenefits: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/benefits`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Benefits
             * @name BenefitsCreateBenefit
             * @request POST:/v1/benefits
             * @secure
             */
            benefitsCreateBenefit: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/benefits`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Benefits
             * @name BenefitsGetBenefit
             * @request GET:/v1/benefits/{benefitId}
             * @secure
             */
            benefitsGetBenefit: (benefitId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/benefits/${benefitId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Benefits
             * @name BenefitsUpdateBenefit
             * @request PUT:/v1/benefits/{benefitId}
             * @secure
             */
            benefitsUpdateBenefit: (benefitId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/benefits/${benefitId}`, method: 'PUT', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Benefits
             * @name BenefitsDeleteBenefit
             * @request DELETE:/v1/benefits/{benefitId}
             * @secure
             */
            benefitsDeleteBenefit: (benefitId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/benefits/${benefitId}`, method: 'DELETE', secure: true }, params)),
            /**
             * No description
             *
             * @tags Benefits
             * @name BenefitsGetBenefitsByList
             * @request POST:/v1/benefits/getBenefitsByIdList
             * @secure
             */
            benefitsGetBenefitsByList: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/benefits/getBenefitsByIdList`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Benefits
             * @name BenefitsActivateStatus
             * @request POST:/v1/benefits/{benefitId}/activate
             * @secure
             */
            benefitsActivateStatus: (benefitId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/benefits/${benefitId}/activate`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Benefits
             * @name BenefitsCancelStatus
             * @request POST:/v1/benefits/{benefitId}/cancel
             * @secure
             */
            benefitsCancelStatus: (benefitId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/benefits/${benefitId}/cancel`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Benefits
             * @name BenefitsUpdateDescriptions
             * @request POST:/v1/benefits/{benefitId}/updateDescriptions
             * @secure
             */
            benefitsUpdateDescriptions: (benefitId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/benefits/${benefitId}/updateDescriptions`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Benefits
             * @name BenefitsUpdateFriendlyTranslations
             * @request POST:/v1/benefits/{benefitId}/updateFriendlyTranslations
             * @secure
             */
            benefitsUpdateFriendlyTranslations: (benefitId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/benefits/${benefitId}/updateFriendlyTranslations`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Benefits
             * @name BenefitsUpdateNames
             * @request POST:/v1/benefits/{benefitId}/updateName
             * @secure
             */
            benefitsUpdateNames: (benefitId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/benefits/${benefitId}/updateName`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Benefits
             * @name BenefitsUpdateInternalName
             * @request POST:/v1/benefits/{benefitId}/updateInternalName
             * @secure
             */
            benefitsUpdateInternalName: (benefitId, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/benefits/${benefitId}/updateInternalName`, method: 'POST', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Benefits
             * @name BenefitsUpdateProvisioningMetaData
             * @request POST:/v1/benefits/{benefitId}/updateProvisioningMetaData
             * @secure
             */
            benefitsUpdateProvisioningMetaData: (benefitId, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/benefits/${benefitId}/updateProvisioningMetaData`, method: 'POST', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Benefits
             * @name BenefitsUpdateMarketingData
             * @request POST:/v1/benefits/{benefitId}/updateMarketingData
             * @secure
             */
            benefitsUpdateMarketingData: (benefitId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/benefits/${benefitId}/updateMarketingData`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Benefits
             * @name BenefitsUpdateCategories
             * @request POST:/v1/benefits/{benefitId}/updateCategories
             * @secure
             */
            benefitsUpdateCategories: (benefitId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/benefits/${benefitId}/updateCategories`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Benefits
             * @name BenefitsUpdateProvisioning
             * @request POST:/v1/benefits/{benefitId}/updateProvisioning
             * @secure
             */
            benefitsUpdateProvisioning: (benefitId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/benefits/${benefitId}/updateProvisioning`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags BenefitsJournal
             * @name BenefitsJournalGetJournalChanges
             * @request GET:/v1/benefits/journal
             * @secure
             */
            benefitsJournalGetJournalChanges: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/benefits/journal`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags BenefitsJournal
             * @name BenefitsJournalGetMaxClock
             * @request GET:/v1/benefits/maxClock
             * @secure
             */
            benefitsJournalGetMaxClock: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/benefits/maxClock`, method: 'GET', secure: true, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;

}(benefits));

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(benefits, exports);

}(benefits$1));

var branches$1 = {};

var branches = {};

(function (exports) {
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.RoleEnum = exports.NetworkEnum = exports.AreaOfLawEnum = exports.EmailTypeEnum = exports.PhoneTypeEnum = exports.CountryEnum = exports.StateEnum = exports.BranchType = exports.ActionEnum = exports.StatusEnum = void 0;
(function (StatusEnum) {
    StatusEnum["CREATED"] = "CREATED";
    StatusEnum["ACTIVATED"] = "ACTIVATED";
    StatusEnum["DEACTIVATED"] = "DEACTIVATED";
    StatusEnum["DELETED"] = "DELETED";
})(exports.StatusEnum || (exports.StatusEnum = {}));
(function (ActionEnum) {
    ActionEnum["CREATE"] = "CREATE";
    ActionEnum["ACTIVATE_BRANCH"] = "ACTIVATE_BRANCH";
    ActionEnum["DEACTIVATE_BRANCH"] = "DEACTIVATE_BRANCH";
    ActionEnum["DELETE"] = "DELETE";
    ActionEnum["CHANGE"] = "CHANGE";
    ActionEnum["UPDATE_ADDRESS"] = "UPDATE_ADDRESS";
    ActionEnum["UPDATE_SERVICE_AREAS"] = "UPDATE_SERVICE_AREAS";
    ActionEnum["UPDATE_ABOUT_US_TEXT"] = "UPDATE_ABOUT_US_TEXT";
    ActionEnum["UPDATE_PERMISSIONS"] = "UPDATE_PERMISSIONS";
    ActionEnum["UPDATE_PHONES"] = "UPDATE_PHONES";
    ActionEnum["UPDATE_PROVIDER_IDS"] = "UPDATE_PROVIDER_IDS";
    ActionEnum["UPDATE_REFERRAL_PROVIDER_IDS"] = "UPDATE_REFERRAL_PROVIDER_IDS";
    ActionEnum["UPDATE_BRANCH_NAME"] = "UPDATE_BRANCH_NAME";
    ActionEnum["UPDATE_TIME_ZONE"] = "UPDATE_TIME_ZONE";
    ActionEnum["UPDATE_WEBSITE_URL"] = "UPDATE_WEBSITE_URL";
    ActionEnum["UPDATE_WELCOME_VIDEO_URL"] = "UPDATE_WELCOME_VIDEO_URL";
    ActionEnum["UPDATE_EMAIL_ADDRESS"] = "UPDATE_EMAIL_ADDRESS";
    ActionEnum["UPDATE_BRANCH_TYPES"] = "UPDATE_BRANCH_TYPES";
    ActionEnum["UPDATE_EXTERNAL_ID"] = "UPDATE_EXTERNAL_ID";
    ActionEnum["UPDATE_AREAS_OF_LAW"] = "UPDATE_AREAS_OF_LAW";
    ActionEnum["UPDATE_YEAR_FOUNDED"] = "UPDATE_YEAR_FOUNDED";
    ActionEnum["UPDATE_YEAR_JOINED"] = "UPDATE_YEAR_JOINED";
    ActionEnum["LINK_PROVIDER"] = "LINK_PROVIDER";
    ActionEnum["UNLINK_PROVIDER"] = "UNLINK_PROVIDER";
    ActionEnum["UPDATE_NETWORK"] = "UPDATE_NETWORK";
    ActionEnum["UPDATE_CASE_ID_PREFIX"] = "UPDATE_CASE_ID_PREFIX";
    ActionEnum["UPDATE_UNAVAILABLE_DATES"] = "UPDATE_UNAVAILABLE_DATES";
    ActionEnum["UPDATE_PROFILE_PICTURE_URL"] = "UPDATE_PROFILE_PICTURE_URL";
})(exports.ActionEnum || (exports.ActionEnum = {}));
(function (BranchType) {
    BranchType["PARTNER"] = "PARTNER";
    BranchType["REFERRAL"] = "REFERRAL";
    BranchType["OTHER"] = "OTHER";
})(exports.BranchType || (exports.BranchType = {}));
(function (StateEnum) {
    StateEnum["AB"] = "AB";
    StateEnum["AK"] = "AK";
    StateEnum["AL"] = "AL";
    StateEnum["AR"] = "AR";
    StateEnum["AZ"] = "AZ";
    StateEnum["BC"] = "BC";
    StateEnum["CA"] = "CA";
    StateEnum["CA2"] = "CA_2";
    StateEnum["CO"] = "CO";
    StateEnum["CT"] = "CT";
    StateEnum["DC"] = "DC";
    StateEnum["DE"] = "DE";
    StateEnum["FL"] = "FL";
    StateEnum["GA"] = "GA";
    StateEnum["GU"] = "GU";
    StateEnum["HI"] = "HI";
    StateEnum["IA"] = "IA";
    StateEnum["ID"] = "ID";
    StateEnum["IL"] = "IL";
    StateEnum["IN"] = "IN";
    StateEnum["KS"] = "KS";
    StateEnum["KY"] = "KY";
    StateEnum["LA"] = "LA";
    StateEnum["LS"] = "LS";
    StateEnum["MA"] = "MA";
    StateEnum["MB"] = "MB";
    StateEnum["MD"] = "MD";
    StateEnum["ME"] = "ME";
    StateEnum["MI"] = "MI";
    StateEnum["MN"] = "MN";
    StateEnum["MO"] = "MO";
    StateEnum["MS"] = "MS";
    StateEnum["MT"] = "MT";
    StateEnum["NB"] = "NB";
    StateEnum["NC"] = "NC";
    StateEnum["ND"] = "ND";
    StateEnum["NE"] = "NE";
    StateEnum["NF"] = "NF";
    StateEnum["NH"] = "NH";
    StateEnum["NJ"] = "NJ";
    StateEnum["NL"] = "NL";
    StateEnum["NM"] = "NM";
    StateEnum["NS"] = "NS";
    StateEnum["NT"] = "NT";
    StateEnum["NU"] = "NU";
    StateEnum["NV"] = "NV";
    StateEnum["NY"] = "NY";
    StateEnum["OH"] = "OH";
    StateEnum["OK"] = "OK";
    StateEnum["ON"] = "ON";
    StateEnum["OR"] = "OR";
    StateEnum["PA"] = "PA";
    StateEnum["PE"] = "PE";
    StateEnum["PR"] = "PR";
    StateEnum["QC"] = "QC";
    StateEnum["RI"] = "RI";
    StateEnum["SC"] = "SC";
    StateEnum["SD"] = "SD";
    StateEnum["SF"] = "SF";
    StateEnum["SK"] = "SK";
    StateEnum["TN"] = "TN";
    StateEnum["TX"] = "TX";
    StateEnum["UT"] = "UT";
    StateEnum["VA"] = "VA";
    StateEnum["VI"] = "VI";
    StateEnum["VT"] = "VT";
    StateEnum["WA"] = "WA";
    StateEnum["WI"] = "WI";
    StateEnum["WV"] = "WV";
    StateEnum["WY"] = "WY";
    StateEnum["YT"] = "YT";
})(exports.StateEnum || (exports.StateEnum = {}));
(function (CountryEnum) {
    CountryEnum["CAN"] = "CAN";
    CountryEnum["USA"] = "USA";
})(exports.CountryEnum || (exports.CountryEnum = {}));
(function (PhoneTypeEnum) {
    PhoneTypeEnum["OFFICE"] = "OFFICE";
    PhoneTypeEnum["TOLL_FREE"] = "TOLL_FREE";
    PhoneTypeEnum["FAX"] = "FAX";
    PhoneTypeEnum["TALKDESK_CALLER_ID"] = "TALKDESK_CALLER_ID";
    PhoneTypeEnum["OTHER"] = "OTHER";
})(exports.PhoneTypeEnum || (exports.PhoneTypeEnum = {}));
(function (EmailTypeEnum) {
    EmailTypeEnum["DOCUMENTS"] = "DOCUMENTS";
    EmailTypeEnum["WILLS"] = "WILLS";
    EmailTypeEnum["PRIMARY"] = "PRIMARY";
    EmailTypeEnum["MANAGEMENT"] = "MANAGEMENT";
})(exports.EmailTypeEnum || (exports.EmailTypeEnum = {}));
(function (AreaOfLawEnum) {
    AreaOfLawEnum["AM"] = "AM";
    AreaOfLawEnum["AD"] = "AD";
    AreaOfLawEnum["AF"] = "AF";
    AreaOfLawEnum["AA"] = "AA";
    AreaOfLawEnum["BK"] = "BK";
    AreaOfLawEnum["BR"] = "BR";
    AreaOfLawEnum["BD"] = "BD";
    AreaOfLawEnum["BT"] = "BT";
    AreaOfLawEnum["BS"] = "BS";
    AreaOfLawEnum["CU"] = "CU";
    AreaOfLawEnum["CS"] = "CS";
    AreaOfLawEnum["CL"] = "CL";
    AreaOfLawEnum["CC"] = "CC";
    AreaOfLawEnum["CO"] = "CO";
    AreaOfLawEnum["CN"] = "CN";
    AreaOfLawEnum["CF"] = "CF";
    AreaOfLawEnum["CT"] = "CT";
    AreaOfLawEnum["CY"] = "CY";
    AreaOfLawEnum["CP"] = "CP";
    AreaOfLawEnum["CD"] = "CD";
    AreaOfLawEnum["CR"] = "CR";
    AreaOfLawEnum["DE"] = "DE";
    AreaOfLawEnum["DI"] = "DI";
    AreaOfLawEnum["DU"] = "DU";
    AreaOfLawEnum["DV"] = "DV";
    AreaOfLawEnum["ED"] = "ED";
    AreaOfLawEnum["EL"] = "EL";
    AreaOfLawEnum["EM"] = "EM";
    AreaOfLawEnum["ET"] = "ET";
    AreaOfLawEnum["EP"] = "EP";
    AreaOfLawEnum["FL"] = "FL";
    AreaOfLawEnum["FW"] = "FW";
    AreaOfLawEnum["FA"] = "FA";
    AreaOfLawEnum["FC"] = "FC";
    AreaOfLawEnum["FR"] = "FR";
    AreaOfLawEnum["GA"] = "GA";
    AreaOfLawEnum["GL"] = "GL";
    AreaOfLawEnum["GC"] = "GC";
    AreaOfLawEnum["HL"] = "HL";
    AreaOfLawEnum["IT"] = "IT";
    AreaOfLawEnum["IM"] = "IM";
    AreaOfLawEnum["ID"] = "ID";
    AreaOfLawEnum["IN"] = "IN";
    AreaOfLawEnum["JV"] = "JV";
    AreaOfLawEnum["LL"] = "LL";
    AreaOfLawEnum["LT"] = "LT";
    AreaOfLawEnum["LM"] = "LM";
    AreaOfLawEnum["LN"] = "LN";
    AreaOfLawEnum["MM"] = "MM";
    AreaOfLawEnum["ML"] = "ML";
    AreaOfLawEnum["MR"] = "MR";
    AreaOfLawEnum["MD"] = "MD";
    AreaOfLawEnum["VD"] = "VD";
    AreaOfLawEnum["NC"] = "NC";
    AreaOfLawEnum["OG"] = "OG";
    AreaOfLawEnum["PC"] = "PC";
    AreaOfLawEnum["PT"] = "PT";
    AreaOfLawEnum["PN"] = "PN";
    AreaOfLawEnum["PD"] = "PD";
    AreaOfLawEnum["PI"] = "PI";
    AreaOfLawEnum["PA"] = "PA";
    AreaOfLawEnum["PU"] = "PU";
    AreaOfLawEnum["PR"] = "PR";
    AreaOfLawEnum["PL"] = "PL";
    AreaOfLawEnum["PY"] = "PY";
    AreaOfLawEnum["TA"] = "TA";
    AreaOfLawEnum["PS"] = "PS";
    AreaOfLawEnum["RE"] = "RE";
    AreaOfLawEnum["RC"] = "RC";
    AreaOfLawEnum["RF"] = "RF";
    AreaOfLawEnum["RP"] = "RP";
    AreaOfLawEnum["SC"] = "SC";
    AreaOfLawEnum["SS"] = "SS";
    AreaOfLawEnum["SN"] = "SN";
    AreaOfLawEnum["SL"] = "SL";
    AreaOfLawEnum["TX"] = "TX";
    AreaOfLawEnum["TS"] = "TS";
    AreaOfLawEnum["TM"] = "TM";
    AreaOfLawEnum["TR"] = "TR";
    AreaOfLawEnum["TU"] = "TU";
    AreaOfLawEnum["UA"] = "UA";
    AreaOfLawEnum["VE"] = "VE";
    AreaOfLawEnum["VA"] = "VA";
    AreaOfLawEnum["WC"] = "WC";
    AreaOfLawEnum["WD"] = "WD";
    AreaOfLawEnum["ZP"] = "ZP";
    AreaOfLawEnum["WL"] = "WL";
})(exports.AreaOfLawEnum || (exports.AreaOfLawEnum = {}));
(function (NetworkEnum) {
    NetworkEnum["LEGALSHIELD"] = "LEGALSHIELD";
    NetworkEnum["CLC"] = "CLC";
})(exports.NetworkEnum || (exports.NetworkEnum = {}));
(function (RoleEnum) {
    RoleEnum["ADMIN"] = "ADMIN";
    RoleEnum["CSR"] = "CSR";
    RoleEnum["LAWYER"] = "LAWYER";
    RoleEnum["RESOLUTION_LAWYER"] = "RESOLUTION_LAWYER";
    RoleEnum["RESOLUTION_CSR"] = "RESOLUTION_CSR";
    RoleEnum["REFERRAL_CLERK"] = "REFERRAL_CLERK";
    RoleEnum["PPLSI_MANAGEMENT"] = "PPLSI_MANAGEMENT";
    RoleEnum["INTAKES_VIEW"] = "INTAKES_VIEW";
    RoleEnum["DECOMMISSIONED_ADMIN"] = "DECOMMISSIONED_ADMIN";
})(exports.RoleEnum || (exports.RoleEnum = {}));
const axios_1 = __importDefault(axios);
const utils_1 = utils;
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://branches.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title Branches Service Api
 * @version v1
 * @baseUrl https://branches.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesGetBranchesByOwner
             * @request GET:/v1/branches
             * @secure
             */
            branchesGetBranchesByOwner: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesCreateBranch
             * @request POST:/v1/branches
             * @secure
             */
            branchesCreateBranch: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesGetSpecificBranch
             * @request GET:/v1/branches/{branchId}
             * @secure
             */
            branchesGetSpecificBranch: (branchId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesDeleteResource
             * @request DELETE:/v1/branches/{branchId}
             * @secure
             */
            branchesDeleteResource: (branchId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}`, method: 'DELETE', secure: true }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesGetBranchesByList
             * @request POST:/v1/branches/getBranchesByIdList
             * @secure
             */
            branchesGetBranchesByList: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/getBranchesByIdList`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesUpdateAddress
             * @request POST:/v1/branches/{branchId}/updateAddress
             * @secure
             */
            branchesUpdateAddress: (branchId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}/updateAddress`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesUpdateServiceAreas
             * @request POST:/v1/branches/{branchId}/updateServiceAreas
             * @secure
             */
            branchesUpdateServiceAreas: (branchId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}/updateServiceAreas`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesUpdateAboutUsText
             * @request POST:/v1/branches/{branchId}/updateAboutUsText
             * @secure
             */
            branchesUpdateAboutUsText: (branchId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}/updateAboutUsText`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesUpdatePhones
             * @request POST:/v1/branches/{branchId}/updatePhones
             * @secure
             */
            branchesUpdatePhones: (branchId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}/updatePhones`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesUpdateProviderIds
             * @request POST:/v1/branches/{branchId}/updateProviderIds
             * @secure
             */
            branchesUpdateProviderIds: (branchId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}/updateProviderIds`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesAddProviderId
             * @request POST:/v1/branches/{branchId}/addProviderId
             * @secure
             */
            branchesAddProviderId: (branchId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}/addProviderId`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesRemoveProviderId
             * @request POST:/v1/branches/{branchId}/removeProviderId
             * @secure
             */
            branchesRemoveProviderId: (branchId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}/removeProviderId`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesUpdateReferralProviderIds
             * @request POST:/v1/branches/{branchId}/updateReferralProviderIds
             * @secure
             */
            branchesUpdateReferralProviderIds: (branchId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}/updateReferralProviderIds`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesUpdateName
             * @request POST:/v1/branches/{branchId}/updateName
             * @secure
             */
            branchesUpdateName: (branchId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}/updateName`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesUpdateEmailAddress
             * @request POST:/v1/branches/{branchId}/updateEmailAddress
             * @deprecated
             * @secure
             */
            branchesUpdateEmailAddress: (branchId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}/updateEmailAddress`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesUpdateEmails
             * @request POST:/v1/branches/{branchId}/updateEmails
             * @secure
             */
            branchesUpdateEmails: (branchId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}/updateEmails`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesUpdateEmail
             * @request POST:/v1/branches/{branchId}/updateEmail
             * @secure
             */
            branchesUpdateEmail: (branchId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}/updateEmail`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesAddEmail
             * @request POST:/v1/branches/{branchId}/addEmail
             * @secure
             */
            branchesAddEmail: (branchId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}/addEmail`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesRemoveEmail
             * @request POST:/v1/branches/{branchId}/removeEmail
             * @secure
             */
            branchesRemoveEmail: (branchId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}/removeEmail`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesUpdateWebsiteUrl
             * @request POST:/v1/branches/{branchId}/updateWebsiteUrl
             * @secure
             */
            branchesUpdateWebsiteUrl: (branchId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}/updateWebsiteUrl`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesUpdateWelcomeVideoUrl
             * @request POST:/v1/branches/{branchId}/updateWelcomeVideoUrl
             * @secure
             */
            branchesUpdateWelcomeVideoUrl: (branchId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}/updateWelcomeVideoUrl`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesUpdateIdentityPermissions
             * @request POST:/v1/branches/{branchId}/updateIdentityPermissions
             * @secure
             */
            branchesUpdateIdentityPermissions: (branchId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}/updateIdentityPermissions`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesUpdatePermissions
             * @request POST:/v1/branches/{branchId}/updatePermissions
             * @secure
             */
            branchesUpdatePermissions: (branchId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}/updatePermissions`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesOverwritePermissions
             * @request POST:/v1/branches/{branchId}/permissions/{identityId}
             * @secure
             */
            branchesOverwritePermissions: (branchId, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}/permissions/${identityId}`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesRemovePermission
             * @request POST:/v1/branches/{branchId}/removePermission
             * @secure
             */
            branchesRemovePermission: (branchId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}/removePermission`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesRemovePermissions
             * @request POST:/v1/branches/{branchId}/removePermissions
             * @secure
             */
            branchesRemovePermissions: (branchId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}/removePermissions`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesUpdateTimeZone
             * @request POST:/v1/branches/{branchId}/updateTimeZone
             * @secure
             */
            branchesUpdateTimeZone: (branchId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}/updateTimeZone`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesUpdateBranchTypes
             * @request POST:/v1/branches/{branchId}/updateBranchTypes
             * @secure
             */
            branchesUpdateBranchTypes: (branchId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}/updateBranchTypes`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesUpdateExternalId
             * @request POST:/v1/branches/{branchId}/updateExternalId
             * @secure
             */
            branchesUpdateExternalId: (branchId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}/updateExternalId`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesUpdateAreasOfLaw
             * @request POST:/v1/branches/{branchId}/updateAreasOfLaw
             * @secure
             */
            branchesUpdateAreasOfLaw: (branchId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}/updateAreasOfLaw`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesUpdateYearFounded
             * @request POST:/v1/branches/{branchId}/updateYearFounded
             * @secure
             */
            branchesUpdateYearFounded: (branchId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}/updateYearFounded`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesUpdateYearJoined
             * @request POST:/v1/branches/{branchId}/updateYearJoined
             * @secure
             */
            branchesUpdateYearJoined: (branchId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}/updateYearJoined`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesActivate
             * @request POST:/v1/branches/{branchId}/activate
             * @secure
             */
            branchesActivate: (branchId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}/activate`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesDeactivate
             * @request POST:/v1/branches/{branchId}/deactivate
             * @secure
             */
            branchesDeactivate: (branchId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}/deactivate`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesUpdateNetwork
             * @request POST:/v1/branches/{branchId}/updateNetwork
             * @secure
             */
            branchesUpdateNetwork: (branchId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}/updateNetwork`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesUpdateCaseIdPrefix
             * @request POST:/v1/branches/{branchId}/updateCaseIdPrefix
             * @secure
             */
            branchesUpdateCaseIdPrefix: (branchId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}/updateCaseIdPrefix`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesAddUnavailableDate
             * @request POST:/v1/branches/{branchId}/addUnavailableDate
             * @secure
             */
            branchesAddUnavailableDate: (branchId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}/addUnavailableDate`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesRemoveUnavailableDate
             * @request POST:/v1/branches/{branchId}/removeUnavailableDate
             * @secure
             */
            branchesRemoveUnavailableDate: (branchId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}/removeUnavailableDate`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesUpdateUnavailableDate
             * @request POST:/v1/branches/{branchId}/updateUnavailableDates
             * @secure
             */
            branchesUpdateUnavailableDate: (branchId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}/updateUnavailableDates`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Branches
             * @name BranchesUpdateProfilePictureUrl
             * @request POST:/v1/branches/{branchId}/updateProfilePictureUrl
             * @secure
             */
            branchesUpdateProfilePictureUrl: (branchId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/${branchId}/updateProfilePictureUrl`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags BranchesJournal
             * @name BranchesJournalGetJournalChanges
             * @request GET:/v1/branches/journal
             * @secure
             */
            branchesJournalGetJournalChanges: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/journal`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags BranchesJournal
             * @name BranchesJournalGetMaxClock
             * @request GET:/v1/branches/journal/maxClock
             * @secure
             */
            branchesJournalGetMaxClock: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/branches/journal/maxClock`, method: 'GET', secure: true, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;

}(branches));

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(branches, exports);

}(branches$1));

var businessplus$1 = {};

var businessplus = {};

(function (exports) {
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.ProvisioningStateStatus = exports.ProvisioningStateAction = void 0;
(function (ProvisioningStateAction) {
    ProvisioningStateAction["CREATE_ACCOUNT"] = "CREATE_ACCOUNT";
    ProvisioningStateAction["MIGRATE_ACCOUNT"] = "MIGRATE_ACCOUNT";
    ProvisioningStateAction["CANCEL_ACCOUNT"] = "CANCEL_ACCOUNT";
    ProvisioningStateAction["ACTIVATE_ACCOUNT"] = "ACTIVATE_ACCOUNT";
    ProvisioningStateAction["ENROLL_AUTHORIZED_USER"] = "ENROLL_AUTHORIZED_USER";
    ProvisioningStateAction["CANCEL_AUTHORIZED_USER"] = "CANCEL_AUTHORIZED_USER";
    ProvisioningStateAction["REPLACE_AUTHORIZED_USER"] = "REPLACE_AUTHORIZED_USER";
    ProvisioningStateAction["CHANGE_OWNER"] = "CHANGE_OWNER";
    ProvisioningStateAction["UPDATE_METADATA"] = "UPDATE_METADATA";
    ProvisioningStateAction["UPDATE_MEMBER_INFO"] = "UPDATE_MEMBER_INFO";
    ProvisioningStateAction["PRODUCT_CHANGE"] = "PRODUCT_CHANGE";
})(exports.ProvisioningStateAction || (exports.ProvisioningStateAction = {}));
(function (ProvisioningStateStatus) {
    ProvisioningStateStatus["ACCOUNT_CANCELED"] = "ACCOUNT_CANCELED";
    ProvisioningStateStatus["ACCOUNT_ACTIVE"] = "ACCOUNT_ACTIVE";
    ProvisioningStateStatus["ACCOUNT_MIGRATED"] = "ACCOUNT_MIGRATED";
})(exports.ProvisioningStateStatus || (exports.ProvisioningStateStatus = {}));
const axios_1 = __importDefault(axios);
const utils_1 = utils;
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://businessplus.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title Business Plus States API
 * @version v1
 * @baseUrl https://businessplus.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * No description
             *
             * @tags BusinessPlusStatesJournal
             * @name BusinessPlusStatesJournalGetJournalChanges
             * @request GET:/v1/businessPlusStates/journal
             * @secure
             */
            businessPlusStatesJournalGetJournalChanges: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/businessPlusStates/journal`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags BusinessPlusStatesJournal
             * @name BusinessPlusStatesJournalGetJournalMaxClock
             * @request GET:/v1/businessPlusStates/journal/maxClock
             * @secure
             */
            businessPlusStatesJournalGetJournalMaxClock: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/businessPlusStates/journal/maxClock`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags BusinessPlusState
             * @name BusinessPlusStateGetBusinessPlusStates
             * @request GET:/v1/users/{userId}/businessPlusStates
             * @secure
             */
            businessPlusStateGetBusinessPlusStates: (userId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${userId}/businessPlusStates`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags BusinessPlusState
             * @name BusinessPlusStateCreateBusinessPlusState
             * @request POST:/v1/users/{userId}/businessPlusStates
             * @secure
             */
            businessPlusStateCreateBusinessPlusState: (userId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${userId}/businessPlusStates`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags BusinessPlusState
             * @name BusinessPlusStateGetEntitlement
             * @request GET:/v1/users/{userId}/businessPlusStates/{businessPlusStateId}
             * @secure
             */
            businessPlusStateGetEntitlement: (userId, businessPlusStateId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${userId}/businessPlusStates/${businessPlusStateId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags BusinessPlusState
             * @name BusinessPlusStateChangeWebsiteDomain
             * @request POST:/v1/users/{userId}/businessPlusStates/{businessPlusStateId}/changeWebsiteDomain
             * @secure
             */
            businessPlusStateChangeWebsiteDomain: (userId, businessPlusStateId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${userId}/businessPlusStates/${businessPlusStateId}/changeWebsiteDomain`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags BusinessPlusState
             * @name BusinessPlusStateChangeUserEmail
             * @request POST:/v1/users/{userId}/businessPlusStates/{businessPlusStateId}/changeUserEmail
             * @secure
             */
            businessPlusStateChangeUserEmail: (userId, businessPlusStateId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${userId}/businessPlusStates/${businessPlusStateId}/changeUserEmail`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags BusinessPlusState
             * @name BusinessPlusStateEntitlementUpdate
             * @request POST:/v1/users/{userId}/businessPlusStates/{businessPlusStateId}/entitlementUpdate
             * @secure
             */
            businessPlusStateEntitlementUpdate: (userId, businessPlusStateId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${userId}/businessPlusStates/${businessPlusStateId}/entitlementUpdate`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags BusinessPlusState
             * @name BusinessPlusStateMakeLoginLink
             * @request POST:/v1/users/{userId}/businessPlusStates/{businessPlusStateId}/makeLoginLink
             * @secure
             */
            businessPlusStateMakeLoginLink: (userId, businessPlusStateId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${userId}/businessPlusStates/${businessPlusStateId}/makeLoginLink`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags BusinessPlusState
             * @name BusinessPlusStateDeleteResource
             * @request DELETE:/v1/users/{userId}/businessPlusState/{businessPlusStateId}
             * @secure
             */
            businessPlusStateDeleteResource: (businessPlusStateId, userId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${userId}/businessPlusState/${businessPlusStateId}`, method: 'DELETE', secure: true }, params)),
            /**
             * No description
             *
             * @tags Migration
             * @name MigrationMigrate
             * @request PUT:/v1/users/{userId}/businessPlusStates/{businessPlusStateId}/migrate
             * @secure
             */
            migrationMigrate: (userId, businessPlusStateId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${userId}/businessPlusStates/${businessPlusStateId}/migrate`, method: 'PUT', secure: true, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;

}(businessplus));

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(businessplus, exports);

}(businessplus$1));

var channelsAssociates$1 = {};

var channelsAssociates = {};

(function (exports) {
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.PhotoApproval = exports.NameApproval = exports.StatusEnum = exports.ActionEnum = exports.ApprovalStatus = void 0;
(function (ApprovalStatus) {
    ApprovalStatus["NO_PENDING"] = "NO_PENDING";
    ApprovalStatus["PENDING"] = "PENDING";
    ApprovalStatus["APPROVED"] = "APPROVED";
    ApprovalStatus["DECLINED"] = "DECLINED";
})(exports.ApprovalStatus || (exports.ApprovalStatus = {}));
(function (ActionEnum) {
    ActionEnum["CREATED"] = "CREATED";
    ActionEnum["CHANGED"] = "CHANGED";
    ActionEnum["CANCELED"] = "CANCELED";
    ActionEnum["CHANGE_OWNER"] = "CHANGE_OWNER";
    ActionEnum["DELETED"] = "DELETED";
    ActionEnum["UPDATE_STATUS"] = "UPDATE_STATUS";
    ActionEnum["PENDING_APPROVAL"] = "PENDING_APPROVAL";
    ActionEnum["APPROVED_PHOTO"] = "APPROVED_PHOTO";
    ActionEnum["APPROVED_NAMES"] = "APPROVED_NAMES";
    ActionEnum["REJECTED_PHOTO"] = "REJECTED_PHOTO";
    ActionEnum["REJECTED_NAMES"] = "REJECTED_NAMES";
    ActionEnum["DELETED_PHOTO"] = "DELETED_PHOTO";
    ActionEnum["UPDATED"] = "UPDATED";
    ActionEnum["CARD_UPDATED"] = "CARD_UPDATED";
    ActionEnum["PRODUCT_MARKETING_UPDATED"] = "PRODUCT_MARKETING_UPDATED";
    ActionEnum["SITENAME_UPDATED"] = "SITENAME_UPDATED";
    ActionEnum["MARKETING_PAGES_UPDATED"] = "MARKETING_PAGES_UPDATED";
    ActionEnum["CHANGE_IDENTITYID"] = "CHANGE_IDENTITYID";
})(exports.ActionEnum || (exports.ActionEnum = {}));
(function (StatusEnum) {
    StatusEnum["ACTIVE"] = "ACTIVE";
    StatusEnum["CANCELED"] = "CANCELED";
    StatusEnum["DELETED"] = "DELETED";
})(exports.StatusEnum || (exports.StatusEnum = {}));
(function (NameApproval) {
    NameApproval["APPROVED"] = "APPROVED";
    NameApproval["REJECTED"] = "REJECTED";
})(exports.NameApproval || (exports.NameApproval = {}));
(function (PhotoApproval) {
    PhotoApproval["APPROVED"] = "APPROVED";
    PhotoApproval["REJECTED"] = "REJECTED";
})(exports.PhotoApproval || (exports.PhotoApproval = {}));
const axios_1 = __importDefault(axios);
const utils_1 = utils;
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://channels-associates.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title Channels Associates Service Api
 * @version v1
 * @baseUrl https://channels-associates.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v2 = {
            /**
             * @description No JWTs required
             *
             * @tags AssociateMarketing
             * @name AssociateMarketingGetById
             * @summary No auth required
             * @request GET:/v2/associateMarketing/{id}
             * @secure
             */
            associateMarketingGetById: (id, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/associateMarketing/${id}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * @description No JWTs required
             *
             * @tags AssociateMarketing
             * @name AssociateMarketingGetByOwnerId
             * @summary No auth required
             * @request GET:/v2/associateAgreements/{associateAgreementId}/associateMarketing
             * @secure
             */
            associateMarketingGetByOwnerId: (associateAgreementId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/associateAgreements/${associateAgreementId}/associateMarketing`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * @description Requires user or machine JWTs
             *
             * @tags AssociateMarketing
             * @name AssociateMarketingUpdateCard
             * @summary User or Machine JWT Only
             * @request PUT:/v2/associateMarketing/{id}/updateCard
             * @secure
             */
            associateMarketingUpdateCard: (id, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/associateMarketing/${id}/updateCard`, method: 'PUT', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description Requires internal or machine JWTs
             *
             * @tags AssociateMarketing
             * @name AssociateMarketingUpdatePendingCard
             * @summary Internal or Machine JWT Only
             * @request PUT:/v2/associateMarketing/{id}/updatePendingCard
             * @secure
             */
            associateMarketingUpdatePendingCard: (id, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/associateMarketing/${id}/updatePendingCard`, method: 'PUT', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description Requires user or machine JWTs
             *
             * @tags AssociateMarketing
             * @name AssociateMarketingDeleteAvatarUrl
             * @summary User or Machine JWT Only
             * @request PUT:/v2/associateMarketing/{id}/deleteAvatarUrl
             * @secure
             */
            associateMarketingDeleteAvatarUrl: (id, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/associateMarketing/${id}/deleteAvatarUrl`, method: 'PUT', secure: true, format: 'json' }, params)),
            /**
             * @description Requires internal or machine JWTs
             *
             * @tags AssociateMarketing
             * @name AssociateMarketingCancel
             * @summary Internal or Machine JWT Only
             * @request POST:/v2/associateMarketing/{id}/cancel
             * @secure
             */
            associateMarketingCancel: (id, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/associateMarketing/${id}/cancel`, method: 'POST', secure: true }, params)),
            /**
             * @description Requires user, internal, or machine JWTs
             *
             * @tags AssociateMarketing
             * @name AssociateMarketingUpdateProductMarketing
             * @summary User, Internal, or Machine JWT Only
             * @request POST:/v2/associateMarketing/{id}/updateProductMarketing
             * @secure
             */
            associateMarketingUpdateProductMarketing: (id, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/associateMarketing/${id}/updateProductMarketing`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description Requires user, internal, or machine JWTs
             *
             * @tags AssociateMarketing
             * @name AssociateMarketingUpdateMarketingPages
             * @summary User, Internal, or Machine JWT Only
             * @request POST:/v2/associateMarketing/{id}/updateMarketingPages
             * @secure
             */
            associateMarketingUpdateMarketingPages: (id, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/associateMarketing/${id}/updateMarketingPages`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description Requires user or machine JWTs
             *
             * @tags AssociateMarketing
             * @name AssociateMarketingUpdateSitename
             * @summary User or Machine JWT Only
             * @request POST:/v2/associateMarketing/{id}/updateSitename
             * @secure
             */
            associateMarketingUpdateSitename: (id, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/associateMarketing/${id}/updateSitename`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description Requires user or machine JWTs
             *
             * @tags AssociateMarketing
             * @name AssociateMarketingChangeIdentityId
             * @summary User or Machine JWT Only
             * @request POST:/v2/associateMarketing/{id}/changeIdentityId
             * @secure
             */
            associateMarketingChangeIdentityId: (id, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/associateMarketing/${id}/changeIdentityId`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
        };
        this.v1 = {
            /**
             * No description
             *
             * @tags ChannelsAssociates
             * @name ChannelsAssociatesGetResourcesByOwnerAll
             * @request GET:/v1/channelsAssociates/owner/{channelsAssociateOwnerId}
             * @secure
             */
            channelsAssociatesGetResourcesByOwnerAll: (channelsAssociateOwnerId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/channelsAssociates/owner/${channelsAssociateOwnerId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ChannelsAssociates
             * @name ChannelsAssociatesGetResourcesByOwner
             * @request GET:/v1/identities/{identityId}/channelsAssociates/owner/{channelsAssociateOwnerId}
             * @secure
             */
            channelsAssociatesGetResourcesByOwner: (channelsAssociateOwnerId, identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/channelsAssociates/owner/${channelsAssociateOwnerId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * @description Requires user match or machine JWTs
             *
             * @tags ChannelsAssociates
             * @name ChannelsAssociatesGetByAssociateNumberAll
             * @summary User Match or Machine JWT Only
             * @request GET:/v1/channelsAssociates/getByAssociateNumber/{associateNumber}
             * @secure
             */
            channelsAssociatesGetByAssociateNumberAll: (associateNumber, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/channelsAssociates/getByAssociateNumber/${associateNumber}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * @description Requires user match or machine JWTs
             *
             * @tags ChannelsAssociates
             * @name ChannelsAssociatesGetByAssociateNumber
             * @summary User Match or Machine JWT Only
             * @request GET:/v1/identities/{identityId}/channelsAssociates/getByAssociateNumber/{associateNumber}
             * @secure
             */
            channelsAssociatesGetByAssociateNumber: (associateNumber, identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/channelsAssociates/getByAssociateNumber/${associateNumber}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * @description No JWTs required
             *
             * @tags ChannelsAssociates
             * @name ChannelsAssociatesGetBySitename
             * @summary No auth required
             * @request GET:/v1/channelsAssociates/getBySitename
             * @secure
             */
            channelsAssociatesGetBySitename: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/channelsAssociates/getBySitename`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * @description Requires user match or machine JWTs
             *
             * @tags ChannelsAssociates
             * @name ChannelsAssociatesGetResourceById
             * @summary User Match or Machine JWT Only
             * @request GET:/v1/channelsAssociates/{associateId}
             * @secure
             */
            channelsAssociatesGetResourceById: (associateId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/channelsAssociates/${associateId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * @description Requires user match or machine JWTs
             *
             * @tags ChannelsAssociates
             * @name ChannelsAssociatesGetResourceById2
             * @summary User Match or Machine JWT Only
             * @request GET:/v1/identities/{identityId}/channelsAssociates/{associateId}
             * @secure
             */
            channelsAssociatesGetResourceById2: (associateId, identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/channelsAssociates/${associateId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * @description Requires user match or machine JWTs
             *
             * @tags ChannelsAssociates
             * @name ChannelsAssociatesCreateResource
             * @summary User Match or Machine JWT Only
             * @request POST:/v1/identities/{identityId}/channelsAssociates
             * @secure
             */
            channelsAssociatesCreateResource: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/channelsAssociates`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description Requires user match or machine JWTs
             *
             * @tags ChannelsAssociates
             * @name ChannelsAssociatesUpdateStatus
             * @summary User Match or Machine JWT Only
             * @request POST:/v1/identities/{identityId}/channelsAssociates/{channelsAssociateId}/updateStatus/{newStatus}
             * @secure
             */
            channelsAssociatesUpdateStatus: (identityId, channelsAssociateId, newStatus, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/channelsAssociates/${channelsAssociateId}/updateStatus/${newStatus}`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * @description Requires user match or machine JWTs
             *
             * @tags ChannelsAssociates
             * @name ChannelsAssociatesUpdateResource
             * @summary User Match or Machine JWT Only
             * @request PUT:/v1/identities/{identityId}/channelsAssociates/{channelsAssociateId}
             * @secure
             */
            channelsAssociatesUpdateResource: (channelsAssociateId, identityId, data, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/channelsAssociates/${channelsAssociateId}`, method: 'PUT', query: query, body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description Requires user match or machine JWTs
             *
             * @tags ChannelsAssociates
             * @name ChannelsAssociatesDeleteResource
             * @summary User Match or Machine JWT Only
             * @request DELETE:/v1/identities/{identityId}/channelsAssociates/{channelsAssociateId}
             * @secure
             */
            channelsAssociatesDeleteResource: (identityId, channelsAssociateId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/channelsAssociates/${channelsAssociateId}`, method: 'DELETE', secure: true }, params)),
            /**
             * @description Requires user match, internal match, or machine JWTs
             *
             * @tags ChannelsAssociates
             * @name ChannelsAssociatesUpdateNamesApproval
             * @summary User Match, Internal Match or Machine JWT Only
             * @request PUT:/v1/identities/{identityId}/channelsAssociates/{channelsAssociateId}/approvals/names/updateStatus/{newStatus}
             * @secure
             */
            channelsAssociatesUpdateNamesApproval: (channelsAssociateId, newStatus, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/channelsAssociates/${channelsAssociateId}/approvals/names/updateStatus/${newStatus}`, method: 'PUT', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description Requires user match, internal match, or machine JWTs
             *
             * @tags ChannelsAssociates
             * @name ChannelsAssociatesUpdatePhotoApproval
             * @summary User Match, Internal Match or Machine JWT Only
             * @request PUT:/v1/identities/{identityId}/channelsAssociates/{channelsAssociateId}/approvals/photo/updateStatus/{newStatus}
             * @secure
             */
            channelsAssociatesUpdatePhotoApproval: (channelsAssociateId, newStatus, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/channelsAssociates/${channelsAssociateId}/approvals/photo/updateStatus/${newStatus}`, method: 'PUT', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description Requires user match or machine JWTs
             *
             * @tags ChannelsAssociates
             * @name ChannelsAssociatesUpdateDisplayPhoto
             * @summary User Match or Machine JWT Only
             * @request PUT:/v1/identities/{identityId}/channelsAssociates/{channelsAssociateId}/updateDisplayPhoto
             * @secure
             */
            channelsAssociatesUpdateDisplayPhoto: (channelsAssociateId, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/channelsAssociates/${channelsAssociateId}/updateDisplayPhoto`, method: 'PUT', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description Requires user match or machine JWTs
             *
             * @tags ChannelsAssociates
             * @name ChannelsAssociatesDeleteDisplayPhoto
             * @summary User Match or Machine JWT Only
             * @request PUT:/v1/identities/{identityId}/channelsAssociates/{channelsAssociateId}/deleteDisplayPhoto
             * @secure
             */
            channelsAssociatesDeleteDisplayPhoto: (channelsAssociateId, identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/channelsAssociates/${channelsAssociateId}/deleteDisplayPhoto`, method: 'PUT', secure: true, format: 'json' }, params)),
            /**
             * @description Requires user match or machine JWTs
             *
             * @tags ChannelsAssociates
             * @name ChannelsAssociatesChangeOwner
             * @summary User Match or Machine JWT Only
             * @request POST:/v1/identities/{identityId}/channelsAssociates/{channelsAssociateId}/changeOwner
             * @secure
             */
            channelsAssociatesChangeOwner: (identityId, channelsAssociateId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/channelsAssociates/${channelsAssociateId}/changeOwner`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description Requires user match or machine JWTs
             *
             * @tags ChannelsAssociates
             * @name ChannelsAssociatesUploadPhoto
             * @summary User Match or Machine JWT Only
             * @request PUT:/v1/identities/{identityId}/channelsAssociates/{channelsAssociateId}/uploadPhoto
             * @secure
             */
            channelsAssociatesUploadPhoto: (identityId, channelsAssociateId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/channelsAssociates/${channelsAssociateId}/uploadPhoto`, method: 'PUT', body: data, secure: true, type: FecContentType.FormData }, params)),
            /**
             * @description Requires user match JWT
             *
             * @tags ChannelsAssociates
             * @name ChannelsAssociatesUpdateDisplayMarketingInformation
             * @summary User Match Only
             * @request PUT:/v1/identities/{identityId}/associateMarketing/{associateMarketingId}/updateDisplayMarketingInformation
             * @secure
             */
            channelsAssociatesUpdateDisplayMarketingInformation: (associateMarketingId, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/associateMarketing/${associateMarketingId}/updateDisplayMarketingInformation`, method: 'PUT', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ChannelsAssociatesJournal
             * @name ChannelsAssociatesJournalGetJournalChanges
             * @request GET:/v1/channelsAssociates/journal
             * @secure
             */
            channelsAssociatesJournalGetJournalChanges: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/channelsAssociates/journal`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ChannelsAssociatesJournal
             * @name ChannelsAssociatesJournalGetJournalMaxClock
             * @request GET:/v1/channelsAssociates/maxClock
             * @secure
             */
            channelsAssociatesJournalGetJournalMaxClock: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/channelsAssociates/maxClock`, method: 'GET', secure: true, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;

}(channelsAssociates));

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(channelsAssociates, exports);

}(channelsAssociates$1));

var channelsCampaigns$1 = {};

var channelsCampaigns = {};

(function (exports) {
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.StatusEnum = exports.ActionEnum = void 0;
(function (ActionEnum) {
    ActionEnum["CREATED"] = "CREATED";
    ActionEnum["CHANGED"] = "CHANGED";
    ActionEnum["CANCELED"] = "CANCELED";
    ActionEnum["CHANGE_OWNER"] = "CHANGE_OWNER";
    ActionEnum["DELETED"] = "DELETED";
    ActionEnum["UPDATE_STATUS"] = "UPDATE_STATUS";
})(exports.ActionEnum || (exports.ActionEnum = {}));
(function (StatusEnum) {
    StatusEnum["ACTIVE"] = "ACTIVE";
    StatusEnum["CANCELED"] = "CANCELED";
    StatusEnum["DELETED"] = "DELETED";
})(exports.StatusEnum || (exports.StatusEnum = {}));
const axios_1 = __importDefault(axios);
const utils_1 = utils;
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://channels-campaigns.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title Campaigns Service Api
 * @version v1
 * @baseUrl https://channels-campaigns.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.campaigns = {
            /**
             * No description
             *
             * @tags Campaigns
             * @name CampaignsGetResourcesByOwner
             * @request GET:/campaigns
             * @secure
             */
            campaignsGetResourcesByOwner: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/campaigns`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Campaigns
             * @name CampaignsGetResourceById
             * @request GET:/campaigns/{campaignId}
             * @secure
             */
            campaignsGetResourceById: (campaignId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/campaigns/${campaignId}`, method: 'GET', secure: true, format: 'json' }, params)),
        };
        this.v1 = {
            /**
             * @description Authorization Policies: Internal Match, Machine
             *
             * @tags Campaigns
             * @name CampaignsCreateResource
             * @summary Internal Match, Machine
             * @request POST:/v1/identities/{identityId}/campaigns
             * @secure
             */
            campaignsCreateResource: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/campaigns`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description Authorization Policies: Internal Match, Machine
             *
             * @tags Campaigns
             * @name CampaignsUpdateStatus
             * @summary Internal Match, Machine
             * @request POST:/v1/identities/{identityId}/campaigns/{campaignId}/updateStatus/{newStatus}
             * @secure
             */
            campaignsUpdateStatus: (identityId, campaignId, newStatus, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/campaigns/${campaignId}/updateStatus/${newStatus}`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * @description Authorization Policies: Internal Match, Machine
             *
             * @tags Campaigns
             * @name CampaignsUpdateResource
             * @summary Internal Match, Machine
             * @request PUT:/v1/identities/{identityId}/campaigns/{campaignId}
             * @secure
             */
            campaignsUpdateResource: (identityId, campaignId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/campaigns/${campaignId}`, method: 'PUT', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description Authorization Policies: Internal Match, Machine
             *
             * @tags Campaigns
             * @name CampaignsDeleteResource
             * @summary Internal Match, Machine
             * @request DELETE:/v1/identities/{identityId}/campaigns/{campaignId}
             * @secure
             */
            campaignsDeleteResource: (identityId, campaignId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/campaigns/${campaignId}`, method: 'DELETE', secure: true }, params)),
            /**
             * @description Authorization Policies: Internal Match, Machine
             *
             * @tags Campaigns
             * @name CampaignsChangeOwner
             * @summary Internal Match, Machine
             * @request POST:/v1/identities/{identityId}/campaigns/{campaignId}/changeOwner
             * @secure
             */
            campaignsChangeOwner: (identityId, campaignId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/campaigns/${campaignId}/changeOwner`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description Authorization Policies: Internal Match, Machine
             *
             * @tags Campaigns
             * @name CampaignsGetAssociates
             * @summary Internal Match, Machine
             * @request GET:/v1/identities/{identityId}/campaigns/{campaignId}/associates
             * @secure
             */
            campaignsGetAssociates: (identityId, campaignId, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/campaigns/${campaignId}/associates`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags CampaignsJournal
             * @name CampaignsJournalGetJournalChanges
             * @request GET:/v1/campaigns/journal
             * @secure
             */
            campaignsJournalGetJournalChanges: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/campaigns/journal`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;

}(channelsCampaigns));

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(channelsCampaigns, exports);

}(channelsCampaigns$1));

var channelsLeadsService$1 = {};

var channelsLeadsService = {};

(function (exports) {
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.LeadStatusEnum = exports.StatusEnum = exports.ActionEnum = void 0;
(function (ActionEnum) {
    ActionEnum["CREATED"] = "CREATED";
    ActionEnum["CHANGED"] = "CHANGED";
    ActionEnum["CANCELED"] = "CANCELED";
    ActionEnum["CHANGE_OWNER"] = "CHANGE_OWNER";
    ActionEnum["DELETED"] = "DELETED";
    ActionEnum["UPDATE_STATUS"] = "UPDATE_STATUS";
    ActionEnum["ADD_NOTE"] = "ADD_NOTE";
})(exports.ActionEnum || (exports.ActionEnum = {}));
(function (StatusEnum) {
    StatusEnum["ACTIVE"] = "ACTIVE";
    StatusEnum["CANCELED"] = "CANCELED";
    StatusEnum["DELETED"] = "DELETED";
})(exports.StatusEnum || (exports.StatusEnum = {}));
(function (LeadStatusEnum) {
    LeadStatusEnum["NEW"] = "NEW";
    LeadStatusEnum["OPENED"] = "OPENED";
    LeadStatusEnum["COMPLETED"] = "COMPLETED";
})(exports.LeadStatusEnum || (exports.LeadStatusEnum = {}));
const axios_1 = __importDefault(axios);
const utils_1 = utils;
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://channels-leads-service.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title Channels Leads Service Api
 * @version v1
 * @baseUrl https://channels-leads-service.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * @description Requires machine JWTs
             *
             * @tags ChannelsLeads
             * @name ChannelsLeadsGetResourcesByOwner
             * @summary Machine JWT Only
             * @request GET:/v1/leads/owner/{ownerId}
             * @secure
             */
            channelsLeadsGetResourcesByOwner: (ownerId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/leads/owner/${ownerId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * @description Requires machine JWTs
             *
             * @tags ChannelsLeads
             * @name ChannelsLeadsGetResourceById
             * @summary Machine JWT Only
             * @request GET:/v1/leads/{leadId}
             * @secure
             */
            channelsLeadsGetResourceById: (leadId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/leads/${leadId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * @description Requires user match or machine JWTs
             *
             * @tags ChannelsLeads
             * @name ChannelsLeadsCreateResource
             * @summary User Match or Machine JWT Only
             * @request POST:/v1/identities/{identityId}/leads
             * @secure
             */
            channelsLeadsCreateResource: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/leads`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description Requires user match or machine JWTs
             *
             * @tags ChannelsLeads
             * @name ChannelsLeadsUpdateResource
             * @summary User Match or Machine JWT Only
             * @request PUT:/v1/identities/{identityId}/leads/{LeadId}
             * @secure
             */
            channelsLeadsUpdateResource: (leadId, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/leads/${leadId}`, method: 'PUT', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description Requires user match or machine JWTs
             *
             * @tags ChannelsLeads
             * @name ChannelsLeadsUpdateStatus
             * @summary User Match or Machine JWT Only
             * @request POST:/v1/identities/{identityId}/leads/{leadId}/updateStatus/{newStatus}
             * @secure
             */
            channelsLeadsUpdateStatus: (identityId, leadId, newStatus, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/leads/${leadId}/updateStatus/${newStatus}`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * @description Requires user match or machine JWTs
             *
             * @tags ChannelsLeads
             * @name ChannelsLeadsChangeOwner
             * @summary User Match or Machine JWT Only
             * @request POST:/v1/identities/{identityId}/leads/{leadId}/changeOwner
             * @secure
             */
            channelsLeadsChangeOwner: (identityId, leadId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/leads/${leadId}/changeOwner`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description Requires user match or machine JWTs
             *
             * @tags ChannelsLeads
             * @name ChannelsLeadsDeleteResource
             * @summary User Match or Machine JWT Only
             * @request DELETE:/v1/identities/{identityId}/leads/{leadId}
             * @secure
             */
            channelsLeadsDeleteResource: (identityId, leadId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/leads/${leadId}`, method: 'DELETE', secure: true }, params)),
            /**
             * @description Requires no JWTs
             *
             * @tags ChannelsLeads
             * @name ChannelsLeadsGetAssociate
             * @summary No Auth Required
             * @request GET:/v1/getAssociate
             * @secure
             */
            channelsLeadsGetAssociate: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/getAssociate`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * @description Requires no JWTs
             *
             * @tags ChannelsLeads
             * @name ChannelsLeadsGetAssociate2
             * @summary No Auth Required
             * @request POST:/v1/getAssociate
             * @secure
             */
            channelsLeadsGetAssociate2: (data, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/getAssociate`, method: 'POST', query: query, body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description Requires machine JWTs
             *
             * @tags ChannelsLeads
             * @name ChannelsLeadsCleanAssociateCache
             * @summary Machine JWT Only
             * @request GET:/v1/cleanAssociateCache
             * @secure
             */
            channelsLeadsCleanAssociateCache: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/cleanAssociateCache`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ChannelsLeadsJournal
             * @name ChannelsLeadsJournalGetJournalChanges
             * @request GET:/v1/leads/journal
             * @secure
             */
            channelsLeadsJournalGetJournalChanges: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/leads/journal`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;

}(channelsLeadsService));

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(channelsLeadsService, exports);

}(channelsLeadsService$1));

var channelsSegments$1 = {};

var channelsSegments = {};

(function (exports) {
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.ProfilesOfSuccessCsvResult2 = exports.StatusEnum = exports.ActionEnum = void 0;
(function (ActionEnum) {
    ActionEnum["CREATED"] = "CREATED";
    ActionEnum["CHANGED"] = "CHANGED";
    ActionEnum["CANCELED"] = "CANCELED";
    ActionEnum["CHANGE_OWNER"] = "CHANGE_OWNER";
    ActionEnum["DELETED"] = "DELETED";
    ActionEnum["UPDATE_STATUS"] = "UPDATE_STATUS";
})(exports.ActionEnum || (exports.ActionEnum = {}));
(function (StatusEnum) {
    StatusEnum["ACTIVE"] = "ACTIVE";
    StatusEnum["CANCELED"] = "CANCELED";
    StatusEnum["DELETED"] = "DELETED";
})(exports.StatusEnum || (exports.StatusEnum = {}));
(function (ProfilesOfSuccessCsvResult2) {
    ProfilesOfSuccessCsvResult2["UPDATED"] = "UPDATED";
    ProfilesOfSuccessCsvResult2["NOTFOUND"] = "NOTFOUND";
    ProfilesOfSuccessCsvResult2["ERROR"] = "ERROR";
    ProfilesOfSuccessCsvResult2["NOACTION"] = "NOACTION";
})(exports.ProfilesOfSuccessCsvResult2 || (exports.ProfilesOfSuccessCsvResult2 = {}));
const axios_1 = __importDefault(axios);
const utils_1 = utils;
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://channels-segments.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title Segments Service Api
 * @version v1
 * @baseUrl https://channels-segments.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.segments = {
            /**
             * @description Requires machine JWTs
             *
             * @tags Segments
             * @name SegmentsGetResourcesByOwner
             * @summary Machine JWT Only
             * @request GET:/segments
             * @secure
             */
            segmentsGetResourcesByOwner: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/segments`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * @description Requires machine JWTs
             *
             * @tags Segments
             * @name SegmentsGetResourceById
             * @summary Machine JWT Only
             * @request GET:/segments/{segmentId}
             * @secure
             */
            segmentsGetResourceById: (segmentId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/segments/${segmentId}`, method: 'GET', secure: true, format: 'json' }, params)),
        };
        this.v1 = {
            /**
             * @description Requires machine or internal match JWTs
             *
             * @tags Segments
             * @name SegmentsCreateResource
             * @summary Machine and Internal Match JWT Only
             * @request POST:/v1/identities/{identityId}/segments
             * @secure
             */
            segmentsCreateResource: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/segments`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description Requires machine or internal match JWTs
             *
             * @tags Segments
             * @name SegmentsUpdateResource
             * @summary Machine and Internal Match JWT Only
             * @request PUT:/v1/identities/{identityId}/segments/{segmentId}
             * @secure
             */
            segmentsUpdateResource: (identityId, segmentId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/segments/${segmentId}`, method: 'PUT', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description Requires internal match JWTs
             *
             * @tags Segments
             * @name SegmentsDeleteResource
             * @summary Internal Match JWT Only
             * @request DELETE:/v1/identities/{identityId}/segments/{segmentId}
             * @secure
             */
            segmentsDeleteResource: (identityId, segmentId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/segments/${segmentId}`, method: 'DELETE', secure: true }, params)),
            /**
             * @description Requires machine or internal match JWTs
             *
             * @tags Segments
             * @name SegmentsUpdateAssociates
             * @summary Machine and Internal Match JWT Only
             * @request POST:/v1/identities/{identityId}/segments/{segmentId}/associates
             * @secure
             */
            segmentsUpdateAssociates: (segmentId, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/segments/${segmentId}/associates`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description Requires machine or internal match JWTs
             *
             * @tags Segments
             * @name SegmentsUploadCsv
             * @summary Machine and Internal Match JWT Only
             * @request POST:/v1/identities/{identityId}/segments/{segmentId}/csvUpload/{startLine}/{endLine}
             * @secure
             */
            segmentsUploadCsv: (identityId, segmentId, startLine, endLine, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/segments/${segmentId}/csvUpload/${startLine}/${endLine}`, method: 'POST', body: data, secure: true, type: FecContentType.FormData, format: 'json' }, params)),
            /**
             * @description Requires machine or internal match JWTs
             *
             * @tags Segments
             * @name SegmentsChangeOwner
             * @summary Machine and Internal Match JWT Only
             * @request POST:/v1/identities/{identityId}/segments/{segmentId}/changeOwner
             * @secure
             */
            segmentsChangeOwner: (identityId, segmentId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/segments/${segmentId}/changeOwner`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags SegmentsJournal
             * @name SegmentsJournalGetJournalChanges
             * @request GET:/v1/segments/journal
             * @secure
             */
            segmentsJournalGetJournalChanges: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/segments/journal`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;

}(channelsSegments));

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(channelsSegments, exports);

}(channelsSegments$1));

var chats$1 = {};

var chats = {};

(function (exports) {
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.StatusEnum = exports.ActionEnum = exports.SourceType = void 0;
(function (SourceType) {
    SourceType["SERVICE_REQUEST"] = "SERVICE_REQUEST";
    SourceType["ENTITLEMENT"] = "ENTITLEMENT";
})(exports.SourceType || (exports.SourceType = {}));
(function (ActionEnum) {
    ActionEnum["CREATED"] = "CREATED";
    ActionEnum["CHANGED"] = "CHANGED";
    ActionEnum["CANCELED"] = "CANCELED";
    ActionEnum["DELETED"] = "DELETED";
    ActionEnum["ADD_MESSAGE"] = "ADD_MESSAGE";
    ActionEnum["MESSAGE_REACTION"] = "MESSAGE_REACTION";
    ActionEnum["ADD_PARTICIPANT"] = "ADD_PARTICIPANT";
    ActionEnum["REMOVE_PARTICIPANT"] = "REMOVE_PARTICIPANT";
    ActionEnum["REMOVE_MESSAGE_REACTION"] = "REMOVE_MESSAGE_REACTION";
    ActionEnum["UPDATE_PARTICIPANT_EMAIL"] = "UPDATE_PARTICIPANT_EMAIL";
})(exports.ActionEnum || (exports.ActionEnum = {}));
(function (StatusEnum) {
    StatusEnum["ACTIVE"] = "ACTIVE";
    StatusEnum["CANCELED"] = "CANCELED";
    StatusEnum["DELETED"] = "DELETED";
})(exports.StatusEnum || (exports.StatusEnum = {}));
const axios_1 = __importDefault(axios);
const utils_1 = utils;
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://chats.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title Chats Service Api
 * @version v1
 * @baseUrl https://chats.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * No description
             *
             * @tags ChatsJournal
             * @name ChatsJournalGetJournalChanges
             * @request GET:/v1/chats/journal
             * @secure
             */
            chatsJournalGetJournalChanges: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/chats/journal`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ChatsJournal
             * @name ChatsJournalGetJournalMaxClock
             * @request GET:/v1/chats/journal/maxClock
             * @secure
             */
            chatsJournalGetJournalMaxClock: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/chats/journal/maxClock`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Chats
             * @name ChatsGetResourceById
             * @request GET:/v1/chats/{chatId}
             * @secure
             */
            chatsGetResourceById: (chatId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/chats/${chatId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Chats
             * @name ChatsUpdateChat
             * @request PUT:/v1/chats/{chatId}
             * @secure
             */
            chatsUpdateChat: (chatId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/chats/${chatId}`, method: 'PUT', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Chats
             * @name ChatsDeleteResource
             * @request DELETE:/v1/chats/{chatId}
             * @secure
             */
            chatsDeleteResource: (chatId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/chats/${chatId}`, method: 'DELETE', secure: true }, params)),
            /**
             * No description
             *
             * @tags Chats
             * @name ChatsGetChatContactsByEntitlement
             * @request GET:/v1/chats/getChatContactsByEntitlement
             * @secure
             */
            chatsGetChatContactsByEntitlement: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/chats/getChatContactsByEntitlement`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Chats
             * @name ChatsGetMessagesSince
             * @request GET:/v1/chats/{chatId}/getMessagesSince
             * @secure
             */
            chatsGetMessagesSince: (chatId, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/chats/${chatId}/getMessagesSince`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Chats
             * @name ChatsCreateResource
             * @request POST:/v1/chats
             * @secure
             */
            chatsCreateResource: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/chats`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Chats
             * @name ChatsAppendNewMsgs
             * @request POST:/v1/chats/{chatId}/appendNewMsgs
             * @secure
             */
            chatsAppendNewMsgs: (chatId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/chats/${chatId}/appendNewMsgs`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Chats
             * @name ChatsAddContactToChat
             * @request POST:/v1/chats/{chatId}/addContactToChat
             * @secure
             */
            chatsAddContactToChat: (chatId, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/chats/${chatId}/addContactToChat`, method: 'POST', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Chats
             * @name ChatsRemoveContactFromChat
             * @request POST:/v1/chats/{chatId}/removeContactFromChat
             * @secure
             */
            chatsRemoveContactFromChat: (chatId, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/chats/${chatId}/removeContactFromChat`, method: 'POST', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Chats
             * @name ChatsGetS3UploadLinks
             * @request POST:/v1/chats/{chatId}/getS3UploadLinks
             * @secure
             */
            chatsGetS3UploadLinks: (chatId, data, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/chats/${chatId}/getS3UploadLinks`, method: 'POST', query: query, body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Chats
             * @name ChatsGetS3DownloadLinks
             * @request POST:/v1/chats/{chatId}/getS3DownloadLinks
             * @secure
             */
            chatsGetS3DownloadLinks: (chatId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/chats/${chatId}/getS3DownloadLinks`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Chats
             * @name ChatsReactToMessage
             * @request POST:/v1/chats/{chatId}/messages/{messageId}/react
             * @secure
             */
            chatsReactToMessage: (chatId, messageId, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/chats/${chatId}/messages/${messageId}/react`, method: 'POST', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Chats
             * @name ChatsRemoveReaction
             * @request POST:/v1/chats/{chatId}/messages/{messageId}/removeReaction
             * @secure
             */
            chatsRemoveReaction: (chatId, messageId, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/chats/${chatId}/messages/${messageId}/removeReaction`, method: 'POST', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Chats
             * @name ChatsUpdateParticipantEmail
             * @request POST:/v1/chats/{chatId}/participants/{participantId}/updateEmail
             * @secure
             */
            chatsUpdateParticipantEmail: (chatId, participantId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/chats/${chatId}/participants/${participantId}/updateEmail`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;

}(chats));

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(chats, exports);

}(chats$1));

var cohorts$1 = {};

var cohorts = {};

(function (exports) {
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.CohortType = exports.Action = void 0;
(function (Action) {
    Action["CREATED"] = "CREATED";
    Action["UPDATED"] = "UPDATED";
    Action["DELETED"] = "DELETED";
    Action["OWNER_CHANGED"] = "OWNER_CHANGED";
})(exports.Action || (exports.Action = {}));
(function (CohortType) {
    CohortType["ASSOCIATE_LICENSES"] = "ASSOCIATE_LICENSES";
    CohortType["SHIELD_AT_WORK_BETA"] = "SHIELD_AT_WORK_BETA";
})(exports.CohortType || (exports.CohortType = {}));
const axios_1 = __importDefault(axios);
const utils_1 = utils;
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://cohorts.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title Cohorts API
 * @version v1
 * @baseUrl https://cohorts.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * No description
             *
             * @tags Cohorts
             * @name CohortsCreate
             * @request POST:/v1/identities/{identityId}/cohorts
             * @secure
             */
            cohortsCreate: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/cohorts`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Cohorts
             * @name CohortsIndex
             * @request GET:/v1/identities/{identityId}/cohorts
             * @secure
             */
            cohortsIndex: (identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/cohorts`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Cohorts
             * @name CohortsUpdate
             * @request PUT:/v1/cohorts/{id}
             * @secure
             */
            cohortsUpdate: (id, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/cohorts/${id}`, method: 'PUT', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Cohorts
             * @name CohortsDelete
             * @request DELETE:/v1/cohorts/{id}
             * @secure
             */
            cohortsDelete: (id, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/cohorts/${id}`, method: 'DELETE', secure: true }, params)),
            /**
             * No description
             *
             * @tags Cohorts
             * @name CohortsChangeOwner
             * @request POST:/v1/cohorts/{id}/changeOwner
             * @secure
             */
            cohortsChangeOwner: (id, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/cohorts/${id}/changeOwner`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
        };
        this.cohorts = {
            /**
             * No description
             *
             * @tags CohortsJournal
             * @name CohortsJournalGetJournalChanges
             * @request GET:/cohorts/journal
             * @secure
             */
            cohortsJournalGetJournalChanges: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/cohorts/journal`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags CohortsJournal
             * @name CohortsJournalGetJournalMaxClock
             * @request GET:/cohorts/journal/maxClock
             * @secure
             */
            cohortsJournalGetJournalMaxClock: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/cohorts/journal/maxClock`, method: 'GET', secure: true, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;

}(cohorts));

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(cohorts, exports);

}(cohorts$1));

var contentEntries$1 = {};

var contentEntries = {};

(function (exports) {
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.FieldType = exports.SiteType = exports.ContentVariant = void 0;
(function (ContentVariant) {
    ContentVariant["BLOCK"] = "BLOCK";
    ContentVariant["PAGE"] = "PAGE";
    ContentVariant["SECTION"] = "SECTION";
    ContentVariant["NAVIGATION"] = "NAVIGATION";
})(exports.ContentVariant || (exports.ContentVariant = {}));
(function (SiteType) {
    SiteType["LEGALSHIELD_US"] = "LEGALSHIELD_US";
    SiteType["IDSHIELD_US"] = "IDSHIELD_US";
    SiteType["ALL"] = "ALL";
})(exports.SiteType || (exports.SiteType = {}));
(function (FieldType) {
    FieldType["BOOLEAN"] = "BOOLEAN";
    FieldType["NUMBER"] = "NUMBER";
    FieldType["RESOURCE"] = "RESOURCE";
    FieldType["RESOURCE_ARRAY"] = "RESOURCE_ARRAY";
    FieldType["RICH_TEXT"] = "RICH_TEXT";
    FieldType["TEXT"] = "TEXT";
})(exports.FieldType || (exports.FieldType = {}));
const axios_1 = __importDefault(axios);
const utils_1 = utils;
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://content-entries.api.legalshieldinternal.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title Fedux ContentEntry Service API
 * @version v1
 * @baseUrl https://content-entries.api.legalshieldinternal.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * No description
             *
             * @tags ContentEntries
             * @name ContentEntriesCreateContentEntry
             * @request POST:/v1/contentEntries
             * @secure
             */
            contentEntriesCreateContentEntry: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/contentEntries`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ContentEntries
             * @name ContentEntriesGetContentEntries
             * @request GET:/v1/contentEntries
             * @secure
             */
            contentEntriesGetContentEntries: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/contentEntries`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ContentEntries
             * @name ContentEntriesGetContentEntry
             * @request GET:/v1/contentEntries/{contentEntryId}
             * @secure
             */
            contentEntriesGetContentEntry: (contentEntryId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/contentEntries/${contentEntryId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ContentEntries
             * @name ContentEntriesDeleteContentEntry
             * @request DELETE:/v1/contentEntries/{contentEntryId}
             * @secure
             */
            contentEntriesDeleteContentEntry: (contentEntryId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/contentEntries/${contentEntryId}`, method: 'DELETE', secure: true }, params)),
            /**
             * No description
             *
             * @tags ContentEntries
             * @name ContentEntriesUpdateArrayField
             * @request POST:/v1/contentEntries/{contentEntryId}/updateArrayField
             * @secure
             */
            contentEntriesUpdateArrayField: (contentEntryId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/contentEntries/${contentEntryId}/updateArrayField`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ContentEntries
             * @name ContentEntriesUpdateContentEntryField
             * @request POST:/v1/contentEntries/{contentEntryId}/updateContentEntryField
             * @secure
             */
            contentEntriesUpdateContentEntryField: (contentEntryId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/contentEntries/${contentEntryId}/updateContentEntryField`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ContentEntries
             * @name ContentEntriesUpdateTextField
             * @request POST:/v1/contentEntries/{contentEntryId}/updateTextField
             * @secure
             */
            contentEntriesUpdateTextField: (contentEntryId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/contentEntries/${contentEntryId}/updateTextField`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ContentEntries
             * @name ContentEntriesUpdateBooleanField
             * @request POST:/v1/contentEntries/{contentEntryId}/updateBooleanField
             * @secure
             */
            contentEntriesUpdateBooleanField: (contentEntryId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/contentEntries/${contentEntryId}/updateBooleanField`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ContentTypes
             * @name ContentTypesGetContentTypes
             * @request GET:/v1/contentTypes
             * @secure
             */
            contentTypesGetContentTypes: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/contentTypes`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ContentTypes
             * @name ContentTypesGetContentType
             * @request GET:/v1/contentTypes/{contentTypeId}
             * @secure
             */
            contentTypesGetContentType: (contentTypeId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/contentTypes/${contentTypeId}`, method: 'GET', secure: true, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;

}(contentEntries));

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(contentEntries, exports);

}(contentEntries$1));

var contractHistories$1 = {};

var contractHistories = {};

(function (exports) {
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.EntitlementHistoryStatus = exports.ContractType = void 0;
(function (ContractType) {
    ContractType["CONTRACT"] = "CONTRACT";
    ContractType["AMENDMENT"] = "AMENDMENT";
    ContractType["SUPPLEMENT"] = "SUPPLEMENT";
})(exports.ContractType || (exports.ContractType = {}));
(function (EntitlementHistoryStatus) {
    EntitlementHistoryStatus["ACTIVE"] = "ACTIVE";
    EntitlementHistoryStatus["SUSPENDED"] = "SUSPENDED";
    EntitlementHistoryStatus["CANCELED"] = "CANCELED";
})(exports.EntitlementHistoryStatus || (exports.EntitlementHistoryStatus = {}));
const axios_1 = __importDefault(axios);
const utils_1 = utils;
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://contract-histories.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title Entitlement Histories API
 * @version v1
 * @baseUrl https://contract-histories.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * No description
             *
             * @tags EntitlementHistories
             * @name EntitlementHistoriesGetEntitlementHistories
             * @request GET:/v1/identities/{identityId}/entitlements/{entitlementId}/histories
             * @secure
             */
            entitlementHistoriesGetEntitlementHistories: (identityId, entitlementId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/entitlements/${entitlementId}/histories`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags EntitlementHistories
             * @name EntitlementHistoriesCreateEntitlementHistory
             * @request POST:/v1/identities/{identityId}/entitlements/{entitlementId}/histories
             * @secure
             */
            entitlementHistoriesCreateEntitlementHistory: (identityId, entitlementId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/entitlements/${entitlementId}/histories`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;

}(contractHistories));

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(contractHistories, exports);

}(contractHistories$1));

var eligibilities$1 = {};

var eligibilities = {};

(function (exports) {
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.AuthorizedUserTypeEnum = exports.StateEnum = void 0;
(function (StateEnum) {
    StateEnum["AB"] = "AB";
    StateEnum["AK"] = "AK";
    StateEnum["AL"] = "AL";
    StateEnum["AR"] = "AR";
    StateEnum["AZ"] = "AZ";
    StateEnum["BC"] = "BC";
    StateEnum["CA"] = "CA";
    StateEnum["CA2"] = "CA_2";
    StateEnum["CO"] = "CO";
    StateEnum["CT"] = "CT";
    StateEnum["DC"] = "DC";
    StateEnum["DE"] = "DE";
    StateEnum["FL"] = "FL";
    StateEnum["GA"] = "GA";
    StateEnum["GU"] = "GU";
    StateEnum["HI"] = "HI";
    StateEnum["IA"] = "IA";
    StateEnum["ID"] = "ID";
    StateEnum["IL"] = "IL";
    StateEnum["IN"] = "IN";
    StateEnum["KS"] = "KS";
    StateEnum["KY"] = "KY";
    StateEnum["LA"] = "LA";
    StateEnum["LS"] = "LS";
    StateEnum["MA"] = "MA";
    StateEnum["MB"] = "MB";
    StateEnum["MD"] = "MD";
    StateEnum["ME"] = "ME";
    StateEnum["MI"] = "MI";
    StateEnum["MN"] = "MN";
    StateEnum["MO"] = "MO";
    StateEnum["MS"] = "MS";
    StateEnum["MT"] = "MT";
    StateEnum["NB"] = "NB";
    StateEnum["NC"] = "NC";
    StateEnum["ND"] = "ND";
    StateEnum["NE"] = "NE";
    StateEnum["NF"] = "NF";
    StateEnum["NH"] = "NH";
    StateEnum["NJ"] = "NJ";
    StateEnum["NL"] = "NL";
    StateEnum["NM"] = "NM";
    StateEnum["NS"] = "NS";
    StateEnum["NT"] = "NT";
    StateEnum["NU"] = "NU";
    StateEnum["NV"] = "NV";
    StateEnum["NY"] = "NY";
    StateEnum["OH"] = "OH";
    StateEnum["OK"] = "OK";
    StateEnum["ON"] = "ON";
    StateEnum["OR"] = "OR";
    StateEnum["PA"] = "PA";
    StateEnum["PE"] = "PE";
    StateEnum["PR"] = "PR";
    StateEnum["QC"] = "QC";
    StateEnum["RI"] = "RI";
    StateEnum["SC"] = "SC";
    StateEnum["SD"] = "SD";
    StateEnum["SF"] = "SF";
    StateEnum["SK"] = "SK";
    StateEnum["TN"] = "TN";
    StateEnum["TX"] = "TX";
    StateEnum["UT"] = "UT";
    StateEnum["VA"] = "VA";
    StateEnum["VI"] = "VI";
    StateEnum["VT"] = "VT";
    StateEnum["WA"] = "WA";
    StateEnum["WI"] = "WI";
    StateEnum["WV"] = "WV";
    StateEnum["WY"] = "WY";
    StateEnum["YT"] = "YT";
})(exports.StateEnum || (exports.StateEnum = {}));
(function (AuthorizedUserTypeEnum) {
    AuthorizedUserTypeEnum["PRIMARY"] = "PRIMARY";
    AuthorizedUserTypeEnum["SPOUSE"] = "SPOUSE";
    AuthorizedUserTypeEnum["DEPENDENT"] = "DEPENDENT";
    AuthorizedUserTypeEnum["NORMAL_USER"] = "NORMAL_USER";
    AuthorizedUserTypeEnum["OWNER"] = "OWNER";
    AuthorizedUserTypeEnum["CO_OWNER"] = "CO_OWNER";
    AuthorizedUserTypeEnum["SECONDARY"] = "SECONDARY";
    AuthorizedUserTypeEnum["TERTIARY"] = "TERTIARY";
    AuthorizedUserTypeEnum["ELDER"] = "ELDER";
    AuthorizedUserTypeEnum["ANY"] = "ANY";
    AuthorizedUserTypeEnum["ALL"] = "ALL";
})(exports.AuthorizedUserTypeEnum || (exports.AuthorizedUserTypeEnum = {}));
const axios_1 = __importDefault(axios);
const utils_1 = utils;
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://eligibilities.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title Benefits Eligibilities Service Api
 * @version v1
 * @baseUrl https://eligibilities.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * No description
             *
             * @tags BenefitsEligibilities
             * @name BenefitsEligibilitiesBenefitsEligibilities
             * @request POST:/v1/users/{userId}/benefitsEligibilities
             * @secure
             */
            benefitsEligibilitiesBenefitsEligibilities: (userId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${userId}/benefitsEligibilities`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags BenefitsEligibilities
             * @name BenefitsEligibilitiesBenefitsEligibilitiesByProduct
             * @request POST:/v1/users/{userId}/benefitsEligibilitiesByProduct
             * @secure
             */
            benefitsEligibilitiesBenefitsEligibilitiesByProduct: (userId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${userId}/benefitsEligibilitiesByProduct`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags BenefitsEligibilities
             * @name BenefitsEligibilitiesBenefitsEligibilitiesByProduct2
             * @request POST:/v1/benefitsEligibilitiesByProduct
             * @secure
             */
            benefitsEligibilitiesBenefitsEligibilitiesByProduct2: (data, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/benefitsEligibilitiesByProduct`, method: 'POST', query: query, body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags BenefitsEligibilities
             * @name BenefitsEligibilitiesGetBenefitsWithProvisioning
             * @request POST:/v1/users/{userId}/benefitsProvisioning
             * @secure
             */
            benefitsEligibilitiesGetBenefitsWithProvisioning: (userId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${userId}/benefitsProvisioning`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;

}(eligibilities));

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(eligibilities, exports);

}(eligibilities$1));

var entitlementHistories$1 = {};

var entitlementHistories = {};

(function (exports) {
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.EntitlementHistoryStatus = exports.ContractType = void 0;
(function (ContractType) {
    ContractType["CONTRACT"] = "CONTRACT";
    ContractType["AMENDMENT"] = "AMENDMENT";
    ContractType["SUPPLEMENT"] = "SUPPLEMENT";
})(exports.ContractType || (exports.ContractType = {}));
(function (EntitlementHistoryStatus) {
    EntitlementHistoryStatus["ACTIVE"] = "ACTIVE";
    EntitlementHistoryStatus["SUSPENDED"] = "SUSPENDED";
    EntitlementHistoryStatus["CANCELLED"] = "CANCELLED";
})(exports.EntitlementHistoryStatus || (exports.EntitlementHistoryStatus = {}));
const axios_1 = __importDefault(axios);
const utils_1 = utils;
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://entitlement-histories.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title Entitlement Histories API
 * @version v1
 * @baseUrl https://entitlement-histories.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * No description
             *
             * @tags EntitlementHistories
             * @name EntitlementHistoriesGetEntitlementHistories
             * @request GET:/v1/identities/{identityId}/entitlements/{entitlementId}/histories
             * @secure
             */
            entitlementHistoriesGetEntitlementHistories: (identityId, entitlementId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/entitlements/${entitlementId}/histories`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags EntitlementHistories
             * @name EntitlementHistoriesUpsertEntitlementHistory
             * @request POST:/v1/identities/{identityId}/entitlements/{entitlementId}/histories
             * @secure
             */
            entitlementHistoriesUpsertEntitlementHistory: (identityId, entitlementId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/entitlements/${entitlementId}/histories`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags EntitlementHistories
             * @name EntitlementHistoriesGetCurrentlyActiveEntitlementHistories
             * @request GET:/v1/identities/{identityId}/entitlements/{entitlementId}/currentlyActive
             * @secure
             */
            entitlementHistoriesGetCurrentlyActiveEntitlementHistories: (identityId, entitlementId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/entitlements/${entitlementId}/currentlyActive`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags EntitlementHistories
             * @name EntitlementHistoriesDeleteEntitlementHistory
             * @request DELETE:/v1/identities/{identityId}/entitlements/{entitlementId}/histories/{entitlementHistoryId}
             * @secure
             */
            entitlementHistoriesDeleteEntitlementHistory: (identityId, entitlementId, entitlementHistoryId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/entitlements/${entitlementId}/histories/${entitlementHistoryId}`, method: 'DELETE', secure: true }, params)),
            /**
             * @description All modification methods require machine JWTs
             *
             * @tags EntitlementHistories
             * @name EntitlementHistoriesChangeIdentity
             * @summary Machine JWT Only
             * @request POST:/v1/identities/{identityId}/entitlements/{entitlementId}/histories/{entitlementHistoryId}/changeIdentity
             * @secure
             */
            entitlementHistoriesChangeIdentity: (identityId, entitlementId, entitlementHistoryId, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/entitlements/${entitlementId}/histories/${entitlementHistoryId}/changeIdentity`, method: 'POST', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags EntitlementHistoriesJournal
             * @name EntitlementHistoriesJournalGetJournalChanges
             * @request GET:/v1/entitlementHistories/journal
             * @secure
             */
            entitlementHistoriesJournalGetJournalChanges: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/entitlementHistories/journal`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags EntitlementHistoriesJournal
             * @name EntitlementHistoriesJournalGetJournalMaxClock
             * @request GET:/v1/entitlementHistories/journal/maxClock
             * @secure
             */
            entitlementHistoriesJournalGetJournalMaxClock: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/entitlementHistories/journal/maxClock`, method: 'GET', secure: true, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;

}(entitlementHistories));

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(entitlementHistories, exports);

}(entitlementHistories$1));

var entitlements$1 = {};

var entitlements = {};

(function (exports) {
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.ProvisioningType = exports.SetupStatus = exports.FulfillmentStatus = exports.RelationPermissionType = exports.Status = exports.CoBrandPartner = exports.Action = void 0;
(function (Action) {
    Action["STATUS_UPDATE"] = "STATUS_UPDATE";
    Action["CREATED"] = "CREATED";
    Action["PRODUCT_CHANGE"] = "PRODUCT_CHANGE";
    Action["FULFILLMENT_CHANGE"] = "FULFILLMENT_CHANGE";
    Action["DELEGATE_CHANGE"] = "DELEGATE_CHANGE";
    Action["SERVICE_AREA_CHANGE"] = "SERVICE_AREA_CHANGE";
    Action["REPLACED"] = "REPLACED";
    Action["EFFECTIVE_DATE_CHANGE"] = "EFFECTIVE_DATE_CHANGE";
    Action["OWNER_CHANGE"] = "OWNER_CHANGE";
    Action["SETUP_CHANGE"] = "SETUP_CHANGE";
    Action["MIGRATION_UPDATE"] = "MIGRATION_UPDATE";
    Action["DELEGATE_REPLACE"] = "DELEGATE_REPLACE";
    Action["CONTRACT_CHANGE"] = "CONTRACT_CHANGE";
    Action["PROVISIONING_TYPE_CHANGE"] = "PROVISIONING_TYPE_CHANGE";
    Action["DELETED"] = "DELETED";
    Action["PRODUCT_INFO_CHANGE"] = "PRODUCT_INFO_CHANGE";
})(exports.Action || (exports.Action = {}));
(function (CoBrandPartner) {
    CoBrandPartner["PRIMERICA"] = "PRIMERICA";
    CoBrandPartner["SOFI"] = "SOFI";
    CoBrandPartner["NEWITY"] = "NEWITY";
})(exports.CoBrandPartner || (exports.CoBrandPartner = {}));
(function (Status) {
    Status["ACTIVE"] = "ACTIVE";
    Status["CANCELLED"] = "CANCELLED";
    Status["SUSPENDED"] = "SUSPENDED";
})(exports.Status || (exports.Status = {}));
(function (RelationPermissionType) {
    RelationPermissionType["PRIMARY"] = "PRIMARY";
    RelationPermissionType["SPOUSE"] = "SPOUSE";
    RelationPermissionType["DEPENDENT"] = "DEPENDENT";
    RelationPermissionType["NORMAL_USER"] = "NORMAL_USER";
    RelationPermissionType["OWNER"] = "OWNER";
    RelationPermissionType["CO_OWNER"] = "CO_OWNER";
    RelationPermissionType["SECONDARY"] = "SECONDARY";
    RelationPermissionType["TERTIARY"] = "TERTIARY";
    RelationPermissionType["ELDER"] = "ELDER";
})(exports.RelationPermissionType || (exports.RelationPermissionType = {}));
(function (FulfillmentStatus) {
    FulfillmentStatus["Fulfilled"] = "Fulfilled";
    FulfillmentStatus["NotFulfilled"] = "NotFulfilled";
    FulfillmentStatus["PendingChange"] = "PendingChange";
    FulfillmentStatus["PendingCreate"] = "PendingCreate";
})(exports.FulfillmentStatus || (exports.FulfillmentStatus = {}));
(function (SetupStatus) {
    SetupStatus["SETUP"] = "SETUP";
    SetupStatus["NOT_SETUP"] = "NOT_SETUP";
})(exports.SetupStatus || (exports.SetupStatus = {}));
(function (ProvisioningType) {
    ProvisioningType["IMMEDIATE"] = "IMMEDIATE";
    ProvisioningType["ON_FIRST_USE"] = "ON_FIRST_USE";
})(exports.ProvisioningType || (exports.ProvisioningType = {}));
const axios_1 = __importDefault(axios);
const utils_1 = utils;
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://entitlements.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title Entitlements API
 * @version v1
 * @baseUrl https://entitlements.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * No description
             *
             * @tags Entitlements
             * @name EntitlementsGetEntitlementsAll
             * @request GET:/v1/identities/{identityId}/entitlements
             * @secure
             */
            entitlementsGetEntitlementsAll: (identityId, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/entitlements`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * @description All modification methods require machine JWTs
             *
             * @tags Entitlements
             * @name EntitlementsCreateEntitlement
             * @summary Machine JWT Only
             * @request POST:/v1/identities/{identityId}/entitlements
             * @secure
             */
            entitlementsCreateEntitlement: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/entitlements`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Entitlements
             * @name EntitlementsGetEntitlements
             * @request GET:/v1/users/{identityId}/entitlements
             * @secure
             */
            entitlementsGetEntitlements: (identityId, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/entitlements`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * @description All modification methods require machine JWTs
             *
             * @tags Entitlements
             * @name EntitlementsCreateEntitlement2
             * @summary Machine JWT Only
             * @request POST:/v1/users/{identityId}/entitlements
             * @secure
             */
            entitlementsCreateEntitlement2: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/entitlements`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Entitlements
             * @name EntitlementsGetEntitlement
             * @request GET:/v1/identities/{identityId}/entitlements/{entitlementId}
             * @secure
             */
            entitlementsGetEntitlement: (identityId, entitlementId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/entitlements/${entitlementId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * @description All modification methods require machine JWTs
             *
             * @tags Entitlements
             * @name EntitlementsUpdateEntitlement
             * @summary Machine JWT Only
             * @request PUT:/v1/identities/{identityId}/entitlements/{entitlementId}
             * @secure
             */
            entitlementsUpdateEntitlement: (identityId, entitlementId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/entitlements/${entitlementId}`, method: 'PUT', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description All modification methods require machine JWTs
             *
             * @tags Entitlements
             * @name EntitlementsDeleteEntitlement
             * @summary Machine JWT Only
             * @request DELETE:/v1/identities/{identityId}/entitlements/{entitlementId}
             * @secure
             */
            entitlementsDeleteEntitlement: (identityId, entitlementId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/entitlements/${entitlementId}`, method: 'DELETE', secure: true }, params)),
            /**
             * No description
             *
             * @tags Entitlements
             * @name EntitlementsGetEntitlement2
             * @request GET:/v1/users/{identityId}/entitlements/{entitlementId}
             * @secure
             */
            entitlementsGetEntitlement2: (identityId, entitlementId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/entitlements/${entitlementId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * @description All modification methods require machine JWTs
             *
             * @tags Entitlements
             * @name EntitlementsUpdateEntitlement2
             * @summary Machine JWT Only
             * @request PUT:/v1/users/{identityId}/entitlements/{entitlementId}
             * @secure
             */
            entitlementsUpdateEntitlement2: (identityId, entitlementId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/entitlements/${entitlementId}`, method: 'PUT', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description All modification methods require machine JWTs
             *
             * @tags Entitlements
             * @name EntitlementsDeleteEntitlement2
             * @summary Machine JWT Only
             * @request DELETE:/v1/users/{identityId}/entitlements/{entitlementId}
             * @secure
             */
            entitlementsDeleteEntitlement2: (identityId, entitlementId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/entitlements/${entitlementId}`, method: 'DELETE', secure: true }, params)),
            /**
             * @description All modification methods require machine JWTs
             *
             * @tags Entitlements
             * @name EntitlementsUpdateProduct
             * @summary Machine JWT Only
             * @request POST:/v1/identities/{identityId}/entitlements/{entitlementId}/changeProduct
             * @secure
             */
            entitlementsUpdateProduct: (identityId, entitlementId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/entitlements/${entitlementId}/changeProduct`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description All modification methods require machine JWTs
             *
             * @tags Entitlements
             * @name EntitlementsUpdateProduct2
             * @summary Machine JWT Only
             * @request POST:/v1/users/{identityId}/entitlements/{entitlementId}/changeProduct
             * @secure
             */
            entitlementsUpdateProduct2: (identityId, entitlementId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/entitlements/${entitlementId}/changeProduct`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description All modification methods require machine JWTs
             *
             * @tags Entitlements
             * @name EntitlementsUpdateProductInfo
             * @summary Machine JWT Only
             * @request POST:/v1/identities/{identityId}/entitlements/{entitlementId}/products/changeProductInfo
             * @secure
             */
            entitlementsUpdateProductInfo: (identityId, entitlementId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/entitlements/${entitlementId}/products/changeProductInfo`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description All modification methods require machine JWTs
             *
             * @tags Entitlements
             * @name EntitlementsUpdateProductInfo2
             * @summary Machine JWT Only
             * @request POST:/v1/users/{identityId}/entitlements/{entitlementId}/products/changeProductInfo
             * @secure
             */
            entitlementsUpdateProductInfo2: (identityId, entitlementId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/entitlements/${entitlementId}/products/changeProductInfo`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description All modification methods require machine JWTs
             *
             * @tags Entitlements
             * @name EntitlementsActivateStatus
             * @summary Machine JWT Only
             * @request POST:/v1/identities/{identityId}/entitlements/{entitlementId}/activate
             * @secure
             */
            entitlementsActivateStatus: (identityId, entitlementId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/entitlements/${entitlementId}/activate`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * @description All modification methods require machine JWTs
             *
             * @tags Entitlements
             * @name EntitlementsActivateStatus2
             * @summary Machine JWT Only
             * @request POST:/v1/users/{identityId}/entitlements/{entitlementId}/activate
             * @secure
             */
            entitlementsActivateStatus2: (identityId, entitlementId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/entitlements/${entitlementId}/activate`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * @description All modification methods require machine JWTs
             *
             * @tags Entitlements
             * @name EntitlementsSuspendStatus
             * @summary Machine JWT Only
             * @request POST:/v1/identities/{identityId}/entitlements/{entitlementId}/suspend
             * @secure
             */
            entitlementsSuspendStatus: (identityId, entitlementId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/entitlements/${entitlementId}/suspend`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * @description All modification methods require machine JWTs
             *
             * @tags Entitlements
             * @name EntitlementsSuspendStatus2
             * @summary Machine JWT Only
             * @request POST:/v1/users/{identityId}/entitlements/{entitlementId}/suspend
             * @secure
             */
            entitlementsSuspendStatus2: (identityId, entitlementId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/entitlements/${entitlementId}/suspend`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * @description All modification methods require machine JWTs
             *
             * @tags Entitlements
             * @name EntitlementsCancelStatus
             * @summary Machine JWT Only
             * @request POST:/v1/identities/{identityId}/entitlements/{entitlementId}/cancel
             * @secure
             */
            entitlementsCancelStatus: (identityId, entitlementId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/entitlements/${entitlementId}/cancel`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * @description All modification methods require machine JWTs
             *
             * @tags Entitlements
             * @name EntitlementsCancelStatus2
             * @summary Machine JWT Only
             * @request POST:/v1/users/{identityId}/entitlements/{entitlementId}/cancel
             * @secure
             */
            entitlementsCancelStatus2: (identityId, entitlementId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/entitlements/${entitlementId}/cancel`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * @description All modification methods require machine JWTs
             *
             * @tags Entitlements
             * @name EntitlementsAddDelegates
             * @summary Machine JWT Only
             * @request POST:/v1/identities/{identityId}/entitlements/{entitlementId}/addDelegates
             * @secure
             */
            entitlementsAddDelegates: (identityId, entitlementId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/entitlements/${entitlementId}/addDelegates`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description All modification methods require machine JWTs
             *
             * @tags Entitlements
             * @name EntitlementsAddDelegates2
             * @summary Machine JWT Only
             * @request POST:/v1/users/{identityId}/entitlements/{entitlementId}/addDelegates
             * @secure
             */
            entitlementsAddDelegates2: (identityId, entitlementId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/entitlements/${entitlementId}/addDelegates`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description All modification methods require machine JWTs
             *
             * @tags Entitlements
             * @name EntitlementsAddDelegates3
             * @summary Machine JWT Only
             * @request POST:/v1/identities/{identityId}/entitlements/{entitlementId}/addAuthorizedUsers
             * @secure
             */
            entitlementsAddDelegates3: (identityId, entitlementId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/entitlements/${entitlementId}/addAuthorizedUsers`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description All modification methods require machine JWTs
             *
             * @tags Entitlements
             * @name EntitlementsAddDelegates4
             * @summary Machine JWT Only
             * @request POST:/v1/users/{identityId}/entitlements/{entitlementId}/addAuthorizedUsers
             * @secure
             */
            entitlementsAddDelegates4: (identityId, entitlementId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/entitlements/${entitlementId}/addAuthorizedUsers`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Entitlements
             * @name EntitlementsRemoveDelegates
             * @request POST:/v1/identities/{identityId}/entitlements/{entitlementId}/removeDelegates
             * @secure
             */
            entitlementsRemoveDelegates: (identityId, entitlementId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/entitlements/${entitlementId}/removeDelegates`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Entitlements
             * @name EntitlementsRemoveDelegates2
             * @request POST:/v1/users/{identityId}/entitlements/{entitlementId}/removeDelegates
             * @secure
             */
            entitlementsRemoveDelegates2: (identityId, entitlementId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/entitlements/${entitlementId}/removeDelegates`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Entitlements
             * @name EntitlementsRemoveDelegates3
             * @request POST:/v1/identities/{identityId}/entitlements/{entitlementId}/removeAuthorizedUsers
             * @secure
             */
            entitlementsRemoveDelegates3: (identityId, entitlementId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/entitlements/${entitlementId}/removeAuthorizedUsers`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Entitlements
             * @name EntitlementsRemoveDelegates4
             * @request POST:/v1/users/{identityId}/entitlements/{entitlementId}/removeAuthorizedUsers
             * @secure
             */
            entitlementsRemoveDelegates4: (identityId, entitlementId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/entitlements/${entitlementId}/removeAuthorizedUsers`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description All modification methods require machine JWTs
             *
             * @tags Entitlements
             * @name EntitlementsReplaceDelegates
             * @summary Machine JWT Only
             * @request POST:/v1/identities/{identityId}/entitlements/{entitlementId}/replaceDelegate
             * @secure
             */
            entitlementsReplaceDelegates: (identityId, entitlementId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/entitlements/${entitlementId}/replaceDelegate`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description All modification methods require machine JWTs
             *
             * @tags Entitlements
             * @name EntitlementsReplaceDelegates2
             * @summary Machine JWT Only
             * @request POST:/v1/users/{identityId}/entitlements/{entitlementId}/replaceDelegate
             * @secure
             */
            entitlementsReplaceDelegates2: (identityId, entitlementId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/entitlements/${entitlementId}/replaceDelegate`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description All modification methods require machine JWTs
             *
             * @tags Entitlements
             * @name EntitlementsReplaceDelegates3
             * @summary Machine JWT Only
             * @request POST:/v1/identities/{identityId}/entitlements/{entitlementId}/replaceAuthorizedUser
             * @secure
             */
            entitlementsReplaceDelegates3: (identityId, entitlementId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/entitlements/${entitlementId}/replaceAuthorizedUser`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description All modification methods require machine JWTs
             *
             * @tags Entitlements
             * @name EntitlementsReplaceDelegates4
             * @summary Machine JWT Only
             * @request POST:/v1/users/{identityId}/entitlements/{entitlementId}/replaceAuthorizedUser
             * @secure
             */
            entitlementsReplaceDelegates4: (identityId, entitlementId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/entitlements/${entitlementId}/replaceAuthorizedUser`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description All modification methods require machine JWTs
             *
             * @tags Entitlements
             * @name EntitlementsAddFulfillment
             * @summary Machine JWT Only
             * @request POST:/v1/identities/{identityId}/entitlements/{entitlementId}/fulfill
             * @secure
             */
            entitlementsAddFulfillment: (identityId, entitlementId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/entitlements/${entitlementId}/fulfill`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description All modification methods require machine JWTs
             *
             * @tags Entitlements
             * @name EntitlementsAddFulfillment2
             * @summary Machine JWT Only
             * @request POST:/v1/users/{identityId}/entitlements/{entitlementId}/fulfill
             * @secure
             */
            entitlementsAddFulfillment2: (identityId, entitlementId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/entitlements/${entitlementId}/fulfill`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description All modification methods require machine JWTs
             *
             * @tags Entitlements
             * @name EntitlementsChangeServiceArea
             * @summary Machine JWT Only
             * @request POST:/v1/identities/{identityId}/entitlements/{entitlementId}/changeServiceArea
             * @secure
             */
            entitlementsChangeServiceArea: (identityId, entitlementId, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/entitlements/${entitlementId}/changeServiceArea`, method: 'POST', query: query, secure: true, format: 'json' }, params)),
            /**
             * @description All modification methods require machine JWTs
             *
             * @tags Entitlements
             * @name EntitlementsChangeServiceArea2
             * @summary Machine JWT Only
             * @request POST:/v1/users/{identityId}/entitlements/{entitlementId}/changeServiceArea
             * @secure
             */
            entitlementsChangeServiceArea2: (identityId, entitlementId, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/entitlements/${entitlementId}/changeServiceArea`, method: 'POST', query: query, secure: true, format: 'json' }, params)),
            /**
             * @description All modification methods require machine JWTs
             *
             * @tags Entitlements
             * @name EntitlementsChangeEffectiveDates
             * @summary Machine JWT Only
             * @request POST:/v1/identities/{identityId}/entitlements/{entitlementId}/changeEffectiveDates
             * @secure
             */
            entitlementsChangeEffectiveDates: (identityId, entitlementId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/entitlements/${entitlementId}/changeEffectiveDates`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description All modification methods require machine JWTs
             *
             * @tags Entitlements
             * @name EntitlementsChangeEffectiveDates2
             * @summary Machine JWT Only
             * @request POST:/v1/users/{identityId}/entitlements/{entitlementId}/changeEffectiveDates
             * @secure
             */
            entitlementsChangeEffectiveDates2: (identityId, entitlementId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/entitlements/${entitlementId}/changeEffectiveDates`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description All modification methods require machine JWTs
             *
             * @tags Entitlements
             * @name EntitlementsAddContracts
             * @summary Machine JWT Only
             * @request POST:/v1/identities/{identityId}/entitlements/{entitlementId}/addContracts
             * @secure
             */
            entitlementsAddContracts: (identityId, entitlementId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/entitlements/${entitlementId}/addContracts`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description All modification methods require machine JWTs
             *
             * @tags Entitlements
             * @name EntitlementsAddContracts2
             * @summary Machine JWT Only
             * @request POST:/v1/users/{identityId}/entitlements/{entitlementId}/addContracts
             * @secure
             */
            entitlementsAddContracts2: (identityId, entitlementId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/entitlements/${entitlementId}/addContracts`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description All modification methods require machine JWTs
             *
             * @tags Entitlements
             * @name EntitlementsChangeOwner
             * @summary Machine JWT Only
             * @request POST:/v1/identities/{identityId}/entitlements/{entitlementId}/changeOwner
             * @secure
             */
            entitlementsChangeOwner: (identityId, entitlementId, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/entitlements/${entitlementId}/changeOwner`, method: 'POST', query: query, secure: true, format: 'json' }, params)),
            /**
             * @description All modification methods require machine JWTs
             *
             * @tags Entitlements
             * @name EntitlementsChangeOwner2
             * @summary Machine JWT Only
             * @request POST:/v1/users/{identityId}/entitlements/{entitlementId}/changeOwner
             * @secure
             */
            entitlementsChangeOwner2: (identityId, entitlementId, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/entitlements/${entitlementId}/changeOwner`, method: 'POST', query: query, secure: true, format: 'json' }, params)),
            /**
             * @description indicates someone has setup their entitlement
             *
             * @tags Entitlements
             * @name MachineJwtOnly
             * @summary All modification methods require machine JWTs
             * @request POST:/v1/identities/{identityId}/entitlements/{entitlementId}/updateProvisioningType
             * @secure
             */
            machineJwtOnly: (identityId, entitlementId, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/entitlements/${entitlementId}/updateProvisioningType`, method: 'POST', query: query, secure: true, format: 'json' }, params)),
            /**
             * @description indicates someone has setup their entitlement
             *
             * @tags Entitlements
             * @name MachineJwtOnly2
             * @summary All modification methods require machine JWTs
             * @request POST:/v1/users/{identityId}/entitlements/{entitlementId}/updateProvisioningType
             * @secure
             */
            machineJwtOnly2: (identityId, entitlementId, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/entitlements/${entitlementId}/updateProvisioningType`, method: 'POST', query: query, secure: true, format: 'json' }, params)),
            /**
             * @description indicates someone has setup their entitlement
             *
             * @tags Entitlements
             * @name MachineJwtOnly3
             * @summary All modification methods require machine JWTs
             * @request POST:/v1/identities/{identityId}/entitlements/{entitlementId}/fulfillment/setup
             * @secure
             */
            machineJwtOnly3: (identityId, entitlementId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/entitlements/${entitlementId}/fulfillment/setup`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * @description indicates someone has setup their entitlement
             *
             * @tags Entitlements
             * @name MachineJwtOnly4
             * @summary All modification methods require machine JWTs
             * @request POST:/v1/users/{identityId}/entitlements/{entitlementId}/fulfillment/setup
             * @secure
             */
            machineJwtOnly4: (identityId, entitlementId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/entitlements/${entitlementId}/fulfillment/setup`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * @description modifies or creates an entitlement in place
             *
             * @tags Entitlements
             * @name MachineJwtOnly5
             * @summary Only to be called by migration services for extraction of data
             * @request POST:/v1/identities/{identityId}/entitlements/migrate
             * @secure
             */
            machineJwtOnly5: (identityId, data, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/entitlements/migrate`, method: 'POST', query: query, body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description modifies or creates an entitlement in place
             *
             * @tags Entitlements
             * @name MachineJwtOnly6
             * @summary Only to be called by migration services for extraction of data
             * @request POST:/v1/users/{identityId}/entitlements/migrate
             * @secure
             */
            machineJwtOnly6: (identityId, data, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/entitlements/migrate`, method: 'POST', query: query, body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description indicates someone a new member number
             *
             * @tags Entitlements
             * @name MachineJwtOnly7
             * @summary All modification methods require machine JWTs
             * @request POST:/v1/identities/{identityId}/entitlements/{entitlementId}/updateFriendlyId
             * @secure
             */
            machineJwtOnly7: (identityId, entitlementId, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/entitlements/${entitlementId}/updateFriendlyId`, method: 'POST', query: query, secure: true, format: 'json' }, params)),
            /**
             * @description indicates someone a new member number
             *
             * @tags Entitlements
             * @name MachineJwtOnly8
             * @summary All modification methods require machine JWTs
             * @request POST:/v1/users/{identityId}/entitlements/{entitlementId}/updateFriendlyId
             * @secure
             */
            machineJwtOnly8: (identityId, entitlementId, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/entitlements/${entitlementId}/updateFriendlyId`, method: 'POST', query: query, secure: true, format: 'json' }, params)),
            /**
             * @description The journal is for internal use only
             *
             * @tags EntitlementsJournal
             * @name EntitlementsJournal
             * @summary Machine JWT Only
             * @request GET:/v1/entitlements/journal
             * @secure
             */
            entitlementsJournal: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/entitlements/journal`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags EntitlementsJournal
             * @name EntitlementsJournalGetJournalMaxClock
             * @request GET:/v1/entitlements/journal/maxClock
             * @secure
             */
            entitlementsJournalGetJournalMaxClock: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/entitlements/journal/maxClock`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * @description modifies or creates an entitlement in place
             *
             * @tags MigrateEntitlements
             * @name MachineJwtOnly22
             * @summary Only to be called by migration services for extraction of data
             * @request POST:/v1/entitlements/migrate
             * @secure
             */
            machineJwtOnly22: (data, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/entitlements/migrate`, method: 'POST', query: query, body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;

}(entitlements));

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(entitlements, exports);

}(entitlements$1));

var factors$1 = {};

var factors = {};

(function (exports) {
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.Realm = exports.ProofType = exports.FactorType = void 0;
(function (FactorType) {
    FactorType["GOOGLE"] = "GOOGLE";
    FactorType["SMS"] = "SMS";
    FactorType["EMAIL"] = "EMAIL";
    FactorType["ACCOUNT"] = "ACCOUNT";
    FactorType["QUESTION"] = "QUESTION";
})(exports.FactorType || (exports.FactorType = {}));
(function (ProofType) {
    ProofType["KNOWLEDGE"] = "KNOWLEDGE";
    ProofType["POSSESSION"] = "POSSESSION";
    ProofType["BIOMETRIC"] = "BIOMETRIC";
    ProofType["ACCOUNT"] = "ACCOUNT";
})(exports.ProofType || (exports.ProofType = {}));
(function (Realm) {
    Realm["User"] = "User";
    Realm["Machine"] = "Machine";
    Realm["Internal"] = "Internal";
    Realm["Partner"] = "Partner";
    Realm["GroupAdmin"] = "GroupAdmin";
})(exports.Realm || (exports.Realm = {}));
const axios_1 = __importDefault(axios);
const utils_1 = utils;
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://factors.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title Factors API
 * @version v1
 * @baseUrl https://factors.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * No description
             *
             * @tags Factors
             * @name FactorsCreateFactor
             * @request POST:/v1/identities/{identityId}/factors
             * @secure
             */
            factorsCreateFactor: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/factors`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Factors
             * @name FactorsGetFactors
             * @request GET:/v1/identities/{identityId}/factors
             * @secure
             */
            factorsGetFactors: (identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/factors`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Factors
             * @name FactorsDeleteFactor
             * @request DELETE:/v1/identities/{identityId}/factors/{factorId}
             * @secure
             */
            factorsDeleteFactor: (identityId, factorId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/factors/${factorId}`, method: 'DELETE', secure: true }, params)),
            /**
             * No description
             *
             * @tags Factors
             * @name FactorsVerifyFactor
             * @request POST:/v1/identities/{identityId}/factors/{factorId}/verify
             * @secure
             */
            factorsVerifyFactor: (identityId, factorId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/factors/${factorId}/verify`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Factors
             * @name FactorsSetPrimary
             * @request POST:/v1/identities/{identityId}/factors/{factorId}/setPrimary
             * @secure
             */
            factorsSetPrimary: (identityId, factorId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/factors/${factorId}/setPrimary`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Factors
             * @name FactorsSendCode
             * @request POST:/v1/identities/{identityId}/factors/{factorId}/sendCode
             * @secure
             */
            factorsSendCode: (identityId, factorId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/factors/${factorId}/sendCode`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Factors
             * @name FactorsValidateFactor
             * @request POST:/v1/identities/{identityId}/factors/{factorId}/validate
             * @secure
             */
            factorsValidateFactor: (identityId, factorId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/factors/${factorId}/validate`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Factors
             * @name FactorsUpdateFactorName
             * @request POST:/v1/identities/{identityId}/factors/{factorId}/updateName
             * @secure
             */
            factorsUpdateFactorName: (identityId, factorId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/factors/${factorId}/updateName`, method: 'POST', body: data, secure: true, type: FecContentType.Json }, params)),
        };
    }
}
exports.Api = Api;

}(factors));

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(factors, exports);

}(factors$1));

var firms$1 = {};

var firms = {};

(function (exports) {
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.NetworkEnum = exports.RoleEnum = exports.FirmType = exports.StatusEnum = exports.ActionEnum = void 0;
(function (ActionEnum) {
    ActionEnum["CREATE"] = "CREATE";
    ActionEnum["DELETE"] = "DELETE";
    ActionEnum["ACTIVATE"] = "ACTIVATE";
    ActionEnum["DEACTIVATE"] = "DEACTIVATE";
    ActionEnum["CHANGE"] = "CHANGE";
    ActionEnum["UPDATE_BRANCH_IDS"] = "UPDATE_BRANCH_IDS";
    ActionEnum["UPDATE_WEBSITE_URL"] = "UPDATE_WEBSITE_URL";
    ActionEnum["UPDATE_FIRM_TYPE"] = "UPDATE_FIRM_TYPE";
    ActionEnum["UPDATE_NAME"] = "UPDATE_NAME";
    ActionEnum["UPDATE_YEAR_FOUNDED"] = "UPDATE_YEAR_FOUNDED";
    ActionEnum["UPDATE_LEGAL_SHIELD_YEAR_JOINED"] = "UPDATE_LEGAL_SHIELD_YEAR_JOINED";
    ActionEnum["UPDATE_EXTERNAL_ID"] = "UPDATE_EXTERNAL_ID";
    ActionEnum["UPDATE_IDENTITY_PERMISSIONS"] = "UPDATE_IDENTITY_PERMISSIONS";
    ActionEnum["ADD_PERMISSIONS"] = "ADD_PERMISSIONS";
    ActionEnum["REMOVE_PERMISSIONS"] = "REMOVE_PERMISSIONS";
    ActionEnum["UPDATE_NETWORK"] = "UPDATE_NETWORK";
    ActionEnum["UPDATE_ABOUT_US_TEXT"] = "UPDATE_ABOUT_US_TEXT";
    ActionEnum["UPDATE_PROFILE_PICTURE_URL"] = "UPDATE_PROFILE_PICTURE_URL";
})(exports.ActionEnum || (exports.ActionEnum = {}));
(function (StatusEnum) {
    StatusEnum["CREATED"] = "CREATED";
    StatusEnum["ACTIVE"] = "ACTIVE";
    StatusEnum["DELETED"] = "DELETED";
    StatusEnum["DEACTIVATED"] = "DEACTIVATED";
})(exports.StatusEnum || (exports.StatusEnum = {}));
(function (FirmType) {
    FirmType["PARTNER"] = "PARTNER";
    FirmType["REFERRAL"] = "REFERRAL";
    FirmType["OTHER"] = "OTHER";
})(exports.FirmType || (exports.FirmType = {}));
(function (RoleEnum) {
    RoleEnum["ADMIN"] = "ADMIN";
    RoleEnum["CSR"] = "CSR";
    RoleEnum["LAWYER"] = "LAWYER";
    RoleEnum["RESOLUTION_LAWYER"] = "RESOLUTION_LAWYER";
    RoleEnum["RESOLUTION_CSR"] = "RESOLUTION_CSR";
    RoleEnum["REFERRAL_CLERK"] = "REFERRAL_CLERK";
    RoleEnum["PPLSI_MANAGEMENT"] = "PPLSI_MANAGEMENT";
    RoleEnum["INTAKES_VIEW"] = "INTAKES_VIEW";
    RoleEnum["DECOMMISSIONED_ADMIN"] = "DECOMMISSIONED_ADMIN";
})(exports.RoleEnum || (exports.RoleEnum = {}));
(function (NetworkEnum) {
    NetworkEnum["LEGALSHIELD"] = "LEGALSHIELD";
    NetworkEnum["CLC"] = "CLC";
})(exports.NetworkEnum || (exports.NetworkEnum = {}));
const axios_1 = __importDefault(axios);
const utils_1 = utils;
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://firms.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title Firms Service Api
 * @version v1
 * @baseUrl https://firms.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * No description
             *
             * @tags Firms
             * @name FirmsGetFirms
             * @request GET:/v1/firms
             * @secure
             */
            firmsGetFirms: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/firms`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Firms
             * @name FirmsCreateFirm
             * @request POST:/v1/firms
             * @secure
             */
            firmsCreateFirm: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/firms`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Firms
             * @name FirmsGetSpecificFirm
             * @request GET:/v1/firms/{firmId}
             * @secure
             */
            firmsGetSpecificFirm: (firmId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/firms/${firmId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Firms
             * @name FirmsReplaceFirm
             * @request PUT:/v1/firms/{firmId}
             * @secure
             */
            firmsReplaceFirm: (firmId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/firms/${firmId}`, method: 'PUT', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Firms
             * @name FirmsDeleteResource
             * @request DELETE:/v1/firms/{firmId}
             * @secure
             */
            firmsDeleteResource: (firmId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/firms/${firmId}`, method: 'DELETE', secure: true }, params)),
            /**
             * No description
             *
             * @tags Firms
             * @name FirmsUpdateBranchIds
             * @request POST:/v1/firms/{firmId}/updateBranchIds
             * @secure
             */
            firmsUpdateBranchIds: (firmId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/firms/${firmId}/updateBranchIds`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Firms
             * @name FirmsDeactivate
             * @request POST:/v1/firms/{firmId}/deactivate
             * @secure
             */
            firmsDeactivate: (firmId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/firms/${firmId}/deactivate`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Firms
             * @name FirmsActivate
             * @request POST:/v1/firms/{firmId}/activate
             * @secure
             */
            firmsActivate: (firmId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/firms/${firmId}/activate`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Firms
             * @name FirmsUpdateWebsiteUrl
             * @request POST:/v1/firms/{firmId}/updateWebsiteUrl
             * @secure
             */
            firmsUpdateWebsiteUrl: (firmId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/firms/${firmId}/updateWebsiteUrl`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Firms
             * @name FirmsUpdateFirmTypes
             * @request POST:/v1/firms/{firmId}/updateFirmTypes
             * @secure
             */
            firmsUpdateFirmTypes: (firmId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/firms/${firmId}/updateFirmTypes`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Firms
             * @name FirmsUpdateName
             * @request POST:/v1/firms/{firmId}/updateName
             * @secure
             */
            firmsUpdateName: (firmId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/firms/${firmId}/updateName`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Firms
             * @name FirmsUpdateYearFounded
             * @request POST:/v1/firms/{firmId}/updateYearFounded
             * @secure
             */
            firmsUpdateYearFounded: (firmId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/firms/${firmId}/updateYearFounded`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Firms
             * @name FirmsUpdateLegalShieldYearJoined
             * @request POST:/v1/firms/{firmId}/updateLegalShieldYearJoined
             * @secure
             */
            firmsUpdateLegalShieldYearJoined: (firmId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/firms/${firmId}/updateLegalShieldYearJoined`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Firms
             * @name FirmsUpdateExternalId
             * @request POST:/v1/firms/{firmId}/updateExternalId
             * @secure
             */
            firmsUpdateExternalId: (firmId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/firms/${firmId}/updateExternalId`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Firms
             * @name FirmsUpdateIdentityPermisisons
             * @request POST:/v1/firms/{firmId}/updateIdentityPermissions
             * @secure
             */
            firmsUpdateIdentityPermisisons: (firmId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/firms/${firmId}/updateIdentityPermissions`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Firms
             * @name FirmsAddPermission
             * @request POST:/v1/firms/{firmId}/addPermission
             * @secure
             */
            firmsAddPermission: (firmId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/firms/${firmId}/addPermission`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Firms
             * @name FirmsRemovePermission
             * @request POST:/v1/firms/{firmId}/removePermission
             * @secure
             */
            firmsRemovePermission: (firmId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/firms/${firmId}/removePermission`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Firms
             * @name FirmsUpdateNetwork
             * @request POST:/v1/firms/{firmId}/updateNetwork
             * @secure
             */
            firmsUpdateNetwork: (firmId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/firms/${firmId}/updateNetwork`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Firms
             * @name FirmsUpdateAboutUsText
             * @request POST:/v1/firms/{firmId}/updateAboutUsText
             * @secure
             */
            firmsUpdateAboutUsText: (firmId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/firms/${firmId}/updateAboutUsText`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Firms
             * @name FirmsUpdateProfilePictureUrl
             * @request POST:/v1/firms/{firmId}/updateProfilePictureUrl
             * @secure
             */
            firmsUpdateProfilePictureUrl: (firmId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/firms/${firmId}/updateProfilePictureUrl`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags FirmsJournal
             * @name FirmsJournalGetJournalChanges
             * @request GET:/v1/firms/journal
             * @secure
             */
            firmsJournalGetJournalChanges: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/firms/journal`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags FirmsJournal
             * @name FirmsJournalGetMaxClock
             * @request GET:/v1/firms/journal/maxClock
             * @secure
             */
            firmsJournalGetMaxClock: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/firms/journal/maxClock`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;

}(firms));

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(firms, exports);

}(firms$1));

var forms$1 = {};

var forms = {};

(function (exports) {
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.StatusEnum = exports.ActionEnum = void 0;
(function (ActionEnum) {
    ActionEnum["CREATED"] = "CREATED";
    ActionEnum["CHANGED"] = "CHANGED";
    ActionEnum["CANCELED"] = "CANCELED";
    ActionEnum["DELETED"] = "DELETED";
})(exports.ActionEnum || (exports.ActionEnum = {}));
(function (StatusEnum) {
    StatusEnum["ACTIVE"] = "ACTIVE";
    StatusEnum["CANCELED"] = "CANCELED";
    StatusEnum["DELETED"] = "DELETED";
})(exports.StatusEnum || (exports.StatusEnum = {}));
const axios_1 = __importDefault(axios);
const utils_1 = utils;
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://forms.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title Forms Service Api
 * @version v1
 * @baseUrl https://forms.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.identities = {
            /**
             * No description
             *
             * @tags Forms
             * @name FormsGetResourcesByOwner
             * @request GET:/identities/forms
             * @secure
             */
            formsGetResourcesByOwner: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/identities/forms`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Forms
             * @name FormsGetResourceById
             * @request GET:/identities/{identityId}/forms/{formName}
             * @secure
             */
            formsGetResourceById: (identityId, formName, params = { withCredentials: true }) => this.request(Object.assign({ path: `/identities/${identityId}/forms/${formName}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Forms
             * @name FormsDeleteResource
             * @request DELETE:/identities/{identityId}/forms/{formName}
             * @secure
             */
            formsDeleteResource: (identityId, formName, params = { withCredentials: true }) => this.request(Object.assign({ path: `/identities/${identityId}/forms/${formName}`, method: 'DELETE', secure: true }, params)),
        };
        this.createForm = {
            /**
             * No description
             *
             * @tags Forms
             * @name FormsCreateResource
             * @request POST:/createForm
             * @secure
             */
            formsCreateResource: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/createForm`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
        };
        this.getDownloadableForms = {
            /**
             * No description
             *
             * @tags Forms
             * @name FormsGet
             * @request GET:/getDownloadableForms
             * @secure
             */
            formsGet: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/getDownloadableForms`, method: 'GET', query: query, secure: true }, params)),
        };
        this.deleteAllResources = {
            /**
             * No description
             *
             * @tags Forms
             * @name FormsDeleteAllResources
             * @request DELETE:/deleteAllResources
             * @secure
             */
            formsDeleteAllResources: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/deleteAllResources`, method: 'DELETE', query: query, secure: true }, params)),
        };
        this.populate = {
            /**
             * No description
             *
             * @tags Forms
             * @name FormsPopulateDb
             * @request POST:/populate
             * @secure
             */
            formsPopulateDb: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/populate`, method: 'POST', query: query, secure: true, format: 'json' }, params)),
        };
        this.v1 = {
            /**
             * No description
             *
             * @tags FormsJournal
             * @name FormsJournalGetJournalChanges
             * @request GET:/v1/forms/journal
             * @secure
             */
            formsJournalGetJournalChanges: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/forms/journal`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;

}(forms));

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(forms, exports);

}(forms$1));

var groupEnrollments$1 = {};

var groupEnrollments = {};

(function (exports) {
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.DependentType = exports.Source = exports.BillingProviderType = exports.PaymentMethodType = exports.Period = exports.Title = exports.Status = exports.GroupEnrollmentAction = void 0;
(function (GroupEnrollmentAction) {
    GroupEnrollmentAction["CREATED"] = "CREATED";
    GroupEnrollmentAction["UPDATED"] = "UPDATED";
    GroupEnrollmentAction["SUBMITTED"] = "SUBMITTED";
})(exports.GroupEnrollmentAction || (exports.GroupEnrollmentAction = {}));
(function (Status) {
    Status[Status["OPEN"] = 0] = "OPEN";
    Status[Status["CREATED"] = 1] = "CREATED";
})(exports.Status || (exports.Status = {}));
(function (Title) {
    Title[Title["ACCOUNTANT"] = 0] = "ACCOUNTANT";
    Title[Title["ASSISTANT"] = 1] = "ASSISTANT";
    Title[Title["BUSINESS_MANAGER"] = 2] = "BUSINESS_MANAGER";
    Title[Title["CEO"] = 3] = "CEO";
    Title[Title["CFO"] = 4] = "CFO";
    Title[Title["CO_OWNER"] = 5] = "CO_OWNER";
    Title[Title["CONTROLLER"] = 6] = "CONTROLLER";
    Title[Title["COO"] = 7] = "COO";
    Title[Title["HR"] = 8] = "HR";
    Title[Title["MANAGER"] = 9] = "MANAGER";
    Title[Title["OFFICE_MANAGER"] = 10] = "OFFICE_MANAGER";
    Title[Title["OTHER"] = 11] = "OTHER";
    Title[Title["OWNER"] = 12] = "OWNER";
    Title[Title["PARTNER"] = 13] = "PARTNER";
    Title[Title["PRESIDENT"] = 14] = "PRESIDENT";
    Title[Title["SECRETARY"] = 15] = "SECRETARY";
    Title[Title["SUPERVISOR"] = 16] = "SUPERVISOR";
    Title[Title["TREASURER"] = 17] = "TREASURER";
    Title[Title["USER"] = 18] = "USER";
    Title[Title["VP"] = 19] = "VP";
})(exports.Title || (exports.Title = {}));
(function (Period) {
    Period[Period["DAY"] = 0] = "DAY";
    Period[Period["WEEK"] = 1] = "WEEK";
    Period[Period["MONTH"] = 2] = "MONTH";
    Period[Period["QUARTER"] = 3] = "QUARTER";
    Period[Period["BIANNUAL"] = 4] = "BIANNUAL";
    Period[Period["ANNUAL"] = 5] = "ANNUAL";
    Period[Period["PAY_PERIOD"] = 6] = "PAY_PERIOD";
})(exports.Period || (exports.Period = {}));
(function (PaymentMethodType) {
    PaymentMethodType[PaymentMethodType["CREDIT_CARD"] = 0] = "CREDIT_CARD";
    PaymentMethodType[PaymentMethodType["BANK_DRAFT"] = 1] = "BANK_DRAFT";
    PaymentMethodType[PaymentMethodType["PREMIUM_BILLING"] = 2] = "PREMIUM_BILLING";
    PaymentMethodType[PaymentMethodType["CHECK"] = 3] = "CHECK";
})(exports.PaymentMethodType || (exports.PaymentMethodType = {}));
(function (BillingProviderType) {
    BillingProviderType[BillingProviderType["SYSTEM_I"] = 0] = "SYSTEM_I";
})(exports.BillingProviderType || (exports.BillingProviderType = {}));
(function (Source) {
    Source[Source["LSWork"] = 0] = "LSWork";
})(exports.Source || (exports.Source = {}));
(function (DependentType) {
    DependentType[DependentType["Spouse"] = 0] = "Spouse";
    DependentType[DependentType["Dependent"] = 1] = "Dependent";
})(exports.DependentType || (exports.DependentType = {}));
const axios_1 = __importDefault(axios);
const utils_1 = utils;
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://group-enrollments.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title GroupEnrollments API
 * @version v1
 * @baseUrl https://group-enrollments.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * No description
             *
             * @tags GroupEnrollments
             * @name GroupEnrollmentsGetGroupEnrollmentsByIdentityId
             * @request GET:/v1/identities/{identityId}/groupEnrollments
             * @secure
             */
            groupEnrollmentsGetGroupEnrollmentsByIdentityId: (identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/groupEnrollments`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags GroupEnrollments
             * @name GroupEnrollmentsCreateGroupEnrollment
             * @request POST:/v1/identities/{identityId}/groupEnrollments
             * @secure
             */
            groupEnrollmentsCreateGroupEnrollment: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/groupEnrollments`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags GroupEnrollments
             * @name GroupEnrollmentsGetGroupEnrollmentById
             * @request GET:/v1/identities/{identityId}/groupEnrollments/{enrollmentId}
             * @secure
             */
            groupEnrollmentsGetGroupEnrollmentById: (enrollmentId, identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/groupEnrollments/${enrollmentId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags GroupEnrollments
             * @name GroupEnrollmentsUpdateGroupEnrollment
             * @request POST:/v1/identities/{identityId}/groupEnrollments/{enrollmentId}
             * @secure
             */
            groupEnrollmentsUpdateGroupEnrollment: (enrollmentId, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/groupEnrollments/${enrollmentId}`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags GroupEnrollments
             * @name GroupEnrollmentsUpdateGroupEnrollmentOffers
             * @request POST:/v1/identities/{identityId}/groupEnrollments/{enrollmentId}/changeOffers
             * @secure
             */
            groupEnrollmentsUpdateGroupEnrollmentOffers: (enrollmentId, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/groupEnrollments/${enrollmentId}/changeOffers`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags GroupEnrollments
             * @name GroupEnrollmentsUpdateGroupEnrollmentDependents
             * @request POST:/v1/identities/{identityId}/groupEnrollments/{enrollmentId}/changeDependents
             * @secure
             */
            groupEnrollmentsUpdateGroupEnrollmentDependents: (enrollmentId, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/groupEnrollments/${enrollmentId}/changeDependents`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags GroupEnrollments
             * @name GroupEnrollmentsSubmitGroupEnrollment
             * @request POST:/v1/identities/{identityId}/groupEnrollments/{enrollmentId}/submit
             * @secure
             */
            groupEnrollmentsSubmitGroupEnrollment: (identityId, enrollmentId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/groupEnrollments/${enrollmentId}/submit`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags GroupEnrollments
             * @name GroupEnrollmentsUpdateGroupEnrollmentAssociateInfo
             * @request POST:/v1/identities/{identityId}/groupEnrollments/{enrollmentId}/changeAssociateInfo
             * @secure
             */
            groupEnrollmentsUpdateGroupEnrollmentAssociateInfo: (enrollmentId, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/groupEnrollments/${enrollmentId}/changeAssociateInfo`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags GroupEnrollments
             * @name GroupEnrollmentsUpdateGroupEnrollmentIdentity
             * @request POST:/v1/identities/{identityId}/groupEnrollments/{enrollmentId}/changeIdentity
             * @secure
             */
            groupEnrollmentsUpdateGroupEnrollmentIdentity: (enrollmentId, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/groupEnrollments/${enrollmentId}/changeIdentity`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags GroupEnrollments
             * @name GroupEnrollmentsUpdateGroupEnrollmentBusiness
             * @request POST:/v1/identities/{identityId}/groupEnrollments/{enrollmentId}/offers/{offerId}/changeBusinessInfo
             * @secure
             */
            groupEnrollmentsUpdateGroupEnrollmentBusiness: (enrollmentId, offerId, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/groupEnrollments/${enrollmentId}/offers/${offerId}/changeBusinessInfo`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;

}(groupEnrollments));

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(groupEnrollments, exports);

}(groupEnrollments$1));

var groupMarketingSites$1 = {};

var groupMarketingSites = {};

(function (exports) {
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.StatusEnum = exports.ActionEnum = exports.CheckoutTypeEnum = exports.MemberServiceType = void 0;
(function (MemberServiceType) {
    MemberServiceType["NATIONAL"] = "NATIONAL";
    MemberServiceType["NONNATIONAL"] = "NONNATIONAL";
    MemberServiceType["CUSTOM"] = "CUSTOM";
})(exports.MemberServiceType || (exports.MemberServiceType = {}));
(function (CheckoutTypeEnum) {
    CheckoutTypeEnum["V1"] = "V1";
    CheckoutTypeEnum["V3"] = "V3";
    CheckoutTypeEnum["NONE"] = "NONE";
})(exports.CheckoutTypeEnum || (exports.CheckoutTypeEnum = {}));
(function (ActionEnum) {
    ActionEnum["CREATED"] = "CREATED";
    ActionEnum["CHANGED"] = "CHANGED";
    ActionEnum["CANCELED"] = "CANCELED";
    ActionEnum["CHANGE_OWNER"] = "CHANGE_OWNER";
    ActionEnum["DELETED"] = "DELETED";
    ActionEnum["UPDATE_STATUS"] = "UPDATE_STATUS";
})(exports.ActionEnum || (exports.ActionEnum = {}));
(function (StatusEnum) {
    StatusEnum["ACTIVE"] = "ACTIVE";
    StatusEnum["CANCELED"] = "CANCELED";
    StatusEnum["DELETED"] = "DELETED";
})(exports.StatusEnum || (exports.StatusEnum = {}));
const axios_1 = __importDefault(axios);
const utils_1 = utils;
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://group-marketing-sites.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title MarketingSites Service Api
 * @version v1
 * @baseUrl https://group-marketing-sites.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * No description
             *
             * @tags MarketingSites
             * @name MarketingSitesGetMarketingSiteById
             * @request GET:/v1/marketingSites/{marketingSitesId}
             * @secure
             */
            marketingSitesGetMarketingSiteById: (marketingSitesId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/marketingSites/${marketingSitesId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags MarketingSites
             * @name MarketingSitesDeleteMarketingSite
             * @request DELETE:/v1/marketingSites/{marketingSitesId}
             * @secure
             */
            marketingSitesDeleteMarketingSite: (marketingSitesId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/marketingSites/${marketingSitesId}`, method: 'DELETE', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags MarketingSites
             * @name MarketingSitesGetMarketingSiteByOwnerId
             * @request GET:/v1/marketingSites/owner/{ownerId}
             * @secure
             */
            marketingSitesGetMarketingSiteByOwnerId: (ownerId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/marketingSites/owner/${ownerId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags MarketingSites
             * @name MarketingSitesCreateMarketingSite
             * @request POST:/v1/marketingSites
             * @secure
             */
            marketingSitesCreateMarketingSite: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/marketingSites`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags MarketingSites
             * @name MarketingSitesUpdateMarketingSite
             * @request PUT:/v1/marketingSites
             * @secure
             */
            marketingSitesUpdateMarketingSite: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/marketingSites`, method: 'PUT', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags MarketingSites
             * @name MarketingSitesChangeMarketingSiteOwnerId
             * @request PUT:/v1/marketingSites/ownerId
             * @secure
             */
            marketingSitesChangeMarketingSiteOwnerId: (data, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/marketingSites/ownerId`, method: 'PUT', query: query, body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags MarketingSitesJournal
             * @name MarketingSitesJournalGetJournalChanges
             * @request GET:/v1/marketingSites/journal
             * @secure
             */
            marketingSitesJournalGetJournalChanges: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/marketingSites/journal`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags MarketingSitesJournal
             * @name MarketingSitesJournalGetJournalMaxClock
             * @request GET:/v1/marketingSites/journal/maxClock
             * @secure
             */
            marketingSitesJournalGetJournalMaxClock: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/marketingSites/journal/maxClock`, method: 'GET', secure: true, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;

}(groupMarketingSites));

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(groupMarketingSites, exports);

}(groupMarketingSites$1));

var groups$1 = {};

var groups = {};

(function (exports) {
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.BrokerType = exports.CommunicationPreferenceType = exports.RestrictedEffectiveDateEffectiveMonth = exports.RestrictedEffectiveDateStatus = exports.RestrictedEffectiveDateEnrollmentSource = exports.RestrictedPeriodType = exports.Format = exports.Transmission = exports.FileSchedule = exports.FileType = exports.ReviewType = exports.EnrollmentConfigFrequency = exports.EnrollmentMarketingSiteType = exports.EnrollmentConfigDefaultEnrollmentMethod = exports.AddressType = exports.ContactInfoType = exports.AuthorizedIdentityType = exports.Role = exports.CommissionStrategy = exports.Payout = exports.CommissionModel = exports.CancelReason = exports.PayType = exports.GroupStatus = exports.GroupAction = void 0;
(function (GroupAction) {
    GroupAction["CREATE"] = "CREATE";
    GroupAction["UPDATE"] = "UPDATE";
    GroupAction["ADD_AMENDMENTS"] = "ADD_AMENDMENTS";
    GroupAction["UPDATE_AMENDMENTS"] = "UPDATE_AMENDMENTS";
    GroupAction["ADD_AUTHORIZED_IDENTITIES"] = "ADD_AUTHORIZED_IDENTITIES";
    GroupAction["UPDATE_AUTHORIZED_IDENTITIES"] = "UPDATE_AUTHORIZED_IDENTITIES";
    GroupAction["ADD_ASSOCIATES"] = "ADD_ASSOCIATES";
    GroupAction["UPDATE_ASSOCIATES"] = "UPDATE_ASSOCIATES";
    GroupAction["ADD_OFFERS"] = "ADD_OFFERS";
    GroupAction["UPDATE_OFFERS"] = "UPDATE_OFFERS";
    GroupAction["DELETE"] = "DELETE";
    GroupAction["ACTIVATE"] = "ACTIVATE";
    GroupAction["PENDING"] = "PENDING";
    GroupAction["CANCEL"] = "CANCEL";
    GroupAction["ADD_ASSOCIATE"] = "ADD_ASSOCIATE";
    GroupAction["REMOVE_ASSOCIATE"] = "REMOVE_ASSOCIATE";
    GroupAction["ADD_AUTHORIZED_IDENTITY"] = "ADD_AUTHORIZED_IDENTITY";
    GroupAction["REMOVE_AUTHORIZED_IDENTITY"] = "REMOVE_AUTHORIZED_IDENTITY";
    GroupAction["ADD_OFFERID"] = "ADD_OFFERID";
    GroupAction["REMOVE_OFFERID"] = "REMOVE_OFFERID";
    GroupAction["UPDATE_COMMISSION"] = "UPDATE_COMMISSION";
    GroupAction["UPDATE_CONTACT_INFO"] = "UPDATE_CONTACT_INFO";
    GroupAction["UPDATE_ADDRESSES"] = "UPDATE_ADDRESSES";
    GroupAction["UPDATE_ENROLLMENT_CONFIG"] = "UPDATE_ENROLLMENT_CONFIG";
    GroupAction["UPDATE_PAYPERIODS"] = "UPDATE_PAYPERIODS";
    GroupAction["ADD_PAYPERIOD"] = "ADD_PAYPERIOD";
    GroupAction["REMOVE_PAYPERIOD"] = "REMOVE_PAYPERIOD";
    GroupAction["UPDATE_RESTRICTED_PERIODS"] = "UPDATE_RESTRICTED_PERIODS";
    GroupAction["ADD_RESTRICTED_PERIOD"] = "ADD_RESTRICTED_PERIOD";
    GroupAction["REMOVE_RESTRICTED_PERIOD"] = "REMOVE_RESTRICTED_PERIOD";
    GroupAction["UPDATE_RESTRICTED_EFFECTIVE_DATES"] = "UPDATE_RESTRICTED_EFFECTIVE_DATES";
    GroupAction["ADD_RESTRICTED_EFFECTIVE_DATE"] = "ADD_RESTRICTED_EFFECTIVE_DATE";
    GroupAction["REMOVE_RESTRICTED_EFFECTIVE_DATE"] = "REMOVE_RESTRICTED_EFFECTIVE_DATE";
    GroupAction["UPDATE_NAME"] = "UPDATE_NAME";
    GroupAction["UPDATE_COUNTRY_IDENTIFIER"] = "UPDATE_COUNTRY_IDENTIFIER";
    GroupAction["UPDATE_NUMBER_OF_EMPLOYEES"] = "UPDATE_NUMBER_OF_EMPLOYEES";
    GroupAction["UPDATE_ISNATIONAL"] = "UPDATE_ISNATIONAL";
    GroupAction["UPDATE_FRANCHISE"] = "UPDATE_FRANCHISE";
    GroupAction["UPDATE_PAYTYPE"] = "UPDATE_PAYTYPE";
    GroupAction["UPDATE_INDUSTRYTYPE"] = "UPDATE_INDUSTRYTYPE";
    GroupAction["UPDATE_EFFECTIVEAT"] = "UPDATE_EFFECTIVEAT";
    GroupAction["UPDATE_SERVICING"] = "UPDATE_SERVICING";
    GroupAction["UPDATE_ORIGINAL_DATE_OF_CREATION"] = "UPDATE_ORIGINAL_DATE_OF_CREATION";
    GroupAction["ADD_ASSOCIATE_ROLE"] = "ADD_ASSOCIATE_ROLE";
    GroupAction["REMOVE_ASSOCIATE_ROLE"] = "REMOVE_ASSOCIATE_ROLE";
    GroupAction["UPDATE_AUTHORIZED_IDENTITY_DIVISIONS"] = "UPDATE_AUTHORIZED_IDENTITY_DIVISIONS";
    GroupAction["UPDATE_COMMUNICATION_PREFERENCES"] = "UPDATE_COMMUNICATION_PREFERENCES";
    GroupAction["UPDATE_BROKER"] = "UPDATE_BROKER";
})(exports.GroupAction || (exports.GroupAction = {}));
(function (GroupStatus) {
    GroupStatus["NONE"] = "NONE";
    GroupStatus["ACTIVE"] = "ACTIVE";
    GroupStatus["CANCELLED"] = "CANCELLED";
    GroupStatus["PENDING"] = "PENDING";
    GroupStatus["CREATED"] = "CREATED";
    GroupStatus["DELETED"] = "DELETED";
})(exports.GroupStatus || (exports.GroupStatus = {}));
(function (PayType) {
    PayType["NONE"] = "NONE";
    PayType["SELF_PAY"] = "SELF_PAY";
    PayType["PAYROLL"] = "PAYROLL";
    PayType["FRINGE"] = "FRINGE";
    PayType["PARTIAL_FRINGE"] = "PARTIAL_FRINGE";
})(exports.PayType || (exports.PayType = {}));
(function (CancelReason) {
    CancelReason["NONE"] = "NONE";
    CancelReason["LACK_OF_PARTICIPATION"] = "LACK_OF_PARTICIPATION";
    CancelReason["COMBINED_WITH_OTHER_GROUPS"] = "COMBINED_WITH_OTHER_GROUPS";
    CancelReason["GROUP_DELINQUENT_STATUS"] = "GROUP_DELINQUENT_STATUS";
    CancelReason["FINANCIAL_REASON_OR_BANKRUPTCY"] = "FINANCIAL_REASON_OR_BANKRUPTCY";
    CancelReason["WRITTEN_REQUEST_FROM_GROUP"] = "WRITTEN_REQUEST_FROM_GROUP";
    CancelReason["NO_ACTIVE_MEMBERS"] = "NO_ACTIVE_MEMBERS";
    CancelReason["COMPANY_SOLD_OR_CLOSED"] = "COMPANY_SOLD_OR_CLOSED";
    CancelReason["TRANSFERRED"] = "TRANSFERRED";
    CancelReason["COMPANY_OPTION"] = "COMPANY_OPTION";
    CancelReason["FRINGE_CONTRACT"] = "FRINGE_CONTRACT";
    CancelReason["UNKNOWN"] = "UNKNOWN";
})(exports.CancelReason || (exports.CancelReason = {}));
(function (CommissionModel) {
    CommissionModel["NONE"] = "NONE";
    CommissionModel["ALTERNATE"] = "ALTERNATE";
    CommissionModel["OVER200"] = "OVER_200";
    CommissionModel["STANDARD"] = "STANDARD";
})(exports.CommissionModel || (exports.CommissionModel = {}));
(function (Payout) {
    Payout["NONE"] = "NONE";
    Payout["AS_EARNED"] = "AS_EARNED";
    Payout["PAYMENT_EARNINGS"] = "PAYMENT_EARNINGS";
    Payout["ADVANCE"] = "ADVANCE";
})(exports.Payout || (exports.Payout = {}));
(function (CommissionStrategy) {
    CommissionStrategy["HIGH_LOW"] = "HIGH_LOW";
    CommissionStrategy["LEVEL"] = "LEVEL";
    CommissionStrategy["NONE"] = "NONE";
})(exports.CommissionStrategy || (exports.CommissionStrategy = {}));
(function (Role) {
    Role["NONE"] = "NONE";
    Role["CURRENT_SERVICING"] = "CURRENT_SERVICING";
    Role["AUTHORIZED"] = "AUTHORIZED";
    Role["DESIGNATED"] = "DESIGNATED";
    Role["ORIGINAL_SERVICING"] = "ORIGINAL_SERVICING";
    Role["NATIONAL_SALES_DIRECTOR"] = "NATIONAL_SALES_DIRECTOR";
    Role["FINDERS_FEE"] = "FINDERS_FEE";
    Role["PRODUCER"] = "PRODUCER";
    Role["FIELD_TRAINER"] = "FIELD_TRAINER";
    Role["ONLINE"] = "ONLINE";
})(exports.Role || (exports.Role = {}));
(function (AuthorizedIdentityType) {
    AuthorizedIdentityType["GROUP_ADMINISTRATOR"] = "GROUP_ADMINISTRATOR";
    AuthorizedIdentityType["CUSTOMER_SERVICE_REPRESENTATIVE"] = "CUSTOMER_SERVICE_REPRESENTATIVE";
    AuthorizedIdentityType["AUTHORIZED_USER"] = "AUTHORIZED_USER";
    AuthorizedIdentityType["FILE_ADMINISTRATOR"] = "FILE_ADMINISTRATOR";
})(exports.AuthorizedIdentityType || (exports.AuthorizedIdentityType = {}));
(function (ContactInfoType) {
    ContactInfoType["PRIMARY"] = "PRIMARY";
    ContactInfoType["COMPANY"] = "COMPANY";
})(exports.ContactInfoType || (exports.ContactInfoType = {}));
(function (AddressType) {
    AddressType["MAILING"] = "MAILING";
    AddressType["BILLING"] = "BILLING";
})(exports.AddressType || (exports.AddressType = {}));
(function (EnrollmentConfigDefaultEnrollmentMethod) {
    EnrollmentConfigDefaultEnrollmentMethod["NONE"] = "NONE";
    EnrollmentConfigDefaultEnrollmentMethod["FILE"] = "FILE";
    EnrollmentConfigDefaultEnrollmentMethod["CHECKOUT"] = "CHECKOUT";
    EnrollmentConfigDefaultEnrollmentMethod["PAPER"] = "PAPER";
})(exports.EnrollmentConfigDefaultEnrollmentMethod || (exports.EnrollmentConfigDefaultEnrollmentMethod = {}));
(function (EnrollmentMarketingSiteType) {
    EnrollmentMarketingSiteType["NONE"] = "NONE";
    EnrollmentMarketingSiteType["CHECKOUT"] = "CHECKOUT";
    EnrollmentMarketingSiteType["WEB"] = "WEB";
})(exports.EnrollmentMarketingSiteType || (exports.EnrollmentMarketingSiteType = {}));
(function (EnrollmentConfigFrequency) {
    EnrollmentConfigFrequency["NONE"] = "NONE";
    EnrollmentConfigFrequency["EVERGREEN"] = "EVERGREEN";
    EnrollmentConfigFrequency["OPEN_ENROLLMENT"] = "OPEN_ENROLLMENT";
    EnrollmentConfigFrequency["OPEN_ENROLLMENT_WITH_NEW_HIRES"] = "OPEN_ENROLLMENT_WITH_NEW_HIRES";
    EnrollmentConfigFrequency["SCHEDULED"] = "SCHEDULED";
    EnrollmentConfigFrequency["OPEN"] = "OPEN";
})(exports.EnrollmentConfigFrequency || (exports.EnrollmentConfigFrequency = {}));
(function (ReviewType) {
    ReviewType["INACTIVE"] = "INACTIVE";
    ReviewType["ACTIVE"] = "ACTIVE";
    ReviewType["REVIEW"] = "REVIEW";
    ReviewType["TEST"] = "TEST";
})(exports.ReviewType || (exports.ReviewType = {}));
(function (FileType) {
    FileType["NONE"] = "NONE";
    FileType["FULL"] = "FULL";
    FileType["ADD_DROP_CHANGE"] = "ADD_DROP_CHANGE";
})(exports.FileType || (exports.FileType = {}));
(function (FileSchedule) {
    FileSchedule["NONE"] = "NONE";
    FileSchedule["AD_HOC"] = "AD_HOC";
    FileSchedule["ANNUAL"] = "ANNUAL";
    FileSchedule["BI_WEEKLY"] = "BI_WEEKLY";
    FileSchedule["DAILY"] = "DAILY";
    FileSchedule["MONTHLY"] = "MONTHLY";
    FileSchedule["ONE_TIME_FILE"] = "ONE_TIME_FILE";
    FileSchedule["SEMI_ANNUALLY"] = "SEMI_ANNUALLY";
    FileSchedule["SEMI_MONTHLY"] = "SEMI_MONTHLY";
    FileSchedule["QUARTERLY"] = "QUARTERLY";
    FileSchedule["WEEKLY"] = "WEEKLY";
})(exports.FileSchedule || (exports.FileSchedule = {}));
(function (Transmission) {
    Transmission["NONE"] = "NONE";
    Transmission["BENEFITFOCUS_SITE"] = "BENEFITFOCUS_SITE";
    Transmission["BRICK_USER"] = "BRICK_USER";
    Transmission["BRICKFTP"] = "BRICKFTP";
    Transmission["PGP"] = "PGP";
    Transmission["PW_PROTECTED_FILE"] = "PW_PROTECTED_FILE";
    Transmission["SECURE_EMAIL"] = "SECURE_EMAIL";
    Transmission["SFTP"] = "SFTP";
})(exports.Transmission || (exports.Transmission = {}));
(function (Format) {
    Format["NONE"] = "NONE";
    Format["CSV"] = "CSV";
    Format["EMPLOYEE_NAVIGATOR"] = "EMPLOYEE_NAVIGATOR";
    Format["EXCEL"] = "EXCEL";
    Format["IMAX"] = "IMAX";
    Format["TEXT"] = "TEXT";
})(exports.Format || (exports.Format = {}));
(function (RestrictedPeriodType) {
    RestrictedPeriodType["OPEN"] = "OPEN";
    RestrictedPeriodType["SCHEDULED"] = "SCHEDULED";
    RestrictedPeriodType["NONE"] = "NONE";
    RestrictedPeriodType["EVERGREEN"] = "EVERGREEN";
    RestrictedPeriodType["OPEN_ENROLLMENT"] = "OPEN_ENROLLMENT";
})(exports.RestrictedPeriodType || (exports.RestrictedPeriodType = {}));
(function (RestrictedEffectiveDateEnrollmentSource) {
    RestrictedEffectiveDateEnrollmentSource["FILE_TRANSFER"] = "FILE_TRANSFER";
    RestrictedEffectiveDateEnrollmentSource["LS_AT_WORK"] = "LS_AT_WORK";
    RestrictedEffectiveDateEnrollmentSource["PAPER"] = "PAPER";
    RestrictedEffectiveDateEnrollmentSource["WEB"] = "WEB";
    RestrictedEffectiveDateEnrollmentSource["ALL"] = "ALL";
})(exports.RestrictedEffectiveDateEnrollmentSource || (exports.RestrictedEffectiveDateEnrollmentSource = {}));
(function (RestrictedEffectiveDateStatus) {
    RestrictedEffectiveDateStatus["ACTIVE"] = "ACTIVE";
    RestrictedEffectiveDateStatus["INACTIVE"] = "INACTIVE";
})(exports.RestrictedEffectiveDateStatus || (exports.RestrictedEffectiveDateStatus = {}));
(function (RestrictedEffectiveDateEffectiveMonth) {
    RestrictedEffectiveDateEffectiveMonth["CURRENT_MONTH"] = "CURRENT_MONTH";
    RestrictedEffectiveDateEffectiveMonth["CURRENT_PLUS_ONE_MONTH"] = "CURRENT_PLUS_ONE_MONTH";
    RestrictedEffectiveDateEffectiveMonth["CURRENT_PLUS_TWO_MONTH"] = "CURRENT_PLUS_TWO_MONTH";
    RestrictedEffectiveDateEffectiveMonth["CURRENT_PLUS_THREE_MONTH"] = "CURRENT_PLUS_THREE_MONTH";
})(exports.RestrictedEffectiveDateEffectiveMonth || (exports.RestrictedEffectiveDateEffectiveMonth = {}));
(function (CommunicationPreferenceType) {
    CommunicationPreferenceType["LETTER"] = "LETTER";
    CommunicationPreferenceType["EMAIL"] = "EMAIL";
    CommunicationPreferenceType["BOTH"] = "BOTH";
})(exports.CommunicationPreferenceType || (exports.CommunicationPreferenceType = {}));
(function (BrokerType) {
    BrokerType["BROKER"] = "BROKER";
    BrokerType["TOP_BROKER"] = "TOP_BROKER";
})(exports.BrokerType || (exports.BrokerType = {}));
const axios_1 = __importDefault(axios);
const utils_1 = utils;
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://groups.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title Groups API
 * @version v1
 * @baseUrl https://groups.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * @description The journal is for internal use only
             *
             * @tags GroupsJournal
             * @name GroupsJournal
             * @summary Machine JWT Only
             * @request GET:/v1/groups/journal
             * @secure
             */
            groupsJournal: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/journal`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags GroupsJournal
             * @name GroupsJournalGetJournalMaxClock
             * @request GET:/v1/groups/journal/maxClock
             * @secure
             */
            groupsJournalGetJournalMaxClock: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/journal/maxClock`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsGetGroupById
             * @request GET:/v1/groups/{groupId}
             * @secure
             */
            groupsGetGroupById: (groupId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsDeleteGroup
             * @request DELETE:/v1/groups/{groupId}
             * @secure
             */
            groupsDeleteGroup: (groupId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}`, method: 'DELETE', secure: true }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsGetGroupByOwner
             * @request GET:/v1/groups
             * @secure
             */
            groupsGetGroupByOwner: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsCreateGroup
             * @request POST:/v1/groups
             * @secure
             */
            groupsCreateGroup: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsPending
             * @request POST:/v1/groups/{groupId}/pending
             * @secure
             */
            groupsPending: (groupId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/pending`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsActivate
             * @request POST:/v1/groups/{groupId}/activate
             * @secure
             */
            groupsActivate: (groupId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/activate`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsCancel
             * @request POST:/v1/groups/{groupId}/cancel
             * @secure
             */
            groupsCancel: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/cancel`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsUpdateName
             * @request POST:/v1/groups/{groupId}/updateName
             * @secure
             */
            groupsUpdateName: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/updateName`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsUpdateCountryIdentifier
             * @request POST:/v1/groups/{groupId}/updateCountryIdentifier
             * @secure
             */
            groupsUpdateCountryIdentifier: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/updateCountryIdentifier`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsUpdateEffectiveAt
             * @request POST:/v1/groups/{groupId}/updateEffectiveAt
             * @secure
             */
            groupsUpdateEffectiveAt: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/updateEffectiveAt`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsUpdateOriginalDateOfCreation
             * @request POST:/v1/groups/{groupId}/updateOriginalDateOfCreation
             * @secure
             */
            groupsUpdateOriginalDateOfCreation: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/updateOriginalDateOfCreation`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsUpdateNumberOfEmployees
             * @request POST:/v1/groups/{groupId}/updateNumberOfEmployees
             * @secure
             */
            groupsUpdateNumberOfEmployees: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/updateNumberOfEmployees`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsUpdateIsNational
             * @request POST:/v1/groups/{groupId}/updateIsNational
             * @secure
             */
            groupsUpdateIsNational: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/updateIsNational`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsUpdateFranchise
             * @request POST:/v1/groups/{groupId}/updateFranchise
             * @secure
             */
            groupsUpdateFranchise: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/updateFranchise`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsUpdateServicing
             * @request POST:/v1/groups/{groupId}/updateServicing
             * @secure
             */
            groupsUpdateServicing: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/updateServicing`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsUpdatePayType
             * @request POST:/v1/groups/{groupId}/updatePayType
             * @secure
             */
            groupsUpdatePayType: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/updatePayType`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsUpdateIndustryType
             * @request POST:/v1/groups/{groupId}/updateIndustryType
             * @secure
             */
            groupsUpdateIndustryType: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/updateIndustryType`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsAddAssociate
             * @request POST:/v1/groups/{groupId}/addAssociate
             * @secure
             */
            groupsAddAssociate: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/addAssociate`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsRemoveAssociate
             * @request POST:/v1/groups/{groupId}/removeAssociate
             * @secure
             */
            groupsRemoveAssociate: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/removeAssociate`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsAddAssociateRole
             * @request POST:/v1/groups/{groupId}/addAssociateRole
             * @secure
             */
            groupsAddAssociateRole: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/addAssociateRole`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsRemoveAssociateRole
             * @request POST:/v1/groups/{groupId}/removeAssociateRole
             * @secure
             */
            groupsRemoveAssociateRole: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/removeAssociateRole`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsAddAuthorizedIdentity
             * @request POST:/v1/groups/{groupId}/addAuthorizedIdentity
             * @secure
             */
            groupsAddAuthorizedIdentity: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/addAuthorizedIdentity`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsRemoveAuthorizedIdentity
             * @request POST:/v1/groups/{groupId}/removeAuthorizedIdentity
             * @secure
             */
            groupsRemoveAuthorizedIdentity: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/removeAuthorizedIdentity`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsUpdateAuthorizedIdentityDivisions
             * @request POST:/v1/groups/{groupId}/updateAuthorizedIdentityDivisions
             * @secure
             */
            groupsUpdateAuthorizedIdentityDivisions: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/updateAuthorizedIdentityDivisions`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsAddOfferId
             * @request POST:/v1/groups/{groupId}/addOfferId
             * @secure
             */
            groupsAddOfferId: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/addOfferId`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsRemoveOfferId
             * @request POST:/v1/groups/{groupId}/removeOfferId
             * @secure
             */
            groupsRemoveOfferId: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/removeOfferId`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsAddAmendment
             * @request POST:/v1/groups/{groupId}/addAmendment
             * @secure
             */
            groupsAddAmendment: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/addAmendment`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsRemoveAmendment
             * @request POST:/v1/groups/{groupId}/removeAmendment
             * @secure
             */
            groupsRemoveAmendment: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/removeAmendment`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsUpdateCommission
             * @request POST:/v1/groups/{groupId}/updateCommission
             * @secure
             */
            groupsUpdateCommission: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/updateCommission`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsAddContactInfo
             * @request POST:/v1/groups/{groupId}/addContactInfo
             * @secure
             */
            groupsAddContactInfo: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/addContactInfo`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsRemoveContactInfo
             * @request POST:/v1/groups/{groupId}/removeContactInfo
             * @secure
             */
            groupsRemoveContactInfo: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/removeContactInfo`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsAddAddress
             * @request POST:/v1/groups/{groupId}/addAddress
             * @secure
             */
            groupsAddAddress: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/addAddress`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsRemoveAddress
             * @request POST:/v1/groups/{groupId}/removeAddress
             * @secure
             */
            groupsRemoveAddress: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/removeAddress`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsUpdateEnrollmentConfig
             * @request POST:/v1/groups/{groupId}/updateEnrollmentConfig
             * @secure
             */
            groupsUpdateEnrollmentConfig: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/updateEnrollmentConfig`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsAddPayPeriod
             * @request POST:/v1/groups/{groupId}/addPayPeriod
             * @secure
             */
            groupsAddPayPeriod: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/addPayPeriod`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsRemovePayPeriod
             * @request POST:/v1/groups/{groupId}/removePayPeriod
             * @secure
             */
            groupsRemovePayPeriod: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/removePayPeriod`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsAddRestrictedPeriod
             * @request POST:/v1/groups/{groupId}/addRestrictedPeriod
             * @secure
             */
            groupsAddRestrictedPeriod: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/addRestrictedPeriod`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsRemoveRestrictedPeriod
             * @request POST:/v1/groups/{groupId}/removeRestrictedPeriod
             * @secure
             */
            groupsRemoveRestrictedPeriod: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/removeRestrictedPeriod`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsAddSpecificRestrictedEffectiveDate
             * @request POST:/v1/groups/{groupId}/addSpecificRestrictedEffectiveDate
             * @secure
             */
            groupsAddSpecificRestrictedEffectiveDate: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/addSpecificRestrictedEffectiveDate`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsRemoveSpecificRestrictedEffectiveDate
             * @request POST:/v1/groups/{groupId}/removeSpecificRestrictedEffectiveDate
             * @secure
             */
            groupsRemoveSpecificRestrictedEffectiveDate: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/removeSpecificRestrictedEffectiveDate`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsAddOngoingRestrictedEffectiveDate
             * @request POST:/v1/groups/{groupId}/addOngoingRestrictedEffectiveDate
             * @secure
             */
            groupsAddOngoingRestrictedEffectiveDate: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/addOngoingRestrictedEffectiveDate`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsRemoveOngoingRestrictedEffectiveDate
             * @request POST:/v1/groups/{groupId}/removeOngoingRestrictedEffectiveDate
             * @secure
             */
            groupsRemoveOngoingRestrictedEffectiveDate: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/removeOngoingRestrictedEffectiveDate`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsUpdateCommunicationPreferences
             * @request POST:/v1/groups/{groupId}/updateCommunicationPreferences
             * @secure
             */
            groupsUpdateCommunicationPreferences: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/updateCommunicationPreferences`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Groups
             * @name GroupsUpdateBroker
             * @request POST:/v1/groups/{groupId}/updateBroker
             * @secure
             */
            groupsUpdateBroker: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/updateBroker`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description modifies or creates an group in place
             *
             * @tags Migration
             * @name MachineJwtOnly
             * @summary Only to be called by migration services for extraction of data
             * @request POST:/v1/groups/migrate
             * @secure
             */
            machineJwtOnly: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/migrate`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description modifies or creates an group in place
             *
             * @tags Migration
             * @name MachineJwtOnly2
             * @summary Only to be called by migration services for extraction of data
             * @request POST:/v1/groups/migrate/{groupId}/addAuthorizedIdentities
             * @secure
             */
            machineJwtOnly2: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/migrate/${groupId}/addAuthorizedIdentities`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description modifies or creates a group in place
             *
             * @tags Migration
             * @name MachineJwtOnly3
             * @summary Only to be called by migration services for extraction of data
             * @request POST:/v1/groups/migrate/{groupId}/addAssociates
             * @secure
             */
            machineJwtOnly3: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/migrate/${groupId}/addAssociates`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description modifies or creates a group in place
             *
             * @tags Migration
             * @name MachineJwtOnly4
             * @summary Only to be called by migration services for extraction of data
             * @request POST:/v1/groups/migrate/{groupId}/addOffers
             * @secure
             */
            machineJwtOnly4: (groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/migrate/${groupId}/addOffers`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;

}(groups));

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(groups, exports);

}(groups$1));

var identityAmendments$1 = {};

var identityAmendments = {};

(function (exports) {
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.Status = exports.Action = void 0;
(function (Action) {
    Action["CREATED"] = "CREATED";
    Action["DELETED"] = "DELETED";
    Action["CHANGED_OWNER"] = "CHANGED_OWNER";
})(exports.Action || (exports.Action = {}));
(function (Status) {
    Status["ACTIVE"] = "ACTIVE";
    Status["DELETED"] = "DELETED";
})(exports.Status || (exports.Status = {}));
const axios_1 = __importDefault(axios);
const utils_1 = utils;
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://identity-amendments.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title Identity Amendments API
 * @version v1
 * @baseUrl https://identity-amendments.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * No description
             *
             * @tags IdentityAmendment
             * @name IdentityAmendmentGetByOwnerId
             * @request GET:/v1/identities/{identityId}/amendments
             * @secure
             */
            identityAmendmentGetByOwnerId: (identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/amendments`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags IdentityAmendment
             * @name IdentityAmendmentCreate
             * @request POST:/v1/identities/{identityId}/amendments
             * @secure
             */
            identityAmendmentCreate: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/amendments`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags IdentityAmendment
             * @name IdentityAmendmentChangeOwner
             * @request POST:/v1/amendments/{identityAmendmentId}/changeOwner
             * @secure
             */
            identityAmendmentChangeOwner: (identityAmendmentId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/amendments/${identityAmendmentId}/changeOwner`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags IdentityAmendment
             * @name IdentityAmendmentDelete
             * @request DELETE:/v1/amendments/{identityAmendmentId}
             * @secure
             */
            identityAmendmentDelete: (identityAmendmentId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/amendments/${identityAmendmentId}`, method: 'DELETE', secure: true }, params)),
            /**
             * @description The journal is for internal use only
             *
             * @tags IdentityAmendmentJournal
             * @name IdentityAmendmentJournal
             * @summary Machine JWT Only
             * @request GET:/v1/identityamendment/journal
             * @secure
             */
            identityAmendmentJournal: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identityamendment/journal`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags IdentityAmendmentJournal
             * @name IdentityAmendmentJournalGetJournalMaxClock
             * @request GET:/v1/identityamendment/journal/maxClock
             * @secure
             */
            identityAmendmentJournalGetJournalMaxClock: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identityamendment/journal/maxClock`, method: 'GET', secure: true, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;

}(identityAmendments));

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(identityAmendments, exports);

}(identityAmendments$1));

var identityMerge$1 = {};

var identityMerge = {};

(function (exports) {
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.ClassicIdType = exports.PhoneNumberType = exports.Status = exports.Action = void 0;
(function (Action) {
    Action["MERGE"] = "MERGE";
    Action["UNMERGE"] = "UNMERGE";
})(exports.Action || (exports.Action = {}));
(function (Status) {
    Status["CREATED"] = "CREATED";
    Status["IN_PROGRESS"] = "IN_PROGRESS";
    Status["OK"] = "OK";
    Status["WARNING"] = "WARNING";
    Status["FAILED"] = "FAILED";
    Status["PROCESSING"] = "PROCESSING";
    Status["COMPLETE"] = "COMPLETE";
})(exports.Status || (exports.Status = {}));
(function (PhoneNumberType) {
    PhoneNumberType["Home"] = "home";
    PhoneNumberType["Cell"] = "cell";
    PhoneNumberType["Work"] = "work";
})(exports.PhoneNumberType || (exports.PhoneNumberType = {}));
(function (ClassicIdType) {
    ClassicIdType["Member"] = "Member";
    ClassicIdType["Associate"] = "Associate";
    ClassicIdType["Dependent"] = "Dependent";
})(exports.ClassicIdType || (exports.ClassicIdType = {}));
const axios_1 = __importDefault(axios);
const utils_1 = utils;
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://identity-merge.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title IdentityMerge API
 * @version v1
 * @baseUrl https://identity-merge.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * No description
             *
             * @tags IdentityMerge
             * @name IdentityMergeMerge
             * @request POST:/v1/identities/{toIdentityId}/merge
             * @secure
             */
            identityMergeMerge: (toIdentityId, query, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${toIdentityId}/merge`, method: 'POST', query: query, body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags IdentityMerge
             * @name IdentityMergeUnMerge
             * @request POST:/v1/identities/{fromIdentityId}/unmerge
             * @secure
             */
            identityMergeUnMerge: (fromIdentityId, data, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${fromIdentityId}/unmerge`, method: 'POST', query: query, body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags IdentityMerge
             * @name IdentityMergeCreateMerge
             * @request POST:/v1/identities/merges
             * @secure
             */
            identityMergeCreateMerge: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/merges`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags IdentityMerge
             * @name IdentityMergeAddProcessorStatuses
             * @request POST:/v1/identities/merges/{identityMergeId}/addProcessorStatuses
             * @secure
             */
            identityMergeAddProcessorStatuses: (identityMergeId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/merges/${identityMergeId}/addProcessorStatuses`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags IdentityMerge
             * @name IdentityMergeGetResource
             * @request GET:/v1/identities/merges/{identityMergeId}
             * @secure
             */
            identityMergeGetResource: (identityMergeId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/merges/${identityMergeId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags IdentityMerge
             * @name IdentityMergeUpdateProcessorStatus
             * @request POST:/v1/identities/merges/{identityMergeId}/updateProcessorStatus
             * @secure
             */
            identityMergeUpdateProcessorStatus: (identityMergeId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/merges/${identityMergeId}/updateProcessorStatus`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description The journal is for internal use only
             *
             * @tags IdentityMergeJournal
             * @name IdentityMergeJournal
             * @summary Machine JWT Only
             * @request GET:/v1/identities/journal
             * @secure
             */
            identityMergeJournal: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/journal`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags IdentityMergeJournal
             * @name IdentityMergeJournalGetJournalMaxClock
             * @request GET:/v1/identities/journal/maxClock
             * @secure
             */
            identityMergeJournalGetJournalMaxClock: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/journal/maxClock`, method: 'GET', secure: true, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;

}(identityMerge));

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(identityMerge, exports);

}(identityMerge$1));

var idshieldforbusiness$1 = {};

var idshieldforbusiness = {};

(function (exports) {
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = void 0;
const axios_1 = __importDefault(axios);
const utils_1 = utils;
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://idshieldforbusiness.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title IDShield for Business Service API
 * @version v1
 * @baseUrl https://idshieldforbusiness.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * No description
             *
             * @tags Health
             * @name HealthGet
             * @request GET:/v1/health
             * @secure
             */
            healthGet: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/health`, method: 'GET', secure: true }, params)),
            /**
             * No description
             *
             * @tags IDShieldBusiness
             * @name IdShieldBusinessGetIdShieldBusinessStatesByUser
             * @request GET:/v1/users/{userId}/IDShieldBusinessStates
             * @secure
             */
            idShieldBusinessGetIdShieldBusinessStatesByUser: (userId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${userId}/IDShieldBusinessStates`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags IDShieldBusiness
             * @name IdShieldBusinessCreateIdShieldBusinessState
             * @request POST:/v1/users/{userId}/IDShieldBusinessStates
             * @secure
             */
            idShieldBusinessCreateIdShieldBusinessState: (userId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${userId}/IDShieldBusinessStates`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags IDShieldBusiness
             * @name IdShieldBusinessGetIdShieldBusinessStateById
             * @request GET:/v1/users/{userId}/IDShieldBusinessStates/{IDShieldBusinessStateId}
             * @secure
             */
            idShieldBusinessGetIdShieldBusinessStateById: (userId, idShieldBusinessStateId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${userId}/IDShieldBusinessStates/${idShieldBusinessStateId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags IDShieldBusiness
             * @name IdShieldBusinessUpdateIdShieldBusinessState
             * @request PUT:/v1/users/{userId}/IDShieldBusinessStates/{IDShieldBusinessStateId}
             * @secure
             */
            idShieldBusinessUpdateIdShieldBusinessState: (userId, idShieldBusinessStateId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${userId}/IDShieldBusinessStates/${idShieldBusinessStateId}`, method: 'PUT', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags IDShieldBusiness
             * @name IdShieldBusinessDeleteIdShieldBusinessState
             * @request DELETE:/v1/users/{userId}/IDShieldBusinessStates/{IDShieldBusinessStateId}
             * @secure
             */
            idShieldBusinessDeleteIdShieldBusinessState: (userId, idShieldBusinessStateId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${userId}/IDShieldBusinessStates/${idShieldBusinessStateId}`, method: 'DELETE', secure: true }, params)),
            /**
             * No description
             *
             * @tags IDShieldBusiness
             * @name IdShieldBusinessGetInteqLoginData
             * @request POST:/v1/users/{userId}/IDShieldBusinessStates/{IDShieldBusinessStateId}/getLogin
             * @secure
             */
            idShieldBusinessGetInteqLoginData: (userId, idShieldBusinessStateId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${userId}/IDShieldBusinessStates/${idShieldBusinessStateId}/getLogin`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags IDShieldBusinessJournal
             * @name IdShieldBusinessJournalGetJournalChanges
             * @request GET:/v1/idshieldbusiness/journal
             * @secure
             */
            idShieldBusinessJournalGetJournalChanges: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/idshieldbusiness/journal`, method: 'GET', query: query, secure: true }, params)),
            /**
             * No description
             *
             * @tags IDShieldBusinessJournal
             * @name IdShieldBusinessJournalGetJournalMaxClock
             * @request GET:/v1/idshieldbusiness/journal/maxClock
             * @secure
             */
            idShieldBusinessJournalGetJournalMaxClock: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/idshieldbusiness/journal/maxClock`, method: 'GET', secure: true, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;

}(idshieldforbusiness));

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(idshieldforbusiness, exports);

}(idshieldforbusiness$1));

var imagestore$1 = {};

var imagestore = {};

(function (exports) {
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.FileActionTypeEnum = void 0;
(function (FileActionTypeEnum) {
    FileActionTypeEnum["CREATE"] = "CREATE";
    FileActionTypeEnum["RETRIEVE"] = "RETRIEVE";
    FileActionTypeEnum["UPDATE"] = "UPDATE";
    FileActionTypeEnum["DELETE"] = "DELETE";
})(exports.FileActionTypeEnum || (exports.FileActionTypeEnum = {}));
const axios_1 = __importDefault(axios);
const utils_1 = utils;
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://imagestore.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title FileStorageService
 * @version v1
 * @baseUrl https://imagestore.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * No description
             *
             * @tags FilePrint
             * @name FilePrintCreateUrlPdfFile
             * @request POST:/v1/print/file
             * @secure
             */
            filePrintCreateUrlPdfFile: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/print/file`, method: 'POST', body: data, secure: true, type: FecContentType.Json }, params)),
            /**
             * No description
             *
             * @tags FilePrint
             * @name FilePrintStoreUrlPdfFile
             * @request POST:/v1/print/store
             * @secure
             */
            filePrintStoreUrlPdfFile: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/print/store`, method: 'POST', body: data, secure: true, type: FecContentType.Json }, params)),
            /**
             * No description
             *
             * @tags FileStorage
             * @name FileStorageGetFile
             * @request GET:/v1/container/files
             * @secure
             */
            fileStorageGetFile: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/container/files`, method: 'GET', query: query, secure: true }, params)),
            /**
             * No description
             *
             * @tags FileStorage
             * @name FileStorageRemoveFile
             * @request DELETE:/v1/container/files
             * @secure
             */
            fileStorageRemoveFile: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/container/files`, method: 'DELETE', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags FileStorage
             * @name FileStorageUploadFile
             * @request POST:/v1/container/files
             * @secure
             */
            fileStorageUploadFile: (data, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/container/files`, method: 'POST', query: query, body: data, secure: true, type: FecContentType.FormData, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;

}(imagestore));

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(imagestore, exports);

}(imagestore$1));

var invitations$1 = {};

var invitations = {};

(function (exports) {
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.IdentityType = exports.SecurityQuestionType = exports.Realm = exports.RelationPermissionType = exports.ResourceType = exports.InvitationAction = exports.InvitationStatus = void 0;
(function (InvitationStatus) {
    InvitationStatus["PENDING"] = "PENDING";
    InvitationStatus["ACCEPTED"] = "ACCEPTED";
})(exports.InvitationStatus || (exports.InvitationStatus = {}));
(function (InvitationAction) {
    InvitationAction["CREATED"] = "CREATED";
    InvitationAction["RESENT"] = "RESENT";
    InvitationAction["ACCEPTED"] = "ACCEPTED";
    InvitationAction["DELETED"] = "DELETED";
    InvitationAction["UPDATED"] = "UPDATED";
})(exports.InvitationAction || (exports.InvitationAction = {}));
(function (ResourceType) {
    ResourceType["RELATION"] = "RELATION";
    ResourceType["ENTITLEMENT"] = "ENTITLEMENT";
    ResourceType["SUBSCRIPTION"] = "SUBSCRIPTION";
})(exports.ResourceType || (exports.ResourceType = {}));
(function (RelationPermissionType) {
    RelationPermissionType["PRIMARY"] = "PRIMARY";
    RelationPermissionType["SPOUSE"] = "SPOUSE";
    RelationPermissionType["DEPENDENT"] = "DEPENDENT";
    RelationPermissionType["NORMAL_USER"] = "NORMAL_USER";
    RelationPermissionType["OWNER"] = "OWNER";
    RelationPermissionType["CO_OWNER"] = "CO_OWNER";
    RelationPermissionType["SECONDARY"] = "SECONDARY";
    RelationPermissionType["TERTIARY"] = "TERTIARY";
    RelationPermissionType["ELDER"] = "ELDER";
})(exports.RelationPermissionType || (exports.RelationPermissionType = {}));
(function (Realm) {
    Realm["User"] = "User";
    Realm["Machine"] = "Machine";
    Realm["Internal"] = "Internal";
    Realm["Partner"] = "Partner";
    Realm["GroupAdmin"] = "GroupAdmin";
})(exports.Realm || (exports.Realm = {}));
(function (SecurityQuestionType) {
    SecurityQuestionType["TEXT"] = "TEXT";
    SecurityQuestionType["DATE"] = "DATE";
    SecurityQuestionType["NUMBER"] = "NUMBER";
})(exports.SecurityQuestionType || (exports.SecurityQuestionType = {}));
(function (IdentityType) {
    IdentityType["OWNER"] = "OWNER";
    IdentityType["INVITEE"] = "INVITEE";
})(exports.IdentityType || (exports.IdentityType = {}));
const axios_1 = __importDefault(axios);
const utils_1 = utils;
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://invitations.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title Invitations API
 * @version v1
 * @baseUrl https://invitations.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * No description
             *
             * @tags Invitations
             * @name InvitationsCreateInvitation
             * @request POST:/v1/invitations
             * @secure
             */
            invitationsCreateInvitation: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/invitations`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Invitations
             * @name InvitationsFetchInvitation
             * @request GET:/v1/invitations/{invitationId}
             * @secure
             */
            invitationsFetchInvitation: (invitationId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/invitations/${invitationId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Invitations
             * @name InvitationsRemoveInvitation
             * @request DELETE:/v1/invitations/{invitationId}
             * @secure
             */
            invitationsRemoveInvitation: (invitationId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/invitations/${invitationId}`, method: 'DELETE', secure: true }, params)),
            /**
             * No description
             *
             * @tags Invitations
             * @name InvitationsFetchInvitationByCode
             * @request GET:/v1/invitations/verificationCode/{code}
             * @secure
             */
            invitationsFetchInvitationByCode: (code, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/invitations/verificationCode/${code}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Invitations
             * @name InvitationsFetchInvitations
             * @request GET:/v1/identities/{identityId}/invitations
             * @secure
             */
            invitationsFetchInvitations: (identityId, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/invitations`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Invitations
             * @name InvitationsFetchInvitationsByEmail
             * @request GET:/v1/invitations/invitee
             * @secure
             */
            invitationsFetchInvitationsByEmail: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/invitations/invitee`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Invitations
             * @name InvitationsResendInvitation
             * @request POST:/v1/invitations/{invitationId}/resend
             * @secure
             */
            invitationsResendInvitation: (invitationId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/invitations/${invitationId}/resend`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Invitations
             * @name InvitationsResendInvitationsByEmail
             * @request POST:/v1/invitations/resendAll
             * @secure
             */
            invitationsResendInvitationsByEmail: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/invitations/resendAll`, method: 'POST', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Invitations
             * @name InvitationsUpdateInvitee
             * @request POST:/v1/invitations/{invitationId}/updateInvitee
             * @secure
             */
            invitationsUpdateInvitee: (invitationId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/invitations/${invitationId}/updateInvitee`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Invitations
             * @name InvitationsAcceptInvitation
             * @request POST:/v1/invitations/{invitationId}/accept
             * @secure
             */
            invitationsAcceptInvitation: (invitationId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/invitations/${invitationId}/accept`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description The journal is for internal use only
             *
             * @tags Invitations
             * @name InvitationsJournal
             * @summary Machine JWT Only
             * @request GET:/v1/invitations/journal
             * @secure
             */
            invitationsJournal: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/invitations/journal`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Invitations
             * @name InvitationsGetJournalMaxClock
             * @request GET:/v1/invitations/journal/maxClock
             * @secure
             */
            invitationsGetJournalMaxClock: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/invitations/journal/maxClock`, method: 'GET', secure: true, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;

}(invitations));

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(invitations, exports);

}(invitations$1));

var invoices$1 = {};

var invoices = {};

(function (exports) {
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.Action = exports.InvoiceStatus = exports.InvoiceableItemType = exports.Currency = exports.InvoiceProductType = exports.RecurrenceType = void 0;
(function (RecurrenceType) {
    RecurrenceType["RECURRING"] = "RECURRING";
    RecurrenceType["ONE_TIME"] = "ONE_TIME";
})(exports.RecurrenceType || (exports.RecurrenceType = {}));
(function (InvoiceProductType) {
    InvoiceProductType["PRODUCT"] = "PRODUCT";
    InvoiceProductType["SUPPLEMENT"] = "SUPPLEMENT";
})(exports.InvoiceProductType || (exports.InvoiceProductType = {}));
(function (Currency) {
    Currency["USD"] = "USD";
    Currency["CAD"] = "CAD";
})(exports.Currency || (exports.Currency = {}));
(function (InvoiceableItemType) {
    InvoiceableItemType["SUBSCRIPTION"] = "SUBSCRIPTION";
    InvoiceableItemType["ORDER"] = "ORDER";
    InvoiceableItemType["DISCOUNT"] = "DISCOUNT";
    InvoiceableItemType["TRANSACTION"] = "TRANSACTION";
    InvoiceableItemType["TAX"] = "TAX";
})(exports.InvoiceableItemType || (exports.InvoiceableItemType = {}));
(function (InvoiceStatus) {
    InvoiceStatus["ACTIVE"] = "ACTIVE";
    InvoiceStatus["VOIDED"] = "VOIDED";
    InvoiceStatus["PAID"] = "PAID";
    InvoiceStatus["FORGIVEN"] = "FORGIVEN";
    InvoiceStatus["DELINQUENT"] = "DELINQUENT";
    InvoiceStatus["FAILED"] = "FAILED";
    InvoiceStatus["REFUNDED"] = "REFUNDED";
})(exports.InvoiceStatus || (exports.InvoiceStatus = {}));
(function (Action) {
    Action["CREATED"] = "CREATED";
    Action["STATUS_CHANGED"] = "STATUS_CHANGED";
    Action["ITEM_ADDED"] = "ITEM_ADDED";
    Action["ITEM_REMOVED"] = "ITEM_REMOVED";
    Action["TAX_UPDATED"] = "TAX_UPDATED";
    Action["PAYMENT_UPDATED"] = "PAYMENT_UPDATED";
    Action["DELETED"] = "DELETED";
    Action["CHANGE_OWNER"] = "CHANGE_OWNER";
})(exports.Action || (exports.Action = {}));
const axios_1 = __importDefault(axios);
const utils_1 = utils;
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://invoices.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title Invoices API
 * @version v1
 * @baseUrl https://invoices.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * No description
             *
             * @tags Invoices
             * @name InvoicesCreateInvoice
             * @request POST:/v1/identities/{identityId}/invoices
             * @secure
             */
            invoicesCreateInvoice: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/invoices`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Invoices
             * @name InvoicesListInvoices
             * @request GET:/v1/identities/{identityId}/invoices
             * @secure
             */
            invoicesListInvoices: (identityId, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/invoices`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Invoices
             * @name InvoicesPayInvoice
             * @request POST:/v1/identities/{identityId}/invoices/{invoiceId}/pay
             * @secure
             */
            invoicesPayInvoice: (identityId, invoiceId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/invoices/${invoiceId}/pay`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Invoices
             * @name InvoicesForgiveInvoice
             * @request POST:/v1/identities/{identityId}/invoices/{invoiceId}/forgive
             * @secure
             */
            invoicesForgiveInvoice: (identityId, invoiceId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/invoices/${invoiceId}/forgive`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Invoices
             * @name InvoicesVoidInvoice
             * @request POST:/v1/identities/{identityId}/invoices/{invoiceId}/void
             * @secure
             */
            invoicesVoidInvoice: (identityId, invoiceId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/invoices/${invoiceId}/void`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Invoices
             * @name InvoicesMakeDelinquent
             * @request POST:/v1/identities/{identityId}/invoices/{invoiceId}/makeDelinquent
             * @secure
             */
            invoicesMakeDelinquent: (identityId, invoiceId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/invoices/${invoiceId}/makeDelinquent`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Invoices
             * @name InvoicesFailInvoice
             * @request POST:/v1/identities/{identityId}/invoices/{invoiceId}/fail
             * @secure
             */
            invoicesFailInvoice: (identityId, invoiceId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/invoices/${invoiceId}/fail`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Invoices
             * @name InvoicesRefundInvoice
             * @request POST:/v1/identities/{identityId}/invoices/{invoiceId}/refund
             * @secure
             */
            invoicesRefundInvoice: (identityId, invoiceId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/invoices/${invoiceId}/refund`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Invoices
             * @name InvoicesGetInvoice
             * @request GET:/v1/identities/{identityId}/invoices/{invoiceId}
             * @secure
             */
            invoicesGetInvoice: (identityId, invoiceId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/invoices/${invoiceId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Invoices
             * @name InvoicesAddItem
             * @request POST:/v1/identities/{identityId}/invoices/{invoiceId}/addItem
             * @secure
             */
            invoicesAddItem: (identityId, invoiceId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/invoices/${invoiceId}/addItem`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Invoices
             * @name InvoicesRemoveItem
             * @request POST:/v1/identities/{identityId}/invoices/{invoiceId}/removeItem
             * @secure
             */
            invoicesRemoveItem: (identityId, invoiceId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/invoices/${invoiceId}/removeItem`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Invoices
             * @name InvoicesUpdatePaymentMethod
             * @request POST:/v1/identities/{identityId}/invoices/{invoiceId}/updatePaymentMethod
             * @secure
             */
            invoicesUpdatePaymentMethod: (identityId, invoiceId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/invoices/${invoiceId}/updatePaymentMethod`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Invoices
             * @name InvoicesChangeOwner
             * @request POST:/v1/identities/{identityId}/invoices/{invoiceId}/changeOwner
             * @secure
             */
            invoicesChangeOwner: (identityId, invoiceId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/invoices/${invoiceId}/changeOwner`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description The journal is for internal use only
             *
             * @tags InvoicesJournal
             * @name InvoicesJournal
             * @summary Machine JWT Only
             * @request GET:/v1/invoices/journal
             * @secure
             */
            invoicesJournal: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/invoices/journal`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags InvoicesJournal
             * @name InvoicesJournalGetJournalMaxClock
             * @request GET:/v1/invoices/journal/maxClock
             * @secure
             */
            invoicesJournalGetJournalMaxClock: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/invoices/journal/maxClock`, method: 'GET', secure: true, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;

}(invoices));

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(invoices, exports);

}(invoices$1));

var launches$1 = {};

var launches = {};

(function (exports) {
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.StatusEnum = exports.ActionEnum = void 0;
(function (ActionEnum) {
    ActionEnum["CREATE"] = "CREATE";
    ActionEnum["DELETE"] = "DELETE";
    ActionEnum["CHANGE_OWNER"] = "CHANGE_OWNER";
    ActionEnum["CHANGE_BUSINESS"] = "CHANGE_BUSINESS";
    ActionEnum["CHANGE_ENTITLEMENT"] = "CHANGE_ENTITLEMENT";
})(exports.ActionEnum || (exports.ActionEnum = {}));
(function (StatusEnum) {
    StatusEnum["CREATED"] = "CREATED";
    StatusEnum["ACTIVE"] = "ACTIVE";
    StatusEnum["DELETED"] = "DELETED";
})(exports.StatusEnum || (exports.StatusEnum = {}));
const axios_1 = __importDefault(axios);
const utils_1 = utils;
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://launches.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title Launches Service Api
 * @version v1
 * @baseUrl https://launches.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * No description
             *
             * @tags Launches
             * @name LaunchesGetResourcesByOwner
             * @request GET:/v1/identities/{identityId}/launches
             * @secure
             */
            launchesGetResourcesByOwner: (identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/launches`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Launches
             * @name LaunchesCreateResource
             * @request POST:/v1/identities/{identityId}/launches
             * @secure
             */
            launchesCreateResource: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/launches`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Launches
             * @name LaunchesGetResourceById
             * @request GET:/v1/identities/{identityId}/launches/{launchId}
             * @secure
             */
            launchesGetResourceById: (identityId, launchId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/launches/${launchId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Launches
             * @name LaunchesDeleteResource
             * @request DELETE:/v1/identities/{identityId}/launches/{launchId}
             * @secure
             */
            launchesDeleteResource: (identityId, launchId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/launches/${launchId}`, method: 'DELETE', secure: true }, params)),
            /**
             * No description
             *
             * @tags Launches
             * @name LaunchesChangeOwner
             * @request POST:/v1/identities/{identityId}/launches/{launchId}/changeOwner
             * @secure
             */
            launchesChangeOwner: (identityId, launchId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/launches/${launchId}/changeOwner`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags LaunchesJournal
             * @name LaunchesJournalGetJournalChanges
             * @request GET:/v1/launches/journal
             * @secure
             */
            launchesJournalGetJournalChanges: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/launches/journal`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags LaunchesJournal
             * @name LaunchesJournalGetJournalMaxClock
             * @request GET:/v1/launches/journal/maxClock
             * @secure
             */
            launchesJournalGetJournalMaxClock: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/launches/journal/maxClock`, method: 'GET', secure: true, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;

}(launches));

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(launches, exports);

}(launches$1));

var lawareas$1 = {};

var lawareas = {};

(function (exports) {
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.StatusEnum = exports.ActionEnum = void 0;
(function (ActionEnum) {
    ActionEnum["CREATED"] = "CREATED";
    ActionEnum["CHANGE"] = "CHANGE";
    ActionEnum["DELETED"] = "DELETED";
    ActionEnum["UPDATE_AREA_OF_LAW"] = "UPDATE_AREA_OF_LAW";
    ActionEnum["UPDATE_PARENT_ID"] = "UPDATE_PARENT_ID";
    ActionEnum["UPDATE_QUESTION_ID"] = "UPDATE_QUESTION_ID";
    ActionEnum["UPDATE_SHORT_CODE"] = "UPDATE_SHORT_CODE";
    ActionEnum["UPDATE_SORT_ORDER"] = "UPDATE_SORT_ORDER";
    ActionEnum["UPDATE_TEMPLATE_ID"] = "UPDATE_TEMPLATE_ID";
    ActionEnum["UPDATE_TRANSLATIONS"] = "UPDATE_TRANSLATIONS";
})(exports.ActionEnum || (exports.ActionEnum = {}));
(function (StatusEnum) {
    StatusEnum["ACTIVE"] = "ACTIVE";
    StatusEnum["DELETED"] = "DELETED";
})(exports.StatusEnum || (exports.StatusEnum = {}));
const axios_1 = __importDefault(axios);
const utils_1 = utils;
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://lawareas.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title LawAreas Service Api
 * @version v1
 * @baseUrl https://lawareas.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * No description
             *
             * @tags LawAreas
             * @name LawAreasGetAll
             * @request GET:/v1/lawAreas
             * @secure
             */
            lawAreasGetAll: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/lawAreas`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags LawAreas
             * @name LawAreasCreate
             * @request POST:/v1/lawAreas
             * @secure
             */
            lawAreasCreate: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/lawAreas`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags LawAreas
             * @name LawAreasGetById
             * @request GET:/v1/lawAreas/{lawAreaId}
             * @secure
             */
            lawAreasGetById: (lawAreaId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/lawAreas/${lawAreaId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags LawAreas
             * @name LawAreasReplaceResource
             * @request PUT:/v1/lawAreas/{lawAreaId}
             * @secure
             */
            lawAreasReplaceResource: (lawAreaId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/lawAreas/${lawAreaId}`, method: 'PUT', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags LawAreas
             * @name LawAreasDeleteResource
             * @request DELETE:/v1/lawAreas/{lawAreaId}
             * @secure
             */
            lawAreasDeleteResource: (lawAreaId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/lawAreas/${lawAreaId}`, method: 'DELETE', secure: true }, params)),
            /**
             * No description
             *
             * @tags LawAreas
             * @name LawAreasUpdateInternalName
             * @request POST:/v1/lawAreas/{lawAreaId}/updateInternalName/{internalName}
             * @secure
             */
            lawAreasUpdateInternalName: (lawAreaId, internalName, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/lawAreas/${lawAreaId}/updateInternalName/${internalName}`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags LawAreas
             * @name LawAreasUpdateParentId
             * @request POST:/v1/lawAreas/{lawAreaId}/updateParentId/{parentId}
             * @secure
             */
            lawAreasUpdateParentId: (lawAreaId, parentId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/lawAreas/${lawAreaId}/updateParentId/${parentId}`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags LawAreas
             * @name LawAreasUpdateQuestionId
             * @request POST:/v1/lawAreas/{lawAreaId}/updateQuestionId/{questionId}
             * @secure
             */
            lawAreasUpdateQuestionId: (lawAreaId, questionId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/lawAreas/${lawAreaId}/updateQuestionId/${questionId}`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags LawAreas
             * @name LawAreasUpdateShortCode
             * @request POST:/v1/lawAreas/{lawAreaId}/updateShortCode/{shortCode}
             * @secure
             */
            lawAreasUpdateShortCode: (lawAreaId, shortCode, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/lawAreas/${lawAreaId}/updateShortCode/${shortCode}`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags LawAreas
             * @name LawAreasUpdateSortOrder
             * @request POST:/v1/lawAreas/{lawAreaId}/updateSortOrder/{sortOrder}
             * @secure
             */
            lawAreasUpdateSortOrder: (lawAreaId, sortOrder, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/lawAreas/${lawAreaId}/updateSortOrder/${sortOrder}`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags LawAreas
             * @name LawAreasUpdateTemplateId
             * @request POST:/v1/lawAreas/{lawAreaId}/updateTemplateId/{templateId}
             * @secure
             */
            lawAreasUpdateTemplateId: (lawAreaId, templateId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/lawAreas/${lawAreaId}/updateTemplateId/${templateId}`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags LawAreas
             * @name LawAreasAddTranslation
             * @request POST:/v1/lawAreas/{lawAreaId}/locale/{locale}/addTranslation
             * @secure
             */
            lawAreasAddTranslation: (lawAreaId, locale, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/lawAreas/${lawAreaId}/locale/${locale}/addTranslation`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags LawAreas
             * @name LawAreasUpdateTranslation
             * @request POST:/v1/lawAreas/{lawAreaId}/locale/{locale}/updateTranslation
             * @secure
             */
            lawAreasUpdateTranslation: (lawAreaId, locale, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/lawAreas/${lawAreaId}/locale/${locale}/updateTranslation`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags LawAreas
             * @name LawAreasRemoveTranslation
             * @request POST:/v1/lawAreas/{lawAreaId}/locale/{locale}/removeTranslation
             * @secure
             */
            lawAreasRemoveTranslation: (lawAreaId, locale, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/lawAreas/${lawAreaId}/locale/${locale}/removeTranslation`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags LawAreasJournal
             * @name LawAreasJournalGetJournalChanges
             * @request GET:/v1/lawareas/journal
             * @secure
             */
            lawAreasJournalGetJournalChanges: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/lawareas/journal`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags LawAreasJournal
             * @name LawAreasJournalGetJournalMaxClock
             * @request GET:/v1/lawareas/journal/maxClock
             * @secure
             */
            lawAreasJournalGetJournalMaxClock: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/lawareas/journal/maxClock`, method: 'GET', secure: true, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;

}(lawareas));

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(lawareas, exports);

}(lawareas$1));

var notes$1 = {};

var notes = {};

(function (exports) {
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.SubjectType = exports.Priority = exports.Action = void 0;
(function (Action) {
    Action["CREATED"] = "CREATED";
    Action["PRIORITY_CHANGED"] = "PRIORITY_CHANGED";
    Action["DELETED"] = "DELETED";
    Action["OWNER_CHANGED"] = "OWNER_CHANGED";
})(exports.Action || (exports.Action = {}));
(function (Priority) {
    Priority["LOW"] = "LOW";
    Priority["MEDIUM"] = "MEDIUM";
    Priority["HIGH"] = "HIGH";
})(exports.Priority || (exports.Priority = {}));
(function (SubjectType) {
    SubjectType["ENTITLEMENT"] = "ENTITLEMENT";
    SubjectType["BRANCH"] = "BRANCH";
    SubjectType["CONTACT_LOG"] = "CONTACT_LOG";
})(exports.SubjectType || (exports.SubjectType = {}));
const axios_1 = __importDefault(axios);
const utils_1 = utils;
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://notes.api.legalshieldinternal.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title Internal Notes Service API
 * @version v1
 * @baseUrl https://notes.api.legalshieldinternal.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * No description
             *
             * @tags Notes
             * @name NotesCreate
             * @request POST:/v1/identities/{identityId}/notes
             * @secure
             */
            notesCreate: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/notes`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Notes
             * @name NotesFindByOwnerId
             * @request GET:/v1/identities/{identityId}/notes
             * @secure
             */
            notesFindByOwnerId: (identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/notes`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Notes
             * @name NotesUpdatePriority
             * @request POST:/v1/notes/{noteId}/updatePriority
             * @secure
             */
            notesUpdatePriority: (noteId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/notes/${noteId}/updatePriority`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Notes
             * @name NotesShow
             * @request GET:/v1/notes/{noteId}
             * @secure
             */
            notesShow: (noteId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/notes/${noteId}`, method: 'GET', secure: true }, params)),
            /**
             * No description
             *
             * @tags Notes
             * @name NotesDelete
             * @request DELETE:/v1/notes/{noteId}
             * @secure
             */
            notesDelete: (noteId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/notes/${noteId}`, method: 'DELETE', secure: true }, params)),
            /**
             * No description
             *
             * @tags Notes
             * @name NotesChangeOwner
             * @request POST:/v1/notes/{noteId}/changeOwner
             * @secure
             */
            notesChangeOwner: (noteId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/notes/${noteId}/changeOwner`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;

}(notes));

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(notes, exports);

}(notes$1));

var notifications$1 = {};

var notifications = {};

(function (exports) {
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.OptOutType = exports.Realm = exports.NotificationAction = exports.Provider = exports.NotificationStatus = exports.NotificationType = void 0;
(function (NotificationType) {
    NotificationType["EMAIL"] = "EMAIL";
    NotificationType["SMS"] = "SMS";
    NotificationType["PUSH"] = "PUSH";
})(exports.NotificationType || (exports.NotificationType = {}));
(function (NotificationStatus) {
    NotificationStatus["CREATED"] = "CREATED";
    NotificationStatus["PENDING"] = "PENDING";
    NotificationStatus["FAILED"] = "FAILED";
    NotificationStatus["RESENT"] = "RESENT";
    NotificationStatus["OPT_IN"] = "OPT_IN";
    NotificationStatus["OPT_OUT"] = "OPT_OUT";
    NotificationStatus["SCHEDULED"] = "SCHEDULED";
    NotificationStatus["CANCELLED"] = "CANCELLED";
    NotificationStatus["PROCESSED"] = "PROCESSED";
    NotificationStatus["DROPPED"] = "DROPPED";
    NotificationStatus["DELIVERED"] = "DELIVERED";
    NotificationStatus["DEFERRED"] = "DEFERRED";
    NotificationStatus["BOUNCE"] = "BOUNCE";
    NotificationStatus["BLOCKED"] = "BLOCKED";
    NotificationStatus["OPEN"] = "OPEN";
    NotificationStatus["CLICK"] = "CLICK";
    NotificationStatus["SPAM_REPORT"] = "SPAMREPORT";
    NotificationStatus["SPAMREPORT"] = "SPAMREPORT";
    NotificationStatus["UNSUBSCRIBE"] = "UNSUBSCRIBE";
    NotificationStatus["GROUP_UNSUBSCRIBE"] = "GROUP_UNSUBSCRIBE";
    NotificationStatus["GROUP_RESUBSCRIBE"] = "GROUP_RESUBSCRIBE";
    NotificationStatus["ACCEPTED"] = "ACCEPTED";
    NotificationStatus["QUEUED"] = "QUEUED";
    NotificationStatus["SENDING"] = "SENDING";
    NotificationStatus["SENT"] = "SENT";
    NotificationStatus["UNDELIVERED"] = "UNDELIVERED";
    NotificationStatus["RECEIVING"] = "RECEIVING";
    NotificationStatus["RECEIVED"] = "RECEIVED";
})(exports.NotificationStatus || (exports.NotificationStatus = {}));
(function (Provider) {
    Provider["SENDGRID"] = "SENDGRID";
    Provider["TWILIO"] = "TWILIO";
    Provider["FIREBASE"] = "FIREBASE";
})(exports.Provider || (exports.Provider = {}));
(function (NotificationAction) {
    NotificationAction["CREATED"] = "CREATED";
    NotificationAction["UPDATED"] = "UPDATED";
    NotificationAction["IDENTITY_CHANGED"] = "IDENTITY_CHANGED";
    NotificationAction["DELETED"] = "DELETED";
})(exports.NotificationAction || (exports.NotificationAction = {}));
(function (Realm) {
    Realm["User"] = "User";
    Realm["Machine"] = "Machine";
    Realm["Internal"] = "Internal";
    Realm["Partner"] = "Partner";
    Realm["GroupAdmin"] = "GroupAdmin";
})(exports.Realm || (exports.Realm = {}));
(function (OptOutType) {
    OptOutType["START"] = "START";
    OptOutType["STOP"] = "STOP";
    OptOutType["HELP"] = "HELP";
})(exports.OptOutType || (exports.OptOutType = {}));
const axios_1 = __importDefault(axios);
const utils_1 = utils;
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://notifications.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title Notifications
 * @version v1
 * @baseUrl https://notifications.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * No description
             *
             * @tags Email
             * @name EmailSendEmail
             * @request POST:/v1/sendEmail
             * @deprecated
             * @secure
             */
            emailSendEmail: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/sendEmail`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Notification
             * @name NotificationGetNotificationsByIdentityId
             * @request GET:/v1/identities/{identityId}/notifications
             * @secure
             */
            notificationGetNotificationsByIdentityId: (identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/notifications`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Notification
             * @name NotificationCreateNotificationsByIdentityId
             * @request POST:/v1/identities/{identityId}/notifications
             * @secure
             */
            notificationCreateNotificationsByIdentityId: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/notifications`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Notification
             * @name NotificationChangeIdentity
             * @request POST:/v1/identities/{identityId}/notifications/{notificationId}/changeIdentity
             * @secure
             */
            notificationChangeIdentity: (identityId, notificationId, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/notifications/${notificationId}/changeIdentity`, method: 'POST', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Notification
             * @name NotificationRemoveNotification
             * @request DELETE:/v1/identities/{identityId}/notifications/{notificationId}
             * @secure
             */
            notificationRemoveNotification: (identityId, notificationId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/notifications/${notificationId}`, method: 'DELETE', secure: true }, params)),
            /**
             * No description
             *
             * @tags Notification
             * @name NotificationSendOtpNotification
             * @request POST:/v1/identities/{identityId}/sendOtp
             * @secure
             */
            notificationSendOtpNotification: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/sendOtp`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Notification
             * @name NotificationSendNotification
             * @request POST:/v1/sendNotification
             * @secure
             */
            notificationSendNotification: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/sendNotification`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Notification
             * @name NotificationResendNotification
             * @request POST:/v1/notifications/{notificationId}/resend
             * @secure
             */
            notificationResendNotification: (notificationId, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/notifications/${notificationId}/resend`, method: 'POST', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Notification
             * @name NotificationCancelScheduledNotification
             * @request POST:/v1/notifications/{notificationId}/cancelScheduled
             * @secure
             */
            notificationCancelScheduledNotification: (notificationId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/notifications/${notificationId}/cancelScheduled`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Notification
             * @name NotificationUpdateDeliverOnDate
             * @request POST:/v1/notifications/{notificationId}/updateDeliverOn
             * @secure
             */
            notificationUpdateDeliverOnDate: (notificationId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/notifications/${notificationId}/updateDeliverOn`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Notification
             * @name NotificationProcessScheduledNotification
             * @request POST:/v1/notifications/{notificationId}/processScheduled
             * @secure
             */
            notificationProcessScheduledNotification: (notificationId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/notifications/${notificationId}/processScheduled`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags NotificationsJournal
             * @name NotificationsJournalGetJournalChanges
             * @request GET:/v1/notifications/journal
             * @secure
             */
            notificationsJournalGetJournalChanges: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/notifications/journal`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags NotificationsJournal
             * @name NotificationsJournalGetJournalMaxClock
             * @request GET:/v1/notifications/journal/maxClock
             * @secure
             */
            notificationsJournalGetJournalMaxClock: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/notifications/journal/maxClock`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags NotificationsTemplates
             * @name NotificationsTemplatesGetTemplates
             * @request GET:/v1/notifications/templates
             * @secure
             */
            notificationsTemplatesGetTemplates: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/notifications/templates`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags NotificationsTemplates
             * @name NotificationsTemplatesCreateTemplateResource
             * @request POST:/v1/notifications/templates
             * @secure
             */
            notificationsTemplatesCreateTemplateResource: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/notifications/templates`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags NotificationsTemplates
             * @name NotificationsTemplatesGetTemplatesForKey
             * @request GET:/v1/notifications/templates/{key}
             * @secure
             */
            notificationsTemplatesGetTemplatesForKey: (key, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/notifications/templates/${key}`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags NotificationsTemplates
             * @name NotificationsTemplatesAddLocalizedTemplate
             * @request PUT:/v1/notifications/templates/{templateKey}/{templateType}/{templateLocale}
             * @secure
             */
            notificationsTemplatesAddLocalizedTemplate: (templateKey, templateType, templateLocale, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/notifications/templates/${templateKey}/${templateType}/${templateLocale}`, method: 'PUT', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags NotificationsTemplates
             * @name NotificationsTemplatesRemoveLocalizedTemplate
             * @request DELETE:/v1/notifications/templates/{templateKey}/{templateType}/{templateLocale}
             * @secure
             */
            notificationsTemplatesRemoveLocalizedTemplate: (templateKey, templateType, templateLocale, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/notifications/templates/${templateKey}/${templateType}/${templateLocale}`, method: 'DELETE', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags NotificationsTemplates
             * @name NotificationsTemplatesRemoveTemplateResource
             * @request DELETE:/v1/notifications/templates/{templateKey}
             * @secure
             */
            notificationsTemplatesRemoveTemplateResource: (templateKey, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/notifications/templates/${templateKey}`, method: 'DELETE', secure: true }, params)),
            /**
             * No description
             *
             * @tags Template
             * @name TemplateGetTemplates
             * @request GET:/v1/templates
             * @secure
             */
            templateGetTemplates: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/templates`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Template
             * @name TemplateGetTemplatesForKey
             * @request GET:/v1/templates/{key}
             * @secure
             */
            templateGetTemplatesForKey: (key, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/templates/${key}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Webhook
             * @name WebhookProcessSendGridWebhookEvent
             * @request POST:/v1/sendgrid/events
             * @secure
             */
            webhookProcessSendGridWebhookEvent: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/sendgrid/events`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Webhook
             * @name WebhookProcessTwilioWebhookEvent
             * @request POST:/v1/twilio/events
             * @secure
             */
            webhookProcessTwilioWebhookEvent: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/twilio/events`, method: 'POST', body: data, secure: true, type: FecContentType.FormData, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Webhook
             * @name WebhookProcessTwilioSmsWebhook
             * @request POST:/v1/twilio/sms
             * @secure
             */
            webhookProcessTwilioSmsWebhook: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/twilio/sms`, method: 'POST', body: data, secure: true, type: FecContentType.FormData }, params)),
        };
    }
}
exports.Api = Api;

}(notifications));

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(notifications, exports);

}(notifications$1));

var offers$1 = {};

var offers = {};

(function (exports) {
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.Status = exports.OfferAction = exports.Currency = exports.CoBrandPartner = exports.OfferType = exports.Channel = exports.BillingPeriod = void 0;
(function (BillingPeriod) {
    BillingPeriod["DAILY"] = "DAILY";
    BillingPeriod["WEEKLY"] = "WEEKLY";
    BillingPeriod["MONTHLY"] = "MONTHLY";
    BillingPeriod["ANNUAL"] = "ANNUAL";
    BillingPeriod["BIANNUAL"] = "BIANNUAL";
    BillingPeriod["QUARTERLY"] = "QUARTERLY";
    BillingPeriod["PAY_PERIOD"] = "PAY_PERIOD";
})(exports.BillingPeriod || (exports.BillingPeriod = {}));
(function (Channel) {
    Channel["D2C"] = "D2C";
    Channel["NETWORK"] = "NETWORK";
    Channel["GROUP"] = "GROUP";
})(exports.Channel || (exports.Channel = {}));
(function (OfferType) {
    OfferType["STANDARD"] = "STANDARD";
    OfferType["LEGACY"] = "LEGACY";
    OfferType["EXPERIMENTAL"] = "EXPERIMENTAL";
})(exports.OfferType || (exports.OfferType = {}));
(function (CoBrandPartner) {
    CoBrandPartner["PRIMERICA"] = "PRIMERICA";
    CoBrandPartner["SOFI"] = "SOFI";
    CoBrandPartner["NEWITY"] = "NEWITY";
})(exports.CoBrandPartner || (exports.CoBrandPartner = {}));
(function (Currency) {
    Currency["USD"] = "USD";
    Currency["CAD"] = "CAD";
})(exports.Currency || (exports.Currency = {}));
(function (OfferAction) {
    OfferAction["CREATED"] = "CREATED";
    OfferAction["UPDATED"] = "UPDATED";
    OfferAction["PRODUCTS_ADDED"] = "PRODUCTS_ADDED";
    OfferAction["PRODUCTS_UPDATED"] = "PRODUCTS_UPDATED";
    OfferAction["DELETED"] = "DELETED";
    OfferAction["STATUS_UPDATED"] = "STATUS_UPDATED";
    OfferAction["AVAILABLE_LOCALITIES_UPDATED"] = "AVAILABLE_LOCALITIES_UPDATED";
    OfferAction["MIGRATION_UPDATE"] = "MIGRATION_UPDATE";
    OfferAction["PROVISION_TYPE_CHANGE"] = "PROVISION_TYPE_CHANGE";
})(exports.OfferAction || (exports.OfferAction = {}));
(function (Status) {
    Status["PENDING_APPROVAL"] = "PENDING_APPROVAL";
    Status["NEEDS_REVIEW"] = "NEEDS_REVIEW";
    Status["AVAILABLE_FOR_SALE"] = "AVAILABLE_FOR_SALE";
    Status["ENROLLABLE"] = "ENROLLABLE";
    Status["GRANDFATHERED"] = "GRANDFATHERED";
})(exports.Status || (exports.Status = {}));
const axios_1 = __importDefault(axios);
const utils_1 = utils;
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://offers.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title Offers API
 * @version v1
 * @baseUrl https://offers.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * No description
             *
             * @tags OfferMigrations
             * @name OfferMigrationsMigrateOffer
             * @request POST:/v1/brands/{brandName}/offers/migrate
             * @secure
             */
            offerMigrationsMigrateOffer: (brandName, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/brands/${brandName}/offers/migrate`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags OfferMigrations
             * @name OfferMigrationsMigrateGroupOffer
             * @request POST:/v1/brands/{brandName}/offers/groupMigrate
             * @secure
             */
            offerMigrationsMigrateGroupOffer: (brandName, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/brands/${brandName}/offers/groupMigrate`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Offers
             * @name OffersGetOffers
             * @request GET:/v1/brands/{brandName}/offers
             * @secure
             */
            offersGetOffers: (brandName, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/brands/${brandName}/offers`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Offers
             * @name OffersCreateOffer
             * @request POST:/v1/brands/{brandName}/offers
             * @secure
             */
            offersCreateOffer: (brandName, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/brands/${brandName}/offers`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Offers
             * @name OffersGetOffer
             * @request GET:/v1/brands/{brandName}/offers/{offerId}
             * @secure
             */
            offersGetOffer: (brandName, offerId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/brands/${brandName}/offers/${offerId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Offers
             * @name OffersUpdateOffer
             * @request PUT:/v1/brands/{brandName}/offers/{offerId}
             * @secure
             */
            offersUpdateOffer: (brandName, offerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/brands/${brandName}/offers/${offerId}`, method: 'PUT', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Offers
             * @name OffersDeleteOffer
             * @request DELETE:/v1/brands/{brandName}/offers/{offerId}
             * @secure
             */
            offersDeleteOffer: (brandName, offerId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/brands/${brandName}/offers/${offerId}`, method: 'DELETE', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Offers
             * @name OffersAddProducts
             * @request POST:/v1/brands/{brandName}/offers/{offerId}/addProducts
             * @secure
             */
            offersAddProducts: (brandName, offerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/brands/${brandName}/offers/${offerId}/addProducts`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Offers
             * @name OffersUpdateProducts
             * @request POST:/v1/brands/{brandName}/offers/{offerId}/updateProducts
             * @secure
             */
            offersUpdateProducts: (brandName, offerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/brands/${brandName}/offers/${offerId}/updateProducts`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Offers
             * @name OffersUpdateAvailableLocalities
             * @request POST:/v1/brands/{brandName}/offers/{offerId}/updateAvailableLocalities
             * @secure
             */
            offersUpdateAvailableLocalities: (brandName, offerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/brands/${brandName}/offers/${offerId}/updateAvailableLocalities`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Offers
             * @name OffersPendingApproval
             * @request POST:/v1/brands/{brandName}/offers/{offerId}/pendingApproval
             * @secure
             */
            offersPendingApproval: (brandName, offerId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/brands/${brandName}/offers/${offerId}/pendingApproval`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Offers
             * @name OffersMakeEnrollable
             * @request POST:/v1/brands/{brandName}/offers/{offerId}/makeEnrollable
             * @secure
             */
            offersMakeEnrollable: (brandName, offerId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/brands/${brandName}/offers/${offerId}/makeEnrollable`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Offers
             * @name OffersReadyForSale
             * @request POST:/v1/brands/{brandName}/offers/{offerId}/readyForSale
             * @secure
             */
            offersReadyForSale: (brandName, offerId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/brands/${brandName}/offers/${offerId}/readyForSale`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Offers
             * @name OffersGrandfather
             * @request POST:/v1/brands/{brandName}/offers/{offerId}/grandfather
             * @secure
             */
            offersGrandfather: (brandName, offerId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/brands/${brandName}/offers/${offerId}/grandfather`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Offers
             * @name OffersValidateSelections
             * @request POST:/v1/brands/{brandName}/offers/{offerId}/validateSelections
             * @secure
             */
            offersValidateSelections: (brandName, offerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/brands/${brandName}/offers/${offerId}/validateSelections`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Offers
             * @name OffersUpdateProvisionTypeToOnFirstUse
             * @request POST:/v1/brands/{brandName}/offers/{offerId}/products/{productId}/provisionType/onFirstUse
             * @secure
             */
            offersUpdateProvisionTypeToOnFirstUse: (brandName, offerId, productId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/brands/${brandName}/offers/${offerId}/products/${productId}/provisionType/onFirstUse`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Offers
             * @name OffersUpdateProvisionTypeToImmediate
             * @request POST:/v1/brands/{brandName}/offers/{offerId}/products/{productId}/provisionType/immediate
             * @secure
             */
            offersUpdateProvisionTypeToImmediate: (brandName, offerId, productId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/brands/${brandName}/offers/${offerId}/products/${productId}/provisionType/immediate`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * @description The journal is for internal use only
             *
             * @tags OffersJournal
             * @name OffersJournal
             * @summary Machine JWT Only
             * @request GET:/v1/offers/journal
             * @secure
             */
            offersJournal: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/offers/journal`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;

}(offers));

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(offers, exports);

}(offers$1));

var paymentMethods$1 = {};

var paymentMethods = {};

(function (exports) {
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.TransactionStatus = exports.Currency = exports.TransactionType = exports.PaymentMethodAction = exports.PaymentMethodStatus = exports.BankAccountType = exports.CardType = exports.Vendor = void 0;
(function (Vendor) {
    Vendor["ISERIES"] = "ISERIES";
    Vendor["TOKENEX_VANTIV"] = "TOKENEX_VANTIV";
    Vendor["TEST"] = "TEST";
})(exports.Vendor || (exports.Vendor = {}));
(function (CardType) {
    CardType["AMEX"] = "AMEX";
    CardType["DISCOVER"] = "DISCOVER";
    CardType["MASTERCARD"] = "MASTERCARD";
    CardType["VISA"] = "VISA";
    CardType["UNKNOWN"] = "UNKNOWN";
})(exports.CardType || (exports.CardType = {}));
(function (BankAccountType) {
    BankAccountType["CHECKING"] = "CHECKING";
    BankAccountType["SAVINGS"] = "SAVINGS";
})(exports.BankAccountType || (exports.BankAccountType = {}));
(function (PaymentMethodStatus) {
    PaymentMethodStatus["INACTIVE"] = "INACTIVE";
    PaymentMethodStatus["ACTIVE"] = "ACTIVE";
})(exports.PaymentMethodStatus || (exports.PaymentMethodStatus = {}));
(function (PaymentMethodAction) {
    PaymentMethodAction["CREATE"] = "CREATE";
    PaymentMethodAction["UPDATE"] = "UPDATE";
    PaymentMethodAction["DELETED"] = "DELETED";
})(exports.PaymentMethodAction || (exports.PaymentMethodAction = {}));
(function (TransactionType) {
    TransactionType["AUTHORIZE"] = "AUTHORIZE";
    TransactionType["CHARGE"] = "CHARGE";
    TransactionType["SALE"] = "SALE";
    TransactionType["VERIFY"] = "VERIFY";
    TransactionType["REFUND"] = "REFUND";
})(exports.TransactionType || (exports.TransactionType = {}));
(function (Currency) {
    Currency["USD"] = "USD";
    Currency["CAD"] = "CAD";
})(exports.Currency || (exports.Currency = {}));
(function (TransactionStatus) {
    TransactionStatus["APPROVED"] = "APPROVED";
    TransactionStatus["DECLINED"] = "DECLINED";
    TransactionStatus["TIMEDOUT"] = "TIMEDOUT";
    TransactionStatus["CREATED"] = "CREATED";
    TransactionStatus["HARD_DECLINED"] = "HARD_DECLINED";
})(exports.TransactionStatus || (exports.TransactionStatus = {}));
const axios_1 = __importDefault(axios);
const utils_1 = utils;
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://payment-methods.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title Payment Methods
 * @version v1
 * @baseUrl https://payment-methods.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * No description
             *
             * @tags Cooldown
             * @name CooldownGetStatus
             * @request GET:/v1/identities/{identityId}/checkCooldown
             * @secure
             */
            cooldownGetStatus: (identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/checkCooldown`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags PaymentMethods
             * @name PaymentMethodsGetPaymentMethods
             * @request GET:/v1/identities/{identityId}/paymentMethods
             * @secure
             */
            paymentMethodsGetPaymentMethods: (identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/paymentMethods`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags PaymentMethods
             * @name PaymentMethodsCreatePaymentMethod
             * @request POST:/v1/identities/{identityId}/paymentMethods
             * @secure
             */
            paymentMethodsCreatePaymentMethod: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/paymentMethods`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags PaymentMethods
             * @name PaymentMethodsGetPaymentMethod
             * @request GET:/v1/identities/{identityId}/paymentMethods/{paymentMethodId}
             * @secure
             */
            paymentMethodsGetPaymentMethod: (identityId, paymentMethodId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/paymentMethods/${paymentMethodId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * @description Requires machine, internal, or user match JWTs
             *
             * @tags PaymentMethods
             * @name PaymentMethodsDeletePaymentMethod
             * @summary Machine, Internal, or UserMatch JWT Only
             * @request DELETE:/v1/identities/{identityId}/paymentMethods/{paymentMethodId}
             * @secure
             */
            paymentMethodsDeletePaymentMethod: (identityId, paymentMethodId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/paymentMethods/${paymentMethodId}`, method: 'DELETE', secure: true }, params)),
            /**
             * No description
             *
             * @tags PaymentMethods
             * @name PaymentMethodsGetPaymentMethodById
             * @request GET:/v1/paymentMethods/{paymentMethodId}
             * @secure
             */
            paymentMethodsGetPaymentMethodById: (paymentMethodId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/paymentMethods/${paymentMethodId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags PaymentMethods
             * @name PaymentMethodsUpdateCardPaymentDetails
             * @request POST:/v1/identities/{identityId}/paymentMethods/{paymentMethodId}/updateCardPaymentDetails
             * @secure
             */
            paymentMethodsUpdateCardPaymentDetails: (identityId, paymentMethodId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/paymentMethods/${paymentMethodId}/updateCardPaymentDetails`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags PaymentMethods
             * @name PaymentMethodsUpdateBankAccountDetails
             * @request POST:/v1/identities/{identityId}/paymentMethods/{paymentMethodId}/updateBankAccountDetails
             * @secure
             */
            paymentMethodsUpdateBankAccountDetails: (identityId, paymentMethodId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/paymentMethods/${paymentMethodId}/updateBankAccountDetails`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags PaymentMethods
             * @name PaymentMethodsCreateNonOwnerPaymentMethod
             * @request POST:/v1/groups/{groupId}/identities/{identityId}/paymentMethods
             * @secure
             */
            paymentMethodsCreateNonOwnerPaymentMethod: (identityId, groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/identities/${identityId}/paymentMethods`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description The journal is for internal use only
             *
             * @tags PaymentMethodsJournal
             * @name PaymentMethodsJournal
             * @summary Machine JWT Only
             * @request GET:/v1/paymentMethods/journal
             * @secure
             */
            paymentMethodsJournal: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/paymentMethods/journal`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags PaymentMethodsJournal
             * @name PaymentMethodsJournalGetJournalMaxClock
             * @request GET:/v1/paymentMethods/journal/maxClock
             * @secure
             */
            paymentMethodsJournalGetJournalMaxClock: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/paymentMethods/journal/maxClock`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Transactions
             * @name TransactionsCreateCharge
             * @request POST:/v1/identities/{identityId}/paymentMethods/{id}/createCharge
             * @deprecated
             * @secure
             */
            transactionsCreateCharge: (identityId, id, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/paymentMethods/${id}/createCharge`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Transactions
             * @name TransactionsCreateAuthorization
             * @request POST:/v1/identities/{identityId}/paymentMethods/{id}/createAuthorization
             * @secure
             */
            transactionsCreateAuthorization: (identityId, id, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/paymentMethods/${id}/createAuthorization`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Transactions
             * @name TransactionsCreateSale
             * @request POST:/v1/identities/{identityId}/paymentMethods/{id}/createSale
             * @secure
             */
            transactionsCreateSale: (identityId, id, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/paymentMethods/${id}/createSale`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Transactions
             * @name TransactionsCreateVerification
             * @request POST:/v1/identities/{identityId}/paymentMethods/{id}/createVerification
             * @secure
             */
            transactionsCreateVerification: (identityId, id, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/paymentMethods/${id}/createVerification`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Transactions
             * @name TransactionsCreateRefund
             * @request POST:/v1/identities/{identityId}/paymentMethods/{id}/createRefund
             * @secure
             */
            transactionsCreateRefund: (identityId, id, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/paymentMethods/${id}/createRefund`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
        };
        this.v2 = {
            /**
             * No description
             *
             * @tags Transactions
             * @name TransactionsCreateChargeV2
             * @request POST:/v2/identities/{identityId}/paymentMethods/{id}/createCharge
             * @secure
             */
            transactionsCreateChargeV2: (identityId, id, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/paymentMethods/${id}/createCharge`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;

}(paymentMethods));

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(paymentMethods, exports);

}(paymentMethods$1));

var planMaps$1 = {};

var planMaps = {};

(function (exports) {
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.OfferMapAction = exports.BillingPeriod = void 0;
(function (BillingPeriod) {
    BillingPeriod["DAILY"] = "DAILY";
    BillingPeriod["WEEKLY"] = "WEEKLY";
    BillingPeriod["MONTHLY"] = "MONTHLY";
    BillingPeriod["ANNUAL"] = "ANNUAL";
    BillingPeriod["BIANNUAL"] = "BIANNUAL";
    BillingPeriod["QUARTERLY"] = "QUARTERLY";
    BillingPeriod["PAY_PERIOD"] = "PAY_PERIOD";
})(exports.BillingPeriod || (exports.BillingPeriod = {}));
(function (OfferMapAction) {
    OfferMapAction["CREATED"] = "CREATED";
    OfferMapAction["UPDATED"] = "UPDATED";
    OfferMapAction["PRODUCT_ADDED"] = "PRODUCT_ADDED";
    OfferMapAction["PRODUCT_UPDATED"] = "PRODUCT_UPDATED";
    OfferMapAction["PRODUCT_ALIGNED"] = "PRODUCT_ALIGNED";
    OfferMapAction["PRODUCT_DELETED"] = "PRODUCT_DELETED";
    OfferMapAction["DELETED"] = "DELETED";
})(exports.OfferMapAction || (exports.OfferMapAction = {}));
const axios_1 = __importDefault(axios);
const utils_1 = utils;
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://plan-maps.api.legalshieldinternal.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title OfferMaps API
 * @version v1
 * @baseUrl https://plan-maps.api.legalshieldinternal.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * @description The journal is for internal use only
             *
             * @tags OfferMapsJournal
             * @name OfferMapsJournal
             * @summary Machine JWT Only
             * @request GET:/v1/offers/maps/journal
             * @secure
             */
            offerMapsJournal: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/offers/maps/journal`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags OfferMapsJournal
             * @name OfferMapsJournalGetJournalMaxClock
             * @request GET:/v1/offers/maps/journal/maxClock
             * @secure
             */
            offerMapsJournalGetJournalMaxClock: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/offers/maps/journal/maxClock`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags OfferMaps
             * @name OfferMapsCreateOfferMap
             * @request POST:/v1/offerMaps
             * @secure
             */
            offerMapsCreateOfferMap: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/offerMaps`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags OfferMaps
             * @name OfferMapsGetOfferMapsByBrand
             * @request GET:/v1/brands/{brandName}/offerMaps
             * @secure
             */
            offerMapsGetOfferMapsByBrand: (brandName, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/brands/${brandName}/offerMaps`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags OfferMaps
             * @name OfferMapsGetOfferMap
             * @request GET:/v1/offerMaps/{offerMapId}
             * @secure
             */
            offerMapsGetOfferMap: (offerMapId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/offerMaps/${offerMapId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags OfferMaps
             * @name OfferMapsDeleteOfferMap
             * @request DELETE:/v1/offerMaps/{offerMapId}
             * @secure
             */
            offerMapsDeleteOfferMap: (offerMapId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/offerMaps/${offerMapId}`, method: 'DELETE', secure: true }, params)),
            /**
             * No description
             *
             * @tags OfferMaps
             * @name OfferMapsAddProduct
             * @request POST:/v1/offerMaps/{offerMapId}/addProduct
             * @secure
             */
            offerMapsAddProduct: (offerMapId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/offerMaps/${offerMapId}/addProduct`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags OfferMaps
             * @name OfferMapsUpdateProduct
             * @request POST:/v1/offerMaps/{offerMapId}/updateProduct
             * @secure
             */
            offerMapsUpdateProduct: (offerMapId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/offerMaps/${offerMapId}/updateProduct`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags OfferMaps
             * @name OfferMapsRemoveProduct
             * @request POST:/v1/offerMaps/{offerMapId}/removeProduct
             * @secure
             */
            offerMapsRemoveProduct: (offerMapId, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/offerMaps/${offerMapId}/removeProduct`, method: 'POST', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags OfferMaps
             * @name OfferMapsMapOfferToPlans
             * @request POST:/v1/offers/{offerId}/planMap
             * @secure
             */
            offerMapsMapOfferToPlans: (offerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/offers/${offerId}/planMap`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;

}(planMaps));

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(planMaps, exports);

}(planMaps$1));

var productfamilies$1 = {};

var productfamilies = {};

(function (exports) {
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.StatusEnum = exports.ActionEnum = void 0;
(function (ActionEnum) {
    ActionEnum["CREATED"] = "CREATED";
    ActionEnum["DELETED"] = "DELETED";
    ActionEnum["UPDATE_INTERNAL_NAME"] = "UPDATE_INTERNAL_NAME";
    ActionEnum["UPDATE_STATUS"] = "UPDATE_STATUS";
    ActionEnum["UPDATE_NAMES"] = "UPDATE_NAMES";
    ActionEnum["UPDATE_DESCRIPTIONS"] = "UPDATE_DESCRIPTIONS";
})(exports.ActionEnum || (exports.ActionEnum = {}));
(function (StatusEnum) {
    StatusEnum["ACTIVE"] = "ACTIVE";
    StatusEnum["CANCELED"] = "CANCELED";
    StatusEnum["DELETED"] = "DELETED";
})(exports.StatusEnum || (exports.StatusEnum = {}));
const axios_1 = __importDefault(axios);
const utils_1 = utils;
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://productfamilies.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title ProductFamilies Service Api
 * @version v1
 * @baseUrl https://productfamilies.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * No description
             *
             * @tags ProductFamiliesJournal
             * @name ProductFamiliesJournalGetJournalChanges
             * @request GET:/v1/productfamilies/journal
             * @secure
             */
            productFamiliesJournalGetJournalChanges: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/productfamilies/journal`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ProductFamiliesJournal
             * @name ProductFamiliesJournalGetJournalMaxClock
             * @request GET:/v1/productfamilies/journal/maxClock
             * @secure
             */
            productFamiliesJournalGetJournalMaxClock: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/productfamilies/journal/maxClock`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ProductFamiliesPublic
             * @name ProductFamiliesPublicGetAll
             * @request GET:/v1/public/productFamilies
             * @secure
             */
            productFamiliesPublicGetAll: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/public/productFamilies`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ProductFamiliesPublic
             * @name ProductFamiliesPublicGetResourceById
             * @request GET:/v1/public/productFamilies/{productFamilyId}
             * @secure
             */
            productFamiliesPublicGetResourceById: (productFamilyId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/public/productFamilies/${productFamilyId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ProductFamilies
             * @name ProductFamiliesGetAll
             * @request GET:/v1/productFamilies
             * @secure
             */
            productFamiliesGetAll: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/productFamilies`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ProductFamilies
             * @name ProductFamiliesCreateProductFamily
             * @request POST:/v1/productFamilies
             * @secure
             */
            productFamiliesCreateProductFamily: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/productFamilies`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ProductFamilies
             * @name ProductFamiliesGetProductFamilyById
             * @request GET:/v1/productFamilies/{productFamilyId}
             * @secure
             */
            productFamiliesGetProductFamilyById: (productFamilyId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/productFamilies/${productFamilyId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ProductFamilies
             * @name ProductFamiliesDeleteResource
             * @request DELETE:/v1/productFamilies/{productFamilyId}
             * @secure
             */
            productFamiliesDeleteResource: (productFamilyId, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/productFamilies/${productFamilyId}`, method: 'DELETE', query: query, secure: true }, params)),
            /**
             * No description
             *
             * @tags ProductFamilies
             * @name ProductFamiliesUpdateStatus
             * @request POST:/v1/productFamilies/{productFamilyId}/updateStatus/{newStatus}
             * @secure
             */
            productFamiliesUpdateStatus: (productFamilyId, newStatus, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/productFamilies/${productFamilyId}/updateStatus/${newStatus}`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ProductFamilies
             * @name ProductFamiliesAddName
             * @request POST:/v1/productFamilies/{productFamilyId}/addName
             * @secure
             */
            productFamiliesAddName: (productFamilyId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/productFamilies/${productFamilyId}/addName`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ProductFamilies
             * @name ProductFamiliesUpdateInternalName
             * @request POST:/v1/productFamilies/{productFamilyId}/updateInternalName
             * @secure
             */
            productFamiliesUpdateInternalName: (productFamilyId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/productFamilies/${productFamilyId}/updateInternalName`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ProductFamilies
             * @name ProductFamiliesUpdateName
             * @request POST:/v1/productFamilies/{productFamilyId}/updateName/{locale}
             * @secure
             */
            productFamiliesUpdateName: (productFamilyId, locale, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/productFamilies/${productFamilyId}/updateName/${locale}`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ProductFamilies
             * @name ProductFamiliesRemoveName
             * @request POST:/v1/productFamilies/{productFamilyId}/removeName/{locale}
             * @secure
             */
            productFamiliesRemoveName: (productFamilyId, locale, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/productFamilies/${productFamilyId}/removeName/${locale}`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ProductFamilies
             * @name ProductFamiliesAddDescription
             * @request POST:/v1/productFamilies/{productFamilyId}/addDescription
             * @secure
             */
            productFamiliesAddDescription: (productFamilyId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/productFamilies/${productFamilyId}/addDescription`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ProductFamilies
             * @name ProductFamiliesUpdateDescription
             * @request POST:/v1/productFamilies/{productFamilyId}/updateDescription/{locale}
             * @secure
             */
            productFamiliesUpdateDescription: (productFamilyId, locale, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/productFamilies/${productFamilyId}/updateDescription/${locale}`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ProductFamilies
             * @name ProductFamiliesRemoveDescription
             * @request POST:/v1/productFamilies/{productFamilyId}/removeDescription/{locale}
             * @secure
             */
            productFamiliesRemoveDescription: (productFamilyId, locale, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/productFamilies/${productFamilyId}/removeDescription/${locale}`, method: 'POST', secure: true, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;

}(productfamilies));

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(productfamilies, exports);

}(productfamilies$1));

var products$1 = {};

var products = {};

(function (exports) {
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.RestrictionType = exports.AuthorizedUserTypeEnum = exports.StateEnum = exports.StatusEnum = exports.ActionEnum = void 0;
(function (ActionEnum) {
    ActionEnum["CREATE"] = "CREATE";
    ActionEnum["ACTIVATE"] = "ACTIVATE";
    ActionEnum["BENEFITS_CHANGE"] = "BENEFITS_CHANGE";
    ActionEnum["CATEGORIES_CHANGE"] = "CATEGORIES_CHANGE";
    ActionEnum["CHANGE"] = "CHANGE";
    ActionEnum["CONTRACT_CHANGE"] = "CONTRACT_CHANGE";
    ActionEnum["DEACTIVATE"] = "DEACTIVATE";
    ActionEnum["DELETE"] = "DELETE";
    ActionEnum["FRIENDLY_NAMES_CHANGE"] = "FRIENDLY_NAMES_CHANGE";
    ActionEnum["QUALIFYING_DELEGATES_CHANGE"] = "QUALIFYING_DELEGATES_CHANGE";
    ActionEnum["INTERNAL_NAME_CHANGE"] = "INTERNAL_NAME_CHANGE";
    ActionEnum["SUPPLEMENTS_CHANGE"] = "SUPPLEMENTS_CHANGE";
    ActionEnum["PRODUCT_TIERS_CHANGE"] = "PRODUCT_TIERS_CHANGE";
    ActionEnum["PRODUCT_VERSIONED"] = "PRODUCT_VERSIONED";
    ActionEnum["STATE_PROVINCE_RESTRICTION_CHANGE"] = "STATE_PROVINCE_RESTRICTION_CHANGE";
    ActionEnum["UPDATING_MARKETING_DATA"] = "UPDATING_MARKETING_DATA";
    ActionEnum["SUPPLEMENT_CONTRACT_CHANGE"] = "SUPPLEMENT_CONTRACT_CHANGE";
    ActionEnum["UPDATE_AREA_OF_LAW_IDS"] = "UPDATE_AREA_OF_LAW_IDS";
})(exports.ActionEnum || (exports.ActionEnum = {}));
(function (StatusEnum) {
    StatusEnum["CREATED"] = "CREATED";
    StatusEnum["ACTIVE"] = "ACTIVE";
    StatusEnum["INACTIVE"] = "INACTIVE";
    StatusEnum["DELETE"] = "DELETE";
})(exports.StatusEnum || (exports.StatusEnum = {}));
(function (StateEnum) {
    StateEnum["AB"] = "AB";
    StateEnum["AK"] = "AK";
    StateEnum["AL"] = "AL";
    StateEnum["AR"] = "AR";
    StateEnum["AZ"] = "AZ";
    StateEnum["BC"] = "BC";
    StateEnum["CA"] = "CA";
    StateEnum["CA2"] = "CA_2";
    StateEnum["CO"] = "CO";
    StateEnum["CT"] = "CT";
    StateEnum["DC"] = "DC";
    StateEnum["DE"] = "DE";
    StateEnum["FL"] = "FL";
    StateEnum["GA"] = "GA";
    StateEnum["GU"] = "GU";
    StateEnum["HI"] = "HI";
    StateEnum["IA"] = "IA";
    StateEnum["ID"] = "ID";
    StateEnum["IL"] = "IL";
    StateEnum["IN"] = "IN";
    StateEnum["KS"] = "KS";
    StateEnum["KY"] = "KY";
    StateEnum["LA"] = "LA";
    StateEnum["LS"] = "LS";
    StateEnum["MA"] = "MA";
    StateEnum["MB"] = "MB";
    StateEnum["MD"] = "MD";
    StateEnum["ME"] = "ME";
    StateEnum["MI"] = "MI";
    StateEnum["MN"] = "MN";
    StateEnum["MO"] = "MO";
    StateEnum["MS"] = "MS";
    StateEnum["MT"] = "MT";
    StateEnum["NB"] = "NB";
    StateEnum["NC"] = "NC";
    StateEnum["ND"] = "ND";
    StateEnum["NE"] = "NE";
    StateEnum["NF"] = "NF";
    StateEnum["NH"] = "NH";
    StateEnum["NJ"] = "NJ";
    StateEnum["NL"] = "NL";
    StateEnum["NM"] = "NM";
    StateEnum["NS"] = "NS";
    StateEnum["NT"] = "NT";
    StateEnum["NU"] = "NU";
    StateEnum["NV"] = "NV";
    StateEnum["NY"] = "NY";
    StateEnum["OH"] = "OH";
    StateEnum["OK"] = "OK";
    StateEnum["ON"] = "ON";
    StateEnum["OR"] = "OR";
    StateEnum["PA"] = "PA";
    StateEnum["PE"] = "PE";
    StateEnum["PR"] = "PR";
    StateEnum["QC"] = "QC";
    StateEnum["RI"] = "RI";
    StateEnum["SC"] = "SC";
    StateEnum["SD"] = "SD";
    StateEnum["SF"] = "SF";
    StateEnum["SK"] = "SK";
    StateEnum["TN"] = "TN";
    StateEnum["TX"] = "TX";
    StateEnum["UT"] = "UT";
    StateEnum["VA"] = "VA";
    StateEnum["VI"] = "VI";
    StateEnum["VT"] = "VT";
    StateEnum["WA"] = "WA";
    StateEnum["WI"] = "WI";
    StateEnum["WV"] = "WV";
    StateEnum["WY"] = "WY";
    StateEnum["YT"] = "YT";
})(exports.StateEnum || (exports.StateEnum = {}));
(function (AuthorizedUserTypeEnum) {
    AuthorizedUserTypeEnum["PRIMARY"] = "PRIMARY";
    AuthorizedUserTypeEnum["SPOUSE"] = "SPOUSE";
    AuthorizedUserTypeEnum["DEPENDENT"] = "DEPENDENT";
    AuthorizedUserTypeEnum["NORMAL_USER"] = "NORMAL_USER";
    AuthorizedUserTypeEnum["OWNER"] = "OWNER";
    AuthorizedUserTypeEnum["CO_OWNER"] = "CO_OWNER";
    AuthorizedUserTypeEnum["SECONDARY"] = "SECONDARY";
    AuthorizedUserTypeEnum["TERTIARY"] = "TERTIARY";
    AuthorizedUserTypeEnum["ELDER"] = "ELDER";
    AuthorizedUserTypeEnum["ANY"] = "ANY";
    AuthorizedUserTypeEnum["ALL"] = "ALL";
})(exports.AuthorizedUserTypeEnum || (exports.AuthorizedUserTypeEnum = {}));
(function (RestrictionType) {
    RestrictionType["NOT_ALLOWED"] = "NOT_ALLOWED";
    RestrictionType["ALLOWED"] = "ALLOWED";
})(exports.RestrictionType || (exports.RestrictionType = {}));
const axios_1 = __importDefault(axios);
const utils_1 = utils;
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://products.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title Products Service Api
 * @version v1
 * @baseUrl https://products.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * No description
             *
             * @tags Products
             * @name ProductsGetProducts
             * @request GET:/v1/products
             * @secure
             */
            productsGetProducts: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsCreateProduct
             * @request POST:/v1/products
             * @secure
             */
            productsCreateProduct: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsGetProduct
             * @request GET:/v1/products/{productId}
             * @secure
             */
            productsGetProduct: (productId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsUpdateProduct
             * @request PUT:/v1/products/{productId}
             * @secure
             */
            productsUpdateProduct: (productId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}`, method: 'PUT', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsDeleteResource
             * @request DELETE:/v1/products/{productId}
             * @secure
             */
            productsDeleteResource: (productId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}`, method: 'DELETE', secure: true }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsActivateStatus
             * @request POST:/v1/products/{productId}/activate
             * @secure
             */
            productsActivateStatus: (productId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/activate`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsDeactivateStatus
             * @request POST:/v1/products/{productId}/deactivate
             * @secure
             */
            productsDeactivateStatus: (productId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/deactivate`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsUpdateProductBenefits
             * @request POST:/v1/products/{productId}/updateProductBenefits
             * @secure
             */
            productsUpdateProductBenefits: (productId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/updateProductBenefits`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsAddProductBenefit
             * @request POST:/v1/products/{productId}/addProductBenefit/{benefitId}
             * @secure
             */
            productsAddProductBenefit: (productId, benefitId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/addProductBenefit/${benefitId}`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsRemoveProductBenefit
             * @request POST:/v1/products/{productId}/removeProductBenefit/{benefitId}
             * @secure
             */
            productsRemoveProductBenefit: (productId, benefitId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/removeProductBenefit/${benefitId}`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsAddTierBenefit
             * @request POST:/v1/products/{productId}/tiers/{tierName}/addBenefit/{benefitId}
             * @secure
             */
            productsAddTierBenefit: (productId, tierName, benefitId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/tiers/${tierName}/addBenefit/${benefitId}`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsRemoveTierBenefit
             * @request POST:/v1/products/{productId}/tiers/{tierName}/removeBenefit/{benefitId}
             * @secure
             */
            productsRemoveTierBenefit: (productId, tierName, benefitId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/tiers/${tierName}/removeBenefit/${benefitId}`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsAddSupplementBenefit
             * @request POST:/v1/products/{productId}/supplements/{supplementInternalName}/addBenefit/{benefitId}
             * @secure
             */
            productsAddSupplementBenefit: (productId, supplementInternalName, benefitId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/supplements/${supplementInternalName}/addBenefit/${benefitId}`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsRemoveSupplementBenefit
             * @request POST:/v1/products/{productId}/supplements/{supplementInternalName}/removeBenefit/{benefitId}
             * @secure
             */
            productsRemoveSupplementBenefit: (productId, supplementInternalName, benefitId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/supplements/${supplementInternalName}/removeBenefit/${benefitId}`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsUpdateSupplements
             * @request POST:/v1/products/{productId}/updateSupplements
             * @secure
             */
            productsUpdateSupplements: (productId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/updateSupplements`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsUpdateInternalName
             * @request POST:/v1/products/{productId}/updateInternalName
             * @secure
             */
            productsUpdateInternalName: (productId, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/updateInternalName`, method: 'POST', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsUpdateFriendlyNames
             * @request POST:/v1/products/{productId}/updateFriendlyNames
             * @secure
             */
            productsUpdateFriendlyNames: (productId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/updateFriendlyNames`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsUpdateQualifyingDelegates
             * @request POST:/v1/products/{productId}/updateQualifyingDelegates
             * @secure
             */
            productsUpdateQualifyingDelegates: (productId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/updateQualifyingDelegates`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsUpdateCategories
             * @request POST:/v1/products/{productId}/updateCategories
             * @secure
             */
            productsUpdateCategories: (productId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/updateCategories`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsUpdateMarketingData
             * @request POST:/v1/products/{productId}/updateMarketingData
             * @secure
             */
            productsUpdateMarketingData: (productId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/updateMarketingData`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsUpdateContracts
             * @request POST:/v1/products/{productId}/updateContracts
             * @secure
             */
            productsUpdateContracts: (productId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/updateContracts`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsAddContract
             * @request POST:/v1/products/{productId}/addContract
             * @secure
             */
            productsAddContract: (productId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/addContract`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsRemoveContract
             * @request POST:/v1/products/{productId}/removeContract/{locale}
             * @secure
             */
            productsRemoveContract: (productId, locale, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/removeContract/${locale}`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsUpdateContract
             * @request POST:/v1/products/{productId}/updateContract/{locale}
             * @secure
             */
            productsUpdateContract: (productId, locale, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/updateContract/${locale}`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsAddContractStateVariant
             * @request POST:/v1/products/{productId}/contracts/{locale}/addStateVariant
             * @secure
             */
            productsAddContractStateVariant: (productId, locale, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/contracts/${locale}/addStateVariant`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsRemoveContractStateVariant
             * @request POST:/v1/products/{productId}/contracts/{locale}/removeStateVariant/{state}
             * @secure
             */
            productsRemoveContractStateVariant: (productId, locale, state, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/contracts/${locale}/removeStateVariant/${state}`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsUpdateContractStateVariant
             * @request POST:/v1/products/{productId}/contracts/{locale}/updateStateVariant/{state}
             * @secure
             */
            productsUpdateContractStateVariant: (productId, locale, state, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/contracts/${locale}/updateStateVariant/${state}`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsUpdateTierContracts
             * @request POST:/v1/products/{productId}/tiers/{tierName}/updateTierContracts
             * @secure
             */
            productsUpdateTierContracts: (productId, tierName, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/tiers/${tierName}/updateTierContracts`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsAddTierContract
             * @request POST:/v1/products/{productId}/tiers/{tierName}/addTierContract
             * @secure
             */
            productsAddTierContract: (productId, tierName, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/tiers/${tierName}/addTierContract`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsRemoveTierContract
             * @request POST:/v1/products/{productId}/tiers/{tierName}/removeTierContract/{locale}
             * @secure
             */
            productsRemoveTierContract: (productId, tierName, locale, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/tiers/${tierName}/removeTierContract/${locale}`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsUpdateTierContract
             * @request POST:/v1/products/{productId}/tiers/{tierName}/updateTierContract/{locale}
             * @secure
             */
            productsUpdateTierContract: (productId, tierName, locale, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/tiers/${tierName}/updateTierContract/${locale}`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsAddTierContractStateVariant
             * @request POST:/v1/products/{productId}/tiers/{tierName}/contracts/{locale}/addStateVariant
             * @secure
             */
            productsAddTierContractStateVariant: (productId, tierName, locale, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/tiers/${tierName}/contracts/${locale}/addStateVariant`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsRemoveTierContractStateVariant
             * @request POST:/v1/products/{productId}/tiers/{tierName}/contracts/{locale}/removeStateVariant/{state}
             * @secure
             */
            productsRemoveTierContractStateVariant: (productId, tierName, locale, state, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/tiers/${tierName}/contracts/${locale}/removeStateVariant/${state}`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsUpdateTierContractStateVariant
             * @request POST:/v1/products/{productId}/tiers/{tierName}/contracts/{locale}/updateStateVariant/{state}
             * @secure
             */
            productsUpdateTierContractStateVariant: (productId, tierName, locale, state, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/tiers/${tierName}/contracts/${locale}/updateStateVariant/${state}`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsUpdateSupplementContracts
             * @request POST:/v1/products/{productId}/supplements/{supplementInternalName}/updateSupplementContracts
             * @secure
             */
            productsUpdateSupplementContracts: (productId, supplementInternalName, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/supplements/${supplementInternalName}/updateSupplementContracts`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsAddSupplementContract
             * @request POST:/v1/products/{productId}/supplements/{supplementInternalName}/addSupplementContract
             * @secure
             */
            productsAddSupplementContract: (productId, supplementInternalName, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/supplements/${supplementInternalName}/addSupplementContract`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsRemoveSupplementContract
             * @request POST:/v1/products/{productId}/supplements/{supplementInternalName}/removeSupplementContract/{locale}
             * @secure
             */
            productsRemoveSupplementContract: (productId, supplementInternalName, locale, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/supplements/${supplementInternalName}/removeSupplementContract/${locale}`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsUpdateSupplementContract
             * @request POST:/v1/products/{productId}/supplements/{supplementInternalName}/updateSupplementContract/{locale}
             * @secure
             */
            productsUpdateSupplementContract: (productId, supplementInternalName, locale, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/supplements/${supplementInternalName}/updateSupplementContract/${locale}`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsAddSupplementContractStateVariant
             * @request POST:/v1/products/{productId}/supplements/{supplementInternalName}/contracts/{locale}/addStateVariant
             * @secure
             */
            productsAddSupplementContractStateVariant: (productId, supplementInternalName, locale, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/supplements/${supplementInternalName}/contracts/${locale}/addStateVariant`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsRemoveSupplementContractStateVariant
             * @request POST:/v1/products/{productId}/supplements/{supplementInternalName}/contracts/{locale}/removeStateVariant/{state}
             * @secure
             */
            productsRemoveSupplementContractStateVariant: (productId, supplementInternalName, locale, state, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/supplements/${supplementInternalName}/contracts/${locale}/removeStateVariant/${state}`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsUpdateSupplementContractStateVariant
             * @request POST:/v1/products/{productId}/supplements/{supplementInternalName}/contracts/{locale}/updateStateVariant/{state}
             * @secure
             */
            productsUpdateSupplementContractStateVariant: (productId, supplementInternalName, locale, state, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/supplements/${supplementInternalName}/contracts/${locale}/updateStateVariant/${state}`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsUpdateProductTiers
             * @request POST:/v1/products/{productId}/updateProductTiers
             * @secure
             */
            productsUpdateProductTiers: (productId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/updateProductTiers`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsAddFriendlyNameToTier
             * @request POST:/v1/products/{productId}/tiers/{tierName}/addFriendlyName
             * @secure
             */
            productsAddFriendlyNameToTier: (productId, tierName, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/tiers/${tierName}/addFriendlyName`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsUpdateFriendlyNameOnTier
             * @request POST:/v1/products/{productId}/tiers/{tierName}/updateFriendlyName/{locale}
             * @secure
             */
            productsUpdateFriendlyNameOnTier: (productId, tierName, locale, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/tiers/${tierName}/updateFriendlyName/${locale}`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsRemoveFriendlyNameFromTier
             * @request POST:/v1/products/{productId}/tiers/{tierName}/removeFriendlyName/{locale}
             * @secure
             */
            productsRemoveFriendlyNameFromTier: (productId, tierName, locale, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/tiers/${tierName}/removeFriendlyName/${locale}`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsAddFriendlyNameToSupplement
             * @request POST:/v1/products/{productId}/supplements/{supplementName}/addFriendlyName
             * @secure
             */
            productsAddFriendlyNameToSupplement: (productId, supplementName, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/supplements/${supplementName}/addFriendlyName`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsUpdateFriendlyNameOnSupplement
             * @request POST:/v1/products/{productId}/supplements/{supplementName}/updateFriendlyName/{locale}
             * @secure
             */
            productsUpdateFriendlyNameOnSupplement: (productId, supplementName, locale, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/supplements/${supplementName}/updateFriendlyName/${locale}`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsRemoveFriendlyNameFromSupplement
             * @request POST:/v1/products/{productId}/supplements/{supplementName}/removeFriendlyName/{locale}
             * @secure
             */
            productsRemoveFriendlyNameFromSupplement: (productId, supplementName, locale, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/supplements/${supplementName}/removeFriendlyName/${locale}`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsUpdateStateProvinceRestrictions
             * @request POST:/v1/products/{productId}/updateStateProvinceRestrictions
             * @secure
             */
            productsUpdateStateProvinceRestrictions: (productId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/updateStateProvinceRestrictions`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsAddStateProvinceRestriction
             * @request POST:/v1/products/{productId}/addStateProvinceRestriction
             * @secure
             */
            productsAddStateProvinceRestriction: (productId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/addStateProvinceRestriction`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsRemoveStateProvinceRestriction
             * @request POST:/v1/products/{productId}/removeStateProvinceRestriction
             * @secure
             */
            productsRemoveStateProvinceRestriction: (productId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/removeStateProvinceRestriction`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsUpdateAreaOfLawIds
             * @request POST:/v1/products/{productId}/updateAreaOfLawIds
             * @secure
             */
            productsUpdateAreaOfLawIds: (productId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/updateAreaOfLawIds`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsAddAreaOfLawId
             * @request POST:/v1/products/{productId}/addAreaOfLawId
             * @secure
             */
            productsAddAreaOfLawId: (productId, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/addAreaOfLawId`, method: 'POST', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsRemoveAreaOfLawId
             * @request POST:/v1/products/{productId}/removeAreaOfLawId/{areaOfLawId}
             * @secure
             */
            productsRemoveAreaOfLawId: (productId, areaOfLawId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/removeAreaOfLawId/${areaOfLawId}`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsVersionProduct
             * @request POST:/v1/products/{productId}/versionProduct
             * @secure
             */
            productsVersionProduct: (productId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/versionProduct`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Products
             * @name ProductsGetProductVersion
             * @request GET:/v1/products/{productId}/productVersion/{productVersionId}
             * @secure
             */
            productsGetProductVersion: (productId, productVersionId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/${productId}/productVersion/${productVersionId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ProductsJournal
             * @name ProductsJournalGetJournalChanges
             * @request GET:/v1/products/journal
             * @secure
             */
            productsJournalGetJournalChanges: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/journal`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ProductsJournal
             * @name ProductsJournalGetMaxClock
             * @request GET:/v1/products/journal/maxClock
             * @secure
             */
            productsJournalGetMaxClock: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/products/journal/maxClock`, method: 'GET', secure: true, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;

}(products));

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(products, exports);

}(products$1));

var profiles$1 = {};

var profiles = {};

(function (exports) {
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.ServiceFlagType = exports.AccountIdentifierType = exports.PhoneNumberType = exports.ProfileAction = void 0;
(function (ProfileAction) {
    ProfileAction["CREATED"] = "CREATED";
    ProfileAction["UPDATED"] = "UPDATED";
    ProfileAction["DELETED"] = "DELETED";
    ProfileAction["TOUCHED"] = "TOUCHED";
    ProfileAction["ACCOUNT_IDENTIFIER_ADDED"] = "ACCOUNT_IDENTIFIER_ADDED";
    ProfileAction["ACCOUNT_IDENTIFIER_UPDATED"] = "ACCOUNT_IDENTIFIER_UPDATED";
    ProfileAction["ACCOUNT_IDENTIFIER_REMOVED"] = "ACCOUNT_IDENTIFIER_REMOVED";
    ProfileAction["ACCOUNT_IDENTIFIERS_BULK_ADDED"] = "ACCOUNT_IDENTIFIERS_BULK_ADDED";
    ProfileAction["ADDRESS_ADDED"] = "ADDRESS_ADDED";
    ProfileAction["ADDRESS_UPDATED"] = "ADDRESS_UPDATED";
    ProfileAction["ADDRESS_REMOVED"] = "ADDRESS_REMOVED";
    ProfileAction["COMMUNICATION_PREFERENCES_UPDATED"] = "COMMUNICATION_PREFERENCES_UPDATED";
    ProfileAction["DATE_OF_BIRTH_UPDATED"] = "DATE_OF_BIRTH_UPDATED";
    ProfileAction["EMAIL_ADDED"] = "EMAIL_ADDED";
    ProfileAction["EMAIL_UPDATED"] = "EMAIL_UPDATED";
    ProfileAction["EMAIL_REMOVED"] = "EMAIL_REMOVED";
    ProfileAction["EMPLOYEE_ID_UPDATED"] = "EMPLOYEE_ID_UPDATED";
    ProfileAction["LOCALE_UPDATED"] = "LOCALE_UPDATED";
    ProfileAction["MARKETING_OPT_IN_UPDATED"] = "MARKETING_OPT_IN_UPDATED";
    ProfileAction["SMS_OPT_IN_UPDATED"] = "SMS_OPT_IN_UPDATED";
    ProfileAction["NAME_UPDATED"] = "NAME_UPDATED";
    ProfileAction["NATIONAL_IDENTIFIER_UPDATED"] = "NATIONAL_IDENTIFIER_UPDATED";
    ProfileAction["PHONE_NUMBER_ADDED"] = "PHONE_NUMBER_ADDED";
    ProfileAction["PHONE_NUMBER_UPDATED"] = "PHONE_NUMBER_UPDATED";
    ProfileAction["PHONE_NUMBER_REMOVED"] = "PHONE_NUMBER_REMOVED";
    ProfileAction["SERVICE_FLAG_ADDED"] = "SERVICE_FLAG_ADDED";
    ProfileAction["SERVICE_FLAG_REMOVED"] = "SERVICE_FLAG_REMOVED";
    ProfileAction["TCPA_UPDATED"] = "TCPA_UPDATED";
    ProfileAction["TERMS_OF_SERVICE_UPDATED"] = "TERMS_OF_SERVICE_UPDATED";
    ProfileAction["PREFERRED_NAME_UPDATED"] = "PREFERRED_NAME_UPDATED";
    ProfileAction["TITLE_UPDATED"] = "TITLE_UPDATED";
    ProfileAction["PRONOUNS_UPDATED"] = "PRONOUNS_UPDATED";
})(exports.ProfileAction || (exports.ProfileAction = {}));
(function (PhoneNumberType) {
    PhoneNumberType["Home"] = "home";
    PhoneNumberType["Cell"] = "cell";
    PhoneNumberType["Work"] = "work";
})(exports.PhoneNumberType || (exports.PhoneNumberType = {}));
(function (AccountIdentifierType) {
    AccountIdentifierType["Member"] = "member";
    AccountIdentifierType["Associate"] = "associate";
})(exports.AccountIdentifierType || (exports.AccountIdentifierType = {}));
(function (ServiceFlagType) {
    ServiceFlagType["Blind"] = "blind";
    ServiceFlagType["Deaf"] = "deaf";
    ServiceFlagType["SpecialNeeds"] = "specialNeeds";
    ServiceFlagType["FullTimeStudent"] = "fullTimeStudent";
    ServiceFlagType["ResidesWithPrimary"] = "residesWithPrimary";
})(exports.ServiceFlagType || (exports.ServiceFlagType = {}));
const axios_1 = __importDefault(axios);
const utils_1 = utils;
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://profiles.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title Profile API
 * @version v1
 * @baseUrl https://profiles.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * @description The journal is for internal use only
             *
             * @tags Journal
             * @name ProfilesJournalAll
             * @summary Machine JWT Only
             * @request GET:/v1/profiles/journal
             * @secure
             */
            profilesJournalAll: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/profiles/journal`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * @description The journal is for internal use only
             *
             * @tags Journal
             * @name ProfilesJournal
             * @summary Machine JWT Only
             * @request GET:/v1/profiles/journal/maxClock
             * @secure
             */
            profilesJournal: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/profiles/journal/maxClock`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags BulkProfiles
             * @name BulkProfilesGetThinProfileInformationForList
             * @request POST:/v1/profiles
             * @secure
             */
            bulkProfilesGetThinProfileInformationForList: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/profiles`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Profiles
             * @name ProfilesFindByIdentityId
             * @request GET:/v1/identities/{identityId}/profile
             * @secure
             */
            profilesFindByIdentityId: (identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/profile`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Profiles
             * @name ProfilesCreateProfile
             * @request POST:/v1/identities/{identityId}/profile
             * @secure
             */
            profilesCreateProfile: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/profile`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Profiles
             * @name ProfilesUpdateProfile
             * @request PUT:/v1/identities/{identityId}/profile
             * @secure
             */
            profilesUpdateProfile: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/profile`, method: 'PUT', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Profiles
             * @name ProfilesRemoveProfile
             * @request DELETE:/v1/identities/{identityId}/profile
             * @secure
             */
            profilesRemoveProfile: (identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/profile`, method: 'DELETE', secure: true }, params)),
            /**
             * No description
             *
             * @tags Profiles
             * @name ProfilesTouchProfile
             * @request POST:/v1/identities/{identityId}/profile/touch
             * @secure
             */
            profilesTouchProfile: (identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/profile/touch`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Search
             * @name SearchSearchProfiles
             * @request POST:/v1/profiles/search
             * @secure
             */
            searchSearchProfiles: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/profiles/search`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags AccountIdentifier
             * @name AccountIdentifierAddAccountIdentifier
             * @request POST:/v1/identities/{identityId}/profile/addAccountIdentifier
             * @secure
             */
            accountIdentifierAddAccountIdentifier: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/profile/addAccountIdentifier`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags AccountIdentifier
             * @name AccountIdentifierUpdateAccountIdentifier
             * @request POST:/v1/identities/{identityId}/profile/updateAccountIdentifier
             * @secure
             */
            accountIdentifierUpdateAccountIdentifier: (identityId, query, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/profile/updateAccountIdentifier`, method: 'POST', query: query, body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags AccountIdentifier
             * @name AccountIdentifierRemoveAccountIdentifier
             * @request POST:/v1/identities/{identityId}/profile/removeAccountIdentifier
             * @secure
             */
            accountIdentifierRemoveAccountIdentifier: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/profile/removeAccountIdentifier`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags AccountIdentifier
             * @name AccountIdentifierBulkAddAccountIdentifiers
             * @request POST:/v1/identities/{identityId}/profile/bulkAddAccountIdentifiers
             * @secure
             */
            accountIdentifierBulkAddAccountIdentifiers: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/profile/bulkAddAccountIdentifiers`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Address
             * @name AddressAddAddress
             * @request POST:/v1/identities/{identityId}/profile/addAddress
             * @secure
             */
            addressAddAddress: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/profile/addAddress`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Address
             * @name AddressUpdateAddress
             * @request POST:/v1/identities/{identityId}/profile/updateAddress
             * @secure
             */
            addressUpdateAddress: (identityId, query, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/profile/updateAddress`, method: 'POST', query: query, body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Address
             * @name AddressRemoveAddress
             * @request POST:/v1/identities/{identityId}/profile/removeAddress
             * @secure
             */
            addressRemoveAddress: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/profile/removeAddress`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags CommunicationPreferences
             * @name CommunicationPreferencesUpdateCommunicationPreferences
             * @request POST:/v1/identities/{identityId}/profile/communicationPreferences
             * @secure
             */
            communicationPreferencesUpdateCommunicationPreferences: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/profile/communicationPreferences`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags CommunicationPreferences
             * @name CommunicationPreferencesUpdateCommunicationPreference
             * @request POST:/v1/identities/{identityId}/profile/communicationPreferences/{communicationPreference}
             * @secure
             */
            communicationPreferencesUpdateCommunicationPreference: (identityId, communicationPreference, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/profile/communicationPreferences/${communicationPreference}`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags CommunicationPreferences
             * @name CommunicationPreferencesUpdateCommunicationPreferenceByEmail
             * @request POST:/v1/profile/{emailAddress}/communicationPreferences/{communicationPreference}
             * @secure
             */
            communicationPreferencesUpdateCommunicationPreferenceByEmail: (emailAddress, communicationPreference, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/profile/${emailAddress}/communicationPreferences/${communicationPreference}`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags DateOfBirth
             * @name DateOfBirthUpdateDateOfBirth
             * @request POST:/v1/identities/{identityId}/profile/updateDateOfBirth
             * @secure
             */
            dateOfBirthUpdateDateOfBirth: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/profile/updateDateOfBirth`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Email
             * @name EmailAddEmail
             * @request POST:/v1/identities/{identityId}/profile/addEmail
             * @secure
             */
            emailAddEmail: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/profile/addEmail`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Email
             * @name EmailUpdateEmail
             * @request POST:/v1/identities/{identityId}/profile/updateEmail
             * @secure
             */
            emailUpdateEmail: (identityId, query, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/profile/updateEmail`, method: 'POST', query: query, body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Email
             * @name EmailRemoveEmail
             * @request POST:/v1/identities/{identityId}/profile/removeEmail
             * @secure
             */
            emailRemoveEmail: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/profile/removeEmail`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags EmployeeId
             * @name EmployeeIdUpdateEmployeeId
             * @request POST:/v1/identities/{identityId}/profile/updateEmployeeId
             * @secure
             */
            employeeIdUpdateEmployeeId: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/profile/updateEmployeeId`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Locale
             * @name LocaleUpdateLocale
             * @request POST:/v1/identities/{identityId}/profile/updateLocale
             * @secure
             */
            localeUpdateLocale: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/profile/updateLocale`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags MarketingPreferences
             * @name MarketingPreferencesMarketingOptIn
             * @request POST:/v1/identities/{identityId}/profile/marketingOptIn
             * @secure
             */
            marketingPreferencesMarketingOptIn: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/profile/marketingOptIn`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags MarketingPreferences
             * @name MarketingPreferencesSmsOptIn
             * @request POST:/v1/identities/{identityId}/profile/smsOptIn
             * @secure
             */
            marketingPreferencesSmsOptIn: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/profile/smsOptIn`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Name
             * @name NameUpdateName
             * @request POST:/v1/identities/{identityId}/profile/updateName
             * @secure
             */
            nameUpdateName: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/profile/updateName`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags NationalIdentifier
             * @name NationalIdentifierUpdateNationalIdentifier
             * @request POST:/v1/identities/{identityId}/profile/updateNationalIdentifier
             * @secure
             */
            nationalIdentifierUpdateNationalIdentifier: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/profile/updateNationalIdentifier`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags PhoneNumber
             * @name PhoneNumberAddPhoneNumber
             * @request POST:/v1/identities/{identityId}/profile/addPhoneNumber
             * @secure
             */
            phoneNumberAddPhoneNumber: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/profile/addPhoneNumber`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags PhoneNumber
             * @name PhoneNumberUpdatePhoneNumber
             * @request POST:/v1/identities/{identityId}/profile/updatePhoneNumber
             * @secure
             */
            phoneNumberUpdatePhoneNumber: (identityId, query, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/profile/updatePhoneNumber`, method: 'POST', query: query, body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags PhoneNumber
             * @name PhoneNumberRemovePhoneNumber
             * @request POST:/v1/identities/{identityId}/profile/removePhoneNumber
             * @secure
             */
            phoneNumberRemovePhoneNumber: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/profile/removePhoneNumber`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags PreferredName
             * @name PreferredNameUpdatePreferredName
             * @request POST:/v1/identities/{identityId}/profile/updatePreferredName
             * @secure
             */
            preferredNameUpdatePreferredName: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/profile/updatePreferredName`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Pronouns
             * @name PronounsUpdatePronouns
             * @request POST:/v1/identities/{identityId}/profile/updatePronouns
             * @secure
             */
            pronounsUpdatePronouns: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/profile/updatePronouns`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceFlags
             * @name ServiceFlagsAddServiceFlag
             * @request POST:/v1/identities/{identityId}/profile/addServiceFlag
             * @secure
             */
            serviceFlagsAddServiceFlag: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/profile/addServiceFlag`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceFlags
             * @name ServiceFlagsRemoveServiceFlag
             * @request POST:/v1/identities/{identityId}/profile/removeServiceFlag
             * @secure
             */
            serviceFlagsRemoveServiceFlag: (identityId, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/profile/removeServiceFlag`, method: 'POST', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags TCPA
             * @name TcpaUpdateTcpa
             * @request POST:/v1/identities/{identityId}/profile/tcpa
             * @secure
             */
            tcpaUpdateTcpa: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/profile/tcpa`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags TermsOfService
             * @name TermsOfServiceUpdateTermsOfService
             * @request POST:/v1/identities/{identityId}/profile/updateTermsOfService
             * @secure
             */
            termsOfServiceUpdateTermsOfService: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/profile/updateTermsOfService`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Title
             * @name TitleUpdateTitle
             * @request POST:/v1/identities/{identityId}/profile/updateTitle
             * @secure
             */
            titleUpdateTitle: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/profile/updateTitle`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;

}(profiles));

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(profiles, exports);

}(profiles$1));

var providers$1 = {};

var providers = {};

(function (exports) {
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.Flag = exports.VerificationStatus = exports.NotificationType = exports.FileUploadType = exports.MartindaleHubbellRatingEnum = exports.LanguageEnum = exports.CompetencyEnum = exports.VolumeEnum = exports.CurrencyCodeEnum = exports.AreaOfLawEnum = exports.CountryEnum = exports.StateEnum = exports.PhoneTypeEnum = exports.Race = exports.Gender = exports.ProviderType = exports.NetworkEnum = exports.StatusEnum = exports.ActionEnum = void 0;
(function (ActionEnum) {
    ActionEnum["CREATE"] = "CREATE";
    ActionEnum["ACTIVATE"] = "ACTIVATE";
    ActionEnum["DEACTIVATE"] = "DEACTIVATE";
    ActionEnum["DELETE"] = "DELETE";
    ActionEnum["CHANGE"] = "CHANGE";
    ActionEnum["UPDATE_ADDRESSES"] = "UPDATE_ADDRESSES";
    ActionEnum["UPDATE_AREAS_OF_PRACTICE"] = "UPDATE_AREAS_OF_PRACTICE";
    ActionEnum["UPDATE_ASSOCIATED_BRANCHES"] = "UPDATE_ASSOCIATED_BRANCHES";
    ActionEnum["UPDATE_ASSOCIATIONS"] = "UPDATE_ASSOCIATIONS";
    ActionEnum["UPDATE_AWARDS"] = "UPDATE_AWARDS";
    ActionEnum["UPDATE_BAR_STATES"] = "UPDATE_BAR_STATES";
    ActionEnum["UPDATE_BIOGRAPHY"] = "UPDATE_BIOGRAPHY";
    ActionEnum["UPDATE_CONTACT_INFO"] = "UPDATE_CONTACT_INFO";
    ActionEnum["UPDATE_CRITICAL_NOTES"] = "UPDATE_CRITICAL_NOTES";
    ActionEnum["UPDATE_DISCIPLINARY_ACTIONS"] = "UPDATE_DISCIPLINARY_ACTIONS";
    ActionEnum["UPDATE_EDUCATION"] = "UPDATE_EDUCATION";
    ActionEnum["UPDATE_EMAIL_ADDRESS"] = "UPDATE_EMAIL_ADDRESS";
    ActionEnum["UPDATE_FIRM"] = "UPDATE_FIRM";
    ActionEnum["UPDATE_PROVIDER_TYPE"] = "UPDATE_PROVIDER_TYPE";
    ActionEnum["UPDATE_LANGUAGES"] = "UPDATE_LANGUAGES";
    ActionEnum["UPDATE_LEGAL_SHIELD_JOIN_YEAR"] = "UPDATE_LEGAL_SHIELD_JOIN_YEAR";
    ActionEnum["UPDATE_NOTIFICATION_HISTORY"] = "UPDATE_NOTIFICATION_HISTORY";
    ActionEnum["UPDATE_PHONE_NUMBERS"] = "UPDATE_PHONE_NUMBERS";
    ActionEnum["UPDATE_PRACTICE_BEGIN_DATE"] = "UPDATE_PRACTICE_BEGIN_DATE";
    ActionEnum["UPDATE_PROFILE_PICTURE_URL"] = "UPDATE_PROFILE_PICTURE_URL";
    ActionEnum["UPDATE_PROVIDER_NAME"] = "UPDATE_PROVIDER_NAME";
    ActionEnum["UPDATE_PUBLICATIONS"] = "UPDATE_PUBLICATIONS";
    ActionEnum["UPDATE_RATING"] = "UPDATE_RATING";
    ActionEnum["UPDATE_REFERRING_ENTITY"] = "UPDATE_REFERRING_ENTITY";
    ActionEnum["UPDATE_SPEAKING_ENGAGEMENTS"] = "UPDATE_SPEAKING_ENGAGEMENTS";
    ActionEnum["UPDATE_TAX_ID"] = "UPDATE_TAX_ID";
    ActionEnum["UPDATE_VERIFICATION"] = "UPDATE_VERIFICATION";
    ActionEnum["UPDATE_WEBSITE_URL"] = "UPDATE_WEBSITE_URL";
    ActionEnum["ADD_FILE_UPLOAD"] = "ADD_FILE_UPLOAD";
    ActionEnum["REMOVE_FILE_UPLOAD"] = "REMOVE_FILE_UPLOAD";
    ActionEnum["UPDATE_FILE_UPLOADS"] = "UPDATE_FILE_UPLOADS";
    ActionEnum["UPDATE_FLAGS"] = "UPDATE_FLAGS";
    ActionEnum["UPDATE_INSURANCE"] = "UPDATE_INSURANCE";
    ActionEnum["UPDATE_EXTERNAL_ID"] = "UPDATE_EXTERNAL_ID";
    ActionEnum["SUSPEND"] = "SUSPEND";
    ActionEnum["MARK_INSURANCE_EXPIRED"] = "MARK_INSURANCE_EXPIRED";
    ActionEnum["MARK_INSURANCE_NEEDS_ATTENTION"] = "MARK_INSURANCE_NEEDS_ATTENTION";
    ActionEnum["UPDATE_ACCEPTING_REFERRALS"] = "UPDATE_ACCEPTING_REFERRALS";
    ActionEnum["LINK_BRANCH"] = "LINK_BRANCH";
    ActionEnum["UNLINK_BRANCH"] = "UNLINK_BRANCH";
    ActionEnum["UPDATE_NETWORK"] = "UPDATE_NETWORK";
    ActionEnum["UPDATE_SEO_FRIENDLY_PATH"] = "UPDATE_SEO_FRIENDLY_PATH";
})(exports.ActionEnum || (exports.ActionEnum = {}));
(function (StatusEnum) {
    StatusEnum["CREATED"] = "CREATED";
    StatusEnum["PENDING_VERIFICATION"] = "PENDING_VERIFICATION";
    StatusEnum["ACTIVE"] = "ACTIVE";
    StatusEnum["SUSPENDED"] = "SUSPENDED";
    StatusEnum["DELETED"] = "DELETED";
    StatusEnum["DEACTIVATED"] = "DEACTIVATED";
    StatusEnum["INSURANCE_EXPIRED"] = "INSURANCE_EXPIRED";
    StatusEnum["INSURANCE_NEEDS_ATTENTION"] = "INSURANCE_NEEDS_ATTENTION";
})(exports.StatusEnum || (exports.StatusEnum = {}));
(function (NetworkEnum) {
    NetworkEnum["LEGALSHIELD"] = "LEGALSHIELD";
    NetworkEnum["CLC"] = "CLC";
})(exports.NetworkEnum || (exports.NetworkEnum = {}));
(function (ProviderType) {
    ProviderType["CLC"] = "CLC";
    ProviderType["PARTNER"] = "PARTNER";
    ProviderType["REFERRAL"] = "REFERRAL";
    ProviderType["OTHER"] = "OTHER";
})(exports.ProviderType || (exports.ProviderType = {}));
(function (Gender) {
    Gender["FEMALE"] = "FEMALE";
    Gender["MALE"] = "MALE";
    Gender["PREFER_NOT_TO_ANSWER"] = "PREFER_NOT_TO_ANSWER";
})(exports.Gender || (exports.Gender = {}));
(function (Race) {
    Race["AFRICAN_AMERICAN"] = "AFRICAN_AMERICAN";
    Race["ALASKAN_NATIVE"] = "ALASKAN_NATIVE";
    Race["ASIAN"] = "ASIAN";
    Race["EUROPEAN"] = "EUROPEAN";
    Race["HISPANIC"] = "HISPANIC";
    Race["INDIAN"] = "INDIAN";
    Race["NATIVE_AMERICAN"] = "NATIVE_AMERICAN";
    Race["WHITE"] = "WHITE";
})(exports.Race || (exports.Race = {}));
(function (PhoneTypeEnum) {
    PhoneTypeEnum["OFFICE"] = "OFFICE";
    PhoneTypeEnum["DESK"] = "DESK";
    PhoneTypeEnum["TOLL_FREE"] = "TOLL_FREE";
    PhoneTypeEnum["MOBILE"] = "MOBILE";
    PhoneTypeEnum["FAX"] = "FAX";
    PhoneTypeEnum["OTHER"] = "OTHER";
})(exports.PhoneTypeEnum || (exports.PhoneTypeEnum = {}));
(function (StateEnum) {
    StateEnum["AB"] = "AB";
    StateEnum["AK"] = "AK";
    StateEnum["AL"] = "AL";
    StateEnum["AR"] = "AR";
    StateEnum["AZ"] = "AZ";
    StateEnum["BC"] = "BC";
    StateEnum["CA"] = "CA";
    StateEnum["CA2"] = "CA_2";
    StateEnum["CO"] = "CO";
    StateEnum["CT"] = "CT";
    StateEnum["DC"] = "DC";
    StateEnum["DE"] = "DE";
    StateEnum["FL"] = "FL";
    StateEnum["GA"] = "GA";
    StateEnum["GU"] = "GU";
    StateEnum["HI"] = "HI";
    StateEnum["IA"] = "IA";
    StateEnum["ID"] = "ID";
    StateEnum["IL"] = "IL";
    StateEnum["IN"] = "IN";
    StateEnum["KS"] = "KS";
    StateEnum["KY"] = "KY";
    StateEnum["LA"] = "LA";
    StateEnum["LS"] = "LS";
    StateEnum["MA"] = "MA";
    StateEnum["MB"] = "MB";
    StateEnum["MD"] = "MD";
    StateEnum["ME"] = "ME";
    StateEnum["MI"] = "MI";
    StateEnum["MN"] = "MN";
    StateEnum["MO"] = "MO";
    StateEnum["MS"] = "MS";
    StateEnum["MT"] = "MT";
    StateEnum["NB"] = "NB";
    StateEnum["NC"] = "NC";
    StateEnum["ND"] = "ND";
    StateEnum["NE"] = "NE";
    StateEnum["NF"] = "NF";
    StateEnum["NH"] = "NH";
    StateEnum["NJ"] = "NJ";
    StateEnum["NL"] = "NL";
    StateEnum["NM"] = "NM";
    StateEnum["NS"] = "NS";
    StateEnum["NT"] = "NT";
    StateEnum["NU"] = "NU";
    StateEnum["NV"] = "NV";
    StateEnum["NY"] = "NY";
    StateEnum["OH"] = "OH";
    StateEnum["OK"] = "OK";
    StateEnum["ON"] = "ON";
    StateEnum["OR"] = "OR";
    StateEnum["PA"] = "PA";
    StateEnum["PE"] = "PE";
    StateEnum["PR"] = "PR";
    StateEnum["QC"] = "QC";
    StateEnum["RI"] = "RI";
    StateEnum["SC"] = "SC";
    StateEnum["SD"] = "SD";
    StateEnum["SF"] = "SF";
    StateEnum["SK"] = "SK";
    StateEnum["TN"] = "TN";
    StateEnum["TX"] = "TX";
    StateEnum["UT"] = "UT";
    StateEnum["VA"] = "VA";
    StateEnum["VI"] = "VI";
    StateEnum["VT"] = "VT";
    StateEnum["WA"] = "WA";
    StateEnum["WI"] = "WI";
    StateEnum["WV"] = "WV";
    StateEnum["WY"] = "WY";
    StateEnum["YT"] = "YT";
})(exports.StateEnum || (exports.StateEnum = {}));
(function (CountryEnum) {
    CountryEnum["CAN"] = "CAN";
    CountryEnum["USA"] = "USA";
})(exports.CountryEnum || (exports.CountryEnum = {}));
(function (AreaOfLawEnum) {
    AreaOfLawEnum["AM"] = "AM";
    AreaOfLawEnum["AD"] = "AD";
    AreaOfLawEnum["AF"] = "AF";
    AreaOfLawEnum["AA"] = "AA";
    AreaOfLawEnum["BK"] = "BK";
    AreaOfLawEnum["BR"] = "BR";
    AreaOfLawEnum["BD"] = "BD";
    AreaOfLawEnum["BT"] = "BT";
    AreaOfLawEnum["BS"] = "BS";
    AreaOfLawEnum["CU"] = "CU";
    AreaOfLawEnum["CS"] = "CS";
    AreaOfLawEnum["CL"] = "CL";
    AreaOfLawEnum["CC"] = "CC";
    AreaOfLawEnum["CO"] = "CO";
    AreaOfLawEnum["CN"] = "CN";
    AreaOfLawEnum["CF"] = "CF";
    AreaOfLawEnum["CT"] = "CT";
    AreaOfLawEnum["CY"] = "CY";
    AreaOfLawEnum["CP"] = "CP";
    AreaOfLawEnum["CD"] = "CD";
    AreaOfLawEnum["CR"] = "CR";
    AreaOfLawEnum["DE"] = "DE";
    AreaOfLawEnum["DI"] = "DI";
    AreaOfLawEnum["DU"] = "DU";
    AreaOfLawEnum["DV"] = "DV";
    AreaOfLawEnum["ED"] = "ED";
    AreaOfLawEnum["EL"] = "EL";
    AreaOfLawEnum["EM"] = "EM";
    AreaOfLawEnum["ET"] = "ET";
    AreaOfLawEnum["EP"] = "EP";
    AreaOfLawEnum["FL"] = "FL";
    AreaOfLawEnum["FW"] = "FW";
    AreaOfLawEnum["FA"] = "FA";
    AreaOfLawEnum["FC"] = "FC";
    AreaOfLawEnum["FR"] = "FR";
    AreaOfLawEnum["GA"] = "GA";
    AreaOfLawEnum["GL"] = "GL";
    AreaOfLawEnum["GC"] = "GC";
    AreaOfLawEnum["HL"] = "HL";
    AreaOfLawEnum["IT"] = "IT";
    AreaOfLawEnum["IM"] = "IM";
    AreaOfLawEnum["ID"] = "ID";
    AreaOfLawEnum["IN"] = "IN";
    AreaOfLawEnum["JV"] = "JV";
    AreaOfLawEnum["LL"] = "LL";
    AreaOfLawEnum["LT"] = "LT";
    AreaOfLawEnum["LM"] = "LM";
    AreaOfLawEnum["LN"] = "LN";
    AreaOfLawEnum["MM"] = "MM";
    AreaOfLawEnum["ML"] = "ML";
    AreaOfLawEnum["MR"] = "MR";
    AreaOfLawEnum["MD"] = "MD";
    AreaOfLawEnum["VD"] = "VD";
    AreaOfLawEnum["NC"] = "NC";
    AreaOfLawEnum["OG"] = "OG";
    AreaOfLawEnum["PC"] = "PC";
    AreaOfLawEnum["PT"] = "PT";
    AreaOfLawEnum["PN"] = "PN";
    AreaOfLawEnum["PD"] = "PD";
    AreaOfLawEnum["PI"] = "PI";
    AreaOfLawEnum["PA"] = "PA";
    AreaOfLawEnum["PU"] = "PU";
    AreaOfLawEnum["PR"] = "PR";
    AreaOfLawEnum["PL"] = "PL";
    AreaOfLawEnum["PY"] = "PY";
    AreaOfLawEnum["TA"] = "TA";
    AreaOfLawEnum["PS"] = "PS";
    AreaOfLawEnum["RE"] = "RE";
    AreaOfLawEnum["RC"] = "RC";
    AreaOfLawEnum["RF"] = "RF";
    AreaOfLawEnum["RP"] = "RP";
    AreaOfLawEnum["SC"] = "SC";
    AreaOfLawEnum["SS"] = "SS";
    AreaOfLawEnum["SN"] = "SN";
    AreaOfLawEnum["SL"] = "SL";
    AreaOfLawEnum["TX"] = "TX";
    AreaOfLawEnum["TS"] = "TS";
    AreaOfLawEnum["TM"] = "TM";
    AreaOfLawEnum["TR"] = "TR";
    AreaOfLawEnum["TU"] = "TU";
    AreaOfLawEnum["UA"] = "UA";
    AreaOfLawEnum["VE"] = "VE";
    AreaOfLawEnum["VA"] = "VA";
    AreaOfLawEnum["WC"] = "WC";
    AreaOfLawEnum["WD"] = "WD";
    AreaOfLawEnum["ZP"] = "ZP";
    AreaOfLawEnum["WL"] = "WL";
})(exports.AreaOfLawEnum || (exports.AreaOfLawEnum = {}));
(function (CurrencyCodeEnum) {
    CurrencyCodeEnum["USD"] = "USD";
    CurrencyCodeEnum["CAD"] = "CAD";
    CurrencyCodeEnum["MXN"] = "MXN";
    CurrencyCodeEnum["GBP"] = "GBP";
})(exports.CurrencyCodeEnum || (exports.CurrencyCodeEnum = {}));
(function (VolumeEnum) {
    VolumeEnum["LOW"] = "LOW";
    VolumeEnum["MEDIUM"] = "MEDIUM";
    VolumeEnum["HIGH"] = "HIGH";
})(exports.VolumeEnum || (exports.VolumeEnum = {}));
(function (CompetencyEnum) {
    CompetencyEnum["UNKNOWN"] = "UNKNOWN";
    CompetencyEnum["BASIC_KNOWLEDGE"] = "BASIC_KNOWLEDGE";
    CompetencyEnum["PROFICIENT"] = "PROFICIENT";
    CompetencyEnum["SPECIALIST"] = "SPECIALIST";
    CompetencyEnum["CERTIFIED"] = "CERTIFIED";
})(exports.CompetencyEnum || (exports.CompetencyEnum = {}));
(function (LanguageEnum) {
    LanguageEnum["ABKHAZ"] = "ABKHAZ";
    LanguageEnum["AFAR"] = "AFAR";
    LanguageEnum["AFRIKAANS"] = "AFRIKAANS";
    LanguageEnum["AKAN"] = "AKAN";
    LanguageEnum["ALBANIAN"] = "ALBANIAN";
    LanguageEnum["AMHARIC"] = "AMHARIC";
    LanguageEnum["ARABIC"] = "ARABIC";
    LanguageEnum["ARAGONESE"] = "ARAGONESE";
    LanguageEnum["ARAMAIC"] = "ARAMAIC";
    LanguageEnum["ARMENIAN"] = "ARMENIAN";
    LanguageEnum["ASSAMESE"] = "ASSAMESE";
    LanguageEnum["AVARIC"] = "AVARIC";
    LanguageEnum["AVESTAN"] = "AVESTAN";
    LanguageEnum["AYMARA"] = "AYMARA";
    LanguageEnum["AZERBAIJANI"] = "AZERBAIJANI";
    LanguageEnum["BAMBARA"] = "BAMBARA";
    LanguageEnum["BASHKIR"] = "BASHKIR";
    LanguageEnum["BASQUE"] = "BASQUE";
    LanguageEnum["BELARUSIAN"] = "BELARUSIAN";
    LanguageEnum["BENGALI"] = "BENGALI";
    LanguageEnum["BIHARI"] = "BIHARI";
    LanguageEnum["BISLAMA"] = "BISLAMA";
    LanguageEnum["BOSNIAN"] = "BOSNIAN";
    LanguageEnum["BRETON"] = "BRETON";
    LanguageEnum["BULGARIAN"] = "BULGARIAN";
    LanguageEnum["BURMESE"] = "BURMESE";
    LanguageEnum["CAMBODIAN"] = "CAMBODIAN";
    LanguageEnum["CANTONESE"] = "CANTONESE";
    LanguageEnum["CATALAN"] = "CATALAN";
    LanguageEnum["CEBUANO"] = "CEBUANO";
    LanguageEnum["CHALDEAN"] = "CHALDEAN";
    LanguageEnum["CHAMORRO"] = "CHAMORRO";
    LanguageEnum["CHECHEN"] = "CHECHEN";
    LanguageEnum["CHICHEWA"] = "CHICHEWA";
    LanguageEnum["CHINESE"] = "CHINESE";
    LanguageEnum["CHUVASH"] = "CHUVASH";
    LanguageEnum["CORNISH"] = "CORNISH";
    LanguageEnum["CORSICAN"] = "CORSICAN";
    LanguageEnum["CREE"] = "CREE";
    LanguageEnum["CREOLE"] = "CREOLE";
    LanguageEnum["CROATIAN"] = "CROATIAN";
    LanguageEnum["CZECH"] = "CZECH";
    LanguageEnum["DANISH"] = "DANISH";
    LanguageEnum["DARI"] = "DARI";
    LanguageEnum["DIVEHI"] = "DIVEHI";
    LanguageEnum["DUTCH"] = "DUTCH";
    LanguageEnum["DZONGKHA"] = "DZONGKHA";
    LanguageEnum["ENGLISH"] = "ENGLISH";
    LanguageEnum["ESPERANTO"] = "ESPERANTO";
    LanguageEnum["ESTONIAN"] = "ESTONIAN";
    LanguageEnum["EWE"] = "EWE";
    LanguageEnum["FAROESE"] = "FAROESE";
    LanguageEnum["FARSI"] = "FARSI";
    LanguageEnum["FIJIAN"] = "FIJIAN";
    LanguageEnum["FINNISH"] = "FINNISH";
    LanguageEnum["FLEMISH"] = "FLEMISH";
    LanguageEnum["FRENCH"] = "FRENCH";
    LanguageEnum["FULA"] = "FULA";
    LanguageEnum["GAELIC"] = "GAELIC";
    LanguageEnum["GALICIAN"] = "GALICIAN";
    LanguageEnum["GANDA"] = "GANDA";
    LanguageEnum["GEORGIAN"] = "GEORGIAN";
    LanguageEnum["GERMAN"] = "GERMAN";
    LanguageEnum["GREEK"] = "GREEK";
    LanguageEnum["GUARANI"] = "GUARANI";
    LanguageEnum["GUJARATI"] = "GUJARATI";
    LanguageEnum["HAITIAN"] = "HAITIAN";
    LanguageEnum["HAUSA"] = "HAUSA";
    LanguageEnum["HEBREW"] = "HEBREW";
    LanguageEnum["HERERO"] = "HERERO";
    LanguageEnum["HINDI"] = "HINDI";
    LanguageEnum["HIRI_MOTU"] = "HIRI_MOTU";
    LanguageEnum["HMONG"] = "HMONG";
    LanguageEnum["HUNGARIAN"] = "HUNGARIAN";
    LanguageEnum["ICELANDIC"] = "ICELANDIC";
    LanguageEnum["IDO"] = "IDO";
    LanguageEnum["IGBO"] = "IGBO";
    LanguageEnum["ILOCANO"] = "ILOCANO";
    LanguageEnum["INDONESIAN"] = "INDONESIAN";
    LanguageEnum["INTERLINGUA"] = "INTERLINGUA";
    LanguageEnum["INTERLINGUE"] = "INTERLINGUE";
    LanguageEnum["INUKTITUT"] = "INUKTITUT";
    LanguageEnum["INUPIAQ"] = "INUPIAQ";
    LanguageEnum["IRISH"] = "IRISH";
    LanguageEnum["ITALIAN"] = "ITALIAN";
    LanguageEnum["JAPANESE"] = "JAPANESE";
    LanguageEnum["JAVANESE"] = "JAVANESE";
    LanguageEnum["KALAALLISUT"] = "KALAALLISUT";
    LanguageEnum["KANNADA"] = "KANNADA";
    LanguageEnum["KANURI"] = "KANURI";
    LanguageEnum["KASHMIRI"] = "KASHMIRI";
    LanguageEnum["KAZAKH"] = "KAZAKH";
    LanguageEnum["KHMER"] = "KHMER";
    LanguageEnum["KIKUYU"] = "KIKUYU";
    LanguageEnum["KINYARWANDA"] = "KINYARWANDA";
    LanguageEnum["KIRUNDI"] = "KIRUNDI";
    LanguageEnum["KOMI"] = "KOMI";
    LanguageEnum["KONGO"] = "KONGO";
    LanguageEnum["KOREAN"] = "KOREAN";
    LanguageEnum["KURDISH"] = "KURDISH";
    LanguageEnum["KWANYAMA"] = "KWANYAMA";
    LanguageEnum["KYRGYZ"] = "KYRGYZ";
    LanguageEnum["LAO"] = "LAO";
    LanguageEnum["LATIN"] = "LATIN";
    LanguageEnum["LATVIAN"] = "LATVIAN";
    LanguageEnum["LIMBURGISH"] = "LIMBURGISH";
    LanguageEnum["LINGALA"] = "LINGALA";
    LanguageEnum["LITHUANIAN"] = "LITHUANIAN";
    LanguageEnum["LUBAKATANGA"] = "LUBAKATANGA";
    LanguageEnum["LUXEMBOURGISH"] = "LUXEMBOURGISH";
    LanguageEnum["MACEDONIAN"] = "MACEDONIAN";
    LanguageEnum["MALAGASY"] = "MALAGASY";
    LanguageEnum["MALAY"] = "MALAY";
    LanguageEnum["MALAYALAM"] = "MALAYALAM";
    LanguageEnum["MALTESE"] = "MALTESE";
    LanguageEnum["MANDARIN"] = "MANDARIN";
    LanguageEnum["MANX"] = "MANX";
    LanguageEnum["MAORI"] = "MAORI";
    LanguageEnum["MARATHI"] = "MARATHI";
    LanguageEnum["MARSHALLESE"] = "MARSHALLESE";
    LanguageEnum["MONGOLIAN"] = "MONGOLIAN";
    LanguageEnum["NAURU"] = "NAURU";
    LanguageEnum["NAVAJO"] = "NAVAJO";
    LanguageEnum["NDONGA"] = "NDONGA";
    LanguageEnum["NEPALI"] = "NEPALI";
    LanguageEnum["NORTHERN_SAMI"] = "NORTHERN_SAMI";
    LanguageEnum["NORTH_NDEBELE"] = "NORTH_NDEBELE";
    LanguageEnum["NORWEGIAN"] = "NORWEGIAN";
    LanguageEnum["NUOSU"] = "NUOSU";
    LanguageEnum["OCCITAN"] = "OCCITAN";
    LanguageEnum["OJIBWE"] = "OJIBWE";
    LanguageEnum["ORIYA"] = "ORIYA";
    LanguageEnum["OROMO"] = "OROMO";
    LanguageEnum["OSSETIAN"] = "OSSETIAN";
    LanguageEnum["PALI"] = "P\u0100LI";
    LanguageEnum["PANJABI"] = "PANJABI";
    LanguageEnum["PUNJABI"] = "PUNJABI";
    LanguageEnum["PASHTO"] = "PASHTO";
    LanguageEnum["PERSIAN"] = "PERSIAN";
    LanguageEnum["POLISH"] = "POLISH";
    LanguageEnum["PORTUGUESE"] = "PORTUGUESE";
    LanguageEnum["QUECHUA"] = "QUECHUA";
    LanguageEnum["ROMANIAN"] = "ROMANIAN";
    LanguageEnum["ROMANSH"] = "ROMANSH";
    LanguageEnum["RUSSIAN"] = "RUSSIAN";
    LanguageEnum["SAMOAN"] = "SAMOAN";
    LanguageEnum["SANGO"] = "SANGO";
    LanguageEnum["SANSKRIT"] = "SANSKRIT";
    LanguageEnum["SARDINIAN"] = "SARDINIAN";
    LanguageEnum["SERBIAN"] = "SERBIAN";
    LanguageEnum["SERBO_CROATIAN"] = "SERBO_CROATIAN";
    LanguageEnum["SHONA"] = "SHONA";
    LanguageEnum["SIGN_LANGUAGE"] = "SIGN_LANGUAGE";
    LanguageEnum["SINDHI"] = "SINDHI";
    LanguageEnum["SINHALA"] = "SINHALA";
    LanguageEnum["SLOVAK"] = "SLOVAK";
    LanguageEnum["SLOVENE"] = "SLOVENE";
    LanguageEnum["SOMALI"] = "SOMALI";
    LanguageEnum["SOUTH_AZERBAIJANI"] = "SOUTH_AZERBAIJANI";
    LanguageEnum["SOUTHERN_SOTHO"] = "SOUTHERN_SOTHO";
    LanguageEnum["SPANISH"] = "SPANISH";
    LanguageEnum["SUNDANESE"] = "SUNDANESE";
    LanguageEnum["SWAHILI"] = "SWAHILI";
    LanguageEnum["SWATI"] = "SWATI";
    LanguageEnum["SWEDISH"] = "SWEDISH";
    LanguageEnum["TAGALOG"] = "TAGALOG";
    LanguageEnum["TAHITIAN"] = "TAHITIAN";
    LanguageEnum["TAJIK"] = "TAJIK";
    LanguageEnum["TAMIL"] = "TAMIL";
    LanguageEnum["TATAR"] = "TATAR";
    LanguageEnum["TELUGU"] = "TELUGU";
    LanguageEnum["THAI"] = "THAI";
    LanguageEnum["TIBETAN"] = "TIBETAN";
    LanguageEnum["TIGRINYA"] = "TIGRINYA";
    LanguageEnum["TONGA"] = "TONGA";
    LanguageEnum["TSONGA"] = "TSONGA";
    LanguageEnum["TSWANA"] = "TSWANA";
    LanguageEnum["TURKISH"] = "TURKISH";
    LanguageEnum["TURKMEN"] = "TURKMEN";
    LanguageEnum["TWI"] = "TWI";
    LanguageEnum["UKRAINIAN"] = "UKRAINIAN";
    LanguageEnum["URDU"] = "URDU";
    LanguageEnum["UYGHUR"] = "UYGHUR";
    LanguageEnum["UZBEK"] = "UZBEK";
    LanguageEnum["VENDA"] = "VENDA";
    LanguageEnum["VIETNAMESE"] = "VIETNAMESE";
    LanguageEnum["VOLAPUK"] = "VOLAPUK";
    LanguageEnum["WALLOON"] = "WALLOON";
    LanguageEnum["WELSH"] = "WELSH";
    LanguageEnum["WESTERN_FRISIAN"] = "WESTERN_FRISIAN";
    LanguageEnum["WOLOF"] = "WOLOF";
    LanguageEnum["XHOSA"] = "XHOSA";
    LanguageEnum["YIDDISH"] = "YIDDISH";
    LanguageEnum["YORUBA"] = "YORUBA";
    LanguageEnum["ZHUANG"] = "ZHUANG";
    LanguageEnum["ZULU"] = "ZULU";
})(exports.LanguageEnum || (exports.LanguageEnum = {}));
(function (MartindaleHubbellRatingEnum) {
    MartindaleHubbellRatingEnum["AV"] = "AV";
    MartindaleHubbellRatingEnum["BV"] = "BV";
    MartindaleHubbellRatingEnum["CV"] = "CV";
    MartindaleHubbellRatingEnum["AV_PREEMINENT"] = "AV_PREEMINENT";
    MartindaleHubbellRatingEnum["DISTINGUISHED"] = "DISTINGUISHED";
    MartindaleHubbellRatingEnum["NOTABLE"] = "NOTABLE";
    MartindaleHubbellRatingEnum["NOT_RATED"] = "NOT_RATED";
})(exports.MartindaleHubbellRatingEnum || (exports.MartindaleHubbellRatingEnum = {}));
(function (FileUploadType) {
    FileUploadType["AWARD"] = "AWARD";
    FileUploadType["CERTIFICATE_OF_INSURANCE"] = "CERTIFICATE_OF_INSURANCE";
    FileUploadType["CERTIFICATE"] = "CERTIFICATE";
    FileUploadType["OTHER"] = "OTHER";
    FileUploadType["PUBLICATION"] = "PUBLICATION";
    FileUploadType["QUESTIONNAIRE"] = "QUESTIONNAIRE";
    FileUploadType["PROFILE_IMAGE"] = "PROFILE_IMAGE";
})(exports.FileUploadType || (exports.FileUploadType = {}));
(function (NotificationType) {
    NotificationType["DEACTIVATION_NOTICE"] = "DEACTIVATION_NOTICE";
    NotificationType["INSURANCEUPDATE1"] = "INSURANCE_UPDATE_1";
    NotificationType["INSURANCEUPDATE2"] = "INSURANCE_UPDATE_2";
    NotificationType["INSURANCEUPDATE3"] = "INSURANCE_UPDATE_3";
    NotificationType["OTHER"] = "OTHER";
    NotificationType["PASSWORD_RESET"] = "PASSWORD_RESET";
    NotificationType["REFERRAL_APPLICATION_RESULT"] = "REFERRAL_APPLICATION_RESULT";
})(exports.NotificationType || (exports.NotificationType = {}));
(function (VerificationStatus) {
    VerificationStatus["PENDING"] = "PENDING";
    VerificationStatus["PASS"] = "PASS";
    VerificationStatus["FAIL"] = "FAIL";
})(exports.VerificationStatus || (exports.VerificationStatus = {}));
(function (Flag) {
    Flag["CONFERENCES"] = "CONFERENCES";
})(exports.Flag || (exports.Flag = {}));
const axios_1 = __importDefault(axios);
const utils_1 = utils;
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://providers.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title Providers Service Api
 * @version v1
 * @baseUrl https://providers.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersGetProviders
             * @request GET:/v1/providers
             * @secure
             */
            providersGetProviders: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersCreateProvider
             * @request POST:/v1/providers
             * @secure
             */
            providersCreateProvider: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersGetProviderById
             * @request GET:/v1/providers/{providerId}
             * @secure
             */
            providersGetProviderById: (providerId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersDeleteResource
             * @request DELETE:/v1/providers/{providerId}
             * @secure
             */
            providersDeleteResource: (providerId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}`, method: 'DELETE', secure: true }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersGetBranchesByList
             * @request POST:/v1/providers/getProvidersByIdList
             * @secure
             */
            providersGetBranchesByList: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/getProvidersByIdList`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersUpdateProviderName
             * @request POST:/v1/providers/{providerId}/updateName
             * @secure
             */
            providersUpdateProviderName: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/updateName`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersUpdatePracticeBeginDate
             * @request POST:/v1/providers/{providerId}/updatePracticeBeginDate
             * @secure
             */
            providersUpdatePracticeBeginDate: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/updatePracticeBeginDate`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersUpdateContactInfo
             * @request POST:/v1/providers/{providerId}/updateContactInformation
             * @secure
             */
            providersUpdateContactInfo: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/updateContactInformation`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersUpdateWebsiteUrl
             * @request POST:/v1/providers/{providerId}/updateWebsiteUrl
             * @secure
             */
            providersUpdateWebsiteUrl: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/updateWebsiteUrl`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersUpdateBiography
             * @request POST:/v1/providers/{providerId}/updateBiography
             * @secure
             */
            providersUpdateBiography: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/updateBiography`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersUpdateFirmId
             * @request POST:/v1/providers/{providerId}/updateFirmId
             * @secure
             */
            providersUpdateFirmId: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/updateFirmId`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersUpdateBranches
             * @request POST:/v1/providers/{providerId}/updateBranchAssociations
             * @secure
             */
            providersUpdateBranches: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/updateBranchAssociations`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersUpdateEmailAddress
             * @request POST:/v1/providers/{providerId}/updateEmailAddress
             * @secure
             */
            providersUpdateEmailAddress: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/updateEmailAddress`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersUpdateAddresses
             * @request POST:/v1/providers/{providerId}/updateAddresses
             * @secure
             */
            providersUpdateAddresses: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/updateAddresses`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersUpdatePhoneNumbers
             * @request POST:/v1/providers/{providerId}/updatePhoneNumbers
             * @secure
             */
            providersUpdatePhoneNumbers: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/updatePhoneNumbers`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersUpdateAreasOfPractice
             * @request POST:/v1/providers/{providerId}/updateAreasOfPractice
             * @secure
             */
            providersUpdateAreasOfPractice: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/updateAreasOfPractice`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersUpdateLanguages
             * @request POST:/v1/providers/{providerId}/updateLanguages
             * @secure
             */
            providersUpdateLanguages: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/updateLanguages`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersUpdateAwards
             * @request POST:/v1/providers/{providerId}/updateAwards
             * @secure
             */
            providersUpdateAwards: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/updateAwards`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersUpdateAssociations
             * @request POST:/v1/providers/{providerId}/updateAssociations
             * @secure
             */
            providersUpdateAssociations: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/updateAssociations`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersUpdateEducation
             * @request POST:/v1/providers/{providerId}/updateEducation
             * @secure
             */
            providersUpdateEducation: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/updateEducation`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersUpdatePublications
             * @request POST:/v1/providers/{providerId}/updatePublications
             * @secure
             */
            providersUpdatePublications: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/updatePublications`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersUpdateSpeakingEngagements
             * @request POST:/v1/providers/{providerId}/updateSpeakingEngagements
             * @secure
             */
            providersUpdateSpeakingEngagements: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/updateSpeakingEngagements`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersUpdateProfilePicUrl
             * @request POST:/v1/providers/{providerId}/updateProfilePicUrl
             * @secure
             */
            providersUpdateProfilePicUrl: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/updateProfilePicUrl`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersUpdateRating
             * @request POST:/v1/providers/{providerId}/updateRating
             * @secure
             */
            providersUpdateRating: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/updateRating`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersUpdateRating2
             * @request POST:/v1/providers/{providerId}/addNotificationHistory
             * @secure
             */
            providersUpdateRating2: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/addNotificationHistory`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersUpdateProviderTypes
             * @request POST:/v1/providers/{providerId}/updateProviderTypes
             * @secure
             */
            providersUpdateProviderTypes: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/updateProviderTypes`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersUpdateLegalShieldJoinYear
             * @request POST:/v1/providers/{providerId}/updateLegalShieldJoinYear
             * @secure
             */
            providersUpdateLegalShieldJoinYear: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/updateLegalShieldJoinYear`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersUpdateBarStates
             * @request POST:/v1/providers/{providerId}/updateBarStates
             * @secure
             */
            providersUpdateBarStates: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/updateBarStates`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersUpdateBarState
             * @request POST:/v1/providers/{providerId}/updateBarState
             * @secure
             */
            providersUpdateBarState: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/updateBarState`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersAddBarState
             * @request POST:/v1/providers/{providerId}/addBarState
             * @secure
             */
            providersAddBarState: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/addBarState`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersRemoveBarState
             * @request POST:/v1/providers/{providerId}/removeBarState
             * @secure
             */
            providersRemoveBarState: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/removeBarState`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersUpdateCriticalNotes
             * @request POST:/v1/providers/{providerId}/updateCriticalNotes
             * @secure
             */
            providersUpdateCriticalNotes: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/updateCriticalNotes`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersUpdateReferringEntity
             * @request POST:/v1/providers/{providerId}/updateReferringEntity
             * @secure
             */
            providersUpdateReferringEntity: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/updateReferringEntity`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersUpdateTaxId
             * @request POST:/v1/providers/{providerId}/updateTaxId
             * @secure
             */
            providersUpdateTaxId: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/updateTaxId`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersUpdateDisciplinaryActions
             * @request POST:/v1/providers/{providerId}/updateDisciplinaryActions
             * @secure
             */
            providersUpdateDisciplinaryActions: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/updateDisciplinaryActions`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersUpdateVerification
             * @request POST:/v1/providers/{providerId}/updateVerification
             * @secure
             */
            providersUpdateVerification: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/updateVerification`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersActivate
             * @request POST:/v1/providers/{providerId}/activate
             * @secure
             */
            providersActivate: (providerId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/activate`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersDeactivate
             * @request POST:/v1/providers/{providerId}/deactivate
             * @secure
             */
            providersDeactivate: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/deactivate`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersSuspend
             * @request POST:/v1/providers/{providerId}/suspend
             * @secure
             */
            providersSuspend: (providerId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/suspend`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersAddFileUpload
             * @request POST:/v1/providers/{providerId}/addFileUpload
             * @secure
             */
            providersAddFileUpload: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/addFileUpload`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersRemoveFileUpload
             * @request POST:/v1/providers/{providerId}/removeFileUpload
             * @secure
             */
            providersRemoveFileUpload: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/removeFileUpload`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersUpdateFileUploads
             * @request POST:/v1/providers/{providerId}/updateFileUploads
             * @secure
             */
            providersUpdateFileUploads: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/updateFileUploads`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersUpdateFlags
             * @request POST:/v1/providers/{providerId}/updateFlags
             * @secure
             */
            providersUpdateFlags: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/updateFlags`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersUpdateInsurance
             * @request POST:/v1/providers/{providerId}/updateInsurance
             * @secure
             */
            providersUpdateInsurance: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/updateInsurance`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersUpdateExternalId
             * @request POST:/v1/providers/{providerId}/updateExternalId
             * @secure
             */
            providersUpdateExternalId: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/updateExternalId`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersMarkInsuranceExpired
             * @request POST:/v1/providers/{providerId}/markInsuranceExpired
             * @secure
             */
            providersMarkInsuranceExpired: (providerId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/markInsuranceExpired`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersMarkInsuranceNeedsAttention
             * @request POST:/v1/providers/{providerId}/markInsuranceNeedsAttention
             * @secure
             */
            providersMarkInsuranceNeedsAttention: (providerId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/markInsuranceNeedsAttention`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersUpdateAcceptingReferrals
             * @request POST:/v1/providers/{providerId}/updateAcceptingReferrals
             * @secure
             */
            providersUpdateAcceptingReferrals: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/updateAcceptingReferrals`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Providers
             * @name ProvidersUpdateNetwork
             * @request POST:/v1/providers/{providerId}/updateNetwork
             * @secure
             */
            providersUpdateNetwork: (providerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/${providerId}/updateNetwork`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ProvidersJournal
             * @name ProvidersJournalGetJournalChanges
             * @request GET:/v1/providers/journal
             * @secure
             */
            providersJournalGetJournalChanges: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/providers/journal`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;

}(providers));

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(providers, exports);

}(providers$1));

var purchases$1 = {};

var purchases = {};

(function (exports) {
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.Action = exports.Status2 = exports.MarketingChannel = exports.BillingPeriod = exports.Currency = exports.SubscriptionAction = exports.Channel = exports.BillingProviderType = exports.PurchasePaymentMethod = exports.Period = exports.Status = void 0;
(function (Status) {
    Status["OPEN"] = "OPEN";
    Status["FUNDED"] = "FUNDED";
    Status["FULLY_FUNDED"] = "FULLY_FUNDED";
})(exports.Status || (exports.Status = {}));
(function (Period) {
    Period["DAY"] = "DAY";
    Period["WEEK"] = "WEEK";
    Period["MONTH"] = "MONTH";
    Period["QUARTER"] = "QUARTER";
    Period["BIANNUAL"] = "BIANNUAL";
    Period["ANNUAL"] = "ANNUAL";
    Period["PAY_PERIOD"] = "PAY_PERIOD";
})(exports.Period || (exports.Period = {}));
(function (PurchasePaymentMethod) {
    PurchasePaymentMethod["CREDIT_CARD"] = "CREDIT_CARD";
    PurchasePaymentMethod["BANK_DRAFT"] = "BANK_DRAFT";
    PurchasePaymentMethod["PREMIUM_BILLING"] = "PREMIUM_BILLING";
    PurchasePaymentMethod["CHECK"] = "CHECK";
})(exports.PurchasePaymentMethod || (exports.PurchasePaymentMethod = {}));
(function (BillingProviderType) {
    BillingProviderType["PSX"] = "PSX";
    BillingProviderType["SYSTEM_I"] = "SYSTEM I";
})(exports.BillingProviderType || (exports.BillingProviderType = {}));
(function (Channel) {
    Channel["GroupSites"] = "GroupSites";
    Channel["Corp"] = "Corp";
    Channel["Hubsites"] = "Hubsites";
    Channel["LaunchByLS"] = "LaunchByLS";
})(exports.Channel || (exports.Channel = {}));
(function (SubscriptionAction) {
    SubscriptionAction["CREATE"] = "CREATE";
    SubscriptionAction["UPDATE"] = "UPDATE";
})(exports.SubscriptionAction || (exports.SubscriptionAction = {}));
(function (Currency) {
    Currency["USD"] = "USD";
    Currency["CAD"] = "CAD";
})(exports.Currency || (exports.Currency = {}));
(function (BillingPeriod) {
    BillingPeriod["DAILY"] = "DAILY";
    BillingPeriod["WEEKLY"] = "WEEKLY";
    BillingPeriod["MONTHLY"] = "MONTHLY";
    BillingPeriod["ANNUAL"] = "ANNUAL";
    BillingPeriod["BIANNUAL"] = "BIANNUAL";
    BillingPeriod["QUARTERLY"] = "QUARTERLY";
    BillingPeriod["PAY_PERIOD"] = "PAY_PERIOD";
})(exports.BillingPeriod || (exports.BillingPeriod = {}));
(function (MarketingChannel) {
    MarketingChannel["GROUPSITES"] = "GROUPSITES";
    MarketingChannel["CORP"] = "CORP";
    MarketingChannel["HUBSITES"] = "HUBSITES";
    MarketingChannel["LAUNCH_BY_LS"] = "LAUNCH_BY_LS";
    MarketingChannel["BUYNOW"] = "BUYNOW";
})(exports.MarketingChannel || (exports.MarketingChannel = {}));
(function (Status2) {
    Status2["OPEN"] = "OPEN";
    Status2["FUNDED"] = "FUNDED";
    Status2["PROVISIONED"] = "PROVISIONED";
    Status2["PAYMENT_FAILED"] = "PAYMENT_FAILED";
})(exports.Status2 || (exports.Status2 = {}));
(function (Action) {
    Action["CREATED"] = "CREATED";
    Action["UPDATED"] = "UPDATED";
    Action["DELETED"] = "DELETED";
    Action["OWNER_ASSIGNED"] = "OWNER_ASSIGNED";
    Action["STATUS_CHANGED"] = "STATUS_CHANGED";
    Action["ENTITLEMENTS_CREATED"] = "ENTITLEMENTS_CREATED";
    Action["SUBSCRIPTIONS_CREATED"] = "SUBSCRIPTIONS_CREATED";
})(exports.Action || (exports.Action = {}));
const axios_1 = __importDefault(axios);
const utils_1 = utils;
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://purchases.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title Purchases
 * @version v1
 * @baseUrl https://purchases.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * No description
             *
             * @tags AnonymousOrders
             * @name AnonymousOrdersCreateOrder
             * @request POST:/v1/orders
             * @secure
             */
            anonymousOrdersCreateOrder: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/orders`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags AnonymousOrders
             * @name AnonymousOrdersGetOrderAnonymous
             * @request GET:/v1/orders/{orderId}
             * @secure
             */
            anonymousOrdersGetOrderAnonymous: (orderId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/orders/${orderId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags AnonymousOrders
             * @name AnonymousOrdersModifyOffers
             * @request PUT:/v1/orders/{orderId}/offers
             * @secure
             */
            anonymousOrdersModifyOffers: (orderId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/orders/${orderId}/offers`, method: 'PUT', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description Non anonymous orders must be created within the context of a user identity
             *
             * @tags AuthorizedOrders
             * @name AuthorizedOrdersCreateOrder
             * @summary User JWT Only
             * @request POST:/v1/identities/{identityId}/orders
             * @secure
             */
            authorizedOrdersCreateOrder: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/orders`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags AuthorizedOrders
             * @name AuthorizedOrdersGetOrders
             * @request GET:/v1/identities/{identityId}/orders
             * @secure
             */
            authorizedOrdersGetOrders: (identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/orders`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags AuthorizedOrders
             * @name AuthorizedOrdersGetOrderWithIdentity
             * @request GET:/v1/identities/{identityId}/orders/{orderId}
             * @secure
             */
            authorizedOrdersGetOrderWithIdentity: (identityId, orderId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/orders/${orderId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * @description All system methods require machine JWTs
             *
             * @tags AuthorizedOrders
             * @name AuthorizedOrdersAssignOwner
             * @summary Machine JWT Only
             * @request POST:/v1/orders/{orderId}/assignOwner
             * @secure
             */
            authorizedOrdersAssignOwner: (orderId, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/orders/${orderId}/assignOwner`, method: 'POST', query: query, secure: true, format: 'json' }, params)),
            /**
             * @description Purchasing must be done by a person
             *
             * @tags AuthorizedOrders
             * @name AuthorizedOrdersPurchaseOrder
             * @summary User JWT Only
             * @request POST:/v1/identities/{identityId}/orders/{orderId}/purchase
             * @secure
             */
            authorizedOrdersPurchaseOrder: (identityId, orderId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/orders/${orderId}/purchase`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description The journal is for internal use only
             *
             * @tags OrdersJournal
             * @name OrdersJournalAll
             * @summary Machine JWT Only
             * @request GET:/v1/orders/journal
             * @secure
             */
            ordersJournalAll: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/orders/journal`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
        };
        this.v2 = {
            /**
             * No description
             *
             * @tags AnonymousOrders
             * @name AnonymousOrdersCreateOrder2
             * @request POST:/v2/orders
             * @secure
             */
            anonymousOrdersCreateOrder2: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/orders`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags AnonymousOrders
             * @name AnonymousOrdersGetOrderAnonymous2
             * @request GET:/v2/orders/{orderId}
             * @secure
             */
            anonymousOrdersGetOrderAnonymous2: (orderId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/orders/${orderId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags AnonymousOrders
             * @name AnonymousOrdersModifyOffers2
             * @request PUT:/v2/orders/{orderId}/offers
             * @secure
             */
            anonymousOrdersModifyOffers2: (orderId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/orders/${orderId}/offers`, method: 'PUT', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description Non anonymous orders must be created within the context of a user identity
             *
             * @tags AuthorizedOrders
             * @name AuthorizedOrdersCreateOrder2
             * @summary User JWT Only
             * @request POST:/v2/identities/{identityId}/orders
             * @secure
             */
            authorizedOrdersCreateOrder2: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/orders`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags AuthorizedOrders
             * @name AuthorizedOrdersGetOrders2
             * @request GET:/v2/identities/{identityId}/orders
             * @secure
             */
            authorizedOrdersGetOrders2: (identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/orders`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags AuthorizedOrders
             * @name AuthorizedOrdersGetOrderWithIdentity2
             * @request GET:/v2/identities/{identityId}/orders/{orderId}
             * @secure
             */
            authorizedOrdersGetOrderWithIdentity2: (identityId, orderId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/orders/${orderId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * @description All system methods require machine JWTs
             *
             * @tags AuthorizedOrders
             * @name AuthorizedOrdersAssignOwner2
             * @summary Machine JWT Only
             * @request POST:/v2/orders/{orderId}/assignOwner
             * @secure
             */
            authorizedOrdersAssignOwner2: (orderId, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/orders/${orderId}/assignOwner`, method: 'POST', query: query, secure: true, format: 'json' }, params)),
            /**
             * @description All system methods require machine JWTs
             *
             * @tags AuthorizedOrders
             * @name AuthorizedOrdersProvisionOrder
             * @summary Machine JWT Only
             * @request POST:/v2/orders/{orderId}/provision
             * @secure
             */
            authorizedOrdersProvisionOrder: (orderId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/orders/${orderId}/provision`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags AuthorizedOrders
             * @name AuthorizedOrdersPurchaseOrder2
             * @request POST:/v2/identities/{identityId}/orders/{orderId}/purchase
             * @secure
             */
            authorizedOrdersPurchaseOrder2: (identityId, orderId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/orders/${orderId}/purchase`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
        };
        this.orders = {
            /**
             * @description The journal is for internal use only
             *
             * @tags OrdersJournal
             * @name OrdersJournal
             * @summary Machine JWT Only
             * @request GET:/orders/journal
             * @secure
             */
            ordersJournal: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/orders/journal`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags OrdersJournal
             * @name OrdersJournalGetJournalMaxClock
             * @request GET:/orders/journal/maxClock
             * @secure
             */
            ordersJournalGetJournalMaxClock: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/orders/journal/maxClock`, method: 'GET', secure: true, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;

}(purchases));

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(purchases, exports);

}(purchases$1));

var queries$1 = {};

var queries = {};

(function (exports) {
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = void 0;
const axios_1 = __importDefault(axios);
const utils_1 = utils;
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://queries.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title Queries Service
 * @version v1
 * @baseUrl https://queries.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * No description
             *
             * @tags PublicQueries
             * @name PublicQueriesServiceOriginatedQueries
             * @request GET:/v1/public/queries/{serviceName}/{methodName}
             * @secure
             */
            publicQueriesServiceOriginatedQueries: (serviceName, methodName, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/public/queries/${serviceName}/${methodName}`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Queries
             * @name QueriesIdentityOriginatedQueries
             * @request GET:/v1/identities/{identityId}/queries/{serviceName}/{methodName}
             * @secure
             */
            queriesIdentityOriginatedQueries: (identityId, serviceName, methodName, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/queries/${serviceName}/${methodName}`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Queries
             * @name QueriesServiceOriginatedQueries
             * @request GET:/v1/queries/{serviceName}/{methodName}
             * @secure
             */
            queriesServiceOriginatedQueries: (serviceName, methodName, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/queries/${serviceName}/${methodName}`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;

}(queries));

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(queries, exports);

}(queries$1));

var questions$1 = {};

var questions = {};

(function (exports) {
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = void 0;
const axios_1 = __importDefault(axios);
const utils_1 = utils;
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://questions.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title Products Questions Service API
 * @version v1
 * @baseUrl https://questions.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * No description
             *
             * @tags ProductsQuestions
             * @name ProductsQuestionsGetQuestions
             * @request GET:/v1/questions
             * @secure
             */
            productsQuestionsGetQuestions: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/questions`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ProductsQuestions
             * @name MachineInternalJwtOnly
             * @request POST:/v1/questions
             * @secure
             */
            machineInternalJwtOnly: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/questions`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ProductsQuestions
             * @name ProductsQuestionsGetSpecificQuestionnaire
             * @request GET:/v1/questions/{questionId}
             * @secure
             */
            productsQuestionsGetSpecificQuestionnaire: (questionId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/questions/${questionId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ProductsQuestions
             * @name MachineInternalJwtOnly2
             * @request PUT:/v1/questions/{questionId}
             * @secure
             */
            machineInternalJwtOnly2: (questionId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/questions/${questionId}`, method: 'PUT', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ProductsQuestions
             * @name MachineInternalJwtOnly3
             * @request POST:/v1/questions/{questionId}/updateSupportedMobileVersions
             * @secure
             */
            machineInternalJwtOnly3: (questionId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/questions/${questionId}/updateSupportedMobileVersions`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ProductsQuestions
             * @name MachineInternalJwtOnly4
             * @request POST:/v1/questions/{questionId}/addSupportedMobileVersions
             * @secure
             */
            machineInternalJwtOnly4: (questionId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/questions/${questionId}/addSupportedMobileVersions`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ProductsQuestions
             * @name MachineInternalJwtOnly5
             * @request POST:/v1/questions/{questionId}/removeSupportedMobileVersions
             * @secure
             */
            machineInternalJwtOnly5: (questionId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/questions/${questionId}/removeSupportedMobileVersions`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ProductsQuestionsJournal
             * @name ProductsQuestionsJournalGetJournalChanges
             * @request GET:/v1/questions/journal
             * @secure
             */
            productsQuestionsJournalGetJournalChanges: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/questions/journal`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ProductsQuestionsJournal
             * @name ProductsQuestionsJournalGetMaxClock
             * @request GET:/v1/questions/journal/maxClock
             * @secure
             */
            productsQuestionsJournalGetMaxClock: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/questions/journal/maxClock`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags PublicProductsQuestions
             * @name PublicProductsQuestionsGetSpecificPublicQuestionnaire
             * @request GET:/v1/public/questions/{questionId}
             * @secure
             */
            publicProductsQuestionsGetSpecificPublicQuestionnaire: (questionId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/public/questions/${questionId}`, method: 'GET', secure: true, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;

}(questions));

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(questions, exports);

}(questions$1));

var relations$1 = {};

var relations = {};

(function (exports) {
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.RelationType = exports.Action = exports.RelationMemberStatus = exports.RelationPermissionType = void 0;
(function (RelationPermissionType) {
    RelationPermissionType["PRIMARY"] = "PRIMARY";
    RelationPermissionType["SPOUSE"] = "SPOUSE";
    RelationPermissionType["DEPENDENT"] = "DEPENDENT";
    RelationPermissionType["NORMAL_USER"] = "NORMAL_USER";
    RelationPermissionType["OWNER"] = "OWNER";
    RelationPermissionType["CO_OWNER"] = "CO_OWNER";
    RelationPermissionType["SECONDARY"] = "SECONDARY";
    RelationPermissionType["TERTIARY"] = "TERTIARY";
    RelationPermissionType["ELDER"] = "ELDER";
})(exports.RelationPermissionType || (exports.RelationPermissionType = {}));
(function (RelationMemberStatus) {
    RelationMemberStatus["Inactive"] = "Inactive";
    RelationMemberStatus["Active"] = "Active";
})(exports.RelationMemberStatus || (exports.RelationMemberStatus = {}));
(function (Action) {
    Action["CREATED"] = "CREATED";
    Action["UPDATED_TYPE"] = "UPDATED_TYPE";
    Action["UPDATED_ALIAS"] = "UPDATED_ALIAS";
    Action["REMOVED"] = "REMOVED";
    Action["ADDED_MEMBER"] = "ADDED_MEMBER";
    Action["ADDED_MEMBERS"] = "ADDED_MEMBERS";
    Action["REMOVED_MEMBER"] = "REMOVED_MEMBER";
    Action["UPDATED_MEMBER"] = "UPDATED_MEMBER";
    Action["UPDATED_PRIMARY_MEMBER"] = "UPDATED_PRIMARY_MEMBER";
})(exports.Action || (exports.Action = {}));
(function (RelationType) {
    RelationType["Family"] = "Family";
    RelationType["Business"] = "Business";
    RelationType["Associate"] = "Associate";
})(exports.RelationType || (exports.RelationType = {}));
const axios_1 = __importDefault(axios);
const utils_1 = utils;
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://relations.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title Relations API
 * @version v1
 * @baseUrl https://relations.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * No description
             *
             * @tags RelationMembers
             * @name RelationMembersFetchMembers
             * @request GET:/v1/identities/{identityId}/relations/{relationId}/members
             * @secure
             */
            relationMembersFetchMembers: (identityId, relationId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/relations/${relationId}/members`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags RelationMembers
             * @name RelationMembersBulkAddMembers
             * @request POST:/v1/identities/{identityId}/relations/{relationId}/bulkAddMembers
             * @secure
             */
            relationMembersBulkAddMembers: (identityId, relationId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/relations/${relationId}/bulkAddMembers`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags RelationMembers
             * @name RelationMembersAddMember
             * @request POST:/v1/identities/{identityId}/relations/{relationId}/addMember
             * @secure
             */
            relationMembersAddMember: (identityId, relationId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/relations/${relationId}/addMember`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags RelationMembers
             * @name RelationMembersRemoveMember
             * @request POST:/v1/identities/{identityId}/relations/{relationId}/removeMember
             * @secure
             */
            relationMembersRemoveMember: (identityId, relationId, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/relations/${relationId}/removeMember`, method: 'POST', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags RelationMembers
             * @name RelationMembersUpdateMember
             * @request POST:/v1/identities/{identityId}/relations/{relationId}/updateMember
             * @secure
             */
            relationMembersUpdateMember: (identityId, relationId, query, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/relations/${relationId}/updateMember`, method: 'POST', query: query, body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags RelationMembers
             * @name RelationMembersUpdatePrimaryMember
             * @request POST:/v1/identities/{identityId}/relations/{relationId}/updatePrimaryMember
             * @secure
             */
            relationMembersUpdatePrimaryMember: (identityId, relationId, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/relations/${relationId}/updatePrimaryMember`, method: 'POST', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Relations
             * @name RelationsCreateRelation
             * @request POST:/v1/identities/{identityId}/relations
             * @secure
             */
            relationsCreateRelation: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/relations`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Relations
             * @name RelationsFetchRelations
             * @request GET:/v1/identities/{identityId}/relations
             * @secure
             */
            relationsFetchRelations: (identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/relations`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Relations
             * @name RelationsFetchRelation
             * @request GET:/v1/identities/{identityId}/relations/{relationId}
             * @secure
             */
            relationsFetchRelation: (identityId, relationId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/relations/${relationId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Relations
             * @name RelationsUpdateType
             * @request POST:/v1/identities/{identityId}/relations/{relationId}/updateType
             * @secure
             */
            relationsUpdateType: (identityId, relationId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/relations/${relationId}/updateType`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Relations
             * @name RelationsUpdateAlias
             * @request POST:/v1/identities/{identityId}/relations/{relationId}/updateAlias
             * @secure
             */
            relationsUpdateAlias: (identityId, relationId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/relations/${relationId}/updateAlias`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Relations
             * @name RelationsRemoveRelation
             * @request POST:/v1/identities/{identityId}/relations/{relationId}/removeRelation
             * @secure
             */
            relationsRemoveRelation: (identityId, relationId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/relations/${relationId}/removeRelation`, method: 'POST', secure: true }, params)),
            /**
             * No description
             *
             * @tags Relations
             * @name RelationsChangeOwner
             * @request POST:/v1/identities/{identityId}/relations/{relationId}/changeOwner
             * @secure
             */
            relationsChangeOwner: (identityId, relationId, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/relations/${relationId}/changeOwner`, method: 'POST', query: query, secure: true, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;

}(relations));

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(relations, exports);

}(relations$1));

var resolutions$1 = {};

var resolutions = {};

(function (exports) {
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.JournalActionEnum = exports.ActionTakenEnum = exports.ConcernEnum = exports.TypeEnum = exports.StatusEnum = exports.SourceEnum = void 0;
(function (SourceEnum) {
    SourceEnum["Associate"] = "Associate";
    SourceEnum["Call"] = "Call";
    SourceEnum["Clarification"] = "Clarification";
    SourceEnum["Letter"] = "Letter";
    SourceEnum["Survey"] = "Survey";
})(exports.SourceEnum || (exports.SourceEnum = {}));
(function (StatusEnum) {
    StatusEnum["Open"] = "Open";
    StatusEnum["ClosedWithMerit"] = "ClosedWithMerit";
    StatusEnum["ClosedWithoutMerit"] = "ClosedWithoutMerit";
    StatusEnum["PendingMember"] = "PendingMember";
    StatusEnum["PendingProvider"] = "PendingProvider";
    StatusEnum["New"] = "New";
    StatusEnum["AttemptMade"] = "AttemptMade";
})(exports.StatusEnum || (exports.StatusEnum = {}));
(function (TypeEnum) {
    TypeEnum["Conflict"] = "Conflict";
    TypeEnum["ProviderFirm"] = "ProviderFirm";
    TypeEnum["ProviderReferral"] = "ProviderReferral";
    TypeEnum["EmergencyAccess"] = "EmergencyAccess";
    TypeEnum["SpecialCase"] = "SpecialCase";
})(exports.TypeEnum || (exports.TypeEnum = {}));
(function (ConcernEnum) {
    ConcernEnum["UntimelyCallback"] = "UntimelyCallback";
    ConcernEnum["LegalAdvice"] = "LegalAdvice";
    ConcernEnum["Docs"] = "Docs";
    ConcernEnum["StaffAttitude"] = "StaffAttitude";
    ConcernEnum["RetainerOrRate"] = "RetainerOrRate";
    ConcernEnum["ReferralAttorney"] = "ReferralAttorney";
    ConcernEnum["CoverageAdvised"] = "CoverageAdvised";
    ConcernEnum["Disposition"] = "Disposition";
    ConcernEnum["AttorneyNoShow"] = "AttorneyNoShow";
    ConcernEnum["Misc"] = "Misc";
    ConcernEnum["NoReferral"] = "NoReferral";
    ConcernEnum["ImproperPplProcedure"] = "ImproperPplProcedure";
    ConcernEnum["ImproperSoftwareUse"] = "ImproperSoftwareUse";
    ConcernEnum["SurveyScore"] = "SurveyScore";
    ConcernEnum["NoCallback"] = "NoCallback";
    ConcernEnum["AttorneyUnreachable"] = "AttorneyUnreachable";
    ConcernEnum["InsufficientAdvice"] = "InsufficientAdvice";
    ConcernEnum["AreaOrDistance"] = "AreaOrDistance";
    ConcernEnum["AttorneyConflict"] = "AttorneyConflict";
    ConcernEnum["AreaOfLaw"] = "AreaOfLaw";
    ConcernEnum["CaseRefused"] = "CaseRefused";
    ConcernEnum["NewAttorneyReq"] = "NewAttorneyReq";
    ConcernEnum["DiscountRefusal"] = "DiscountRefusal";
})(exports.ConcernEnum || (exports.ConcernEnum = {}));
(function (ActionTakenEnum) {
    ActionTakenEnum["WaitingOnProvider"] = "WaitingOnProvider";
    ActionTakenEnum["ProviderActionTaken"] = "ProviderActionTaken";
})(exports.ActionTakenEnum || (exports.ActionTakenEnum = {}));
(function (JournalActionEnum) {
    JournalActionEnum["Migrated"] = "Migrated";
    JournalActionEnum["Created"] = "Created";
    JournalActionEnum["Updated"] = "Updated";
    JournalActionEnum["NoteAdded"] = "NoteAdded";
    JournalActionEnum["StatusUpdated"] = "StatusUpdated";
    JournalActionEnum["AssigneeIdUpdated"] = "AssigneeIdUpdated";
    JournalActionEnum["ContactMethodUpdated"] = "ContactMethodUpdated";
    JournalActionEnum["OwnerChanged"] = "OwnerChanged";
})(exports.JournalActionEnum || (exports.JournalActionEnum = {}));
const axios_1 = __importDefault(axios);
const utils_1 = utils;
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://resolutions.api.legalshieldinternal.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title Resolutions API
 * @version v1
 * @baseUrl https://resolutions.api.legalshieldinternal.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * No description
             *
             * @tags MemberIntakes
             * @name MemberIntakesGetIntakesForMember
             * @request GET:/v1/intakes/{memberid}
             * @secure
             */
            memberIntakesGetIntakesForMember: (memberId, memberid, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/intakes/${memberid}`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Permissions
             * @name PermissionsGetAssignees
             * @request GET:/v1/resolutions/assignees
             * @secure
             */
            permissionsGetAssignees: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/resolutions/assignees`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Permissions
             * @name PermissionsGetOktaGroupMembers
             * @request GET:/v1/resolutions/oktagroup/{groupId}/users
             * @secure
             */
            permissionsGetOktaGroupMembers: (groupId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/resolutions/oktagroup/${groupId}/users`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ResolutionHistory
             * @name ResolutionHistoryGetResolutionHistory
             * @request GET:/v1/resolutions/{resolutionId}/history
             * @secure
             */
            resolutionHistoryGetResolutionHistory: (resolutionId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/resolutions/${resolutionId}/history`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Resolutions
             * @name ResolutionsGetResolutionResourceById
             * @request GET:/v1/resolutions/{id}
             * @secure
             */
            resolutionsGetResolutionResourceById: (id, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/resolutions/${id}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Resolutions
             * @name ResolutionsUpdateResolutionResource
             * @request PUT:/v1/resolutions/{id}
             * @secure
             */
            resolutionsUpdateResolutionResource: (id, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/resolutions/${id}`, method: 'PUT', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Resolutions
             * @name ResolutionsCreateResolutionResource
             * @request POST:/v1/resolutions
             * @secure
             */
            resolutionsCreateResolutionResource: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/resolutions`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Resolutions
             * @name ResolutionsAddNote
             * @request POST:/v1/resolutions/{id}/addNote
             * @secure
             */
            resolutionsAddNote: (id, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/resolutions/${id}/addNote`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Resolutions
             * @name ResolutionsUpdateNotePinPriority
             * @request POST:/v1/resolutions/{resolutionId}/note/{noteId}/updatePinPriority/{newPinPriority}
             * @secure
             */
            resolutionsUpdateNotePinPriority: (resolutionId, noteId, newPinPriority, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/resolutions/${resolutionId}/note/${noteId}/updatePinPriority/${newPinPriority}`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Resolutions
             * @name ResolutionsUpdateStatus
             * @request POST:/v1/resolutions/{id}/updateStatus/{newStatus}
             * @secure
             */
            resolutionsUpdateStatus: (id, newStatus, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/resolutions/${id}/updateStatus/${newStatus}`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Resolutions
             * @name ResolutionsUpdateAssigneeId
             * @request POST:/v1/resolutions/{id}/updateAssigneeId/{newAssigneeId}
             * @secure
             */
            resolutionsUpdateAssigneeId: (id, newAssigneeId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/resolutions/${id}/updateAssigneeId/${newAssigneeId}`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Resolutions
             * @name ResolutionsUpdateContactMethod
             * @request POST:/v1/resolutions/{id}/updateContactMethod/{newContactMethod}
             * @secure
             */
            resolutionsUpdateContactMethod: (id, newContactMethod, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/resolutions/${id}/updateContactMethod/${newContactMethod}`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * @description This modification method requires a machine JWT
             *
             * @tags Resolutions
             * @name ResolutionsChangeOwner
             * @summary Machine JWT Only
             * @request POST:/v1/resolutions/{id}/changeOwner
             * @secure
             */
            resolutionsChangeOwner: (id, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/resolutions/${id}/changeOwner`, method: 'POST', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Resolutions
             * @name ResolutionsGetResolutionsByOwner
             * @request GET:/v1/identities/{identityId}/resolutions
             * @secure
             */
            resolutionsGetResolutionsByOwner: (identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/resolutions`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ResolutionsDetail
             * @name ResolutionsDetailGetResolutionDetailsById
             * @request GET:/v1/resolutions/{id}/details
             * @secure
             */
            resolutionsDetailGetResolutionDetailsById: (id, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/resolutions/${id}/details`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * @description The journal is for internal use only
             *
             * @tags ResolutionsJournal
             * @name ResolutionsJournal
             * @summary Machine JWT Only
             * @request GET:/v1/resolutions/journal
             * @secure
             */
            resolutionsJournal: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/resolutions/journal`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ResolutionsJournal
             * @name ResolutionsJournalGetJournalMaxClock
             * @request GET:/v1/resolutions/journal/maxClock
             * @secure
             */
            resolutionsJournalGetJournalMaxClock: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/resolutions/journal/maxClock`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ResolutionsSearch
             * @name ResolutionsSearchSearchResolutions
             * @request POST:/v1/resolutions/search
             * @secure
             */
            resolutionsSearchSearchResolutions: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/resolutions/search`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ResolutionsSearch
             * @name ResolutionsSearchGetPartnerBranches
             * @request GET:/v1/resolutions/partnerbranches
             * @secure
             */
            resolutionsSearchGetPartnerBranches: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/resolutions/partnerbranches`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ResolutionsSearch
             * @name ResolutionsSearchGetFirmEmployeesByFirmId
             * @request GET:/v1/resolutions/firms/{firmid}/employees
             * @secure
             */
            resolutionsSearchGetFirmEmployeesByFirmId: (firmId, firmid, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/resolutions/firms/${firmid}/employees`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ResolutionsSearch
             * @name ResolutionsSearchGetFirmsByBranchId
             * @request GET:/v1/resolutions/branches/{branchid}/firms
             * @secure
             */
            resolutionsSearchGetFirmsByBranchId: (branchId, branchid, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/resolutions/branches/${branchid}/firms`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ResolutionsSearch
             * @name ResolutionsSearchGetServicingBranches
             * @request GET:/v1/resolutions/servicingbranches/{memberId}/{entitlementId}
             * @secure
             */
            resolutionsSearchGetServicingBranches: (memberId, entitlementId, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/resolutions/servicingbranches/${memberId}/${entitlementId}`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;

}(resolutions));

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(resolutions, exports);

}(resolutions$1));

var scheduledCommunications$1 = {};

var scheduledCommunications = {};

(function (exports) {
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.ScheduledCommunicationAction = exports.ScheduledCommunicationStatus = void 0;
(function (ScheduledCommunicationStatus) {
    ScheduledCommunicationStatus["SCHEDULED"] = "SCHEDULED";
    ScheduledCommunicationStatus["PROCESSING"] = "PROCESSING";
    ScheduledCommunicationStatus["SUCCESSFUL"] = "SUCCESSFUL";
    ScheduledCommunicationStatus["FAILED"] = "FAILED";
    ScheduledCommunicationStatus["CANCELLED"] = "CANCELLED";
    ScheduledCommunicationStatus["RETRYING"] = "RETRYING";
})(exports.ScheduledCommunicationStatus || (exports.ScheduledCommunicationStatus = {}));
(function (ScheduledCommunicationAction) {
    ScheduledCommunicationAction["CREATED"] = "CREATED";
    ScheduledCommunicationAction["UPDATE_DELIVER_DATE"] = "UPDATE_DELIVER_DATE";
    ScheduledCommunicationAction["CHANGE_OWNER"] = "CHANGE_OWNER";
    ScheduledCommunicationAction["STATUS_UPDATE"] = "STATUS_UPDATE";
    ScheduledCommunicationAction["DELETED"] = "DELETED";
})(exports.ScheduledCommunicationAction || (exports.ScheduledCommunicationAction = {}));
const axios_1 = __importDefault(axios);
const utils_1 = utils;
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://scheduled-communications.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title Scheduled Communications API
 * @version v1
 * @baseUrl https://scheduled-communications.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * No description
             *
             * @tags ScheduledCommunications
             * @name ScheduledCommunicationsCreate
             * @request POST:/v1/scheduledCommunications
             * @secure
             */
            scheduledCommunicationsCreate: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/scheduledCommunications`, method: 'POST', body: data, secure: true, type: FecContentType.Json }, params)),
            /**
             * No description
             *
             * @tags ScheduledCommunications
             * @name ScheduledCommunicationsGet
             * @request GET:/v1/scheduledCommunications/{id}
             * @secure
             */
            scheduledCommunicationsGet: (id, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/scheduledCommunications/${id}`, method: 'GET', secure: true }, params)),
            /**
             * No description
             *
             * @tags ScheduledCommunications
             * @name ScheduledCommunicationsChangeDeliverOn
             * @request POST:/v1/scheduledCommunications/{id}/changeDeliverOn
             * @secure
             */
            scheduledCommunicationsChangeDeliverOn: (id, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/scheduledCommunications/${id}/changeDeliverOn`, method: 'POST', body: data, secure: true, type: FecContentType.Json }, params)),
            /**
             * No description
             *
             * @tags ScheduledCommunications
             * @name ScheduledCommunicationsCancel
             * @request POST:/v1/scheduledCommunications/{id}/cancel
             * @secure
             */
            scheduledCommunicationsCancel: (id, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/scheduledCommunications/${id}/cancel`, method: 'POST', secure: true }, params)),
            /**
             * No description
             *
             * @tags ScheduledCommunications
             * @name ScheduledCommunicationsProcessSingle
             * @request POST:/v1/scheduledCommunications/{id}/process
             * @secure
             */
            scheduledCommunicationsProcessSingle: (id, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/scheduledCommunications/${id}/process`, method: 'POST', secure: true }, params)),
            /**
             * No description
             *
             * @tags ScheduledCommunicationsWorker
             * @name ScheduledCommunicationsWorkerGetWorker
             * @request GET:/v1/scheduledCommunications/worker
             * @secure
             */
            scheduledCommunicationsWorkerGetWorker: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/scheduledCommunications/worker`, method: 'GET', secure: true }, params)),
            /**
             * No description
             *
             * @tags ScheduledCommunicationsWorker
             * @name ScheduledCommunicationsWorkerPause
             * @request POST:/v1/scheduledCommunications/worker/pause
             * @secure
             */
            scheduledCommunicationsWorkerPause: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/scheduledCommunications/worker/pause`, method: 'POST', secure: true }, params)),
            /**
             * No description
             *
             * @tags ScheduledCommunicationsWorker
             * @name ScheduledCommunicationsWorkerActivate
             * @request POST:/v1/scheduledCommunications/worker/activate
             * @secure
             */
            scheduledCommunicationsWorkerActivate: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/scheduledCommunications/worker/activate`, method: 'POST', secure: true }, params)),
        };
    }
}
exports.Api = Api;

}(scheduledCommunications));

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(scheduledCommunications, exports);

}(scheduledCommunications$1));

var servicerequests$1 = {};

var servicerequests = {};

(function (exports) {
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.AreaOfLawEnum = exports.CommunicationRequestorType = exports.StatusEnum = exports.ActionEnum = void 0;
(function (ActionEnum) {
    ActionEnum["CREATE"] = "CREATE";
    ActionEnum["PROVIDER_CREATE"] = "PROVIDER_CREATE";
    ActionEnum["UPDATE_STATUS"] = "UPDATE_STATUS";
    ActionEnum["UPDATE_ASSIGNEE"] = "UPDATE_ASSIGNEE";
    ActionEnum["UPDATE_CONFLICTS"] = "UPDATE_CONFLICTS";
    ActionEnum["UPDATE_AREA_OF_LAW"] = "UPDATE_AREA_OF_LAW";
    ActionEnum["UPDATE_QUICK_ALERT"] = "UPDATE_QUICK_ALERT";
    ActionEnum["UPDATE_CRITICAL_DATE"] = "UPDATE_CRITICAL_DATE";
    ActionEnum["ADD_NOTE"] = "ADD_NOTE";
    ActionEnum["UPDATE_NOTES"] = "UPDATE_NOTES";
    ActionEnum["ADD_ATTACHMENT"] = "ADD_ATTACHMENT";
    ActionEnum["MIGRATE_CREATE"] = "MIGRATE_CREATE";
    ActionEnum["MIGRATE_UPDATE"] = "MIGRATE_UPDATE";
    ActionEnum["UPDATE_WILL_COMPLETED"] = "UPDATE_WILL_COMPLETED";
    ActionEnum["REFER"] = "REFER";
    ActionEnum["RECLAIM"] = "RECLAIM";
    ActionEnum["CLOSE"] = "CLOSE";
    ActionEnum["CHANGE_OWNER"] = "CHANGE_OWNER";
    ActionEnum["POPULATE_DUE_BY"] = "POPULATE_DUE_BY";
    ActionEnum["CLEAR_ASSIGNEE"] = "CLEAR_ASSIGNEE";
    ActionEnum["MIGRATE_CHANGE_OWNER"] = "MIGRATE_CHANGE_OWNER";
    ActionEnum["CLEAR_QUICK_ALERT"] = "CLEAR_QUICK_ALERT";
    ActionEnum["CLEAR_CRITICAL_DATE"] = "CLEAR_CRITICAL_DATE";
    ActionEnum["CHANGE_ENTITLEMENT"] = "CHANGE_ENTITLEMENT";
    ActionEnum["ADD_ALERT"] = "ADD_ALERT";
    ActionEnum["UPDATE_ALERT_STATUS"] = "UPDATE_ALERT_STATUS";
    ActionEnum["UPDATE_LOCALE"] = "UPDATE_LOCALE";
    ActionEnum["REPROCESS_ANSWERS"] = "REPROCESS_ANSWERS";
    ActionEnum["MIGRATE_BRANCH_ACCESS"] = "MIGRATE_BRANCH_ACCESS";
    ActionEnum["ADD_TALKDESK_INTERACTION"] = "ADD_TALKDESK_INTERACTION";
    ActionEnum["ADD_CHAT"] = "ADD_CHAT";
    ActionEnum["REMOVE_CHAT"] = "REMOVE_CHAT";
    ActionEnum["ACKNOWLEDGE_CHAT"] = "ACKNOWLEDGE_CHAT";
    ActionEnum["ADD_SCHEDULED_CALL"] = "ADD_SCHEDULED_CALL";
})(exports.ActionEnum || (exports.ActionEnum = {}));
(function (StatusEnum) {
    StatusEnum["NEW"] = "NEW";
    StatusEnum["CALL_ATTEMPT_MADE"] = "CALL_ATTEMPT_MADE";
    StatusEnum["COMMUNICATION_SENT"] = "COMMUNICATION_SENT";
    StatusEnum["CLOSED"] = "CLOSED";
    StatusEnum["WAITING_ON_MEMBER"] = "WAITING_ON_MEMBER";
    StatusEnum["IN_PROGRESS"] = "IN_PROGRESS";
    StatusEnum["TO_BE_REFERRED"] = "TO_BE_REFERRED";
    StatusEnum["REFERRED"] = "REFERRED";
    StatusEnum["RE_OPENED"] = "RE_OPENED";
    StatusEnum["RECLAIMED"] = "RECLAIMED";
    StatusEnum["DISCARD"] = "DISCARD";
    StatusEnum["READY_TO_PICK_UP"] = "READY_TO_PICK_UP";
    StatusEnum["WILL_PENDING"] = "WILL_PENDING";
    StatusEnum["NEEDS_REVIEW"] = "NEEDS_REVIEW";
    StatusEnum["CALL_STARTED"] = "CALL_STARTED";
    StatusEnum["NEW_DOCUMENTS"] = "NEW_DOCUMENTS";
    StatusEnum["NEW_UPDATES"] = "NEW_UPDATES";
})(exports.StatusEnum || (exports.StatusEnum = {}));
(function (CommunicationRequestorType) {
    CommunicationRequestorType["INTERNAL"] = "INTERNAL";
    CommunicationRequestorType["PROVIDER"] = "PROVIDER";
    CommunicationRequestorType["MEMBER"] = "MEMBER";
})(exports.CommunicationRequestorType || (exports.CommunicationRequestorType = {}));
(function (AreaOfLawEnum) {
    AreaOfLawEnum["AM"] = "AM";
    AreaOfLawEnum["AD"] = "AD";
    AreaOfLawEnum["AF"] = "AF";
    AreaOfLawEnum["AA"] = "AA";
    AreaOfLawEnum["BK"] = "BK";
    AreaOfLawEnum["BR"] = "BR";
    AreaOfLawEnum["BD"] = "BD";
    AreaOfLawEnum["BT"] = "BT";
    AreaOfLawEnum["BS"] = "BS";
    AreaOfLawEnum["CU"] = "CU";
    AreaOfLawEnum["CS"] = "CS";
    AreaOfLawEnum["CL"] = "CL";
    AreaOfLawEnum["CC"] = "CC";
    AreaOfLawEnum["CO"] = "CO";
    AreaOfLawEnum["CN"] = "CN";
    AreaOfLawEnum["CF"] = "CF";
    AreaOfLawEnum["CT"] = "CT";
    AreaOfLawEnum["CY"] = "CY";
    AreaOfLawEnum["CP"] = "CP";
    AreaOfLawEnum["CD"] = "CD";
    AreaOfLawEnum["CR"] = "CR";
    AreaOfLawEnum["DE"] = "DE";
    AreaOfLawEnum["DI"] = "DI";
    AreaOfLawEnum["DU"] = "DU";
    AreaOfLawEnum["DV"] = "DV";
    AreaOfLawEnum["ED"] = "ED";
    AreaOfLawEnum["EL"] = "EL";
    AreaOfLawEnum["EM"] = "EM";
    AreaOfLawEnum["ET"] = "ET";
    AreaOfLawEnum["EP"] = "EP";
    AreaOfLawEnum["FL"] = "FL";
    AreaOfLawEnum["FW"] = "FW";
    AreaOfLawEnum["FA"] = "FA";
    AreaOfLawEnum["FC"] = "FC";
    AreaOfLawEnum["FR"] = "FR";
    AreaOfLawEnum["GA"] = "GA";
    AreaOfLawEnum["GL"] = "GL";
    AreaOfLawEnum["GC"] = "GC";
    AreaOfLawEnum["HL"] = "HL";
    AreaOfLawEnum["IT"] = "IT";
    AreaOfLawEnum["IM"] = "IM";
    AreaOfLawEnum["ID"] = "ID";
    AreaOfLawEnum["IN"] = "IN";
    AreaOfLawEnum["JV"] = "JV";
    AreaOfLawEnum["LL"] = "LL";
    AreaOfLawEnum["LT"] = "LT";
    AreaOfLawEnum["LM"] = "LM";
    AreaOfLawEnum["LN"] = "LN";
    AreaOfLawEnum["MM"] = "MM";
    AreaOfLawEnum["ML"] = "ML";
    AreaOfLawEnum["MR"] = "MR";
    AreaOfLawEnum["MD"] = "MD";
    AreaOfLawEnum["VD"] = "VD";
    AreaOfLawEnum["NC"] = "NC";
    AreaOfLawEnum["OG"] = "OG";
    AreaOfLawEnum["PC"] = "PC";
    AreaOfLawEnum["PT"] = "PT";
    AreaOfLawEnum["PN"] = "PN";
    AreaOfLawEnum["PD"] = "PD";
    AreaOfLawEnum["PI"] = "PI";
    AreaOfLawEnum["PA"] = "PA";
    AreaOfLawEnum["PU"] = "PU";
    AreaOfLawEnum["PR"] = "PR";
    AreaOfLawEnum["PL"] = "PL";
    AreaOfLawEnum["PY"] = "PY";
    AreaOfLawEnum["TA"] = "TA";
    AreaOfLawEnum["PS"] = "PS";
    AreaOfLawEnum["RE"] = "RE";
    AreaOfLawEnum["RC"] = "RC";
    AreaOfLawEnum["RF"] = "RF";
    AreaOfLawEnum["RP"] = "RP";
    AreaOfLawEnum["SC"] = "SC";
    AreaOfLawEnum["SS"] = "SS";
    AreaOfLawEnum["SN"] = "SN";
    AreaOfLawEnum["SL"] = "SL";
    AreaOfLawEnum["TX"] = "TX";
    AreaOfLawEnum["TS"] = "TS";
    AreaOfLawEnum["TM"] = "TM";
    AreaOfLawEnum["TR"] = "TR";
    AreaOfLawEnum["TU"] = "TU";
    AreaOfLawEnum["UA"] = "UA";
    AreaOfLawEnum["VE"] = "VE";
    AreaOfLawEnum["VA"] = "VA";
    AreaOfLawEnum["WC"] = "WC";
    AreaOfLawEnum["WD"] = "WD";
    AreaOfLawEnum["ZP"] = "ZP";
    AreaOfLawEnum["WL"] = "WL";
})(exports.AreaOfLawEnum || (exports.AreaOfLawEnum = {}));
const axios_1 = __importDefault(axios);
const utils_1 = utils;
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://servicerequests.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title ServiceRequests Service Api
 * @version v1
 * @baseUrl https://servicerequests.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v2 = {
            /**
             * No description
             *
             * @tags Migration
             * @name MigrationMigrateBranchAccess
             * @request POST:/v2/migration/users/{identityId}/serviceRequests/{serviceRequestId}/migrateBranchAccess
             * @secure
             */
            migrationMigrateBranchAccess: (identityId, serviceRequestId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/migration/users/${identityId}/serviceRequests/${serviceRequestId}/migrateBranchAccess`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Migration
             * @name MigrationMigrateBranchAccess2
             * @request POST:/v2/migration/identities/{identityId}/serviceRequests/{serviceRequestId}/migrateBranchAccess
             * @secure
             */
            migrationMigrateBranchAccess2: (identityId, serviceRequestId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/migration/identities/${identityId}/serviceRequests/${serviceRequestId}/migrateBranchAccess`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsCreateServiceRequest
             * @request POST:/v2/identities/{identityId}/serviceRequests
             * @secure
             */
            serviceRequestsCreateServiceRequest: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/serviceRequests`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsGetServiceRequestsByUserIdAll
             * @request GET:/v2/identities/{identityId}/serviceRequests
             * @secure
             */
            serviceRequestsGetServiceRequestsByUserIdAll: (identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/serviceRequests`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsGetServiceRequestById
             * @request GET:/v2/identities/{identityId}/serviceRequests/{serviceRequestId}
             * @secure
             */
            serviceRequestsGetServiceRequestById: (serviceRequestId, identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/serviceRequests/${serviceRequestId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsUpdateAssignee
             * @request POST:/v2/identities/{identityId}/serviceRequests/{serviceRequestId}/updateAssignee
             * @secure
             */
            serviceRequestsUpdateAssignee: (serviceRequestId, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/serviceRequests/${serviceRequestId}/updateAssignee`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsUpdateAreaOfLaw
             * @request POST:/v2/identities/{identityId}/serviceRequests/{serviceRequestId}/updateAreaOfLaw
             * @secure
             */
            serviceRequestsUpdateAreaOfLaw: (serviceRequestId, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/serviceRequests/${serviceRequestId}/updateAreaOfLaw`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsUpdateConflictsCleared
             * @request POST:/v2/identities/{identityId}/serviceRequests/{serviceRequestId}/updateConflictsChecked
             * @secure
             */
            serviceRequestsUpdateConflictsCleared: (serviceRequestId, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/serviceRequests/${serviceRequestId}/updateConflictsChecked`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsUpdateStatus
             * @request POST:/v2/identities/{identityId}/serviceRequests/{serviceRequestId}/updateStatus
             * @secure
             */
            serviceRequestsUpdateStatus: (serviceRequestId, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/serviceRequests/${serviceRequestId}/updateStatus`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsUpdateQuickAlert
             * @request POST:/v2/identities/{identityId}/serviceRequests/{serviceRequestId}/updateQuickAlert
             * @secure
             */
            serviceRequestsUpdateQuickAlert: (serviceRequestId, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/serviceRequests/${serviceRequestId}/updateQuickAlert`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsUpdateCriticalDate
             * @request POST:/v2/identities/{identityId}/serviceRequests/{serviceRequestId}/updateCriticalDate
             * @secure
             */
            serviceRequestsUpdateCriticalDate: (serviceRequestId, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/serviceRequests/${serviceRequestId}/updateCriticalDate`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsAddNote
             * @request POST:/v2/identities/{identityId}/serviceRequests/{serviceRequestId}/addNote
             * @secure
             */
            serviceRequestsAddNote: (serviceRequestId, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/serviceRequests/${serviceRequestId}/addNote`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsUpdateWillCompleted
             * @request POST:/v2/identities/{identityId}/serviceRequests/{serviceRequestId}/updateWillCompleted
             * @secure
             */
            serviceRequestsUpdateWillCompleted: (serviceRequestId, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/serviceRequests/${serviceRequestId}/updateWillCompleted`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsReclaim
             * @request POST:/v2/identities/{identityId}/serviceRequests/{serviceRequestId}/reclaim
             * @secure
             */
            serviceRequestsReclaim: (serviceRequestId, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/serviceRequests/${serviceRequestId}/reclaim`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsRefer
             * @request POST:/v2/identities/{identityId}/serviceRequests/{serviceRequestId}/refer
             * @secure
             */
            serviceRequestsRefer: (serviceRequestId, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/serviceRequests/${serviceRequestId}/refer`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsClose
             * @request POST:/v2/identities/{identityId}/serviceRequests/{serviceRequestId}/close
             * @secure
             */
            serviceRequestsClose: (serviceRequestId, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/serviceRequests/${serviceRequestId}/close`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsClearAssignee
             * @request POST:/v2/identities/{identityId}/serviceRequests/{serviceRequestId}/clearAssignee
             * @secure
             */
            serviceRequestsClearAssignee: (serviceRequestId, identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/serviceRequests/${serviceRequestId}/clearAssignee`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsClearQuickAlert
             * @request POST:/v2/identities/{identityId}/serviceRequests/{serviceRequestId}/clearQuickAlert
             * @secure
             */
            serviceRequestsClearQuickAlert: (serviceRequestId, identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/serviceRequests/${serviceRequestId}/clearQuickAlert`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsClearCriticalDate
             * @request POST:/v2/identities/{identityId}/serviceRequests/{serviceRequestId}/clearCriticalDate
             * @secure
             */
            serviceRequestsClearCriticalDate: (serviceRequestId, identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/serviceRequests/${serviceRequestId}/clearCriticalDate`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsChangeOwner
             * @request POST:/v2/identities/{identityId}/serviceRequests/{serviceRequestId}/changeOwner
             * @secure
             */
            serviceRequestsChangeOwner: (serviceRequestId, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/serviceRequests/${serviceRequestId}/changeOwner`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsChangeEntitlement
             * @request POST:/v2/identities/{identityId}/serviceRequests/{serviceRequestId}/changeEntitlement
             * @secure
             */
            serviceRequestsChangeEntitlement: (identityId, serviceRequestId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/serviceRequests/${serviceRequestId}/changeEntitlement`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsAddAlert
             * @request POST:/v2/identities/{identityId}/serviceRequests/{serviceRequestId}/addAlert
             * @secure
             */
            serviceRequestsAddAlert: (identityId, serviceRequestId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/serviceRequests/${serviceRequestId}/addAlert`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsUpdateAlertStatus
             * @request POST:/v2/identities/{identityId}/serviceRequests/{serviceRequestId}/updateAlertStatus/{communicationId}
             * @deprecated
             * @secure
             */
            serviceRequestsUpdateAlertStatus: (identityId, serviceRequestId, communicationId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/serviceRequests/${serviceRequestId}/updateAlertStatus/${communicationId}`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsUpdateLocale
             * @request POST:/v2/identities/{identityId}/serviceRequests/{serviceRequestId}/updateLocale
             * @secure
             */
            serviceRequestsUpdateLocale: (identityId, serviceRequestId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/serviceRequests/${serviceRequestId}/updateLocale`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsReprocessAnswers
             * @request POST:/v2/identities/{identityId}/serviceRequests/{serviceRequestId}/reprocessAnswers
             * @secure
             */
            serviceRequestsReprocessAnswers: (identityId, serviceRequestId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/serviceRequests/${serviceRequestId}/reprocessAnswers`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsAddTalkdeskInteraction
             * @request POST:/v2/identities/{identityId}/serviceRequests/{serviceRequestId}/addTalkdeskInteraction
             * @secure
             */
            serviceRequestsAddTalkdeskInteraction: (identityId, serviceRequestId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/serviceRequests/${serviceRequestId}/addTalkdeskInteraction`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsAddChat
             * @request POST:/v2/identities/{identityId}/serviceRequests/{serviceRequestId}/addChat
             * @secure
             */
            serviceRequestsAddChat: (identityId, serviceRequestId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/serviceRequests/${serviceRequestId}/addChat`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsRemoveChat
             * @request DELETE:/v2/identities/{identityId}/serviceRequests/{serviceRequestId}/chats/{chatId}
             * @secure
             */
            serviceRequestsRemoveChat: (identityId, serviceRequestId, chatId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/serviceRequests/${serviceRequestId}/chats/${chatId}`, method: 'DELETE', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsUpdateChatLastAcknowledgedVersion
             * @request POST:/v2/identities/{identityId}/serviceRequests/{serviceRequestId}/chats/{chatId}/acknowledge
             * @secure
             */
            serviceRequestsUpdateChatLastAcknowledgedVersion: (identityId, serviceRequestId, chatId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/serviceRequests/${serviceRequestId}/chats/${chatId}/acknowledge`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsStartChat
             * @request POST:/v2/identities/{identityId}/serviceRequests/{serviceRequestId}/startChat
             * @secure
             */
            serviceRequestsStartChat: (identityId, serviceRequestId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/serviceRequests/${serviceRequestId}/startChat`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsAddScheduledCall
             * @request POST:/v2/identities/{identityId}/serviceRequests/{serviceRequestId}/addScheduledCall
             * @secure
             */
            serviceRequestsAddScheduledCall: (identityId, serviceRequestId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/serviceRequests/${serviceRequestId}/addScheduledCall`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequestsJournal
             * @name ServiceRequestsJournalGetJournalChangesAll
             * @request GET:/v2/servicerequests/journal
             * @secure
             */
            serviceRequestsJournalGetJournalChangesAll: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/servicerequests/journal`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags TalkDesk
             * @name TalkDeskGetTokenForCall
             * @request POST:/v2/talkDesk/tokenForCall
             * @secure
             */
            talkDeskGetTokenForCall: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/talkDesk/tokenForCall`, method: 'POST', secure: true, format: 'json' }, params)),
        };
        this.v1 = {
            /**
             * No description
             *
             * @tags Migration
             * @name MigrationMigrateBranchAccess3
             * @request POST:/v1/migration/users/{userId}/serviceRequests/{serviceRequestId}/migrateBranchAccess
             * @secure
             */
            migrationMigrateBranchAccess3: (identityId, serviceRequestId, userId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/migration/users/${userId}/serviceRequests/${serviceRequestId}/migrateBranchAccess`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsCreateServiceRequest2
             * @request POST:/v1/users/{identityId}/serviceRequests
             * @secure
             */
            serviceRequestsCreateServiceRequest2: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/serviceRequests`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsGetServiceRequestsByUserId
             * @request GET:/v1/users/{identityId}/serviceRequests
             * @secure
             */
            serviceRequestsGetServiceRequestsByUserId: (identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/serviceRequests`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsGetServiceRequestById2
             * @request GET:/v1/users/{identityId}/serviceRequests/{serviceRequestId}
             * @secure
             */
            serviceRequestsGetServiceRequestById2: (serviceRequestId, identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/serviceRequests/${serviceRequestId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsUpdateAssignee2
             * @request POST:/v1/users/{identityId}/serviceRequests/{serviceRequestId}/updateAssignee
             * @secure
             */
            serviceRequestsUpdateAssignee2: (serviceRequestId, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/serviceRequests/${serviceRequestId}/updateAssignee`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsUpdateAreaOfLaw2
             * @request POST:/v1/users/{identityId}/serviceRequests/{serviceRequestId}/updateAreaOfLaw
             * @secure
             */
            serviceRequestsUpdateAreaOfLaw2: (serviceRequestId, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/serviceRequests/${serviceRequestId}/updateAreaOfLaw`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsUpdateConflictsCleared2
             * @request POST:/v1/users/{identityId}/serviceRequests/{serviceRequestId}/updateConflictsChecked
             * @secure
             */
            serviceRequestsUpdateConflictsCleared2: (serviceRequestId, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/serviceRequests/${serviceRequestId}/updateConflictsChecked`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsUpdateStatus2
             * @request POST:/v1/users/{identityId}/serviceRequests/{serviceRequestId}/updateStatus
             * @secure
             */
            serviceRequestsUpdateStatus2: (serviceRequestId, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/serviceRequests/${serviceRequestId}/updateStatus`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsUpdateQuickAlert2
             * @request POST:/v1/users/{identityId}/serviceRequests/{serviceRequestId}/updateQuickAlert
             * @secure
             */
            serviceRequestsUpdateQuickAlert2: (serviceRequestId, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/serviceRequests/${serviceRequestId}/updateQuickAlert`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsUpdateCriticalDate2
             * @request POST:/v1/users/{identityId}/serviceRequests/{serviceRequestId}/updateCriticalDate
             * @secure
             */
            serviceRequestsUpdateCriticalDate2: (serviceRequestId, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/serviceRequests/${serviceRequestId}/updateCriticalDate`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsAddNote2
             * @request POST:/v1/users/{identityId}/serviceRequests/{serviceRequestId}/addNote
             * @secure
             */
            serviceRequestsAddNote2: (serviceRequestId, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/serviceRequests/${serviceRequestId}/addNote`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsUpdateWillCompleted2
             * @request POST:/v1/users/{identityId}/serviceRequests/{serviceRequestId}/updateWillCompleted
             * @secure
             */
            serviceRequestsUpdateWillCompleted2: (serviceRequestId, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/serviceRequests/${serviceRequestId}/updateWillCompleted`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsReclaim2
             * @request POST:/v1/users/{identityId}/serviceRequests/{serviceRequestId}/reclaim
             * @secure
             */
            serviceRequestsReclaim2: (serviceRequestId, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/serviceRequests/${serviceRequestId}/reclaim`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsRefer2
             * @request POST:/v1/users/{identityId}/serviceRequests/{serviceRequestId}/refer
             * @secure
             */
            serviceRequestsRefer2: (serviceRequestId, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/serviceRequests/${serviceRequestId}/refer`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsClose2
             * @request POST:/v1/users/{identityId}/serviceRequests/{serviceRequestId}/close
             * @secure
             */
            serviceRequestsClose2: (serviceRequestId, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/serviceRequests/${serviceRequestId}/close`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsClearAssignee2
             * @request POST:/v1/users/{identityId}/serviceRequests/{serviceRequestId}/clearAssignee
             * @secure
             */
            serviceRequestsClearAssignee2: (serviceRequestId, identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/serviceRequests/${serviceRequestId}/clearAssignee`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsClearQuickAlert2
             * @request POST:/v1/users/{identityId}/serviceRequests/{serviceRequestId}/clearQuickAlert
             * @secure
             */
            serviceRequestsClearQuickAlert2: (serviceRequestId, identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/serviceRequests/${serviceRequestId}/clearQuickAlert`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsClearCriticalDate2
             * @request POST:/v1/users/{identityId}/serviceRequests/{serviceRequestId}/clearCriticalDate
             * @secure
             */
            serviceRequestsClearCriticalDate2: (serviceRequestId, identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/serviceRequests/${serviceRequestId}/clearCriticalDate`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsChangeOwner2
             * @request POST:/v1/users/{identityId}/serviceRequests/{serviceRequestId}/changeOwner
             * @secure
             */
            serviceRequestsChangeOwner2: (serviceRequestId, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/serviceRequests/${serviceRequestId}/changeOwner`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsChangeEntitlement2
             * @request POST:/v1/users/{identityId}/serviceRequests/{serviceRequestId}/changeEntitlement
             * @secure
             */
            serviceRequestsChangeEntitlement2: (identityId, serviceRequestId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/serviceRequests/${serviceRequestId}/changeEntitlement`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsAddAlert2
             * @request POST:/v1/users/{identityId}/serviceRequests/{serviceRequestId}/addAlert
             * @secure
             */
            serviceRequestsAddAlert2: (identityId, serviceRequestId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/serviceRequests/${serviceRequestId}/addAlert`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsUpdateAlertStatus2
             * @request POST:/v1/users/{identityId}/serviceRequests/{serviceRequestId}/updateAlertStatus/{communicationId}
             * @deprecated
             * @secure
             */
            serviceRequestsUpdateAlertStatus2: (identityId, serviceRequestId, communicationId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/serviceRequests/${serviceRequestId}/updateAlertStatus/${communicationId}`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsUpdateLocale2
             * @request POST:/v1/users/{identityId}/serviceRequests/{serviceRequestId}/updateLocale
             * @secure
             */
            serviceRequestsUpdateLocale2: (identityId, serviceRequestId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/serviceRequests/${serviceRequestId}/updateLocale`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsReprocessAnswers2
             * @request POST:/v1/users/{identityId}/serviceRequests/{serviceRequestId}/reprocessAnswers
             * @secure
             */
            serviceRequestsReprocessAnswers2: (identityId, serviceRequestId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/serviceRequests/${serviceRequestId}/reprocessAnswers`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequests
             * @name ServiceRequestsAddTalkdeskInteraction2
             * @request POST:/v1/users/{identityId}/serviceRequests/{serviceRequestId}/addTalkdeskInteraction
             * @secure
             */
            serviceRequestsAddTalkdeskInteraction2: (identityId, serviceRequestId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/serviceRequests/${serviceRequestId}/addTalkdeskInteraction`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceRequestsJournal
             * @name ServiceRequestsJournalGetJournalChanges
             * @request GET:/v1/servicerequests/journal
             * @secure
             */
            serviceRequestsJournalGetJournalChanges: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/servicerequests/journal`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
        };
        this.maxClock = {
            /**
             * No description
             *
             * @tags ServiceRequestsJournal
             * @name ServiceRequestsJournalMaxClock
             * @request GET:/maxClock
             * @secure
             */
            serviceRequestsJournalMaxClock: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/maxClock`, method: 'GET', secure: true, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;

}(servicerequests));

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(servicerequests, exports);

}(servicerequests$1));

var subscriptions$1 = {};

var subscriptions = {};

(function (exports) {
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.CancelReason = exports.Action = exports.CoBrandPartner = exports.FriendlyIdType = exports.SubscriptionStatus = exports.BillingPeriod = exports.SubscriptionVendorType = exports.Currency = exports.OfferItemType = void 0;
(function (OfferItemType) {
    OfferItemType["PRODUCT"] = "PRODUCT";
    OfferItemType["SUPPLEMENT"] = "SUPPLEMENT";
})(exports.OfferItemType || (exports.OfferItemType = {}));
(function (Currency) {
    Currency["USD"] = "USD";
    Currency["CAD"] = "CAD";
})(exports.Currency || (exports.Currency = {}));
(function (SubscriptionVendorType) {
    SubscriptionVendorType["ATLAS"] = "ATLAS";
    SubscriptionVendorType["ISERIES"] = "ISERIES";
    SubscriptionVendorType["PAYPAL"] = "PAYPAL";
})(exports.SubscriptionVendorType || (exports.SubscriptionVendorType = {}));
(function (BillingPeriod) {
    BillingPeriod["DAILY"] = "DAILY";
    BillingPeriod["WEEKLY"] = "WEEKLY";
    BillingPeriod["MONTHLY"] = "MONTHLY";
    BillingPeriod["ANNUAL"] = "ANNUAL";
    BillingPeriod["BIANNUAL"] = "BIANNUAL";
    BillingPeriod["QUARTERLY"] = "QUARTERLY";
    BillingPeriod["PAY_PERIOD"] = "PAY_PERIOD";
})(exports.BillingPeriod || (exports.BillingPeriod = {}));
(function (SubscriptionStatus) {
    SubscriptionStatus["ACTIVE"] = "ACTIVE";
    SubscriptionStatus["CANCELLED"] = "CANCELLED";
    SubscriptionStatus["SUSPENDED"] = "SUSPENDED";
    SubscriptionStatus["PRECANCEL"] = "PRECANCEL";
    SubscriptionStatus["PENDING_CANCEL"] = "PENDING_CANCEL";
    SubscriptionStatus["CATCHING_UP"] = "CATCHING_UP";
})(exports.SubscriptionStatus || (exports.SubscriptionStatus = {}));
(function (FriendlyIdType) {
    FriendlyIdType["MEMBER"] = "MEMBER";
    FriendlyIdType["ASSOCIATE"] = "ASSOCIATE";
    FriendlyIdType["OTHER"] = "OTHER";
})(exports.FriendlyIdType || (exports.FriendlyIdType = {}));
(function (CoBrandPartner) {
    CoBrandPartner["PRIMERICA"] = "PRIMERICA";
    CoBrandPartner["SOFI"] = "SOFI";
    CoBrandPartner["NEWITY"] = "NEWITY";
})(exports.CoBrandPartner || (exports.CoBrandPartner = {}));
(function (Action) {
    Action["CREATED"] = "CREATED";
    Action["UPDATE_OFFERS"] = "UPDATE_OFFERS";
    Action["DELETED"] = "DELETED";
    Action["UPDATED"] = "UPDATED";
    Action["STATUS_CHANGED"] = "STATUS_CHANGED";
    Action["PAYMENT_UPDATED"] = "PAYMENT_UPDATED";
    Action["BILLING_ADVANCED"] = "BILLING_ADVANCED";
    Action["VENDOR_UPDATED"] = "VENDOR_UPDATED";
    Action["FRIENDLYID_UPDATED"] = "FRIENDLYID_UPDATED";
    Action["CHANGE_OWNER"] = "CHANGE_OWNER";
    Action["DO_NOT_REINSTATE_UPDATED"] = "DO_NOT_REINSTATE_UPDATED";
    Action["RETRY_SCHEDULE_UPDATED"] = "RETRY_SCHEDULE_UPDATED";
    Action["ADMINISTRATIVE_AREA_UPDATED"] = "ADMINISTRATIVE_AREA_UPDATED";
    Action["POSTAL_CODE_UPDATED"] = "POSTAL_CODE_UPDATED";
    Action["STARTED_ON_UPDATED"] = "STARTED_ON_UPDATED";
    Action["NEXT_BILL_ON_UPDATED"] = "NEXT_BILL_ON_UPDATED";
    Action["SOURCE_UPDATED"] = "SOURCE_UPDATED";
    Action["BILLING_FREQUENCY_UPDATED"] = "BILLING_FREQUENCY_UPDATED";
    Action["BILL_CYCLE_DAY_UPDATED"] = "BILL_CYCLE_DAY_UPDATED";
    Action["BILLING_DIVISION_UPDATED"] = "BILLING_DIVISION_UPDATED";
})(exports.Action || (exports.Action = {}));
(function (CancelReason) {
    CancelReason["NO_LONGER_EMPLOYED"] = "NO_LONGER_EMPLOYED";
    CancelReason["LEAVE_OF_ABSENCE"] = "LEAVE_OF_ABSENCE";
    CancelReason["MEMBER_REQUESTED_CANCEL"] = "MEMBER_REQUESTED_CANCEL";
    CancelReason["DECEASED"] = "DECEASED";
})(exports.CancelReason || (exports.CancelReason = {}));
const axios_1 = __importDefault(axios);
const utils_1 = utils;
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://subscriptions.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title Subscriptions API
 * @version v1
 * @baseUrl https://subscriptions.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * No description
             *
             * @tags GroupSubscriptions
             * @name GroupSubscriptionsCancelSubscriptionByGroup
             * @request POST:/v1/groups/{groupId}/identities/{identityId}/subscriptions/{subscriptionId}/cancel
             * @secure
             */
            groupSubscriptionsCancelSubscriptionByGroup: (groupId, identityId, subscriptionId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/identities/${identityId}/subscriptions/${subscriptionId}/cancel`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags GroupSubscriptions
             * @name GroupSubscriptionsPendingCancelSubscriptionByGroup
             * @request POST:/v1/groups/{groupId}/identities/{identityId}/subscriptions/{subscriptionId}/pendingCancel
             * @secure
             */
            groupSubscriptionsPendingCancelSubscriptionByGroup: (groupId, identityId, subscriptionId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/identities/${identityId}/subscriptions/${subscriptionId}/pendingCancel`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags GroupSubscriptions
             * @name GroupSubscriptionsRemovePendingCancelSubscriptionByGroup
             * @request POST:/v1/groups/{groupId}/identities/{identityId}/subscriptions/{subscriptionId}/removePendingCancel
             * @secure
             */
            groupSubscriptionsRemovePendingCancelSubscriptionByGroup: (groupId, identityId, subscriptionId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/identities/${identityId}/subscriptions/${subscriptionId}/removePendingCancel`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Subscriptions
             * @name SubscriptionsCreateSubscription
             * @request POST:/v1/identities/{identityId}/subscriptions
             * @secure
             */
            subscriptionsCreateSubscription: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/subscriptions`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Subscriptions
             * @name SubscriptionsGetSubscriptions
             * @request GET:/v1/identities/{identityId}/subscriptions
             * @secure
             */
            subscriptionsGetSubscriptions: (identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/subscriptions`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Subscriptions
             * @name SubscriptionsGetSubscription
             * @request GET:/v1/identities/{identityId}/subscriptions/{subscriptionId}
             * @secure
             */
            subscriptionsGetSubscription: (identityId, subscriptionId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/subscriptions/${subscriptionId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Subscriptions
             * @name SubscriptionsDeleteSubscription
             * @request DELETE:/v1/identities/{identityId}/subscriptions/{subscriptionId}
             * @secure
             */
            subscriptionsDeleteSubscription: (identityId, subscriptionId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/subscriptions/${subscriptionId}`, method: 'DELETE', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Subscriptions
             * @name SubscriptionsUpdateOffers
             * @request POST:/v1/identities/{identityId}/subscriptions/{subscriptionId}/updateOffer
             * @secure
             */
            subscriptionsUpdateOffers: (identityId, subscriptionId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/subscriptions/${subscriptionId}/updateOffer`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Subscriptions
             * @name SubscriptionsCancelSubscription
             * @request POST:/v1/identities/{identityId}/subscriptions/{subscriptionId}/cancel
             * @secure
             */
            subscriptionsCancelSubscription: (identityId, subscriptionId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/subscriptions/${subscriptionId}/cancel`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Subscriptions
             * @name SubscriptionsSuspendSubscription
             * @request POST:/v1/identities/{identityId}/subscriptions/{subscriptionId}/suspend
             * @secure
             */
            subscriptionsSuspendSubscription: (identityId, subscriptionId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/subscriptions/${subscriptionId}/suspend`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Subscriptions
             * @name SubscriptionsActivateSubscription
             * @request POST:/v1/identities/{identityId}/subscriptions/{subscriptionId}/activate
             * @secure
             */
            subscriptionsActivateSubscription: (identityId, subscriptionId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/subscriptions/${subscriptionId}/activate`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Subscriptions
             * @name SubscriptionsPreCancelSubscription
             * @request POST:/v1/identities/{identityId}/subscriptions/{subscriptionId}/preCancel
             * @secure
             */
            subscriptionsPreCancelSubscription: (identityId, subscriptionId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/subscriptions/${subscriptionId}/preCancel`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Subscriptions
             * @name SubscriptionsPendingCancelSubscription
             * @request POST:/v1/identities/{identityId}/subscriptions/{subscriptionId}/pendingCancel
             * @secure
             */
            subscriptionsPendingCancelSubscription: (identityId, subscriptionId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/subscriptions/${subscriptionId}/pendingCancel`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Subscriptions
             * @name SubscriptionsAdvanceNextBillOn
             * @request POST:/v1/identities/{identityId}/subscriptions/{subscriptionId}/advanceNextBillOn
             * @secure
             */
            subscriptionsAdvanceNextBillOn: (identityId, subscriptionId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/subscriptions/${subscriptionId}/advanceNextBillOn`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Subscriptions
             * @name SubscriptionsUpdatePaymentMethod
             * @request POST:/v1/identities/{identityId}/subscriptions/{subscriptionId}/updatePaymentMethod
             * @secure
             */
            subscriptionsUpdatePaymentMethod: (identityId, subscriptionId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/subscriptions/${subscriptionId}/updatePaymentMethod`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Subscriptions
             * @name SubscriptionsUpdateVendor
             * @request POST:/v1/identities/{identityId}/subscriptions/{subscriptionId}/updateVendor
             * @secure
             */
            subscriptionsUpdateVendor: (identityId, subscriptionId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/subscriptions/${subscriptionId}/updateVendor`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Subscriptions
             * @name SubscriptionsUpdateIdempotentKey
             * @request POST:/v1/identities/{identityId}/subscriptions/{subscriptionId}/updateIdempotentKey
             * @secure
             */
            subscriptionsUpdateIdempotentKey: (identityId, subscriptionId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/subscriptions/${subscriptionId}/updateIdempotentKey`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Subscriptions
             * @name SubscriptionsChangeOwner
             * @request POST:/v1/identities/{identityId}/subscriptions/{subscriptionId}/changeOwner
             * @secure
             */
            subscriptionsChangeOwner: (identityId, subscriptionId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/subscriptions/${subscriptionId}/changeOwner`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Subscriptions
             * @name SubscriptionsUpdateDoNotReinstate
             * @request POST:/v1/identities/{identityId}/subscriptions/{subscriptionId}/updateDoNotReinstate
             * @secure
             */
            subscriptionsUpdateDoNotReinstate: (identityId, subscriptionId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/subscriptions/${subscriptionId}/updateDoNotReinstate`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Subscriptions
             * @name SubscriptionsUpdateRetrySchedule
             * @request POST:/v1/identities/{identityId}/subscriptions/{subscriptionId}/updateRetrySchedule
             * @secure
             */
            subscriptionsUpdateRetrySchedule: (identityId, subscriptionId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/subscriptions/${subscriptionId}/updateRetrySchedule`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Subscriptions
             * @name SubscriptionsUpdateAdministrativeArea
             * @request POST:/v1/identities/{identityId}/subscriptions/{subscriptionId}/updateAdministrativeArea
             * @secure
             */
            subscriptionsUpdateAdministrativeArea: (identityId, subscriptionId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/subscriptions/${subscriptionId}/updateAdministrativeArea`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Subscriptions
             * @name SubscriptionsUpdateNextBillOn
             * @request POST:/v1/identities/{identityId}/subscriptions/{subscriptionId}/updateNextBillOn
             * @secure
             */
            subscriptionsUpdateNextBillOn: (identityId, subscriptionId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/subscriptions/${subscriptionId}/updateNextBillOn`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Subscriptions
             * @name SubscriptionsUpdatePostalCode
             * @request POST:/v1/identities/{identityId}/subscriptions/{subscriptionId}/updatePostalCode
             * @secure
             */
            subscriptionsUpdatePostalCode: (identityId, subscriptionId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/subscriptions/${subscriptionId}/updatePostalCode`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Subscriptions
             * @name SubscriptionsUpdateSource
             * @request POST:/v1/identities/{identityId}/subscriptions/{subscriptionId}/updateSource
             * @secure
             */
            subscriptionsUpdateSource: (identityId, subscriptionId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/subscriptions/${subscriptionId}/updateSource`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Subscriptions
             * @name SubscriptionsUpdateStartedOn
             * @request POST:/v1/identities/{identityId}/subscriptions/{subscriptionId}/updateStartedOn
             * @secure
             */
            subscriptionsUpdateStartedOn: (identityId, subscriptionId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/subscriptions/${subscriptionId}/updateStartedOn`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Subscriptions
             * @name SubscriptionsUpdateBillingFrequency
             * @request POST:/v1/identities/{identityId}/subscriptions/{subscriptionId}/updateBillingFrequency
             * @secure
             */
            subscriptionsUpdateBillingFrequency: (identityId, subscriptionId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/subscriptions/${subscriptionId}/updateBillingFrequency`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Subscriptions
             * @name SubscriptionsUpdateBillCycleDay
             * @request POST:/v1/identities/{identityId}/subscriptions/{subscriptionId}/updateBillCycleDay
             * @secure
             */
            subscriptionsUpdateBillCycleDay: (identityId, subscriptionId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/subscriptions/${subscriptionId}/updateBillCycleDay`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Subscriptions
             * @name SubscriptionsGetOutstandingInvoices
             * @request GET:/v1/identities/{identityId}/subscriptions/{subscriptionId}/outstandingInvoices
             * @secure
             */
            subscriptionsGetOutstandingInvoices: (identityId, subscriptionId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/subscriptions/${subscriptionId}/outstandingInvoices`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Subscriptions
             * @name SubscriptionsCatchUp
             * @request POST:/v1/identities/{identityId}/subscriptions/{subscriptionId}/catchUp
             * @secure
             */
            subscriptionsCatchUp: (identityId, subscriptionId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/subscriptions/${subscriptionId}/catchUp`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Subscriptions
             * @name SubscriptionsUpdateBillingDivision
             * @request POST:/v1/identities/{identityId}/subscriptions/{subscriptionId}/updateBillingDivision
             * @secure
             */
            subscriptionsUpdateBillingDivision: (identityId, subscriptionId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/subscriptions/${subscriptionId}/updateBillingDivision`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description The journal is for internal use only
             *
             * @tags SubscriptionsJournal
             * @name SubscriptionJournal
             * @summary Machine JWT Only
             * @request GET:/v1/subscriptions/journal
             * @secure
             */
            subscriptionJournal: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/subscriptions/journal`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags SubscriptionsJournal
             * @name SubscriptionsJournalGetJournalMaxClock
             * @request GET:/v1/subscriptions/journal/maxClock
             * @secure
             */
            subscriptionsJournalGetJournalMaxClock: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/subscriptions/journal/maxClock`, method: 'GET', secure: true, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;

}(subscriptions));

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(subscriptions, exports);

}(subscriptions$1));

var tokenizer$1 = {};

var tokenizer = {};

(function (exports) {
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = void 0;
const axios_1 = __importDefault(axios);
const utils_1 = utils;
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://tokenizer.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title Tokenizer API
 * @version v1
 * @baseUrl https://tokenizer.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * No description
             *
             * @tags Jwts
             * @name JwtsCreate
             * @request POST:/v1/jwts
             * @secure
             */
            jwtsCreate: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/jwts`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Jwts
             * @name JwtsVerify
             * @request POST:/v1/jwts/verify
             * @secure
             */
            jwtsVerify: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/jwts/verify`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Keys
             * @name KeysFetchKey
             * @request GET:/v1/keys/{keyId}
             * @secure
             */
            keysFetchKey: (keyId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/keys/${keyId}`, method: 'GET', secure: true, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;

}(tokenizer));

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(tokenizer, exports);

}(tokenizer$1));

var trendmicrostates$1 = {};

var trendmicrostates = {};

(function (exports) {
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.StatusEnum = exports.ActionEnum = void 0;
(function (ActionEnum) {
    ActionEnum["CREATE"] = "CREATE";
    ActionEnum["ACTIVATE"] = "ACTIVATE";
    ActionEnum["CHANGE"] = "CHANGE";
    ActionEnum["MARK_LICENSE_KEY_ACTIVE"] = "MARK_LICENSE_KEY_ACTIVE";
    ActionEnum["PRODUCT_CHANGE"] = "PRODUCT_CHANGE";
    ActionEnum["CHANGE_OWNER"] = "CHANGE_OWNER";
    ActionEnum["DELETE"] = "DELETE";
})(exports.ActionEnum || (exports.ActionEnum = {}));
(function (StatusEnum) {
    StatusEnum["ACTIVE"] = "ACTIVE";
    StatusEnum["INACTIVE"] = "INACTIVE";
    StatusEnum["DELETED"] = "DELETED";
})(exports.StatusEnum || (exports.StatusEnum = {}));
const axios_1 = __importDefault(axios);
const utils_1 = utils;
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://trendmicrostates.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title TrendMicroStates Service Api
 * @version v1
 * @baseUrl https://trendmicrostates.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * No description
             *
             * @tags TrendMicroStatesActivation
             * @name TrendMicroStatesActivationMarkTrendMicroStateAsActivated
             * @request POST:/v1/TrendMicroStates/markLicenseKeyActive
             * @secure
             */
            trendMicroStatesActivationMarkTrendMicroStateAsActivated: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/TrendMicroStates/markLicenseKeyActive`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags TrendMicroStates
             * @name TrendMicroStatesGetTrendMicroStates
             * @request GET:/v1/users/{userId}/TrendMicroStates
             * @secure
             */
            trendMicroStatesGetTrendMicroStates: (userId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${userId}/TrendMicroStates`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags TrendMicroStates
             * @name TrendMicroStatesCreateTrendMicroState
             * @request POST:/v1/users/{userId}/TrendMicroStates
             * @secure
             */
            trendMicroStatesCreateTrendMicroState: (userId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${userId}/TrendMicroStates`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags TrendMicroStates
             * @name TrendMicroStatesGetTrendMicroStateById
             * @request GET:/v1/users/{userId}/TrendMicroStates/{trendMicroStateId}
             * @secure
             */
            trendMicroStatesGetTrendMicroStateById: (userId, trendMicroStateId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${userId}/TrendMicroStates/${trendMicroStateId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags TrendMicroStates
             * @name TrendMicroStatesDeleteResource
             * @request DELETE:/v1/users/{userId}/TrendMicroStates/{trendMicroStateId}
             * @secure
             */
            trendMicroStatesDeleteResource: (userId, trendMicroStateId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${userId}/TrendMicroStates/${trendMicroStateId}`, method: 'DELETE', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags TrendMicroStates
             * @name TrendMicroStatesMakeLoginLink
             * @request GET:/v1/users/{userId}/TrendMicroStates/{trendMicroStateId}/makeLoginLink
             * @secure
             */
            trendMicroStatesMakeLoginLink: (userId, trendMicroStateId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${userId}/TrendMicroStates/${trendMicroStateId}/makeLoginLink`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags TrendMicroStates
             * @name TrendMicroStatesEntitlementUpdate
             * @request POST:/v1/users/{userId}/TrendMicroStates/{trendMicroStateId}/entitlementUpdate
             * @secure
             */
            trendMicroStatesEntitlementUpdate: (userId, trendMicroStateId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${userId}/TrendMicroStates/${trendMicroStateId}/entitlementUpdate`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags TrendMicroStates
             * @name TrendMicroStatesResetTrendMicroUser
             * @request POST:/v1/users/{userId}/TrendMicroStates/{trendMicroStateId}/resetTrendMicroUser
             * @secure
             */
            trendMicroStatesResetTrendMicroUser: (userId, trendMicroStateId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${userId}/TrendMicroStates/${trendMicroStateId}/resetTrendMicroUser`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags TrendMicroStatesJournal
             * @name TrendMicroStatesJournalGetJournalChanges
             * @request GET:/v1/TrendMicroStates/journal
             * @secure
             */
            trendMicroStatesJournalGetJournalChanges: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/TrendMicroStates/journal`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags TrendMicroStatesJournal
             * @name TrendMicroStatesJournalGetJournalMaxClock
             * @request GET:/v1/TrendMicroStates/journal/maxClock
             * @secure
             */
            trendMicroStatesJournalGetJournalMaxClock: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/TrendMicroStates/journal/maxClock`, method: 'GET', secure: true, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;

}(trendmicrostates));

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(trendmicrostates, exports);

}(trendmicrostates$1));

var userapplicationsettings$1 = {};

var userapplicationsettings = {};

(function (exports) {
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = void 0;
const axios_1 = __importDefault(axios);
const utils_1 = utils;
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://userapplicationsettings.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title UserApplicationSettings Service Api
 * @version v1
 * @baseUrl https://userapplicationsettings.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * No description
             *
             * @tags Health
             * @name HealthGet
             * @request GET:/v1/health
             * @secure
             */
            healthGet: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/health`, method: 'GET', secure: true }, params)),
            /**
             * No description
             *
             * @tags Migration
             * @name MigrationMigrateUserSettings
             * @request GET:/v1/migration/identity/{identityId}/applicationSettings
             * @secure
             */
            migrationMigrateUserSettings: (identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/migration/identity/${identityId}/applicationSettings`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags UserApplicationSettings
             * @name UserApplicationSettingsGetApplicationSettingsByOwner
             * @request GET:/v1/identities/{identityId}/applicationSettings
             * @secure
             */
            userApplicationSettingsGetApplicationSettingsByOwner: (identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/applicationSettings`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags UserApplicationSettings
             * @name UserApplicationSettingsCreateApplicationSetting
             * @request POST:/v1/identities/{identityId}/applicationSettings
             * @secure
             */
            userApplicationSettingsCreateApplicationSetting: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/applicationSettings`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags UserApplicationSettings
             * @name UserApplicationSettingsGetApplicationSettingById
             * @request GET:/v1/identities/{identityId}/applicationSettings/{appSettingId}
             * @secure
             */
            userApplicationSettingsGetApplicationSettingById: (identityId, appSettingId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/applicationSettings/${appSettingId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags UserApplicationSettings
             * @name UserApplicationSettingsDeleteApplicationSettingById
             * @request DELETE:/v1/identities/{identityId}/applicationSettings/{appSettingId}
             * @secure
             */
            userApplicationSettingsDeleteApplicationSettingById: (identityId, appSettingId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/applicationSettings/${appSettingId}`, method: 'DELETE', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags UserApplicationSettings
             * @name UserApplicationSettingsGetByApplicationName
             * @request GET:/v1/identities/{identityId}/applicationSettings/getByApplicationName
             * @secure
             */
            userApplicationSettingsGetByApplicationName: (identityId, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/applicationSettings/getByApplicationName`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags UserApplicationSettings
             * @name UserApplicationSettingsUpdateSettings
             * @request POST:/v1/identities/{identityId}/applicationSettings/{appSettingId}/updateSettings
             * @secure
             */
            userApplicationSettingsUpdateSettings: (identityId, appSettingId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/applicationSettings/${appSettingId}/updateSettings`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags UserApplicationSettingsJournal
             * @name UserApplicationSettingsJournalGetJournalChanges
             * @request GET:/v1/userapplicationsettings/journal
             * @secure
             */
            userApplicationSettingsJournalGetJournalChanges: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/userapplicationsettings/journal`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;

}(userapplicationsettings));

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(userapplicationsettings, exports);

}(userapplicationsettings$1));

var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(sdk, "__esModule", { value: true });
sdk.Questions = sdk.Queries = sdk.Purchases = sdk.Providers = sdk.Profiles = sdk.Products = sdk.Productfamilies = sdk.PlanMaps = sdk.PaymentMethods = sdk.Offers = sdk.Notifications = sdk.Notes = sdk.Lawareas = sdk.Launches = sdk.Invoices = sdk.Invitations = sdk.Imagestore = sdk.Idshieldforbusiness = sdk.IdentityMerge = sdk.IdentityAmendments = sdk.Identities = sdk.Groups = sdk.GroupMarketingSites = sdk.GroupEnrollments = sdk.Forms = sdk.Firms = sdk.Factors = sdk.Entitlements = sdk.EntitlementHistories = sdk.Eligibilities = sdk.ContractHistories = sdk.ContentEntries = sdk.Cohorts = sdk.Chats = sdk.ChannelsSegments = sdk.ChannelsLeadsService = sdk.ChannelsCampaigns = sdk.ChannelsAssociates = sdk.Businessplus = sdk.Branches = sdk.Benefits = sdk.Benefitcohorts = sdk.AutoComments = sdk.AtlasReports = sdk.AtlasQueries = sdk.Associates = sdk.AssociateMarketing = sdk.Applications = sdk.Answers = sdk.Alerts = void 0;
sdk.Userapplicationsettings = sdk.Trendmicrostates = sdk.Tokenizer = sdk.Subscriptions = sdk.Servicerequests = sdk.ScheduledCommunications = sdk.Resolutions = sdk.Relations = void 0;
sdk.Alerts = __importStar(alerts$1);
sdk.Answers = __importStar(answers$1);
sdk.Applications = __importStar(applications$1);
sdk.AssociateMarketing = __importStar(associateMarketing$1);
sdk.Associates = __importStar(associates$1);
sdk.AtlasQueries = __importStar(atlasQueries$1);
sdk.AtlasReports = __importStar(atlasReports$1);
sdk.AutoComments = __importStar(autoComments$1);
sdk.Benefitcohorts = __importStar(benefitcohorts$1);
sdk.Benefits = __importStar(benefits$1);
sdk.Branches = __importStar(branches$1);
sdk.Businessplus = __importStar(businessplus$1);
sdk.ChannelsAssociates = __importStar(channelsAssociates$1);
sdk.ChannelsCampaigns = __importStar(channelsCampaigns$1);
sdk.ChannelsLeadsService = __importStar(channelsLeadsService$1);
sdk.ChannelsSegments = __importStar(channelsSegments$1);
sdk.Chats = __importStar(chats$1);
sdk.Cohorts = __importStar(cohorts$1);
sdk.ContentEntries = __importStar(contentEntries$1);
sdk.ContractHistories = __importStar(contractHistories$1);
sdk.Eligibilities = __importStar(eligibilities$1);
sdk.EntitlementHistories = __importStar(entitlementHistories$1);
sdk.Entitlements = __importStar(entitlements$1);
sdk.Factors = __importStar(factors$1);
sdk.Firms = __importStar(firms$1);
sdk.Forms = __importStar(forms$1);
sdk.GroupEnrollments = __importStar(groupEnrollments$1);
sdk.GroupMarketingSites = __importStar(groupMarketingSites$1);
sdk.Groups = __importStar(groups$1);
sdk.Identities = __importStar(identities$1);
sdk.IdentityAmendments = __importStar(identityAmendments$1);
sdk.IdentityMerge = __importStar(identityMerge$1);
sdk.Idshieldforbusiness = __importStar(idshieldforbusiness$1);
sdk.Imagestore = __importStar(imagestore$1);
sdk.Invitations = __importStar(invitations$1);
sdk.Invoices = __importStar(invoices$1);
sdk.Launches = __importStar(launches$1);
sdk.Lawareas = __importStar(lawareas$1);
sdk.Notes = __importStar(notes$1);
sdk.Notifications = __importStar(notifications$1);
sdk.Offers = __importStar(offers$1);
sdk.PaymentMethods = __importStar(paymentMethods$1);
sdk.PlanMaps = __importStar(planMaps$1);
sdk.Productfamilies = __importStar(productfamilies$1);
sdk.Products = __importStar(products$1);
sdk.Profiles = __importStar(profiles$1);
sdk.Providers = __importStar(providers$1);
sdk.Purchases = __importStar(purchases$1);
sdk.Queries = __importStar(queries$1);
sdk.Questions = __importStar(questions$1);
sdk.Relations = __importStar(relations$1);
sdk.Resolutions = __importStar(resolutions$1);
sdk.ScheduledCommunications = __importStar(scheduledCommunications$1);
sdk.Servicerequests = __importStar(servicerequests$1);
sdk.Subscriptions = __importStar(subscriptions$1);
sdk.Tokenizer = __importStar(tokenizer$1);
sdk.Trendmicrostates = __importStar(trendmicrostates$1);
sdk.Userapplicationsettings = __importStar(userapplicationsettings$1);

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(interfaces, exports);
__exportStar(sdk, exports);
__exportStar(utils, exports);

}(dist));

var getPSXURL = function (environmentArg) {
    if (environmentArg === void 0) { environmentArg = exports.Environment.PRODUCTION; }
    var baseURL = environment$1.psx[environmentArg];
    return baseURL;
};
var createBillingFrequency2 = function (_a) {
    var period = _a.period, term = _a.term;
    return {
        period: period,
        term: term,
    };
};
var createGroup2 = function (_a) {
    var billingDivision = _a.billingDivision, employeeId = _a.employeeId, id = _a.id;
    return {
        billingDivision: billingDivision,
        employeeId: employeeId,
        id: id,
    };
};
var createOrderV2 = function (_a) {
    var billingFrequency = _a.billingFrequency, currency = _a.currency, group = _a.group, offerSelections = _a.offerSelections, paymentMethod = _a.paymentMethod, source = _a.source, totalPrice = _a.totalPrice;
    return {
        billingFrequency: billingFrequency,
        currency: currency,
        group: group,
        offerSelections: offerSelections,
        paymentMethod: paymentMethod,
        source: source,
        /** @format decimal */
        totalPrice: totalPrice,
    };
};
var getTotalPrice = function (_a) {
    var products = _a.products;
    var totalPrice = 0;
    totalPrice = products.reduce(function (accuVal, product) {
        if (product.supplementSelections) {
            product.supplementSelections.forEach(function (supplement) {
                accuVal += supplement.price;
            });
        }
        return accuVal + product.productPrice;
    }, 0);
    return totalPrice;
};
var createProductV2 = function (_a) {
    var discountIds = _a.discountIds, entitlementId = _a.entitlementId, fees = _a.fees, friendlyId = _a.friendlyId, _b = _a.prepaidTerm, prepaidTerm = _b === void 0 ? 1 : _b, // this will set prepaidTerm to 1 when no value is provided
    productId = _a.productId, productInfo = _a.productInfo, productPrice = _a.productPrice, supplementSelections = _a.supplementSelections, subscriptionId = _a.subscriptionId, tierName = _a.tierName;
    return {
        discountIds: discountIds,
        entitlementId: entitlementId,
        fees: fees,
        friendlyId: friendlyId,
        prepaidTerm: prepaidTerm,
        productId: productId,
        productInfo: productInfo,
        productPrice: productPrice,
        subscriptionId: subscriptionId,
        supplementSelections: supplementSelections,
        tierName: tierName,
    };
};
var createSource2 = function (_a) {
    var marketingChannel = _a.marketingChannel, marketingSite = _a.marketingSite, marketLocale = _a.marketLocale, referrerId = _a.referrerId, returnURLPath = _a.returnURLPath, sponsorId = _a.sponsorId, sponsorLogin = _a.sponsorLogin;
    return {
        marketLocale: marketLocale,
        marketingChannel: marketingChannel,
        marketingSite: marketingSite,
        referrerId: referrerId,
        returnURLPath: returnURLPath,
        sponsorId: sponsorId,
        sponsorLogin: sponsorLogin,
    };
};
var createSupplement2 = function (_a) {
    var name = _a.name, price = _a.price;
    return {
        name: name,
        /** @format decimal */
        price: price,
    };
};
var createD2COrderV2LowVerbosity = function (_a) {
    var _b = _a.billingFrequency, billingFrequency = _b === void 0 ? {
        period: dist.Purchases.BillingPeriod.MONTHLY,
        term: 1,
    } : _b, _c = _a.currency, currency = _c === void 0 ? dist.Purchases.Currency.USD : _c, _d = _a.marketLocale, marketLocale = _d === void 0 ? LocaleConstants.ES_US : _d, marketingSite = _a.marketingSite, offerSelections = _a.offerSelections, totalPrice = _a.totalPrice;
    return {
        billingFrequency: billingFrequency,
        currency: currency,
        offerSelections: offerSelections,
        source: {
            marketLocale: marketLocale,
            marketingChannel: dist.Purchases.MarketingChannel.CORP,
            marketingSite: marketingSite,
        },
        /** @format decimal */
        totalPrice: totalPrice,
    };
};
var createGroupOrderV2MidVerbosity = function (_a) {
    var billingDivision = _a.billingDivision, _b = _a.billingFrequency, billingFrequency = _b === void 0 ? {
        period: dist.Purchases.BillingPeriod.MONTHLY,
        term: 1,
    } : _b, _c = _a.currency, currency = _c === void 0 ? dist.Purchases.Currency.USD : _c, employeeId = _a.employeeId, groupId = _a.groupId, _d = _a.marketLocale, marketLocale = _d === void 0 ? LocaleConstants.EN_US : _d, marketingSite = _a.marketingSite, offerSelections = _a.offerSelections, totalPrice = _a.totalPrice;
    return {
        billingFrequency: billingFrequency,
        currency: currency,
        group: {
            billingDivision: billingDivision,
            employeeId: employeeId,
            id: groupId,
        },
        offerSelections: offerSelections,
        source: {
            marketLocale: marketLocale,
            marketingChannel: dist.Purchases.MarketingChannel.GROUPSITES,
            marketingSite: marketingSite,
        },
        /** @format decimal */
        totalPrice: totalPrice,
    };
};
var createOfferSelection = function (_a) {
    var offerId = _a.offerId, offerProducts = _a.offerProducts;
    return {
        id: offerId,
        products: offerProducts,
    };
};
var createWALSOrderV2MidVerbosity = function (_a) {
    var _b = _a.billingFrequency, billingFrequency = _b === void 0 ? {
        period: dist.Purchases.BillingPeriod.MONTHLY,
        term: 1,
    } : _b, _c = _a.currency, currency = _c === void 0 ? dist.Purchases.Currency.USD : _c, _d = _a.marketLocale, marketLocale = _d === void 0 ? LocaleConstants.EN_US : _d, marketingSite = _a.marketingSite, offerSelections = _a.offerSelections, sponsorId = _a.sponsorId, totalPrice = _a.totalPrice;
    return {
        billingFrequency: billingFrequency,
        currency: currency,
        offerSelections: offerSelections,
        source: {
            marketLocale: marketLocale,
            marketingChannel: dist.Purchases.MarketingChannel.HUBSITES,
            marketingSite: marketingSite,
            sponsorId: sponsorId,
        },
        /** @format decimal */
        totalPrice: totalPrice,
    };
};
var OrderServiceV2 = /** @class */ (function () {
    function OrderServiceV2() {
    }
    OrderServiceV2.prototype.anonymousCreateOrderV2 = function (_a) {
        var _b = _a.environmentArg, environmentArg = _b === void 0 ? exports.Environment.PRODUCTION : _b, _c = _a.httpAdapter, httpAdapter = _c === void 0 ? true : _c, orderInfo = _a.orderInfo;
        return __awaiter$1(this, void 0, void 0, function () {
            var fullURL, PurchasesClient, response, info, err_1;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        fullURL = "".concat(getPSXURL(environmentArg)) + '/v2/orders';
                        PurchasesClient = axios.create({
                            baseURL: fullURL,
                            timeout: 5000,
                        });
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, PurchasesClient.post('', orderInfo, {
                                adapter: httpAdapter ? require('axios/lib/adapters/http') : null,
                                headers: {
                                    'Content-Type': httpAdapter ? 'application/json' : null,
                                },
                            }).catch(function (err) {
                                console.log('err.response');
                                console.log(err.response);
                                console.log('err.response.data');
                                console.log(err.response.data);
                                console.log('err.response.data.errors');
                                console.log(err.response.data.errors);
                            })];
                    case 2:
                        response = _d.sent();
                        info = response.data;
                        Cookies.set('Order', info, { expires: 2 });
                        return [2 /*return*/, info];
                    case 3:
                        err_1 = _d.sent();
                        console.log('anonymousCreateOrderV2 fails and Err is');
                        console.log(err_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return OrderServiceV2;
}());

exports.Brand = void 0;
(function (Brand) {
    Brand["LEGALSHIELD"] = "legalshield";
    Brand["IDSHIELD"] = "idshield";
})(exports.Brand || (exports.Brand = {}));
exports.CAProvTerr = void 0;
(function (CAProvTerr) {
    CAProvTerr["AB"] = "AB";
    CAProvTerr["BC"] = "BC";
    CAProvTerr["MB"] = "MB";
    CAProvTerr["NB"] = "NB";
    CAProvTerr["NL"] = "NL";
    CAProvTerr["NS"] = "NS";
    CAProvTerr["NT"] = "NT";
    CAProvTerr["NU"] = "NU";
    CAProvTerr["ON"] = "ON";
    CAProvTerr["PE"] = "PE";
    CAProvTerr["QC"] = "QC";
    CAProvTerr["SK"] = "SK";
    CAProvTerr["YT"] = "YT";
})(exports.CAProvTerr || (exports.CAProvTerr = {}));
exports.URLOptionsEnum = void 0;
(function (URLOptionsEnum) {
    URLOptionsEnum["CHECKOUT"] = "checkout";
    URLOptionsEnum["GROUP"] = "group";
    URLOptionsEnum["IDSHIELDCAURL"] = "idshieldCAURL";
    URLOptionsEnum["LAUNCHBYLS"] = "launchByLS";
    URLOptionsEnum["LGLSHIELDCAURL"] = "lglShieldCAURL";
    URLOptionsEnum["LGLSHIELDUSURL"] = "lglShieldUSURL";
    URLOptionsEnum["PSX"] = "psx";
})(exports.URLOptionsEnum || (exports.URLOptionsEnum = {}));
exports.USStates = void 0;
(function (USStates) {
    USStates["AK"] = "AK";
    USStates["AL"] = "AL";
    USStates["AR"] = "AR";
    USStates["AZ"] = "AZ";
    USStates["CA"] = "CA";
    USStates["CO"] = "CO";
    USStates["CT"] = "CT";
    USStates["DC"] = "DC";
    USStates["DE"] = "DE";
    USStates["FL"] = "FL";
    USStates["GA"] = "GA";
    USStates["HI"] = "HI";
    USStates["IA"] = "IA";
    USStates["ID"] = "ID";
    USStates["IL"] = "IL";
    USStates["IN"] = "IN";
    USStates["KS"] = "KS";
    USStates["KY"] = "KY";
    USStates["LA"] = "LA";
    USStates["MA"] = "MA";
    USStates["MD"] = "MD";
    USStates["ME"] = "ME";
    USStates["MI"] = "MI";
    USStates["MN"] = "MN";
    USStates["MO"] = "MO";
    USStates["MS"] = "MS";
    USStates["MT"] = "MT";
    USStates["NC"] = "NC";
    USStates["ND"] = "ND";
    USStates["NE"] = "NE";
    USStates["NH"] = "NH";
    USStates["NJ"] = "NJ";
    USStates["NM"] = "NM";
    USStates["NV"] = "NV";
    USStates["NY"] = "NY";
    USStates["OH"] = "OH";
    USStates["OK"] = "OK";
    USStates["OR"] = "OR";
    USStates["PA"] = "PA";
    USStates["RI"] = "RI";
    USStates["SC"] = "SC";
    USStates["SD"] = "SD";
    USStates["TN"] = "TN";
    USStates["TX"] = "TX";
    USStates["UT"] = "UT";
    USStates["VA"] = "VA";
    USStates["VT"] = "VT";
    USStates["WA"] = "WA";
    USStates["WI"] = "WI";
    USStates["WV"] = "WV";
    USStates["WY"] = "WY";
})(exports.USStates || (exports.USStates = {}));
exports.OrderVersion = void 0;
(function (OrderVersion) {
    OrderVersion["ORDERV2OFFERS"] = "OrderV2Offers";
    OrderVersion["ORDERV1SIPLANS"] = "OrderV1SIPlans";
})(exports.OrderVersion || (exports.OrderVersion = {}));

var getCheckoutURL = function (environmentArg) {
    if (environmentArg === void 0) { environmentArg = exports.Environment.PRODUCTION; }
    var baseURL = environment$1.checkout[environmentArg];
    return baseURL;
};
var getGroupURL = function (environmentArg) {
    if (environmentArg === void 0) { environmentArg = exports.Environment.PRODUCTION; }
    var baseURL = environment$1.group[environmentArg];
    return baseURL;
};
var getDynamicEnvURL = function (urlSelection, environmentArg) {
    if (environmentArg === void 0) { environmentArg = exports.Environment.PRODUCTION; }
    var baseURL = environment$1[urlSelection][environmentArg];
    return baseURL;
};
var stripDomain = function (sourceURL) {
    var _a;
    var out = "";
    if (sourceURL && sourceURL !== "") {
        try {
            out = (_a = new URL(sourceURL)) === null || _a === void 0 ? void 0 : _a.hostname;
        }
        catch (e) {
            // eslint-disable-next-line no-console
            console.warn("Error stripping domain from source URL", e);
        }
    }
    return out;
};
var stripSub = function (fullHost) {
    //Split on the last period, take the last 2, and join them by period
    var hostSplit = fullHost.split('.');
    return "".concat(hostSplit[hostSplit.length - 2], ".").concat(hostSplit[hostSplit.length - 1]);
};
var constructURL = function (_a) {
    var baseURL = _a.baseURL, brand = _a.brand, _b = _a.gaId, gaId = _b === void 0 ? '' : _b, marketLocale = _a.marketLocale, _c = _a.marketId, marketId = _c === void 0 ? window.location.hostname : _c, orderId = _a.orderId, _d = _a.orderVersion, orderVersion = _d === void 0 ? exports.OrderVersion.ORDERV1SIPLANS : _d, pplsiChannelStripped = _a.pplsiChannelStripped, region = _a.region, sourceURLStripped = _a.sourceURLStripped, returnPath = _a.returnPath;
    return (baseURL +
        '/?id=' +
        orderId +
        '&brand=' +
        brand +
        '&market=' +
        marketLocale +
        '&marketId=' +
        "".concat(marketId + (returnPath ? returnPath : '')) +
        '&region=' +
        region +
        '&source=' +
        sourceURLStripped +
        '&orderVersionFlag=' +
        orderVersion +
        (pplsiChannelStripped ? "&pplsiChannel=" + pplsiChannelStripped : "") +
        (gaId ? "&".concat(gaId) : ''));
};
var RedirectService = /** @class */ (function () {
    function RedirectService() {
    }
    RedirectService.prototype.assignNewUrl = function (url) {
        window.location.assign(url);
    };
    RedirectService.prototype.generateCheckoutURL = function (_a) {
        var brand = _a.brand, environment = _a.environment, _b = _a.hostName, hostName = _b === void 0 ? window.location.hostname : _b, marketLocale = _a.marketLocale, orderID = _a.orderID, orderVersion = _a.orderVersion, pplsiChannel = _a.pplsiChannel, region = _a.region, returnPath = _a.returnPath, source = _a.source;
        var constructedURL = "".concat(getCheckoutURL(environment), "/?id=").concat(orderID, "&brand=").concat(brand, "&market=").concat(marketLocale, "&marketId=").concat(hostName + (returnPath ? returnPath : ''), "&region=").concat(region).concat(source && source !== "" ? "&source=" + stripDomain(source) : "", "&orderVersionFlag=").concat(orderVersion).concat(pplsiChannel && pplsiChannel !== "" ? "&pplsiChannel=" + stripDomain(pplsiChannel) : "");
        return constructedURL;
    };
    RedirectService.prototype.redirectToCheckout = function (_a) {
        var brand = _a.brand, _b = _a.environment, environment = _b === void 0 ? exports.Environment.DEVELOPMENT : _b, hostName = _a.hostName, marketLocale = _a.marketLocale, orderID = _a.orderID, orderVersion = _a.orderVersion, pplsiChannel = _a.pplsiChannel, region = _a.region, returnPath = _a.returnPath, source = _a.source;
        var redirectURL = this.generateCheckoutURL({
            brand: brand,
            environment: environment,
            hostName: hostName,
            marketLocale: marketLocale,
            orderID: orderID,
            orderVersion: orderVersion,
            pplsiChannel: pplsiChannel,
            region: region,
            returnPath: returnPath,
            source: source,
        });
        window.location.assign(redirectURL);
    };
    return RedirectService;
}());

exports.LocaleConstants = LocaleConstants;
exports.OrderService = OrderService;
exports.OrderServiceV2 = OrderServiceV2;
exports.RedirectService = RedirectService;
exports.constructURL = constructURL;
exports.createBillingFrequency2 = createBillingFrequency2;
exports.createD2COrderV2LowVerbosity = createD2COrderV2LowVerbosity;
exports.createGroup2 = createGroup2;
exports.createGroupOrderV2MidVerbosity = createGroupOrderV2MidVerbosity;
exports.createLaunchInfo = createLaunchInfo;
exports.createMinD2CInfo = createMinD2CInfo;
exports.createMinGroupsInfo = createMinGroupsInfo;
exports.createMinPrimericaInfo = createMinPrimericaInfo;
exports.createOfferSelection = createOfferSelection;
exports.createOfferV1 = createOfferV1;
exports.createOrderV2 = createOrderV2;
exports.createProductV2 = createProductV2;
exports.createSource2 = createSource2;
exports.createSupplement2 = createSupplement2;
exports.createSupplementV1 = createSupplementV1;
exports.createWALSOrderV1 = createWALSOrderV1;
exports.createWALSOrderV2MidVerbosity = createWALSOrderV2MidVerbosity;
exports.getCheckoutURL = getCheckoutURL;
exports.getDynamicEnvURL = getDynamicEnvURL;
exports.getGroupURL = getGroupURL;
exports.getPSXURL = getPSXURL;
exports.getPSXURLV2 = getPSXURLV2;
exports.getTotalPrice = getTotalPrice;
exports.stripDomain = stripDomain;
exports.stripSub = stripSub;
//# sourceMappingURL=index.js.map
